{
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [7.373584801564812, 59.12982593071946],
            [7.656916191265985, 59.12981038157017],
            [7.677451552505871, 59.1315453410598],
            [7.751208031141693, 59.13765518176954],
            [7.805316860747285, 59.117063553238225],
            [7.911349759246627, 59.00881047239623],
            [7.940631157169607, 59.00522965667582],
            [7.9420937534276606, 58.986731548454],
            [7.985462176172403, 58.96142350666261],
            [8.009571443960416, 58.9644881819975],
            [8.044535080334109, 58.95172157319675],
            [8.091816375123317, 58.948272326111685],
            [8.136849508456027, 58.96088609276355],
            [8.08929117211909, 58.964873148711725],
            [8.079616326394303, 58.971947779963784],
            [8.12728234836871, 58.98481294294355],
            [8.173425858409225, 58.982126382195375],
            [8.222489815948453, 58.97013700044466],
            [8.294025744935146, 58.93647142736537],
            [8.31007182306431, 58.91924553376858],
            [8.39044481633663, 58.91210297705089],
            [8.47659179138966, 58.88669401171781],
            [8.503184024621575, 58.90778842788528],
            [8.575585475867577, 58.93122755861922],
            [8.63837294173944, 58.89145138869909],
            [8.65354842691363, 58.869194886578555],
            [8.721854024128907, 58.850473690565295],
            [8.743849277121193, 58.83118661164091],
            [8.7865702701421, 58.843352722086266],
            [8.79260966635072, 58.86425825341745],
            [8.78125908266936, 58.86737142883635],
            [8.83086816771312, 58.912362071834714],
            [8.761802441720471, 58.937153744046135],
            [8.76212589928874, 58.94827922686096],
            [8.82234295222967, 58.969648747686136],
            [8.83430009095154, 58.98785566727541],
            [8.93981042394712, 58.98588968321426],
            [8.995013007614922, 58.993015302875044],
            [9.03480316983185, 58.93239779926235],
            [9.072976234009849, 58.91110494130241],
            [9.166803577218966, 58.87908819695774],
            [9.190324187564116, 58.84521586207819],
            [9.192156623927685, 58.81427020558745],
            [9.208025520762071, 58.81292535438278],
            [9.196470485189268, 58.80323400042189],
            [9.274747068910969, 58.79548900463621],
            [9.305105981198379, 58.77182216266737],
            [9.32896135548173, 58.78500366705488],
            [9.354004213378184, 58.77660676522124],
            [9.489994451558008, 58.701347061846924],
            [9.427852817357, 58.674740096229506],
            [9.147424815369304, 58.50661191848187],
            [8.771150616349638, 58.254361446767305],
            [8.253660431110093, 58.04803418987249],
            [8.25348000688363, 58.048233536522474],
            [7.7307003247661585, 57.92508195190858],
            [7.219090685445563, 57.90653666650012],
            [6.52822422587703, 57.996826144125826],
            [6.378574059476073, 58.09072795059865],
            [6.256739186575417, 58.147529983442666],
            [6.372950593663838, 58.27650740920263],
            [6.543394175498408, 58.319500581453646],
            [6.608524392880298, 58.37217495912463],
            [6.5953206088248955, 58.41631338472347],
            [6.632150304752484, 58.451400888083604],
            [6.607412656450225, 58.48942913568838],
            [6.596123743030164, 58.496607905328524],
            [6.587697948192539, 58.492770624048475],
            [6.606548628210985, 58.53142719517537],
            [6.826528236021352, 58.51333833892443],
            [7.078743268085856, 58.52065558162875],
            [7.291257637460975, 58.52507716727599],
            [7.346985935157679, 58.554915442262356],
            [7.406050186013842, 58.64218654998965],
            [7.5087920581440954, 58.865712348208135],
            [7.508842917730326, 58.86582233106112],
            [7.5088832102334795, 58.865892741888835],
            [7.514352465010914, 58.87544775672307],
            [7.530764862549956, 59.02598634602422],
            [7.373688038560486, 59.129758005893564],
            [7.373584801564812, 59.12982593071946]
          ]
        ]
      },
      "properties": {
        "objektType": "SkredVarslingsområde",
        "omradeID": 3038,
        "omradeNavn": "Agder sør",
        "safeName": "AgderSor",
        "regionType": "B",
        "dataUttaksdato": "20200127",
        "eksportType": "NVEs nedlastningsløsning"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [11.839735477241746, 59.84076146602841],
            [11.853341809363613, 59.83024715053791],
            [11.884430312250629, 59.82499907241495],
            [11.926977599480105, 59.790585722280525],
            [11.9064805553631, 59.78125825572429],
            [11.793483056320115, 59.78311568269801],
            [11.764146910513729, 59.77254842108214],
            [11.75790560859153, 59.761150209807724],
            [11.72610166679461, 59.760362346922165],
            [11.679633383762962, 59.74183560684273],
            [11.70762511286343, 59.72001526522872],
            [11.66996780611486, 59.69848749456836],
            [11.650635979376208, 59.672464927262844],
            [11.623890518802764, 59.67721598403649],
            [11.626569975087085, 59.66604528908793],
            [11.589784099744657, 59.649637794228084],
            [11.532047864309517, 59.63887720731926],
            [11.545410442860712, 59.618090007667654],
            [11.528322030055675, 59.616713625757875],
            [11.52049570397293, 59.6017546669351],
            [11.492860427148312, 59.59364646112408],
            [11.476696295216394, 59.60107722941887],
            [11.477294939441418, 59.62416524513555],
            [11.499308785197607, 59.62350259649804],
            [11.503428600967776, 59.632116359336884],
            [11.465915835265395, 59.666306735492405],
            [11.420462785580808, 59.67399497521672],
            [11.367762396650967, 59.698207208552354],
            [11.37312844641378, 59.72777855515567],
            [11.343559579164452, 59.754599222299106],
            [11.25483596445324, 59.77026130543756],
            [11.23729217039854, 59.756958539380946],
            [11.230280186071836, 59.68274101622328],
            [11.153205980834475, 59.684421183413924],
            [11.13266577991558, 59.702156962996185],
            [11.105315060602523, 59.691456223654185],
            [11.102027744508032, 59.70332595528309],
            [11.037982849384623, 59.69146317540447],
            [10.970041563879228, 59.70486335898583],
            [10.952783317568528, 59.67299619593468],
            [10.984361358301099, 59.65921854694139],
            [10.960833204397463, 59.63552393769324],
            [10.951647156170122, 59.64942944683718],
            [10.938318107415556, 59.64727303407683],
            [10.935331454227107, 59.63154997155844],
            [10.920749213776345, 59.627275057121714],
            [10.914461845409049, 59.63207964584025],
            [10.906781707768438, 59.62030269668604],
            [10.879906148287288, 59.61867649899346],
            [10.891606840907894, 59.608078142055696],
            [10.867855976099133, 59.607421921570555],
            [10.870176561891398, 59.59499188840012],
            [10.837395134948224, 59.58311896068593],
            [10.852958384262216, 59.57759012572403],
            [10.846746253514285, 59.56958980021159],
            [10.771343253146238, 59.551585925966826],
            [10.786580533261477, 59.535464306937804],
            [10.772302834896026, 59.51035089888564],
            [10.77933205914076, 59.49570586117872],
            [10.74751651782226, 59.49230276179584],
            [10.753197826622928, 59.483462682545984],
            [10.728702741759161, 59.47249422394309],
            [10.708315888849027, 59.49045153412092],
            [10.679577355829249, 59.488320276623696],
            [10.659291456284887, 59.517231253406855],
            [10.616438431657459, 59.5345808270909],
            [10.632133568409293, 59.56672001600999],
            [10.63008877091038, 59.61569334464059],
            [10.615854622173895, 59.65898331108941],
            [10.555926243771424, 59.6832023269878],
            [10.539182670868994, 59.7205019078226],
            [10.545148793567995, 59.78833475201808],
            [10.49672694445503, 59.788690964407685],
            [10.42485474119667, 59.771438998888996],
            [10.426847514577073, 59.77953285067501],
            [10.40125454481146, 59.78666624408587],
            [10.375669113540566, 59.78443290272781],
            [10.342610709236482, 59.79401379501276],
            [10.3564197765891, 59.804145108679414],
            [10.352938781216528, 59.82635395001036],
            [10.328466620383011, 59.873932054100145],
            [10.352128941332847, 59.877183481179536],
            [10.362275164994381, 59.905429506065424],
            [10.377295820141663, 59.91128657323086],
            [10.349863187136348, 59.9605653917676],
            [10.385548680981461, 59.98166732809187],
            [10.42107292786968, 59.98613856787841],
            [10.41247746727064, 60.00314314626317],
            [10.434770994728536, 60.01347723380698],
            [10.435707833605951, 60.03013225775529],
            [10.477742606620154, 60.0321832110204],
            [10.489165172838883, 60.01725987237466],
            [10.518070354830757, 59.999291170702094],
            [10.55585521816055, 59.99672657430896],
            [10.59065368064662, 59.97717003608584],
            [10.613956055887192, 59.974323454967575],
            [10.635615448326776, 59.9478452502469],
            [10.625689730108778, 59.92270845947743],
            [10.647765600970425, 59.90940770820996],
            [10.658082484659955, 59.884410483442366],
            [10.688962492412386, 59.87592809719597],
            [10.73100663891497, 59.877178566827084],
            [10.744019668227386, 59.83928320264522],
            [10.771553297404523, 59.823506110719336],
            [10.812456031784519, 59.8253618409945],
            [10.856299511710176, 59.80931131839779],
            [10.936608835980394, 59.8317020584302],
            [10.907158498257445, 59.869893465966655],
            [10.921416189975472, 59.92647496514193],
            [10.951389441905965, 59.94924298867558],
            [10.936206846424737, 59.97156582299359],
            [10.925650263157133, 59.983724240983236],
            [10.89315510425073, 59.98080203353044],
            [10.849278014703808, 60.00202262945761],
            [10.837688556871047, 59.99803551819295],
            [10.828334793465379, 60.02215153439113],
            [10.821144965713671, 60.01737810600497],
            [10.811705830319163, 60.02546660636919],
            [10.819631408160067, 60.06471548667971],
            [10.785743055257404, 60.069096847049934],
            [10.754849709401288, 60.10024668446784],
            [10.767744339171443, 60.11298254966289],
            [10.73868948433596, 60.12563876204395],
            [10.7072627413985, 60.11940333585275],
            [10.68031961054535, 60.13353032001292],
            [10.676881299699096, 60.147582303862045],
            [10.722648408201966, 60.15756775987245],
            [10.770182787845506, 60.151062251191796],
            [10.782218726091063, 60.22958280231634],
            [10.872311168206542, 60.32082456777124],
            [10.882833612624708, 60.318724506931744],
            [10.933902696774423, 60.34669199096342],
            [10.902088522591363, 60.37807290813418],
            [10.903109406225092, 60.39629218196078],
            [10.819523497901514, 60.42737177799953],
            [10.671977667485363, 60.43385709721782],
            [10.710195109194055, 60.45397320625049],
            [10.692413062337247, 60.49202550540807],
            [10.711302738684108, 60.497157015968746],
            [10.710801312110581, 60.52214382141208],
            [10.77942541915483, 60.48916898000804],
            [10.922589835520085, 60.47058697190672],
            [10.980715896675761, 60.500110283648624],
            [11.067134018254096, 60.51866814854456],
            [11.092591982482903, 60.51676894022004],
            [11.10784518532416, 60.56966544994218],
            [11.153986002947322, 60.6051477506487],
            [11.185065227774606, 60.58545959466591],
            [11.21467304403355, 60.563812823207186],
            [11.209564492513614, 60.504914386399655],
            [11.252083418260353, 60.49501324201252],
            [11.297230440992651, 60.46868371128623],
            [11.34225900373199, 60.45879848158249],
            [11.432605392639449, 60.339613834227734],
            [11.474393471354345, 60.332018337114306],
            [11.518149742810246, 60.29645264074123],
            [11.601894849206289, 60.26728733681006],
            [11.580863202538042, 60.23732588339234],
            [11.582243098117717, 60.2002630226153],
            [11.562371840859464, 60.17596904524063],
            [11.58415007502519, 60.17321995496988],
            [11.652515668362946, 60.12304231635047],
            [11.735010873800283, 60.09606433878846],
            [11.778080501748937, 60.08973760364978],
            [11.79146638725522, 60.04778368582847],
            [11.818061279850735, 60.058501656195865],
            [11.819385589292091, 60.02363367672547],
            [11.83815017711841, 60.008484096815735],
            [11.83227870544701, 59.995568894325494],
            [11.810731516639924, 59.9890837941817],
            [11.793047957505776, 59.95645926225316],
            [11.821408238321093, 59.93029832197412],
            [11.802595000526534, 59.91947483177886],
            [11.80480258554168, 59.89866957138421],
            [11.823035133020836, 59.89278892985437],
            [11.839735477241746, 59.84076146602841]
          ]
        ]
      },
      "properties": {
        "objektType": "SkredVarslingsområde",
        "omradeID": 3044,
        "omradeNavn": "Akershus",
        "safeName": "Akershus",
        "regionType": "B",
        "dataUttaksdato": "20200127",
        "eksportType": "NVEs nedlastningsløsning"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [9.318031204577215, 60.69899482637334],
            [9.32131719292488, 60.679489944388166],
            [9.352647039150263, 60.66711740441623],
            [9.36715926987665, 60.6297555143309],
            [9.388980784790238, 60.61688324889144],
            [9.42134813748014, 60.61301083685455],
            [9.435144329337042, 60.59956434123161],
            [9.410588243251617, 60.58275485774111],
            [9.417290994101656, 60.547658655659134],
            [9.495721570526351, 60.527579288293005],
            [9.607069571929259, 60.53885508696744],
            [9.611785085625412, 60.50034267194187],
            [9.80089629824338, 60.45423283427813],
            [9.830494395697379, 60.456421923418404],
            [9.81047621813827, 60.55606483682903],
            [9.832300639003464, 60.57972599016801],
            [9.843245518310868, 60.58663358994803],
            [9.853391000500315, 60.567694763557725],
            [9.952252698201349, 60.61089984164787],
            [9.903134827452298, 60.6342784210815],
            [9.962893784014298, 60.63792596374688],
            [10.03532987447749, 60.632055005616344],
            [10.094054913520276, 60.55956653095894],
            [10.156375213300448, 60.52219305057253],
            [10.199175995182479, 60.37553781983948],
            [10.319490475420087, 60.26319229655807],
            [10.310172116727337, 60.245087515876094],
            [10.357407244501296, 60.2168469655275],
            [10.376291954174198, 60.22360848550853],
            [10.495193918959037, 60.17263561563263],
            [10.560687255208421, 60.16555751252065],
            [10.596928159341562, 60.145196109699896],
            [10.600720249305056, 60.13160981872188],
            [10.57278253020766, 60.11678480264957],
            [10.597304033458236, 60.07728003527356],
            [10.580764868996987, 60.076238420701685],
            [10.489165172838883, 60.01725987237466],
            [10.477742606620154, 60.0321832110204],
            [10.435707833605951, 60.03013225775529],
            [10.434770994728536, 60.01347723380698],
            [10.41247746727064, 60.00314314626317],
            [10.42107292786968, 59.98613856787841],
            [10.385548680981461, 59.98166732809187],
            [10.349863187136348, 59.9605653917676],
            [10.377295820141663, 59.91128657323086],
            [10.362275164994381, 59.905429506065424],
            [10.352128941332847, 59.877183481179536],
            [10.328466620383011, 59.873932054100145],
            [10.352938781216528, 59.82635395001036],
            [10.3564197765891, 59.804145108679414],
            [10.342610709236482, 59.79401379501276],
            [10.375669113540566, 59.78443290272781],
            [10.40125454481146, 59.78666624408587],
            [10.426847514577073, 59.77953285067501],
            [10.42485474119667, 59.771438998888996],
            [10.49672694445503, 59.788690964407685],
            [10.545148793567995, 59.78833475201808],
            [10.539182670868994, 59.7205019078226],
            [10.555926243771424, 59.6832023269878],
            [10.615854622173895, 59.65898331108941],
            [10.63008877091038, 59.61569334464059],
            [10.632133568409293, 59.56672001600999],
            [10.616438431657459, 59.5345808270909],
            [10.54305966600501, 59.45732694695945],
            [10.4558138408523, 59.47988333267552],
            [10.393691113642435, 59.51468937198992],
            [10.423497610813316, 59.59815862982786],
            [10.410823774052453, 59.60916981407464],
            [10.424496810535366, 59.6252690528437],
            [10.410374906221143, 59.66706549988493],
            [10.363462922516149, 59.697734676228556],
            [10.323407299138625, 59.701938022065065],
            [10.302943686629977, 59.66824167931411],
            [10.25100771637286, 59.674010966301694],
            [10.238611720013791, 59.666408973457386],
            [10.224503243501658, 59.67128726237568],
            [10.218963409889, 59.6638317968419],
            [10.192839049694413, 59.67189990200268],
            [10.157231978336432, 59.66582064889061],
            [10.115514598361626, 59.67066715256403],
            [10.08890853500215, 59.64256862417679],
            [10.037463449214682, 59.64053280484363],
            [9.998171146840987, 59.66381667705343],
            [9.974638485584208, 59.63257868964682],
            [9.981073908672458, 59.617951841837595],
            [9.932930804917332, 59.60387282389357],
            [9.941837949944045, 59.58691853002609],
            [9.915329270778606, 59.58248410306776],
            [10.024989776061151, 59.512347322266685],
            [10.059967600742763, 59.4730291038406],
            [10.011825163526028, 59.4584802488124],
            [9.99831871391597, 59.46699900419357],
            [9.944778670599863, 59.468288080765255],
            [9.920556332689268, 59.45553134170267],
            [9.85294727950259, 59.458329898454025],
            [9.819076125430696, 59.469176652921824],
            [9.758501966478804, 59.45827853449728],
            [9.778087414817184, 59.41200210520688],
            [9.660119707239597, 59.40787093047277],
            [9.624620828936527, 59.42490078569269],
            [9.621375057828807, 59.43843535086743],
            [9.586835602713029, 59.4506349806536],
            [9.584599515663538, 59.46641816532133],
            [9.55203196689202, 59.48725439929179],
            [9.471744273521056, 59.48221126541468],
            [9.46857896805398, 59.49430728028176],
            [9.515263540522625, 59.53811475663818],
            [9.464459700300237, 59.566755316261],
            [9.40556601070156, 59.65882800254251],
            [9.405283923977665, 59.68453511934652],
            [9.333291501078511, 59.69277615616765],
            [9.354786605351753, 59.71824920344121],
            [9.338960026217286, 59.71950562162159],
            [9.344094733947044, 59.75729821975544],
            [9.367754845733415, 59.781338828184325],
            [9.186088508288819, 59.826987399144095],
            [9.188569853561436, 59.89690573477164],
            [9.17429160437365, 59.90001642055032],
            [9.192594395240505, 59.9168137732459],
            [9.179507871448868, 59.92905809120342],
            [9.139301871361777, 59.93928795512209],
            [9.104273777947476, 59.95892966468817],
            [9.0585837007558, 59.96197873519886],
            [9.01921116795848, 59.984031528654825],
            [9.003978980088142, 59.98169780138345],
            [8.992794990953824, 59.980771352538014],
            [8.987512364427282, 59.98974784422674],
            [9.002400474587127, 59.99682193445268],
            [8.9578696767773, 60.098060672593974],
            [8.832765956846453, 60.14941837147393],
            [8.722863576459371, 60.183106927322804],
            [8.659873528225322, 60.17200786973075],
            [8.565214380740471, 60.17724305738892],
            [8.486105719256143, 60.16879444784407],
            [8.384281098896755, 60.18117273458293],
            [8.284269802308268, 60.17510114419418],
            [8.208790453916032, 60.18827181461586],
            [8.166885422109868, 60.186353206341884],
            [8.186946061234863, 60.17368765316819],
            [8.17038267205501, 60.17375038349808],
            [8.15380533248517, 60.18460686020647],
            [8.1349560801974, 60.18526784712593],
            [8.104126000477166, 60.18378638020944],
            [8.057670099415326, 60.16358617252871],
            [7.920952109229101, 60.13714423666064],
            [7.812840509060449, 60.10265102536176],
            [7.76466515562384, 60.115934458284464],
            [7.6460005887947995, 60.126852020758506],
            [7.488040528304484, 60.098838472494464],
            [7.583063882847161, 60.175719965046945],
            [7.609751978562312, 60.24409458887883],
            [7.673709027453453, 60.294334811797704],
            [7.69209505640298, 60.41262995985692],
            [7.704016705897899, 60.40103622342455],
            [7.695607089923918, 60.392481148354506],
            [7.788771108849949, 60.371524159981185],
            [7.947905682025265, 60.39502037969672],
            [8.05256080918478, 60.378736578356275],
            [8.036564895693944, 60.36113252860573],
            [8.05574595135615, 60.34561926880486],
            [8.078619164175922, 60.35888494577186],
            [8.113572006507365, 60.36461849027518],
            [8.131625979916167, 60.36132920298022],
            [8.115670057227701, 60.349217435297795],
            [8.137200898640657, 60.34104363177661],
            [8.28784247762897, 60.35894718554727],
            [8.29466063738063, 60.366014463785405],
            [8.43605179855223, 60.38576091226601],
            [8.495948119495893, 60.40147239661111],
            [8.570448596385017, 60.40337852586883],
            [8.582541255188024, 60.42806094689396],
            [8.622495944276015, 60.4423575680609],
            [8.542277768368123, 60.47708486716321],
            [8.494370698087046, 60.47736839780397],
            [8.470180805072973, 60.485622944358255],
            [8.591287427645758, 60.50995278968335],
            [8.629494382601287, 60.50075975124984],
            [8.681447228113225, 60.51207159856652],
            [8.70568553347729, 60.544057969868646],
            [8.734419226795344, 60.55750985182833],
            [8.703305121734443, 60.57001088206235],
            [8.790941075420127, 60.59187738942549],
            [8.857100228915387, 60.63630760779925],
            [8.864689801604086, 60.65215443492463],
            [9.003410072566657, 60.67413854093209],
            [9.015772680460746, 60.66330442468755],
            [9.031240822273062, 60.6680155987071],
            [9.05355469902211, 60.65487411843602],
            [9.062969886940973, 60.63376377281852],
            [9.07807630474182, 60.633933268541625],
            [9.135764116649153, 60.66124059662413],
            [9.15791270935794, 60.65607306801405],
            [9.296975077492572, 60.70063136669119],
            [9.318031204577215, 60.69899482637334]
          ]
        ]
      },
      "properties": {
        "objektType": "SkredVarslingsområde",
        "omradeID": 3041,
        "omradeNavn": "Buskerud sør",
        "safeName": "Buskerud_sor",
        "regionType": "B",
        "dataUttaksdato": "20200127",
        "eksportType": "NVEs nedlastningsløsning"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [28.907994463581115, 71.0082233904899],
            [28.385282096515436, 70.76160052980589],
            [28.31446123868256, 70.75584228608179],
            [28.238899297957072, 70.66400971221756],
            [27.921599577301, 70.56116800758865],
            [27.78030092728103, 70.5465447373865],
            [27.624800018148555, 70.4985038549241],
            [27.495302368284083, 70.4144070546595],
            [27.42789121162983, 70.39948477811998],
            [27.391039394330527, 70.3784502692092],
            [27.367701170810214, 70.29235658457148],
            [27.009708264969927, 70.21418613658449],
            [27.011495497045487, 70.15637656033677],
            [26.743088958501392, 70.14319020938315],
            [26.244596714440203, 70.0782474630622],
            [26.265345575408865, 69.9979474946054],
            [26.125103187509875, 69.97311696668545],
            [26.054205651392007, 69.98214922601075],
            [25.9555634246834, 69.97969205891054],
            [25.914689129684778, 69.97193053726352],
            [25.840743759827358, 69.94927487189149],
            [25.767371624046337, 69.9031575292314],
            [25.49641360720767, 69.74866934701649],
            [25.250561609549067, 69.73087321457342],
            [24.966647429322318, 69.74597002850874],
            [24.584796181801547, 69.81876703769845],
            [24.218235331053357, 69.80654937468323],
            [24.115281113630616, 69.98827476677471],
            [24.072400624166352, 69.98248840144097],
            [23.911365731678114, 70.00448275362182],
            [23.961041837799208, 70.09652263327898],
            [24.17711199310049, 70.11257720453648],
            [24.493023644314633, 70.33684482930816],
            [24.63699623227232, 70.36288564253978],
            [24.733498626917076, 70.41587817867527],
            [24.674499098992474, 70.44232429161147],
            [24.688451587968693, 70.46224727027854],
            [24.877036182703815, 70.54896967513831],
            [24.977208256311325, 70.61827492569861],
            [24.761700754359353, 70.65300705987896],
            [24.654850238306754, 70.65786412490141],
            [24.606177395950347, 70.65295976473283],
            [24.505076108032757, 70.69521502533567],
            [24.382979046790773, 70.72465300533035],
            [24.168381944599304, 70.72649235609641],
            [23.936641187435686, 70.78251110735],
            [23.8177653107804, 70.92482671743072],
            [23.572818693057926, 71.01722699764053],
            [23.24746419232016, 71.1862280590386],
            [25.90356534030605, 71.26600209760913],
            [27.66959714532958, 71.1991130661533],
            [28.5756907319697, 71.0796819329778],
            [28.907994463581115, 71.0082233904899]
          ]
        ]
      },
      "properties": {
        "objektType": "SkredVarslingsområde",
        "omradeID": 3006,
        "omradeNavn": "Finnmarkskysten",
        "safeName": "Finnmarkskysten",
        "regionType": "B",
        "dataUttaksdato": "20200127",
        "eksportType": "NVEs nedlastningsløsning"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [26.260195670381233, 69.81903850270699],
            [26.241287553146694, 69.81453040862041],
            [26.24578851610258, 69.79438355071386],
            [26.192442701974343, 69.77706446181983],
            [26.183416703894952, 69.76024590824572],
            [26.151183737016517, 69.75605319258707],
            [26.135618940037443, 69.73861475762224],
            [26.052232543927257, 69.72052773475586],
            [26.007141486840492, 69.72285553092219],
            [25.8914930123974, 69.66550330662442],
            [25.95529954447538, 69.64652751661237],
            [25.97657663408141, 69.61024285703456],
            [25.937492072320595, 69.5725322510427],
            [25.84146347475078, 69.55101301176666],
            [25.87626741627631, 69.52857903482656],
            [25.846357338916647, 69.49254190210738],
            [25.864428041817053, 69.47532456214782],
            [25.833726836669964, 69.46734527540387],
            [25.793039701124762, 69.42090900139466],
            [25.821961955519317, 69.41610892534881],
            [25.812171727642028, 69.40541751139853],
            [25.83184748296265, 69.40682298223068],
            [25.846647795872467, 69.3938352166556],
            [25.812594277304495, 69.37591197752303],
            [25.817893769489775, 69.36020820277228],
            [25.784856862382632, 69.3559041614699],
            [25.759379558353125, 69.34037932129819],
            [25.7377665582347, 69.31057753800297],
            [25.743153702285767, 69.27692613038745],
            [25.70128929635742, 69.25001363772125],
            [25.713328631463142, 69.21158834117011],
            [25.693021467275482, 69.19674436962369],
            [25.742955256293342, 69.14411155597126],
            [25.72012950276743, 69.10973227003986],
            [25.724290847016164, 69.07960281629015],
            [25.774032019170498, 69.01314333189241],
            [25.722843321270723, 68.98963875591105],
            [25.65423033014792, 68.90587407309752],
            [25.62683433660987, 68.89268988930108],
            [25.589377606672603, 68.88326994998062],
            [25.541571075470813, 68.8864621901417],
            [25.481194766360534, 68.90507483458696],
            [25.39855934246885, 68.89102355625056],
            [25.26770183290442, 68.85098922484484],
            [25.22691282434671, 68.82358110151942],
            [25.15712664070722, 68.79989300580334],
            [25.12101130671475, 68.74560463821615],
            [25.11638904570222, 68.63958831167886],
            [25.069130743709277, 68.61986583117749],
            [25.04707667793902, 68.6269826104015],
            [25.009409476169697, 68.61432463372569],
            [24.95898088093017, 68.61767118449656],
            [24.9169451183854, 68.605247845869],
            [24.903165687691864, 68.55459184250503],
            [24.85716605490338, 68.56220985712932],
            [24.78342466696251, 68.63623459199292],
            [24.608387948465666, 68.68190160286608],
            [24.25096468711642, 68.72713205107367],
            [24.208049490614403, 68.74530759668639],
            [24.152962191591715, 68.75359104659645],
            [24.15855105252747, 68.78970961308677],
            [24.07559159347083, 68.77996685044997],
            [23.9833308287638, 68.82714342723078],
            [23.871460729822175, 68.83651915098555],
            [23.775391560870712, 68.81885127402468],
            [23.731063427348015, 68.75075137195223],
            [23.673520265082004, 68.70552133208528],
            [23.440635570038683, 68.69216348814948],
            [23.16758227020457, 68.62851889802187],
            [23.04595226768207, 68.6893435368137],
            [22.800824148243684, 68.68754812915934],
            [22.53538940927264, 68.74451263501413],
            [22.374521945301392, 68.71666653370929],
            [22.34078069989356, 68.82722565145016],
            [22.191867979465037, 68.91877365264013],
            [22.17576250038662, 68.95632435213317],
            [21.983608726226876, 69.07289358481073],
            [22.3188697498926, 69.07959948247542],
            [22.478635057861684, 69.10992154533726],
            [22.500715165083616, 69.12599469724967],
            [22.49448260551327, 69.14308326314674],
            [22.52892905177542, 69.16149226462296],
            [22.5162801890265, 69.17767279559168],
            [22.52980356667293, 69.23830726715728],
            [22.365605874723926, 69.36279992504404],
            [22.327762556592976, 69.36794763605629],
            [22.32532890550182, 69.39613157555436],
            [22.287159899089072, 69.42916268632179],
            [22.30181528007878, 69.4527181645696],
            [22.273188465622024, 69.47042472837944],
            [22.279290680226776, 69.48229522733877],
            [22.38054742193143, 69.48655151604315],
            [22.510670873072577, 69.51341438419853],
            [22.633756531252857, 69.51902309239598],
            [22.722002766321417, 69.50847400458903],
            [22.70324060123797, 69.5421752326428],
            [22.7433038280202, 69.5499031515952],
            [22.777257302635167, 69.60675228473686],
            [22.846799532720148, 69.62146209528647],
            [22.894465992950384, 69.64739184614217],
            [22.83482940279264, 69.66723161198813],
            [22.89625793627446, 69.69459768045606],
            [23.15945795708163, 69.68621811745987],
            [23.32461353550085, 69.70911271003949],
            [23.48809943639297, 69.71295745619545],
            [24.210662573082715, 69.66879650273229],
            [24.193830611351856, 69.69413781358128],
            [24.213035234789526, 69.78728566485414],
            [24.218235331053357, 69.80654937468323],
            [24.584796181801547, 69.81876703769845],
            [24.966647429322318, 69.74597002850874],
            [25.250561609549067, 69.73087321457342],
            [25.49641360720767, 69.74866934701649],
            [25.767371624046337, 69.9031575292314],
            [25.832746554894026, 69.89050126833484],
            [25.81377028568999, 69.86266233476685],
            [25.879837301975527, 69.86541398089362],
            [25.953006245691263, 69.84173157489533],
            [26.077223709995373, 69.84979480263114],
            [26.10532224712103, 69.81768640504862],
            [26.260195670381233, 69.81903850270699]
          ]
        ]
      },
      "properties": {
        "objektType": "SkredVarslingsområde",
        "omradeID": 3008,
        "omradeNavn": "Finnmarksvidda",
        "safeName": "Finnmarksvidda",
        "regionType": "B",
        "dataUttaksdato": "20200127",
        "eksportType": "NVEs nedlastningsløsning"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [8.657227798589465, 60.939159587742786],
            [8.814491234969273, 60.90058560538342],
            [8.890585181996528, 60.8966212521313],
            [8.918991014575207, 60.86337604691631],
            [9.146906768497253, 60.80683103984089],
            [9.19287654752437, 60.79087209179481],
            [9.216258959780783, 60.770573371105044],
            [9.291303549111717, 60.76186300888666],
            [9.332110104958202, 60.729904214566126],
            [9.318031204577215, 60.69899482637334],
            [9.296975077492572, 60.70063136669119],
            [9.15791270935794, 60.65607306801405],
            [9.135764116649153, 60.66124059662413],
            [9.07807630474182, 60.633933268541625],
            [9.062969886940973, 60.63376377281852],
            [9.05355469902211, 60.65487411843602],
            [9.031240822273062, 60.6680155987071],
            [9.015772680460746, 60.66330442468755],
            [9.003410072566657, 60.67413854093209],
            [8.864689801604086, 60.65215443492463],
            [8.857100228915387, 60.63630760779925],
            [8.790941075420127, 60.59187738942549],
            [8.703305121734443, 60.57001088206235],
            [8.734419226795344, 60.55750985182833],
            [8.70568553347729, 60.544057969868646],
            [8.681447228113225, 60.51207159856652],
            [8.629494382601287, 60.50075975124984],
            [8.591287427645758, 60.50995278968335],
            [8.470180805072973, 60.485622944358255],
            [8.494370698087046, 60.47736839780397],
            [8.542277768368123, 60.47708486716321],
            [8.622495944276015, 60.4423575680609],
            [8.582541255188024, 60.42806094689396],
            [8.570448596385017, 60.40337852586883],
            [8.495948119495893, 60.40147239661111],
            [8.43605179855223, 60.38576091226601],
            [8.29466063738063, 60.366014463785405],
            [8.28784247762897, 60.35894718554727],
            [8.137200898640657, 60.34104363177661],
            [8.115670057227701, 60.349217435297795],
            [8.131625979916167, 60.36132920298022],
            [8.113572006507365, 60.36461849027518],
            [8.078619164175922, 60.35888494577186],
            [8.05574595135615, 60.34561926880486],
            [8.036564895693944, 60.36113252860573],
            [8.05256080918478, 60.378736578356275],
            [7.947905682025265, 60.39502037969672],
            [7.788771108849949, 60.371524159981185],
            [7.695607089923918, 60.392481148354506],
            [7.704016705897899, 60.40103622342455],
            [7.69209505640298, 60.41262995985692],
            [7.732114689080656, 60.5209704898087],
            [7.673179509934115, 60.537387777603826],
            [7.639576811877155, 60.55958774831633],
            [7.6217136327892065, 60.59614539334378],
            [7.6358507382177745, 60.63290696647603],
            [7.5463179201754595, 60.657404449535576],
            [7.43884239170354, 60.6600393507578],
            [7.469640098781279, 60.67554768935076],
            [7.614698644690534, 60.74419434071582],
            [7.685222458648012, 60.73201066385743],
            [7.704408176826, 60.7391205595968],
            [7.726234980086227, 60.76113132180003],
            [7.721540429916471, 60.79007162419214],
            [7.704431979337083, 60.7927721546644],
            [7.803027073133465, 60.896734539714316],
            [7.851515354391214, 60.91992277344203],
            [7.879034969212499, 60.92404767001758],
            [7.9352048779190305, 60.89725519401387],
            [7.980069577521764, 60.90164246183222],
            [8.040872298960725, 60.89321496104569],
            [8.153942130115349, 60.982232579062746],
            [8.183869197799613, 60.96900314735917],
            [8.223110666380645, 60.968088829595025],
            [8.232816481436615, 60.994564428384514],
            [8.220874902629065, 61.004292690401115],
            [8.257331728163527, 61.00854299842687],
            [8.28266142546315, 61.033330654459675],
            [8.214433573418374, 61.053910541431975],
            [8.251701165718725, 61.07394382617299],
            [8.309203759211947, 61.091720497728154],
            [8.366334633749457, 61.04826346262047],
            [8.459028649125381, 61.01915429486651],
            [8.50949221570074, 61.018407973397586],
            [8.559301917573439, 61.00351242342858],
            [8.62643241084108, 60.97134479980763],
            [8.621085629083712, 60.951902908314985],
            [8.657227798589465, 60.939159587742786]
          ]
        ]
      },
      "properties": {
        "objektType": "SkredVarslingsområde",
        "omradeID": 3032,
        "omradeNavn": "Hallingdal",
        "safeName": "Hallingdal",
        "regionType": "A",
        "dataUttaksdato": "20200127",
        "eksportType": "NVEs nedlastningsløsning"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [7.488040528304484, 60.098838472494464],
            [7.442652739734844, 60.0573201707266],
            [7.436428801336987, 60.01922769790947],
            [7.320434533086833, 59.985960830963805],
            [7.266462725273358, 59.98373892573164],
            [7.232910870712489, 59.9627143347557],
            [7.146821599543263, 59.880980658988726],
            [7.158105381070628, 59.86722227987372],
            [7.141345935487646, 59.85363177246644],
            [7.158129680422305, 59.82846762910686],
            [7.096287399116789, 59.782776822428104],
            [6.977219446042789, 59.772071349615736],
            [6.816001722272826, 59.72260170915975],
            [6.767480243966013, 59.70049429287291],
            [6.688464643824926, 59.69572694148852],
            [6.639179993741846, 59.65914226283592],
            [6.550923710442281, 59.61923067810199],
            [6.403387565767448, 59.58994890962189],
            [6.382237971295188, 59.57154318562472],
            [6.36059892650099, 59.56628363117362],
            [6.335384626983024, 59.562705697948836],
            [6.307810660464545, 59.570005711286264],
            [6.290607737260266, 59.56372050226554],
            [6.280358949755752, 59.56603565311734],
            [6.196530095778948, 59.584929197692055],
            [6.118118869080071, 59.585343129112395],
            [6.0169790535519905, 59.74649579459174],
            [5.969585111651148, 59.79544173937712],
            [5.955100530945528, 60.16590428433745],
            [6.14597153797096, 60.22627437220699],
            [6.210591767256932, 60.26839977713557],
            [6.212679311455552, 60.307594744173464],
            [6.29113072737172, 60.34537134508769],
            [6.3289476772498805, 60.37813056302259],
            [6.450035687113813, 60.40267051252423],
            [6.5663575667444976, 60.449655977483715],
            [6.661797669513436, 60.424559997553196],
            [6.711021131939559, 60.42606345562055],
            [6.805234458829932, 60.469807724314926],
            [6.846573899249952, 60.48164105767588],
            [6.885513984448099, 60.47884645572992],
            [6.908588953539156, 60.485576079801454],
            [7.024665955457909, 60.58584968355907],
            [7.43884239170354, 60.6600393507578],
            [7.5463179201754595, 60.657404449535576],
            [7.6358507382177745, 60.63290696647603],
            [7.6217136327892065, 60.59614539334378],
            [7.639576811877155, 60.55958774831633],
            [7.673179509934115, 60.537387777603826],
            [7.732114689080656, 60.5209704898087],
            [7.69209505640298, 60.41262995985692],
            [7.673709027453453, 60.294334811797704],
            [7.609751978562312, 60.24409458887883],
            [7.583063882847161, 60.175719965046945],
            [7.488040528304484, 60.098838472494464]
          ]
        ]
      },
      "properties": {
        "objektType": "SkredVarslingsområde",
        "omradeID": 3034,
        "omradeNavn": "Hardanger",
        "safeName": "Hardanger",
        "regionType": "A",
        "dataUttaksdato": "20200127",
        "eksportType": "NVEs nedlastningsløsning"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [10.325076717304867, 62.695295656522646],
            [10.592832508100594, 62.66381116267349],
            [10.649512361334608, 62.676579971288454],
            [10.673069860175167, 62.67505323527517],
            [10.711754506354541, 62.666012186869764],
            [10.718072602148615, 62.65017594141677],
            [10.740345128470612, 62.64546668282717],
            [10.792361591269955, 62.67908459889524],
            [10.825307920240277, 62.68830488493655],
            [10.928247934715626, 62.69629568212847],
            [11.04382047860382, 62.66683504461746],
            [11.12453962738762, 62.661668169071035],
            [11.131453209457412, 62.64987906776242],
            [11.16012209511618, 62.64737904027614],
            [11.164457032812352, 62.61601746209183],
            [11.196428949210533, 62.59403497437975],
            [11.196123072967255, 62.5707594095664],
            [11.243888425458069, 62.5668602859084],
            [11.254266763449246, 62.532485473712306],
            [11.285470597913937, 62.53128497523235],
            [11.298517707344523, 62.52182360160946],
            [11.340369600654524, 62.51452019665278],
            [11.370960923355135, 62.49374842616339],
            [11.44653954033598, 62.47032151326293],
            [11.556107244544679, 62.371585786129735],
            [11.671719764100503, 62.38178765503374],
            [11.688839930989518, 62.350451025710385],
            [11.727132436753765, 62.34758156480137],
            [11.724647310695925, 62.35910663920876],
            [11.74774135832055, 62.36192170903887],
            [11.775646584160699, 62.382642109612995],
            [12.05039940014038, 62.3484924996671],
            [12.130958699575224, 62.31004406151404],
            [12.166634724173365, 62.31285097886767],
            [12.208930962456193, 62.33112375606931],
            [12.254665262295756, 62.33102492413106],
            [12.299370861282883, 62.26749595877162],
            [12.137665883055547, 61.723817606849316],
            [12.419609782477771, 61.5629807718864],
            [12.569317601787832, 61.56874658218382],
            [12.870848559881425, 61.35649635251255],
            [12.833826091426742, 61.25846457967341],
            [12.790349320765866, 61.197046397611096],
            [12.707028982890973, 61.143268901836976],
            [12.681402277522693, 61.05953621772631],
            [12.610337911412213, 61.04653920586243],
            [12.447614399288911, 61.050729021742896],
            [12.223991558106443, 61.013077959705484],
            [12.332790431852226, 60.890172139417004],
            [12.334485502871745, 60.85236340975852],
            [12.395371157360037, 60.73388667482424],
            [12.51101732210177, 60.642458659453084],
            [12.515779951862598, 60.60015457994185],
            [12.581861313439525, 60.55090523375944],
            [12.606882969812988, 60.51274204539624],
            [12.606054238164333, 60.40592581185264],
            [12.545286975608947, 60.347348861310934],
            [12.49879571842845, 60.32365328320896],
            [12.541906213924984, 60.19337726051371],
            [12.500642771591954, 60.09907630361048],
            [12.448559032771069, 60.03917691111703],
            [12.395662685118905, 60.01559728279327],
            [12.341138463378973, 59.965671746744476],
            [12.231043384694248, 59.92759135517084],
            [12.174292518545043, 59.88981061832951],
            [12.155281917052434, 59.886745134937776],
            [12.126115358847636, 59.89394120802954],
            [12.053458823384686, 59.88594028736793],
            [11.985175742452467, 59.900718851311645],
            [11.926973819444292, 59.884790699091404],
            [11.917888832537484, 59.873103726535554],
            [11.88480553068668, 59.87176886527977],
            [11.884831895853054, 59.85604958431644],
            [11.839735477241746, 59.84076146602841],
            [11.823035133020836, 59.89278892985437],
            [11.80480258554168, 59.89866957138421],
            [11.802595000526534, 59.91947483177886],
            [11.821408238321093, 59.93029832197412],
            [11.793047957505776, 59.95645926225316],
            [11.810731516639924, 59.9890837941817],
            [11.83227870544701, 59.995568894325494],
            [11.83815017711841, 60.008484096815735],
            [11.819385589292091, 60.02363367672547],
            [11.818061279850735, 60.058501656195865],
            [11.79146638725522, 60.04778368582847],
            [11.778080501748937, 60.08973760364978],
            [11.735010873800283, 60.09606433878846],
            [11.652515668362946, 60.12304231635047],
            [11.58415007502519, 60.17321995496988],
            [11.562371840859464, 60.17596904524063],
            [11.582243098117717, 60.2002630226153],
            [11.580863202538042, 60.23732588339234],
            [11.601894849206289, 60.26728733681006],
            [11.518149742810246, 60.29645264074123],
            [11.474393471354345, 60.332018337114306],
            [11.432605392639449, 60.339613834227734],
            [11.34225900373199, 60.45879848158249],
            [11.297230440992651, 60.46868371128623],
            [11.252083418260353, 60.49501324201252],
            [11.209564492513614, 60.504914386399655],
            [11.21467304403355, 60.563812823207186],
            [11.185065227774606, 60.58545959466591],
            [11.153986002947322, 60.6051477506487],
            [11.093086022952487, 60.65824620557612],
            [10.861811113070038, 60.75096730440065],
            [10.778017036455685, 60.76412847747927],
            [10.738048793488778, 60.77866185187063],
            [10.694695462379144, 60.824000014055265],
            [10.722805412313193, 60.8699708016127],
            [10.681544250556435, 60.90310951392131],
            [10.650988940040795, 60.95580532453468],
            [10.59504730577618, 60.98629185899858],
            [10.484891482653852, 61.01789170740419],
            [10.442950831850824, 61.06229648694662],
            [10.510239521562122, 61.06485658572013],
            [10.546999630795625, 61.08279105931741],
            [10.574299081596653, 61.082424434328324],
            [10.626054392785392, 61.12561094213482],
            [10.637510761635943, 61.12444346307165],
            [10.657365151907708, 61.162786596854176],
            [10.722622110465382, 61.20250827832973],
            [10.743669817545578, 61.23641180401414],
            [10.849054636748885, 61.2660153296083],
            [10.753395377354611, 61.4047169371895],
            [10.68053475487257, 61.47159292269126],
            [10.705044387985177, 61.50139253093223],
            [10.654613661562438, 61.59988762362353],
            [10.639634406024083, 61.707869052391125],
            [10.577684479703123, 61.74396605493445],
            [10.490128306561447, 61.72049780654631],
            [10.404652996020431, 61.66813860885662],
            [10.291015977380196, 61.71337677449978],
            [10.19317808826918, 61.719876913445596],
            [10.052638464338946, 61.75176698399951],
            [10.16482225048629, 61.881925176987735],
            [10.124723921883906, 61.884482695760106],
            [10.087334404799044, 61.90618550113957],
            [10.052874473194034, 61.91342400997874],
            [10.011705251447264, 61.90875397969661],
            [10.015503479200653, 61.8844452594885],
            [9.919541108678477, 61.90199478134425],
            [9.848242726371804, 61.90381027252655],
            [9.870198599448548, 61.949470770747105],
            [9.838812277441429, 62.01339505677229],
            [9.876374176750787, 62.040546708698],
            [9.92796956178752, 62.04749652302043],
            [9.912229578809894, 62.06853188216772],
            [9.865987669709355, 62.09496337370246],
            [9.765248737806486, 62.12322791708371],
            [9.650833366838107, 62.13932268347556],
            [9.583826783291634, 62.18462092962007],
            [9.611973226386644, 62.19901043626529],
            [9.643807049829773, 62.19690762519822],
            [9.730946516003563, 62.265099290285846],
            [9.792454908954538, 62.28793202989553],
            [9.827304208497148, 62.29919431915993],
            [9.833558043788948, 62.32868612381926],
            [9.854754320482405, 62.33097623865046],
            [9.821443589259461, 62.34283680372758],
            [9.839302390776712, 62.36208821459702],
            [9.90026209780039, 62.344369576569925],
            [9.934195114728192, 62.35521995163826],
            [9.951809986919612, 62.397198058839614],
            [10.097583077440769, 62.42780772375924],
            [10.00573180883309, 62.55813255947697],
            [10.038760463002276, 62.56777570827657],
            [10.026678707560638, 62.585623699124625],
            [10.074166528714835, 62.60190068741561],
            [10.108972690768075, 62.65362246271322],
            [10.147597362192474, 62.67669225954932],
            [10.14413824802706, 62.68751220763698],
            [10.162987566833616, 62.68604259271652],
            [10.176474926881465, 62.69692794159545],
            [10.19698685619505, 62.68767702173648],
            [10.238727669500868, 62.695074827565946],
            [10.325076717304867, 62.695295656522646]
          ]
        ]
      },
      "properties": {
        "objektType": "SkredVarslingsområde",
        "omradeID": 3043,
        "omradeNavn": "Hedmark",
        "safeName": "Hedmark",
        "regionType": "B",
        "dataUttaksdato": "20200127",
        "eksportType": "NVEs nedlastningsløsning"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [7.177689813405382, 59.67303899142585],
            [7.240496761864561, 59.454472484660826],
            [7.242064840448176, 59.21606469285613],
            [7.373584801564812, 59.12982593071946],
            [7.373688038560486, 59.129758005893564],
            [7.530764862549956, 59.02598634602422],
            [7.514352465010914, 58.87544775672307],
            [7.5088832102334795, 58.865892741888835],
            [7.508842917730326, 58.86582233106112],
            [7.5087920581440954, 58.865712348208135],
            [7.506566305656505, 58.86089859422577],
            [7.406050186013842, 58.64218654998965],
            [7.346985935157679, 58.554915442262356],
            [7.291257637460975, 58.52507716727599],
            [7.078743268085856, 58.52065558162875],
            [6.826528236021352, 58.51333833892443],
            [6.606548628210985, 58.53142719517537],
            [6.2640218199054996, 58.55879691026499],
            [6.168836951404229, 58.79119110975313],
            [6.1556637973646, 58.7982789665251],
            [5.984180950937414, 59.13859896098506],
            [6.280358949755752, 59.56603565311734],
            [6.290607737260266, 59.56372050226554],
            [6.307810660464545, 59.570005711286264],
            [6.335384626983024, 59.562705697948836],
            [6.36059892650099, 59.56628363117362],
            [6.382237971295188, 59.57154318562472],
            [6.403387565767448, 59.58994890962189],
            [6.550923710442281, 59.61923067810199],
            [6.639179993741846, 59.65914226283592],
            [6.688464643824926, 59.69572694148852],
            [6.767480243966013, 59.70049429287291],
            [6.816001722272826, 59.72260170915975],
            [6.977219446042789, 59.772071349615736],
            [7.096287399116789, 59.782776822428104],
            [7.110451701570402, 59.7633205973096],
            [7.110080241067349, 59.70060347289024],
            [7.149915900054863, 59.69158688882514],
            [7.177689813405382, 59.67303899142585]
          ]
        ]
      },
      "properties": {
        "objektType": "SkredVarslingsområde",
        "omradeID": 3037,
        "omradeNavn": "Heiane",
        "safeName": "Heiane",
        "regionType": "A",
        "dataUttaksdato": "20200127",
        "eksportType": "NVEs nedlastningsløsning"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [14.528795263597369, 66.09555948907067],
            [14.625477676332546, 65.81180736567977],
            [14.541469624688203, 65.70075178305022],
            [14.49877296116551, 65.52129703674343],
            [14.506831554618369, 65.30972858364365],
            [14.37879810416888, 65.24761968665581],
            [14.325985837453887, 65.11891514981411],
            [14.2966592367091, 65.11505526220567],
            [14.252453129208739, 65.13143231058032],
            [14.191513185640638, 65.13107930570915],
            [14.164296948907745, 65.13924894897147],
            [14.063855831105185, 65.12195751232167],
            [14.012209310916857, 65.1295053325977],
            [13.948850568592977, 65.126831390034],
            [13.931619077291984, 65.11868725284714],
            [13.628920389912583, 65.10531716127133],
            [13.52978901123218, 65.11673006681046],
            [13.411249828068648, 65.0990780079642],
            [13.152544842072656, 65.11587821690402],
            [13.085395608625877, 65.10996787149844],
            [13.053238729631422, 65.07378890742679],
            [12.995960108821512, 65.0684489472268],
            [12.967593993808599, 65.03287704271214],
            [12.92988587964755, 65.03875574743321],
            [12.907894606509956, 65.0290579622087],
            [12.910960874413988, 65.01712749485687],
            [12.94805049847644, 65.00002293637702],
            [12.906963963680157, 64.97424882019499],
            [12.774677105339125, 64.97552955741611],
            [12.791317848714355, 64.95344862531299],
            [12.768324344199641, 64.94077501109174],
            [12.715100904851411, 64.9526076973044],
            [12.628669435623653, 64.93949726689814],
            [12.587158071446163, 64.96252373940216],
            [12.580887788201402, 64.9870511514345],
            [12.561257230852611, 64.99031124630982],
            [12.507786182748486, 64.97709220889222],
            [12.389166954207795, 64.99121623419619],
            [12.276820703967806, 64.95978663403872],
            [12.247736813789068, 64.97137758046065],
            [12.187387584777806, 64.97810394242994],
            [12.191622985617759, 64.99907410423928],
            [12.161407815228177, 65.00644433648114],
            [12.149926102919848, 65.01893373749631],
            [12.133347929216525, 65.02165846504268],
            [12.119992405483657, 65.01292330210254],
            [12.13171170640649, 64.99902560617512],
            [12.114132890584251, 65.0042532195261],
            [12.085053614730239, 64.99994766015962],
            [12.036030955580953, 65.03014172377752],
            [12.048860802908123, 65.06686899496847],
            [11.984131790072647, 65.06802503926879],
            [11.959581454005855, 65.07777030651367],
            [11.942053175009674, 65.06737370225844],
            [11.878613987908032, 65.06635762622851],
            [11.917114760762539, 65.07988933795343],
            [11.920935428290896, 65.09970540934263],
            [11.960207336540122, 65.11682244779803],
            [11.935947601967348, 65.12662523925856],
            [11.946125747518584, 65.1489401896938],
            [11.915473684836993, 65.16044506519471],
            [11.836197446568596, 65.15792378115911],
            [11.486048403139968, 65.23685779549838],
            [11.40040317095477, 65.2957033546197],
            [11.132572897732832, 65.36563883458435],
            [11.311097891325664, 65.51257572766252],
            [11.364417262695646, 65.65337764809242],
            [11.540680617362634, 65.83777528198786],
            [11.624271196531849, 66.00807447919813],
            [11.743942544563438, 66.15933339797603],
            [11.839954180304844, 66.31274807035996],
            [11.994546721877574, 66.33417988242411],
            [12.191343705914967, 66.28638044742779],
            [12.33375722792557, 66.28718482585367],
            [12.42720755359554, 66.23247261400475],
            [12.573027976920613, 66.2639975544063],
            [12.627075649145596, 66.26016535023636],
            [12.81197230741949, 66.33154606104205],
            [12.879145302637363, 66.32951422105153],
            [12.95077511779522, 66.30552331828316],
            [13.195407651743354, 66.2943757587576],
            [13.283636211205458, 66.30192607839045],
            [13.324047858720329, 66.24098563900817],
            [13.347539335730797, 66.2424041889772],
            [13.383595837629555, 66.22833624835607],
            [13.543902012434392, 66.25190844119854],
            [13.601796024940503, 66.23539176553446],
            [13.81875906856772, 66.25693491384821],
            [13.860594385620866, 66.25231267202665],
            [13.89024326726829, 66.2142894072222],
            [13.932813924583256, 66.19263974803002],
            [14.0697567485584, 66.20226483619578],
            [14.17344041533221, 66.19989621102968],
            [14.269417509752138, 66.16285854444514],
            [14.254622926721954, 66.13228558520217],
            [14.27340112011629, 66.11619862643957],
            [14.311217108750377, 66.11908996248538],
            [14.349412529679666, 66.10843374089161],
            [14.528795263597369, 66.09555948907067]
          ]
        ]
      },
      "properties": {
        "objektType": "SkredVarslingsområde",
        "omradeID": 3018,
        "omradeNavn": "Helgeland",
        "safeName": "Helgeland",
        "regionType": "B",
        "dataUttaksdato": "20200127",
        "eksportType": "NVEs nedlastningsløsning"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [5.955100530945528, 60.16590428433745],
            [5.969585111651148, 59.79544173937712],
            [6.0169790535519905, 59.74649579459174],
            [6.118118869080071, 59.585343129112395],
            [6.059179387991616, 59.59825145681279],
            [6.0424927651284195, 59.591065324287506],
            [6.008278111173128, 59.59531457933184],
            [6.004635701097077, 59.585107858148604],
            [5.969413400074668, 59.57896789502067],
            [5.963017461537923, 59.60105564157473],
            [5.907024288058036, 59.60787390216673],
            [5.891525382710388, 59.62571326485311],
            [5.834139990193743, 59.631643997081085],
            [5.823429095969827, 59.645405285065294],
            [5.808557783933457, 59.64397564125702],
            [5.772206638544088, 59.64758110206977],
            [5.771083149028003, 59.649216894235664],
            [5.679816638667252, 59.66836797037611],
            [5.667060447470683, 59.66383759151924],
            [5.6369746119873465, 59.66891550354487],
            [5.612846306950833, 59.68527382557616],
            [5.594448633136881, 59.685590214642474],
            [5.555136248649876, 59.64785421379444],
            [5.554590688116327, 59.602727825481594],
            [5.554562811569, 59.600431499326355],
            [5.555836149069405, 59.60000894056492],
            [5.563961935017192, 59.58225773326855],
            [5.567199931877058, 59.558593953076674],
            [5.555410855950652, 59.54937656828436],
            [5.548012848077654, 59.54425883053722],
            [5.534166574676251, 59.53692194967404],
            [5.533498179492428, 59.53736722198912],
            [5.531989178969979, 59.53576777242879],
            [5.51411264964784, 59.51732033486476],
            [5.491827235963186, 59.510635097160325],
            [5.467802023777011, 59.512148413520904],
            [5.4677141508505045, 59.511786322911085],
            [5.456245742900315, 59.499516956215516],
            [5.453296054650378, 59.49725191226763],
            [5.4531065881178, 59.49767690830838],
            [5.422718203167291, 59.49968203333672],
            [5.389401684906702, 59.49113617870293],
            [5.389469927523839, 59.49106765897188],
            [5.364883885672899, 59.49500712439179],
            [5.36061679189772, 59.49334349194925],
            [5.314694597630812, 59.4754208020048],
            [5.2431714635980375, 59.50467145868042],
            [5.187412395144026, 59.51547857527121],
            [4.976893270578358, 59.4961281036915],
            [4.88336571685133, 59.511799000495344],
            [4.912897187838331, 59.70831525716401],
            [4.817824600781182, 60.09796804367154],
            [4.64200036368826, 60.43448724809168],
            [4.349485398239138, 60.855264250986714],
            [4.6106518139971495, 60.88722032662222],
            [4.686904157269979, 60.858220119682976],
            [4.892077634121957, 60.84667402422644],
            [5.048121409148192, 60.82888487850508],
            [5.109884264612806, 60.80552016860445],
            [5.14060687107164, 60.837446164058576],
            [5.132289385912891, 60.859806869686025],
            [5.163117684191484, 60.87387315875151],
            [5.164142284401497, 60.89993547551698],
            [5.226700523785494, 60.92587791268733],
            [5.2768906497044945, 60.9285069023688],
            [5.291888033520972, 60.94392103092487],
            [5.309110575467039, 60.939818455629435],
            [5.330113615624963, 60.91196760854313],
            [5.3765613222265145, 60.911264558124],
            [5.461483268604318, 60.9346966315162],
            [5.477995970107889, 60.934063950290806],
            [5.483676966148221, 60.92161156180171],
            [5.516864988987333, 60.927192417275485],
            [5.52568300737373, 60.91397386676414],
            [5.487739154952199, 60.893231404232246],
            [5.446812473340072, 60.87781386484742],
            [5.381325324397278, 60.873103998616614],
            [5.354346993721623, 60.86351909452606],
            [5.33690667575124, 60.822691643166095],
            [5.23501157152615, 60.77499058617438],
            [5.266718314595623, 60.75024319792633],
            [5.395266265928151, 60.70962531632592],
            [5.494362706468169, 60.64320081816436],
            [5.561915639066571, 60.56268523047001],
            [5.61171309013298, 60.45478222294935],
            [5.6879190597312705, 60.36750681386236],
            [5.639559055912814, 60.34389101752543],
            [5.628397847863731, 60.2988555810099],
            [5.584566372335397, 60.25931928930676],
            [5.569565756126878, 60.22151661760456],
            [5.71347498238484, 60.14350468932902],
            [5.913563202967955, 60.15119544166941],
            [5.955100530945528, 60.16590428433745]
          ]
        ]
      },
      "properties": {
        "objektType": "SkredVarslingsområde",
        "omradeID": 3033,
        "omradeNavn": "Hordalandskysten",
        "safeName": "Hordalandskysten",
        "regionType": "B",
        "dataUttaksdato": "20200127",
        "eksportType": "NVEs nedlastningsløsning"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [7.380880502680348, 62.00296047111602],
            [7.3989217798379165, 61.97846714833567],
            [7.38879929788248, 61.9330714538322],
            [7.414227000846392, 61.891514819696],
            [7.412503204858362, 61.85750942402648],
            [7.381850041728679, 61.85292735418148],
            [7.281760325133101, 61.81187289262404],
            [7.224431401417602, 61.80001285819428],
            [7.036573947840884, 61.67715707152394],
            [6.90452413428256, 61.636308211495425],
            [6.80575828444164, 61.58366120897436],
            [6.808735096572566, 61.570247153001446],
            [6.733095798684286, 61.53516897634934],
            [6.712379822121244, 61.49915078672169],
            [6.680816416592922, 61.476357655035315],
            [6.592791140231505, 61.43039010134245],
            [6.565980878696485, 61.42983137492314],
            [6.506653543308896, 61.402303761910964],
            [6.46434726401223, 61.36354430317474],
            [6.413051366718745, 61.339912789311676],
            [6.408139850906011, 61.32090098926044],
            [6.33571098123297, 61.297367449634024],
            [6.342421450639131, 61.2765791785296],
            [6.4109129244074285, 61.25573561562882],
            [6.4043552325062345, 61.24910273855325],
            [6.388317009418277, 61.23871983721457],
            [6.32497663209887, 61.24190592815568],
            [6.257974143273136, 61.2323119321526],
            [6.2573429868939865, 61.22506781566798],
            [6.245913151574396, 61.22899515373546],
            [6.2017865923618585, 61.21115742225761],
            [6.133026025785258, 61.167720540506465],
            [6.1320548932301815, 61.135129404857],
            [6.025576371245936, 61.13354343785585],
            [5.808630735531791, 61.144873634846114],
            [5.676743750929968, 61.22686354453172],
            [5.562361432828173, 61.36165094983987],
            [5.538125463199438, 61.44370138366269],
            [5.590796675874793, 61.542059719546096],
            [5.733439350077098, 61.56503143070083],
            [5.718563271687383, 61.57019206797727],
            [5.7164069797999515, 61.58595929131979],
            [5.6654793079391075, 61.58954205600179],
            [5.6459758972026295, 61.617389230416556],
            [5.647536307503769, 61.63962269633946],
            [5.700317653517425, 61.68889584639155],
            [5.636588603846945, 61.741661439608535],
            [5.790026106037927, 61.74563179898662],
            [5.845998749531457, 61.766777980702386],
            [5.877283664400295, 61.81536696243062],
            [5.825756228939468, 61.85279635862149],
            [5.768813460730791, 61.863037568773244],
            [5.70723045528257, 61.89616800890094],
            [5.703560471047668, 61.96881913641198],
            [5.728986013032394, 61.9807920600422],
            [5.802578646019904, 61.96599577746085],
            [5.926908990938698, 61.99659482172081],
            [5.946621765842711, 61.98790179458203],
            [5.964776888561535, 61.99410983649981],
            [6.039896513977589, 61.956646075922684],
            [6.059246310144812, 61.96784691719876],
            [6.088683947707437, 61.961714051586256],
            [6.141878940994731, 61.973540821978496],
            [6.131906230721678, 61.98702627197765],
            [6.1704270247589745, 61.99411979968836],
            [6.181774540982831, 62.010666611954775],
            [6.257523952683856, 62.00555253410604],
            [6.235822299229094, 61.99181295608489],
            [6.320624602304048, 61.958762322715266],
            [6.404956321209243, 61.98564770999269],
            [6.401248092648165, 62.00534341150453],
            [6.421017567269673, 62.01437881648338],
            [6.495587202257104, 62.01496228802869],
            [6.494643644748062, 62.03781081239354],
            [6.530873301152169, 62.0412919623015],
            [6.5362762502224525, 62.055526135767195],
            [6.561418818546541, 62.05329055818191],
            [6.578724946027669, 62.06003480356138],
            [6.6208260787495234, 62.05189806073398],
            [6.657573407929146, 62.07185394658499],
            [6.688336077355387, 62.05630528731308],
            [6.793987849072447, 61.96994634933051],
            [6.840865827337052, 61.96354678754039],
            [6.851911087492854, 61.97576905874688],
            [6.895820187948871, 61.98225480910048],
            [6.911665592972717, 61.975292269018105],
            [6.9516051777384344, 61.98867437640788],
            [6.983415591747, 61.98159311055163],
            [7.051395939045871, 61.98442440617608],
            [7.082728704707002, 62.00500090674642],
            [7.0734803638411385, 62.00938552575324],
            [7.155443536591957, 62.016091025028956],
            [7.170770090661512, 62.01199421710257],
            [7.199337295608457, 62.01961308774877],
            [7.194888434123294, 62.03069378422168],
            [7.2340652265557495, 62.03409249796596],
            [7.240762881463988, 62.01892976705184],
            [7.311453547881811, 62.01797970933725],
            [7.328831444462088, 62.00802314074994],
            [7.380880502680348, 62.00296047111602]
          ]
        ]
      },
      "properties": {
        "objektType": "SkredVarslingsområde",
        "omradeID": 3027,
        "omradeNavn": "Indre Fjordane",
        "safeName": "Indre_Fjordane",
        "regionType": "A",
        "dataUttaksdato": "20200127",
        "eksportType": "NVEs nedlastningsløsning"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [8.251701165718725, 61.07394382617299],
            [8.214433573418374, 61.053910541431975],
            [8.28266142546315, 61.033330654459675],
            [8.257331728163527, 61.00854299842687],
            [8.220874902629065, 61.004292690401115],
            [8.232816481436615, 60.994564428384514],
            [8.223110666380645, 60.968088829595025],
            [8.183869197799613, 60.96900314735917],
            [8.153942130115349, 60.982232579062746],
            [8.040872298960725, 60.89321496104569],
            [7.980069577521764, 60.90164246183222],
            [7.9352048779190305, 60.89725519401387],
            [7.879034969212499, 60.92404767001758],
            [7.851515354391214, 60.91992277344203],
            [7.803027073133465, 60.896734539714316],
            [7.704431979337083, 60.7927721546644],
            [7.721540429916471, 60.79007162419214],
            [7.726234980086227, 60.76113132180003],
            [7.704408176826, 60.7391205595968],
            [7.685222458648012, 60.73201066385743],
            [7.614698644690534, 60.74419434071582],
            [7.469640098781279, 60.67554768935076],
            [7.203467528904086, 60.701377942995904],
            [7.155772545153291, 60.884627244012606],
            [7.18010375759557, 60.93400421758202],
            [7.0749292605433585, 60.97198875832432],
            [7.0262211973323465, 61.028791815187994],
            [6.998928567310532, 61.097607931327765],
            [6.913618102001655, 61.103245047039934],
            [6.882350582234792, 61.15748261798089],
            [6.729310920187561, 61.1660704305097],
            [6.690267485453665, 61.182774164597255],
            [6.5973834601733765, 61.187754195301245],
            [6.576568884166981, 61.136277731687635],
            [6.507604492934239, 61.10804055005275],
            [6.430076706903276, 61.09355397379061],
            [6.368473988897766, 61.09318976997582],
            [6.193814804451534, 61.13837967104837],
            [6.1320548932301815, 61.135129404857],
            [6.133026025785258, 61.167720540506465],
            [6.2017865923618585, 61.21115742225761],
            [6.245913151574396, 61.22899515373546],
            [6.2573429868939865, 61.22506781566798],
            [6.257974143273136, 61.2323119321526],
            [6.32497663209887, 61.24190592815568],
            [6.388317009418277, 61.23871983721457],
            [6.4043552325062345, 61.24910273855325],
            [6.4109129244074285, 61.25573561562882],
            [6.342421450639131, 61.2765791785296],
            [6.33571098123297, 61.297367449634024],
            [6.408139850906011, 61.32090098926044],
            [6.413051366718745, 61.339912789311676],
            [6.46434726401223, 61.36354430317474],
            [6.506653543308896, 61.402303761910964],
            [6.565980878696485, 61.42983137492314],
            [6.592791140231505, 61.43039010134245],
            [6.680816416592922, 61.476357655035315],
            [6.712379822121244, 61.49915078672169],
            [6.733095798684286, 61.53516897634934],
            [6.808735096572566, 61.570247153001446],
            [6.80575828444164, 61.58366120897436],
            [6.90452413428256, 61.636308211495425],
            [7.036573947840884, 61.67715707152394],
            [7.224431401417602, 61.80001285819428],
            [7.281760325133101, 61.81187289262404],
            [7.381850041728679, 61.85292735418148],
            [7.412503204858362, 61.85750942402648],
            [7.514754689894256, 61.76032823119587],
            [7.51386053896675, 61.730137215051826],
            [7.649042878566278, 61.68892364887059],
            [7.675967506889424, 61.575848625995974],
            [7.804804895153134, 61.53835790338461],
            [7.671122722432041, 61.4696524689607],
            [7.714671355486464, 61.38611136362914],
            [7.865576605218538, 61.352644150522686],
            [8.047705557678482, 61.337800260616206],
            [8.01745473363229, 61.273280792285696],
            [8.022923097404814, 61.24874912770376],
            [8.053131154591664, 61.23465093272379],
            [8.060572986495563, 61.1933160487254],
            [8.044005787059069, 61.178987090070166],
            [8.075600946123718, 61.17972204809294],
            [8.133876693636132, 61.10967117672835],
            [8.22120664442276, 61.089478167115196],
            [8.251701165718725, 61.07394382617299]
          ]
        ]
      },
      "properties": {
        "objektType": "SkredVarslingsområde",
        "omradeID": 3029,
        "omradeNavn": "Indre Sogn",
        "safeName": "Indre_Sogn",
        "regionType": "A",
        "dataUttaksdato": "20200127",
        "eksportType": "NVEs nedlastningsløsning"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [19.904133334719152, 69.269300590747],
            [19.820952694287307, 69.22970322889691],
            [19.91977777497249, 69.20567521159357],
            [19.953885859551832, 69.10026770184251],
            [19.9914321039813, 69.09151548294935],
            [19.9664810175828, 69.0697940623335],
            [20.060047202147224, 69.04575780910712],
            [20.306589550385496, 68.92618235071241],
            [20.33587305684839, 68.80231445153865],
            [20.202834994079954, 68.66592384366339],
            [20.05224693179057, 68.59107043929943],
            [19.93750399075728, 68.55794179653604],
            [20.02588440674095, 68.53081393769699],
            [20.226543808176217, 68.49081438841164],
            [19.921397091945877, 68.35601380296988],
            [18.983802149426225, 68.51696323733212],
            [18.621223768749694, 68.50695648378623],
            [18.40568821893214, 68.58187690605214],
            [18.125923898236508, 68.53651485242762],
            [18.023286448433353, 68.60845523653815],
            [17.999284453463876, 68.65004046419345],
            [18.045572389904212, 68.6552441719098],
            [18.050160715959443, 68.69846148474932],
            [18.04429593976274, 68.71145052490812],
            [17.99489961545073, 68.72592465519628],
            [18.0107432399244, 68.73909176774451],
            [17.98479643820385, 68.7573694468301],
            [18.092453748144862, 68.76881627592658],
            [18.13592741020984, 68.83465972653423],
            [18.071740435396304, 68.86537342871027],
            [18.118509156538067, 68.86764381838407],
            [18.179217107209606, 68.88318789208175],
            [18.14427062125836, 68.9117550203225],
            [18.22694482240944, 68.99543057113587],
            [18.368067939777205, 69.0376145482186],
            [18.37891424983301, 69.04882625073189],
            [18.452446128578266, 69.04366092692166],
            [18.460828683624577, 69.05854459920467],
            [18.42971564316417, 69.07349653303602],
            [18.42264237984085, 69.10146509977032],
            [18.44593466776043, 69.13064858987019],
            [18.361184686116992, 69.13361084256553],
            [18.17827873063258, 69.18077717370323],
            [18.19719693413636, 69.18667417586228],
            [18.31545781827879, 69.17926075668652],
            [18.342428710337714, 69.1886152663342],
            [18.34311988650561, 69.20716412232666],
            [18.310843560888642, 69.2199102907775],
            [18.276805494800584, 69.21742111114281],
            [18.260890421335784, 69.24648139593947],
            [18.453596021199257, 69.29905104292791],
            [18.52004526316586, 69.29511222562215],
            [18.508648266028175, 69.33246117690877],
            [18.54879828919865, 69.37718614511635],
            [18.686096841891295, 69.41474098967174],
            [18.749722597028484, 69.45143690551996],
            [18.848394162071795, 69.46663355590687],
            [18.867906676557997, 69.4899885594217],
            [18.95343742436768, 69.52039521219498],
            [18.953974313330818, 69.44915145933497],
            [19.018753345208427, 69.4231997370184],
            [19.086968114937168, 69.36841624678756],
            [19.32009477036995, 69.35744032434033],
            [19.373236276143984, 69.32205430089958],
            [19.36830158019904, 69.24796975875752],
            [19.52635201745441, 69.21765164335253],
            [19.904133334719152, 69.269300590747]
          ]
        ]
      },
      "properties": {
        "objektType": "SkredVarslingsområde",
        "omradeID": 3013,
        "omradeNavn": "Indre Troms",
        "safeName": "Indre_Troms",
        "regionType": "A",
        "dataUttaksdato": "20200127",
        "eksportType": "NVEs nedlastningsløsning"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [9.211228153815135, 61.56037419736296],
            [9.230962732578032, 61.45141502252682],
            [9.02377329500077, 61.24758412548689],
            [8.875117042300591, 61.18606916987217],
            [8.859996587372997, 61.13197306902018],
            [8.7979570839958, 61.13708642611508],
            [8.679739201372273, 61.05546791977903],
            [8.742820244941386, 61.02966778387354],
            [8.73820995763849, 61.0045634589217],
            [8.678056017707947, 60.96869661046042],
            [8.657227798589465, 60.939159587742786],
            [8.621085629083712, 60.951902908314985],
            [8.62643241084108, 60.97134479980763],
            [8.559301917573439, 61.00351242342858],
            [8.50949221570074, 61.018407973397586],
            [8.459028649125381, 61.01915429486651],
            [8.366334633749457, 61.04826346262047],
            [8.309203759211947, 61.091720497728154],
            [8.251701165718725, 61.07394382617299],
            [8.22120664442276, 61.089478167115196],
            [8.133876693636132, 61.10967117672835],
            [8.075600946123718, 61.17972204809294],
            [8.044005787059069, 61.178987090070166],
            [8.060572986495563, 61.1933160487254],
            [8.053131154591664, 61.23465093272379],
            [8.022923097404814, 61.24874912770376],
            [8.01745473363229, 61.273280792285696],
            [8.047705557678482, 61.337800260616206],
            [7.865576605218538, 61.352644150522686],
            [7.714671355486464, 61.38611136362914],
            [7.671122722432041, 61.4696524689607],
            [7.804804895153134, 61.53835790338461],
            [7.675967506889424, 61.575848625995974],
            [7.649042878566278, 61.68892364887059],
            [7.51386053896675, 61.730137215051826],
            [7.514754689894256, 61.76032823119587],
            [7.412503204858362, 61.85750942402648],
            [7.414227000846392, 61.891514819696],
            [7.38879929788248, 61.9330714538322],
            [7.3989217798379165, 61.97846714833567],
            [7.380880502680348, 62.00296047111602],
            [7.442001662567468, 62.01881281543625],
            [7.557207757586168, 62.03424296131315],
            [7.627872070502623, 62.00848165553771],
            [7.71061694352604, 62.000334109492435],
            [7.774566642167016, 62.014178379237016],
            [7.870494710005056, 62.00831819325311],
            [7.896848995356223, 61.95642940067132],
            [8.023051215055979, 61.938450263937945],
            [8.033546207134734, 61.9236296053587],
            [8.065898744599192, 61.917494462814844],
            [8.247410194422093, 61.89404899843401],
            [8.27363858698829, 61.87696466157116],
            [8.412594305492393, 61.87296882400694],
            [8.569586408219516, 61.852574101065834],
            [8.765384376499345, 61.861624873027544],
            [8.934555804837666, 61.84792584608793],
            [9.044008018942815, 61.80196331513658],
            [9.119519457433828, 61.75603384248009],
            [9.112118641989014, 61.71833480360885],
            [9.138160310591955, 61.675045759628766],
            [9.114617014294756, 61.60830054969566],
            [9.211228153815135, 61.56037419736296]
          ]
        ]
      },
      "properties": {
        "objektType": "SkredVarslingsområde",
        "omradeID": 3028,
        "omradeNavn": "Jotunheimen",
        "safeName": "Jotunheimen",
        "regionType": "A",
        "dataUttaksdato": "20200127",
        "eksportType": "NVEs nedlastningsløsning"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [16.32720929461984, 69.1838812390295],
            [16.052313806898393, 69.00862947141752],
            [16.11226698060729, 68.93178451578264],
            [16.02646020437358, 68.9092709052694],
            [15.930780825924755, 68.82523994645729],
            [15.938634257230618, 68.81147367653676],
            [16.024027233938465, 68.81367115215389],
            [16.045701672755904, 68.75783802441782],
            [15.995717239888268, 68.67485678334317],
            [15.998937408522073, 68.64405078109608],
            [15.962338153751848, 68.61389755053719],
            [16.02332485261292, 68.5769229470278],
            [16.06299639114314, 68.58361975621284],
            [16.074131763203425, 68.60247562664965],
            [16.120241475855277, 68.60549416463883],
            [16.12493010656441, 68.61131141770133],
            [16.140706779078315, 68.60647821209761],
            [16.154868819774894, 68.61719060463652],
            [16.19900769503344, 68.61705289851075],
            [16.268136919155705, 68.63111513002035],
            [16.307854135802998, 68.60185414173371],
            [16.329137038158418, 68.6025141278048],
            [16.395667424667657, 68.57967515533221],
            [16.429844923738177, 68.58027158782855],
            [16.4577998042509, 68.56752388765845],
            [16.45631587131733, 68.55262821491688],
            [16.381792760504567, 68.5648089402537],
            [16.23562183868555, 68.54980687168779],
            [16.160819111927314, 68.52207512874888],
            [16.040450518417288, 68.42240096031642],
            [16.029851431564456, 68.37680948871797],
            [15.815883026540904, 68.28675823936754],
            [15.79396926323313, 68.24730836524148],
            [15.362711194606153, 68.20773305616164],
            [15.194535140581804, 68.16998294693077],
            [15.121011657131884, 68.14196201892895],
            [14.903100989799146, 68.132807859062],
            [14.455027072372644, 68.13004093257969],
            [13.93530141321902, 68.02688183695248],
            [13.321406146922582, 67.89263672973375],
            [13.087878190822444, 67.7894187099213],
            [12.90325712202234, 67.60199826489391],
            [12.317351567124435, 67.45937451722543],
            [11.879422842512836, 67.36217673295529],
            [11.715732805193511, 67.4045402398017],
            [12.118407051498515, 67.67068381466603],
            [12.603299582223146, 67.82076182699672],
            [12.858492273772741, 68.04680395499673],
            [12.87342763792803, 68.14904196342765],
            [12.928130150727842, 68.18911041471947],
            [13.038571451694263, 68.23763279334541],
            [13.517953034381314, 68.37041592558057],
            [13.66672597868773, 68.43557463926024],
            [13.895187571475859, 68.58481685957395],
            [14.16532285537682, 68.63134421009111],
            [14.38194235650582, 68.78368515651783],
            [15.162431237741716, 69.11582558997213],
            [16.014196158667946, 69.33314300936732],
            [16.159515307724334, 69.35995410519034],
            [16.267797335624834, 69.34533519246999],
            [16.32720929461984, 69.1838812390295]
          ]
        ]
      },
      "properties": {
        "objektType": "SkredVarslingsområde",
        "omradeID": 3014,
        "omradeNavn": "Lofoten og Vesterålen",
        "safeName": "Lofoten_Vesteralen",
        "regionType": "A",
        "dataUttaksdato": "20200127",
        "eksportType": "NVEs nedlastningsløsning"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [19.904133334719152, 69.269300590747],
            [19.52635201745441, 69.21765164335253],
            [19.36830158019904, 69.24796975875752],
            [19.373236276143984, 69.32205430089958],
            [19.32009477036995, 69.35744032434033],
            [19.086968114937168, 69.36841624678756],
            [19.018753345208427, 69.4231997370184],
            [18.953974313330818, 69.44915145933497],
            [18.95343742436768, 69.52039521219498],
            [18.856308944511582, 69.56447305819823],
            [19.003344209942842, 69.60013727005654],
            [19.221376972673628, 69.6077785547061],
            [19.45545885758053, 69.6764676239517],
            [19.541301677922704, 69.69129494213225],
            [19.73223143820219, 69.69583529311524],
            [19.858143645623038, 69.85335132504451],
            [19.999783576430733, 69.94972117830828],
            [20.206826961958335, 70.03838182795052],
            [20.221029382197095, 70.0557625227749],
            [20.498815390354036, 69.94028226883019],
            [20.384043818199675, 69.76340579964732],
            [20.427325988343405, 69.69446580985976],
            [20.42200652232365, 69.66227159279447],
            [20.38693260355883, 69.57912014287531],
            [20.273667796441735, 69.4641320412807],
            [20.17366275777191, 69.39449597433214],
            [20.025658976338665, 69.34777068593243],
            [19.904133334719152, 69.269300590747]
          ]
        ]
      },
      "properties": {
        "objektType": "SkredVarslingsområde",
        "omradeID": 3010,
        "omradeNavn": "Lyngen",
        "safeName": "Lyngen",
        "regionType": "A",
        "dataUttaksdato": "20200127",
        "eksportType": "NVEs nedlastningsløsning"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [8.731640233366708, 62.376872972967526],
            [8.889618403379208, 62.37549435219113],
            [8.931802840542026, 62.353193381606836],
            [9.020433267535426, 62.35912356848249],
            [9.062061789315832, 62.37260842221783],
            [9.483888656260332, 62.29226981176129],
            [9.601920978479576, 62.255726729172466],
            [9.718068285060943, 62.28278615011217],
            [9.792454908954538, 62.28793202989553],
            [9.730946516003563, 62.265099290285846],
            [9.643807049829773, 62.19690762519822],
            [9.611973226386644, 62.19901043626529],
            [9.583826783291634, 62.18462092962007],
            [9.650833366838107, 62.13932268347556],
            [9.765248737806486, 62.12322791708371],
            [9.865987669709355, 62.09496337370246],
            [9.912229578809894, 62.06853188216772],
            [9.92796956178752, 62.04749652302043],
            [9.876374176750787, 62.040546708698],
            [9.838812277441429, 62.01339505677229],
            [9.870198599448548, 61.949470770747105],
            [9.848242726371804, 61.90381027252655],
            [9.919541108678477, 61.90199478134425],
            [10.015503479200653, 61.8844452594885],
            [9.925393265893742, 61.8333070628187],
            [9.746386089180245, 61.824878597110505],
            [9.712123806045941, 61.783280402219795],
            [9.555197274257104, 61.67053152928485],
            [9.437357778726845, 61.638332218252245],
            [9.40110756106692, 61.64918628068608],
            [9.294271270161438, 61.585897186263125],
            [9.211228153815135, 61.56037419736296],
            [9.114617014294756, 61.60830054969566],
            [9.138160310591955, 61.675045759628766],
            [9.112118641989014, 61.71833480360885],
            [9.119519457433828, 61.75603384248009],
            [9.044008018942815, 61.80196331513658],
            [8.934555804837666, 61.84792584608793],
            [8.765384376499345, 61.861624873027544],
            [8.569586408219516, 61.852574101065834],
            [8.412594305492393, 61.87296882400694],
            [8.27363858698829, 61.87696466157116],
            [8.247410194422093, 61.89404899843401],
            [8.065898744599192, 61.917494462814844],
            [8.033546207134734, 61.9236296053587],
            [8.023051215055979, 61.938450263937945],
            [7.896848995356223, 61.95642940067132],
            [7.870494710005056, 62.00831819325311],
            [7.774566642167016, 62.014178379237016],
            [7.71061694352604, 62.000334109492435],
            [7.627872070502623, 62.00848165553771],
            [7.557207757586168, 62.03424296131315],
            [7.589321265871828, 62.04769359153988],
            [7.5920666520985955, 62.07450870749361],
            [7.6318286810512275, 62.08508627523047],
            [7.579379565549673, 62.1218971921141],
            [7.655260503008389, 62.14089256579568],
            [7.734595489016545, 62.184633181976004],
            [7.827342028341916, 62.189686860754755],
            [7.863971867755428, 62.17077792133224],
            [7.983609909673337, 62.177458831341184],
            [8.13125213005481, 62.290660544850255],
            [8.205852119942364, 62.33174420038932],
            [8.391711054983492, 62.36386583297851],
            [8.731640233366708, 62.376872972967526]
          ]
        ]
      },
      "properties": {
        "objektType": "SkredVarslingsområde",
        "omradeID": 3025,
        "omradeNavn": "Nord-Gudbrandsdalen",
        "safeName": "Nord_Gudbrandsdalen",
        "regionType": "B",
        "dataUttaksdato": "20200127",
        "eksportType": "NVEs nedlastningsløsning"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [21.00662959106296, 70.23750770783754],
            [21.110583730614884, 70.10448981827307],
            [21.438689451956208, 70.05645857999185],
            [21.52271769563219, 70.05926547045681],
            [21.67306416917924, 70.04386758347485],
            [21.83902861595502, 70.00089246366389],
            [22.072801164087, 70.02446370333497],
            [22.186415035587338, 70.02553330299382],
            [22.18691802228297, 70.01012726667665],
            [22.247613893971053, 69.97609208918395],
            [22.24323912763972, 69.96089351433801],
            [22.282097378063842, 69.94562518101577],
            [22.402729853454254, 69.92444978723728],
            [22.497193075040496, 69.91878482913884],
            [22.526748938035496, 69.90104363986475],
            [22.448572677232658, 69.87335608731064],
            [22.47750213730448, 69.86308636444622],
            [22.531772042629918, 69.86079158696143],
            [22.546645442381447, 69.84602728635203],
            [22.45147154276486, 69.79070262335254],
            [22.536222523629693, 69.76955483328834],
            [22.55513214478825, 69.7478612873366],
            [22.537648890041968, 69.72190325778243],
            [22.57041517227902, 69.69699086905015],
            [22.75509652412686, 69.64545085777694],
            [22.83482940279264, 69.66723161198813],
            [22.894465992950384, 69.64739184614217],
            [22.846799532720148, 69.62146209528647],
            [22.777257302635167, 69.60675228473686],
            [22.7433038280202, 69.5499031515952],
            [22.70324060123797, 69.5421752326428],
            [22.722002766321417, 69.50847400458903],
            [22.633756531252857, 69.51902309239598],
            [22.510670873072577, 69.51341438419853],
            [22.38054742193143, 69.48655151604315],
            [22.279290680226776, 69.48229522733877],
            [22.273188465622024, 69.47042472837944],
            [22.30181528007878, 69.4527181645696],
            [22.287159899089072, 69.42916268632179],
            [22.32532890550182, 69.39613157555436],
            [22.327762556592976, 69.36794763605629],
            [22.365605874723926, 69.36279992504404],
            [22.52980356667293, 69.23830726715728],
            [22.5162801890265, 69.17767279559168],
            [22.52892905177542, 69.16149226462296],
            [22.49448260551327, 69.14308326314674],
            [22.500715165083616, 69.12599469724967],
            [22.478635057861684, 69.10992154533726],
            [22.3188697498926, 69.07959948247542],
            [21.983608726226876, 69.07289358481073],
            [21.627086221697784, 69.27658827373948],
            [21.27882084967942, 69.31188413674239],
            [21.09616993679715, 69.26091197247058],
            [21.00331349043365, 69.22233818231675],
            [20.987575170459074, 69.19192736695499],
            [21.055625415894287, 69.12208528714642],
            [21.10867508486234, 69.10392915927528],
            [21.057543946322316, 69.03628967079331],
            [20.71732226447867, 69.1197912108251],
            [20.552327464237777, 69.06007679820688],
            [20.060047202147224, 69.04575780910712],
            [19.9664810175828, 69.0697940623335],
            [19.9914321039813, 69.09151548294935],
            [19.953885859551832, 69.10026770184251],
            [19.91977777497249, 69.20567521159357],
            [19.820952694287307, 69.22970322889691],
            [19.904133334719152, 69.269300590747],
            [20.025658976338665, 69.34777068593243],
            [20.17366275777191, 69.39449597433214],
            [20.273667796441735, 69.4641320412807],
            [20.38693260355883, 69.57912014287531],
            [20.42200652232365, 69.66227159279447],
            [20.427325988343405, 69.69446580985976],
            [20.384043818199675, 69.76340579964732],
            [20.498815390354036, 69.94028226883019],
            [20.221029382197095, 70.0557625227749],
            [20.4218650572547, 70.24184481802578],
            [20.669445063628014, 70.24896290206411],
            [21.00662959106296, 70.23750770783754]
          ]
        ]
      },
      "properties": {
        "objektType": "SkredVarslingsområde",
        "omradeID": 3009,
        "omradeNavn": "Nord-Troms",
        "safeName": "Nord_Troms",
        "regionType": "A",
        "dataUttaksdato": "20200127",
        "eksportType": "NVEs nedlastningsløsning"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [12.052459338263922, 63.18344794318978],
            [11.930875855490951, 63.19490440635641],
            [11.791166341551705, 63.18798703537977],
            [11.778950261160661, 63.1874592409547],
            [11.771787112629836, 63.18712631181274],
            [11.767012152018852, 63.18691030615857],
            [11.762282549616826, 63.18671071461905],
            [11.758187281420474, 63.1865391052806],
            [11.756934293386943, 63.186493240411664],
            [11.746250582777279, 63.18598673642841],
            [11.745286569311803, 63.18593759845824],
            [11.742640562624421, 63.185813128669565],
            [11.740192827078372, 63.185687142863294],
            [11.73470250113212, 63.18544813423189],
            [11.734543284233565, 63.1854403395687],
            [11.630786561848199, 63.18068732613448],
            [11.550196122703904, 63.26405221049055],
            [11.45456167705845, 63.32623369884368],
            [11.327340764742154, 63.33780997021927],
            [11.32645571372905, 63.33788465197259],
            [11.309427639845858, 63.33950421103894],
            [11.298656673156225, 63.34047578116175],
            [11.298459465220748, 63.34049447154458],
            [11.288425745152292, 63.34140382589217],
            [11.282807610313958, 63.341913190291564],
            [11.282666421480327, 63.341919212232625],
            [11.275403927360085, 63.3422445694653],
            [11.263982567321356, 63.34275479398758],
            [11.26256667812576, 63.342831162109874],
            [11.257934293112278, 63.343081892228724],
            [11.24478643065926, 63.343791648562764],
            [11.244657069796785, 63.343798843499954],
            [11.235828445170153, 63.34427817237996],
            [11.230316749556987, 63.34451502862973],
            [11.222377169666752, 63.34514061308541],
            [11.216194271939827, 63.345612465189575],
            [11.214717638468173, 63.34571326048996],
            [11.205976495967388, 63.34630685520569],
            [11.196987298111898, 63.34729347818245],
            [11.189142373973356, 63.347894153735034],
            [11.186807925363548, 63.347333214385],
            [11.185377528429635, 63.347068736324466],
            [11.18397508651187, 63.34679429770564],
            [11.180356071105372, 63.346291857385985],
            [11.175074318002933, 63.34532906158351],
            [11.174026890704688, 63.345017408535014],
            [11.164263674895496, 63.34390953953323],
            [11.163444383462934, 63.343835358794536],
            [11.158162273457151, 63.343354054353604],
            [11.155843235430268, 63.34305883708895],
            [11.153598866342247, 63.34293554014526],
            [11.148216948865494, 63.342380168640034],
            [11.144440285053378, 63.34214115194448],
            [11.14434329380879, 63.342118576187794],
            [11.1442011835333, 63.342084893668435],
            [11.143479398992724, 63.34191078258688],
            [11.14068317599187, 63.3407938324157],
            [11.139525439940689, 63.340224413501],
            [11.134649700221033, 63.34028966465684],
            [11.133409374203156, 63.34043826745576],
            [11.122021516896533, 63.34069908546375],
            [11.11116902299205, 63.34139205606945],
            [11.106705607962763, 63.341508950911894],
            [11.105337332244918, 63.341580031442334],
            [11.103608321258921, 63.34154228433296],
            [11.10068177582782, 63.34158651462027],
            [11.099427570120154, 63.341581841947274],
            [11.098185604769368, 63.341572460538984],
            [11.096621169175435, 63.34166630591273],
            [11.095449409306902, 63.34168641517539],
            [11.084141944675208, 63.34160697065938],
            [11.079148290230297, 63.34149129410722],
            [11.078257309835093, 63.34146928821231],
            [11.078006116002658, 63.341463002734194],
            [11.073796690514714, 63.34121953166502],
            [11.063689706141604, 63.34113738342833],
            [11.042871569247602, 63.34064884074155],
            [11.037135565049427, 63.33927732046219],
            [11.027809073282844, 63.33809264536957],
            [11.02170935366768, 63.33731728194605],
            [11.007282794687839, 63.33547334133073],
            [11.006793396115542, 63.33543715277633],
            [11.004374177949742, 63.335256514095555],
            [11.004231933421607, 63.33521935850686],
            [11.003976406735113, 63.335211561117944],
            [11.003556339369197, 63.335193214870266],
            [11.003185083933065, 63.33517479893943],
            [11.002783310774003, 63.33516729983387],
            [11.002497905941262, 63.33520899376119],
            [11.002218543298184, 63.3352892352035],
            [11.001902968566778, 63.335366662139734],
            [11.001468610938147, 63.335420890735115],
            [11.001061344948655, 63.33543561262414],
            [11.00068490982998, 63.33545299657859],
            [11.000468868029785, 63.33545897452539],
            [11.000228045606008, 63.3354288437898],
            [10.999887993242004, 63.33535718798926],
            [10.999622779368872, 63.3353715806331],
            [10.999431206043408, 63.3353497523567],
            [10.999085017786193, 63.33528628104626],
            [10.998726801697282, 63.335261838255406],
            [10.998516912598804, 63.335256661221464],
            [10.99825762669606, 63.33525719662505],
            [10.99796538064133, 63.33525743467003],
            [10.997749913552854, 63.335247785559005],
            [10.99756419145964, 63.33528166476554],
            [10.997149592522248, 63.335446807794106],
            [10.99691945391155, 63.33546065316015],
            [10.996601018535818, 63.33559874699073],
            [10.996489906594045, 63.335622498149704],
            [10.996185426775499, 63.33564306112049],
            [10.995992490587186, 63.33567700523226],
            [10.995762482400915, 63.335724377605395],
            [10.99559928169888, 63.33575160719851],
            [10.995197936364498, 63.33576252420944],
            [10.995019684403784, 63.33576281543415],
            [10.99473098599301, 63.33589410164381],
            [10.99459033205892, 63.33593463715629],
            [10.994381528960547, 63.33589146546436],
            [10.994150797064153, 63.33585495703498],
            [10.993976317529025, 63.33585544293546],
            [10.992075256767626, 63.336021452441074],
            [10.970267978975453, 63.330827890047175],
            [10.967932727508204, 63.33027751400764],
            [10.964594099761106, 63.329421924170155],
            [10.963564020031454, 63.32956458704004],
            [10.946898441926468, 63.33185435642651],
            [10.940341985301304, 63.33276617534553],
            [10.921668292601495, 63.335453242769056],
            [10.914611219769295, 63.33639038416609],
            [10.910721449302915, 63.336906702801606],
            [10.898328023888489, 63.3385302780956],
            [10.880683605357067, 63.34078720627494],
            [10.872337455279986, 63.34185913950975],
            [10.865099121773687, 63.34280976676488],
            [10.85955363824013, 63.343537963940754],
            [10.858879796181196, 63.343626513619064],
            [10.856513320431977, 63.343937752631994],
            [10.855610405790637, 63.344056478832684],
            [10.855446635532633, 63.344077961934644],
            [10.854599387075622, 63.34418940238374],
            [10.851667884604465, 63.35296401173867],
            [10.852438263234948, 63.3529849096636],
            [10.854509676065758, 63.35282657819463],
            [10.860386129807964, 63.353492258679275],
            [10.860241856779767, 63.35481617332173],
            [10.851369590260084, 63.35447023219826],
            [10.850673020465745, 63.35654823822027],
            [10.84417427999413, 63.35514552972547],
            [10.845320457443442, 63.356840114876384],
            [10.855774946702189, 63.37217171745572],
            [10.861202641753197, 63.38013576410557],
            [10.85910101904046, 63.381828925107015],
            [10.85828466045417, 63.382539247714746],
            [10.860232116922328, 63.38504130435423],
            [10.860542821349402, 63.38557392392857],
            [10.861037822167104, 63.386226499138175],
            [10.862233140963081, 63.386892021299005],
            [10.862261667785598, 63.38745438174065],
            [10.86222363626836, 63.38865760301507],
            [10.862326390945576, 63.39011165211808],
            [10.862335487664696, 63.39018337726709],
            [10.86233845328676, 63.390225351279504],
            [10.862341662160267, 63.39027119754806],
            [10.862489583329252, 63.39240997743702],
            [10.862610944893865, 63.39394222860168],
            [10.862693278554215, 63.3956645397333],
            [10.862644114472792, 63.3979038495798],
            [10.86266396809095, 63.39956178576198],
            [10.86263348313776, 63.39987317361053],
            [10.862602774982356, 63.40017637515294],
            [10.862130153653029, 63.40216403159242],
            [10.86156429413326, 63.403539899931594],
            [10.86124816577265, 63.40481056071875],
            [10.860696267561035, 63.40702522130743],
            [10.860439074625837, 63.408063521864804],
            [10.859629384017033, 63.41077632474461],
            [10.85956281561332, 63.411101137822506],
            [10.859548981514092, 63.41114415256092],
            [10.859405244323595, 63.41164218889669],
            [10.858712082269284, 63.41240725166888],
            [10.857392125528282, 63.413861811890484],
            [10.856590893415088, 63.41509339769541],
            [10.85571959983102, 63.416320698864745],
            [10.855672171016993, 63.416436446624736],
            [10.855449092228815, 63.41652255432856],
            [10.855248307231477, 63.41660014046789],
            [10.855545901315944, 63.41730407100105],
            [10.855731567659621, 63.41762515100279],
            [10.855764215473565, 63.417746190175905],
            [10.855789620595822, 63.418072684269355],
            [10.856147593665222, 63.41929153999592],
            [10.85642921448703, 63.42041981722877],
            [10.856667797984244, 63.42054440683958],
            [10.856692879453929, 63.42075250779359],
            [10.856814937270322, 63.421179335836264],
            [10.857248786542842, 63.42231661286276],
            [10.85967606381954, 63.42696396883505],
            [10.858876270130798, 63.42899705864476],
            [10.857898173092117, 63.431546146783305],
            [10.857806330209621, 63.4318064959716],
            [10.857622354337666, 63.432306960952204],
            [10.857605924678442, 63.43257596983962],
            [10.857566680039216, 63.43282786726375],
            [10.85735901522823, 63.4334073759265],
            [10.857030224365214, 63.43403047173564],
            [10.856791503376162, 63.435286478453996],
            [10.856566590186922, 63.436471873856725],
            [10.856554789580969, 63.436534003955245],
            [10.854855770926617, 63.43815347826298],
            [10.854794273558309, 63.43821218825963],
            [10.85473303727142, 63.438256613526704],
            [10.853730576370548, 63.43898383513931],
            [10.853088200263024, 63.4394843707678],
            [10.84411184529681, 63.44647652545383],
            [10.838211312095497, 63.4545423946606],
            [10.774467828874615, 63.455347180753336],
            [10.715080875261359, 63.46863933138131],
            [10.65392875109006, 63.4905445160489],
            [10.60679582679203, 63.49170752340746],
            [10.550349736982886, 63.495293135673336],
            [10.488585614057548, 63.516594387180064],
            [10.418553627185439, 63.51268702392922],
            [10.356563081390252, 63.50919847581782],
            [10.312776105760172, 63.50431444122086],
            [10.272786874652702, 63.49984081730661],
            [10.23479838542, 63.495577986962644],
            [10.17024199895629, 63.52579036660058],
            [10.170249769545983, 63.52582417620514],
            [10.170310137740627, 63.526093962780585],
            [10.17033910773412, 63.5263706938174],
            [10.170378599708384, 63.52659397316584],
            [10.170584548255006, 63.527758284124324],
            [10.170609874480206, 63.52791086613617],
            [10.170697314499625, 63.52808335287588],
            [10.171301126466995, 63.53208470041739],
            [10.170980858047324, 63.53263915717066],
            [10.169324865653126, 63.53550438546455],
            [10.164978074481676, 63.53785356635256],
            [10.164678483963907, 63.53808196246282],
            [10.163712295772795, 63.53975897030901],
            [10.160797142183979, 63.54005030784734],
            [10.155141200512098, 63.54070769669296],
            [10.154713963628332, 63.54097240607708],
            [10.15441921570728, 63.541345841250404],
            [10.152653752371899, 63.54364113977791],
            [10.151314500910061, 63.54716056228891],
            [10.14873919310468, 63.55134358805866],
            [10.146230337860727, 63.55264569593471],
            [10.145720763376067, 63.553111399180075],
            [10.144036683642202, 63.55496345887469],
            [10.143980146465305, 63.55504896374223],
            [10.143960255840337, 63.555076890271465],
            [10.142744246750034, 63.55693042588753],
            [10.142670310670708, 63.55704574021391],
            [10.142273323960637, 63.55765106554995],
            [10.141987571375017, 63.558086758103684],
            [10.14304940685674, 63.559816105109455],
            [10.144391016200442, 63.56198151878839],
            [10.146013275803336, 63.56452968276005],
            [10.146074361469426, 63.56468411316349],
            [10.146221443439659, 63.56485917685709],
            [10.146305426717003, 63.564991358415476],
            [10.147069283825253, 63.56624071148164],
            [10.147471183360834, 63.56678983782741],
            [10.147836335321738, 63.567084804413994],
            [10.14894825405586, 63.56808879673269],
            [10.150578540048413, 63.56930118588538],
            [10.150682390341936, 63.571512469666914],
            [10.150692855658582, 63.57173520166494],
            [10.149166961674988, 63.572579111137394],
            [10.147335532009565, 63.57367550671936],
            [10.146606613798388, 63.574092057775104],
            [10.145235142850867, 63.574876991300634],
            [10.144521812803571, 63.57528048056421],
            [10.14381655417133, 63.57557864976442],
            [10.143109931910217, 63.57592371882925],
            [10.142244967457795, 63.576516239241556],
            [10.138720595113108, 63.57810429684786],
            [10.137916815421871, 63.57844780003727],
            [10.137710028073258, 63.57855100422796],
            [10.136945219942978, 63.578900187583265],
            [10.136296128661375, 63.57916281513704],
            [10.135074232122678, 63.57965670015562],
            [10.135005866556096, 63.579652174781835],
            [10.134934430200571, 63.57964848947101],
            [10.134855137715514, 63.5796458864322],
            [10.134778450744692, 63.57964103335815],
            [10.134696516769738, 63.57963735115813],
            [10.13459425797946, 63.57963801531897],
            [10.134520019105116, 63.57963891157981],
            [10.134447415062871, 63.5796588635124],
            [10.134457595459887, 63.57969345459454],
            [10.134496336345032, 63.579758449161176],
            [10.134524057625967, 63.57980526097844],
            [10.134535714655549, 63.57985629407638],
            [10.134505214545255, 63.57989474253746],
            [10.134461454436863, 63.579913942801014],
            [10.134422322539304, 63.579956235384],
            [10.134370506499751, 63.580012487801476],
            [10.13430987386391, 63.580037680677144],
            [10.134204289472326, 63.58007546750471],
            [10.134108399837713, 63.580113223803764],
            [10.134032222445045, 63.58013959744549],
            [10.1339526364793, 63.58016819375025],
            [10.133909443113334, 63.580205311521134],
            [10.133881374854662, 63.580229541752075],
            [10.1338369838307, 63.580265989230156],
            [10.133823182966182, 63.580297089971076],
            [10.133828455440332, 63.58034826603926],
            [10.133885425770723, 63.58039638635888],
            [10.133897630413118, 63.58044775292861],
            [10.133928892537321, 63.58049333602024],
            [10.133955061299213, 63.5805244453547],
            [10.134002829350594, 63.58054612495584],
            [10.134051018811768, 63.58056062351606],
            [10.134066087610764, 63.580591715551535],
            [10.134081967450044, 63.580618068222606],
            [10.134140202170295, 63.580649367292885],
            [10.134235947903216, 63.58068796654573],
            [10.134406724941286, 63.580726955590485],
            [10.134614820055155, 63.58077791493846],
            [10.13474244733937, 63.58081660727287],
            [10.134806105990798, 63.58085042873683],
            [10.134829527385724, 63.58089111329934],
            [10.134772436854123, 63.58093158187361],
            [10.134697161409207, 63.580943236107885],
            [10.134594875452844, 63.58095936943442],
            [10.134525061364815, 63.580968600760166],
            [10.134467879800143, 63.5810054684688],
            [10.13438386121535, 63.58104933951158],
            [10.134340638767144, 63.581073055131135],
            [10.134334514559347, 63.581106485314095],
            [10.134371371533177, 63.581140026231665],
            [10.134402554617255, 63.58117841116013],
            [10.134423451944844, 63.58121437807052],
            [10.13444395960797, 63.5812479033163],
            [10.134443280803012, 63.58128844396039],
            [10.134453053459001, 63.58133869351534],
            [10.13445761663754, 63.5813745553477],
            [10.134424880362275, 63.5814006958153],
            [10.134311626086014, 63.58143372525847],
            [10.1342389854412, 63.58144295041414],
            [10.134151066023682, 63.581430565242854],
            [10.13406236909917, 63.58143982955917],
            [10.134005749904615, 63.581451577513874],
            [10.133948821822825, 63.58144802486228],
            [10.133853183002907, 63.5814406388864],
            [10.133757354123274, 63.58144026184481],
            [10.13369341698922, 63.58144699418377],
            [10.133629249606333, 63.58147512480966],
            [10.133596943274018, 63.5815105437158],
            [10.133596116702051, 63.5815460426288],
            [10.133610602025398, 63.581610033570115],
            [10.133656548474804, 63.581702525461985],
            [10.133686971829743, 63.581759502687554],
            [10.133702109081849, 63.581794914282675],
            [10.133701052437203, 63.5818518115119],
            [10.133731892767296, 63.581908712943715],
            [10.13374659927855, 63.58196551603222],
            [10.133777640531902, 63.5820224242735],
            [10.133806807259145, 63.58213629188883],
            [10.133821293301768, 63.58220028281187],
            [10.133883835556317, 63.58225007633822],
            [10.13394631812521, 63.58232145381701],
            [10.134024970434869, 63.5823856454992],
            [10.134055421172215, 63.58244954904913],
            [10.1340866521707, 63.582478221941514],
            [10.134085801565053, 63.5825280207563],
            [10.134115821957142, 63.58261331579449],
            [10.134114801272448, 63.58266292894777],
            [10.134161777612748, 63.58271992859671],
            [10.134223869617427, 63.582777081855305],
            [10.13428640464004, 63.582841085695605],
            [10.134364832347043, 63.58289834399528],
            [10.134411999536917, 63.58294833456965],
            [10.134425931011334, 63.58301203672415],
            [10.13440974764737, 63.58304053825229],
            [10.1343687541727, 63.58309014292089],
            [10.134407871134755, 63.58312582917451],
            [10.134390897136267, 63.58318254553808],
            [10.134390302750676, 63.58321787243153],
            [10.134372876724134, 63.5832819486608],
            [10.13434019831608, 63.58331717524075],
            [10.134314089772383, 63.58335766168449],
            [10.134161266015639, 63.58349916610645],
            [10.134156678103016, 63.58354838827369],
            [10.134148133952014, 63.58360539093983],
            [10.134109767129699, 63.583677390319984],
            [10.134254505520548, 63.5836987511505],
            [10.134349504849748, 63.58372840518877],
            [10.134417156640463, 63.58374993504312],
            [10.134480636430341, 63.58376891003921],
            [10.134496662307654, 63.58379855043631],
            [10.13445426962159, 63.58382742104764],
            [10.134411041684203, 63.58386294145106],
            [10.134387482643662, 63.58389737598459],
            [10.13437022031339, 63.5839274598272],
            [10.134350480799718, 63.58395314233647],
            [10.134321859433046, 63.58398648303115],
            [10.134282029354772, 63.58402082184713],
            [10.134297672074098, 63.58405703028782],
            [10.13434799916732, 63.58409614087807],
            [10.134426475395076, 63.58413612380091],
            [10.13450512509946, 63.584162022304795],
            [10.134563548363031, 63.584180465745995],
            [10.134609417296067, 63.58419794316046],
            [10.13465779050631, 63.58421730443755],
            [10.134713798881178, 63.58424160195094],
            [10.134784823730149, 63.58427135617903],
            [10.134827918687595, 63.584292067154934],
            [10.134873623257313, 63.58431286673489],
            [10.134929117171641, 63.584343712423305],
            [10.134990993861182, 63.58438327431533],
            [10.135033442508032, 63.58443215277777],
            [10.134969538445635, 63.58445733220267],
            [10.134924379430048, 63.584479948025034],
            [10.13489284725941, 63.584510536706105],
            [10.134861516659702, 63.58454171684759],
            [10.134886545896386, 63.58471165707386],
            [10.13490904396607, 63.58486217388305],
            [10.134917077998175, 63.584985127086966],
            [10.134932475829268, 63.58526680749548],
            [10.135182925461413, 63.58567339342335],
            [10.135159699239901, 63.58596959196436],
            [10.135128873407966, 63.586568006098226],
            [10.135089577596435, 63.58677403219956],
            [10.13506441920832, 63.586911013470704],
            [10.135013967261598, 63.587277791173804],
            [10.134916894835296, 63.58767509504367],
            [10.134834508356212, 63.58796415815189],
            [10.134845958923904, 63.588189850735574],
            [10.134782169108323, 63.58845283264869],
            [10.134761578545886, 63.588489369320584],
            [10.134705612560811, 63.588588653292675],
            [10.134676102172214, 63.58865695127055],
            [10.134746187849863, 63.588668954839],
            [10.134825413490066, 63.588680354012695],
            [10.134900835671715, 63.588691759808576],
            [10.135124860298715, 63.58875538458554],
            [10.135846517845197, 63.5888459471022],
            [10.137497817045126, 63.58890442364162],
            [10.144960416939284, 63.58916818137986],
            [10.146094359129332, 63.58918897033989],
            [10.148168750450983, 63.58961647001539],
            [10.148580477995479, 63.58996561901359],
            [10.152874601127374, 63.59229783659417],
            [10.153261654614457, 63.5925920810216],
            [10.15699229396743, 63.594972461805554],
            [10.157422007763019, 63.59532497651954],
            [10.158204042973033, 63.59595570466634],
            [10.157482004866388, 63.59691138277978],
            [10.15742865548667, 63.5969802728224],
            [10.157204472447878, 63.5972722871524],
            [10.160797083075774, 63.598061977503804],
            [10.161911436973288, 63.598350529566304],
            [10.165825441588142, 63.59977682151456],
            [10.165818248824815, 63.60058962820538],
            [10.165675826492652, 63.6010538570154],
            [10.165094824817482, 63.60298881729044],
            [10.164987169454578, 63.60329610564313],
            [10.16490739972313, 63.603519072267005],
            [10.166347308525985, 63.60369939477137],
            [10.171551149313249, 63.604328875293],
            [10.171768883865546, 63.60454081944918],
            [10.172669548377906, 63.605492062587615],
            [10.174170313415022, 63.607076281813725],
            [10.176441999936094, 63.60947385943624],
            [10.176580035947593, 63.610418447421644],
            [10.176767306848966, 63.61059527035086],
            [10.182860514767647, 63.61558597550386],
            [10.183188616979379, 63.615996590282165],
            [10.183512565925868, 63.61637216877124],
            [10.183857597814363, 63.61683083721099],
            [10.185951923978422, 63.62142060556388],
            [10.186332238771634, 63.621695628471215],
            [10.186529428933548, 63.62180837293586],
            [10.186588948021763, 63.62186271407643],
            [10.186636549636173, 63.62190388411299],
            [10.186700335942994, 63.62195809860083],
            [10.186731681331578, 63.621987840598955],
            [10.186773794905125, 63.622024419465546],
            [10.186825163472033, 63.62206841396695],
            [10.186930521299585, 63.622149295867814],
            [10.18702031307487, 63.622217064074626],
            [10.187074774851279, 63.622268656746805],
            [10.187157658946392, 63.62232510107243],
            [10.18724636524572, 63.62237304648271],
            [10.187294585527306, 63.62239984705159],
            [10.187412862578645, 63.62246416391732],
            [10.187538350950677, 63.62253483838141],
            [10.18766216721689, 63.62260464717839],
            [10.187831249646916, 63.622691263999926],
            [10.187976675443423, 63.62276359629279],
            [10.188125325039765, 63.62282884160381],
            [10.188337769873684, 63.6229125056648],
            [10.188549653110838, 63.62298517820434],
            [10.18876710805672, 63.623050032905404],
            [10.189053910946592, 63.62312440844227],
            [10.189255246311442, 63.623177029807884],
            [10.189514465011866, 63.62324598226076],
            [10.189763163856181, 63.62331736943898],
            [10.189992085349546, 63.62339690671046],
            [10.190190393534794, 63.623467412553204],
            [10.190420261005626, 63.6235425738897],
            [10.190583239858597, 63.62359489630686],
            [10.190845935745266, 63.62367916212204],
            [10.191138215935778, 63.62376900612928],
            [10.191386165955095, 63.62384486201074],
            [10.19151742751787, 63.62388155010796],
            [10.191657362305119, 63.623926713105654],
            [10.191882459317116, 63.62400620881928],
            [10.19203046237787, 63.62406342362899],
            [10.192241807359686, 63.62414056905124],
            [10.192443188609412, 63.62421567135624],
            [10.192619864505364, 63.62428266039745],
            [10.192759995749837, 63.62433862122748],
            [10.19298805959212, 63.62442451005813],
            [10.19315325149844, 63.62448769588972],
            [10.193325440549362, 63.62455732164361],
            [10.193478348781838, 63.624622613631786],
            [10.193647707124768, 63.62469583150274],
            [10.193727008787212, 63.624728977464635],
            [10.193810517277377, 63.624762354281984],
            [10.193892522131499, 63.62479028445708],
            [10.1940343090112, 63.6248364962888],
            [10.194202296102235, 63.62488439527365],
            [10.19440100308959, 63.62493952894834],
            [10.194629488994133, 63.6250110391915],
            [10.194951220987425, 63.625118140027105],
            [10.195228615117266, 63.625210084453144],
            [10.195500957163107, 63.62529844147704],
            [10.195766197781817, 63.625380984011066],
            [10.196094426069738, 63.62548200409831],
            [10.196337115589339, 63.6255598329879],
            [10.196411724285262, 63.62559147110433],
            [10.196587142479212, 63.625664798171],
            [10.196778636105083, 63.62575305316638],
            [10.197021698102368, 63.62584483341755],
            [10.19730751979479, 63.62593723554409],
            [10.197673014392594, 63.62604750385769],
            [10.198009305837964, 63.62616308904017],
            [10.19835826822772, 63.62627550008182],
            [10.198614511693812, 63.62636232246806],
            [10.198938898959154, 63.626476607433574],
            [10.199263727556989, 63.626588298217136],
            [10.199538793082363, 63.62667026265528],
            [10.19993261027921, 63.62676978091231],
            [10.200048704675277, 63.626800646773574],
            [10.20016315621894, 63.62683046826151],
            [10.20039070507438, 63.626895731611604],
            [10.200598568514978, 63.62695664852456],
            [10.20081869723672, 63.62701797548649],
            [10.201101243533094, 63.62710477374165],
            [10.201349981197414, 63.6271535665484],
            [10.20160312452366, 63.62720979110648],
            [10.20182046101698, 63.627263738195616],
            [10.202125315208942, 63.62735137044252],
            [10.20237728261252, 63.627414569228364],
            [10.20255735813561, 63.62747365431865],
            [10.20268067366353, 63.62752283655644],
            [10.202784116441437, 63.62756757674601],
            [10.202899204415903, 63.62761639367888],
            [10.203091018122532, 63.62770294132831],
            [10.203297162827422, 63.62779203644797],
            [10.203355735745133, 63.62782232494305],
            [10.20343167138347, 63.62786353663925],
            [10.203553338266696, 63.627933258247424],
            [10.2036401290586, 63.6279820276682],
            [10.203747223350298, 63.628042268222806],
            [10.20387708547483, 63.62811136417814],
            [10.204078093654282, 63.62822609789777],
            [10.204217300912443, 63.62831169440909],
            [10.204391084461921, 63.62842003132646],
            [10.204512716001211, 63.628503151261846],
            [10.20459719334761, 63.6285644336966],
            [10.204685218785592, 63.62864301243131],
            [10.204785230226573, 63.62874519522508],
            [10.204861990513429, 63.628841384411615],
            [10.204870741399919, 63.628872165185875],
            [10.204896340602364, 63.62893606593491],
            [10.204967192240582, 63.629055260973054],
            [10.20504307836426, 63.629168598546016],
            [10.205108053802634, 63.62927590540638],
            [10.205198286412449, 63.62942281878831],
            [10.205309917464264, 63.62957593340286],
            [10.205419847855007, 63.629752284426914],
            [10.205515421804945, 63.62991547455717],
            [10.205588820178404, 63.630055529438145],
            [10.205675980998388, 63.6301871405796],
            [10.205723836688444, 63.63023901405892],
            [10.20573919545769, 63.63026659802552],
            [10.20580764769441, 63.63036412769736],
            [10.20587375716136, 63.63046355761641],
            [10.205950497836211, 63.630583848126875],
            [10.206036309902931, 63.63069832609924],
            [10.206113385576954, 63.63082861054907],
            [10.206191112966684, 63.630967010932345],
            [10.206277689968381, 63.63110210954538],
            [10.206365876464686, 63.63123726186657],
            [10.206433008189592, 63.63134383050302],
            [10.206511199198072, 63.63145436606066],
            [10.206573760093777, 63.63155088894712],
            [10.20658575738698, 63.63161154673292],
            [10.206621180132029, 63.631678383380354],
            [10.206688248675917, 63.631784140312554],
            [10.206808106429493, 63.63193653889062],
            [10.206894441112794, 63.63205993724446],
            [10.206993156368155, 63.63219265279464],
            [10.207100882570591, 63.63235822600656],
            [10.207195656864831, 63.632514282902164],
            [10.207296379156816, 63.632672247193504],
            [10.207399554505844, 63.63281689292616],
            [10.207476680566753, 63.63293377760513],
            [10.207498039495018, 63.632964169875066],
            [10.207540100353041, 63.633038422795586],
            [10.207608813417282, 63.633147651612525],
            [10.207678545806107, 63.63328317562667],
            [10.207759660399063, 63.63340280145641],
            [10.20784037618889, 63.6335116216313],
            [10.207900466559007, 63.633610849181814],
            [10.207963735574634, 63.63372718069244],
            [10.208015851233688, 63.63387362777943],
            [10.208060571152707, 63.633981245450954],
            [10.208097436627401, 63.63407430100116],
            [10.208130449990591, 63.63421291513569],
            [10.208171098583158, 63.63431949740747],
            [10.208214966965889, 63.63441899235553],
            [10.20825781931126, 63.63450055617367],
            [10.208288329437133, 63.63453665004853],
            [10.208325036551768, 63.63458275386051],
            [10.208392173898046, 63.63466422935313],
            [10.20847626351806, 63.63477585975781],
            [10.208566286213538, 63.634889486952126],
            [10.20869603868285, 63.635031331600146],
            [10.2088160236192, 63.63517114113842],
            [10.20894541366912, 63.63530317042422],
            [10.209037403239178, 63.635405171299496],
            [10.20915285300319, 63.63553592541734],
            [10.209269672934582, 63.635683722968],
            [10.209396552981632, 63.63581746662905],
            [10.209536054734686, 63.63595073221986],
            [10.209616784213063, 63.63605955148543],
            [10.209666013664588, 63.63611416713494],
            [10.20973547158173, 63.63619392057548],
            [10.209804793970076, 63.63627447886609],
            [10.209911719636688, 63.63639586412159],
            [10.209995067042572, 63.63650117308986],
            [10.210088169340423, 63.636608606364895],
            [10.21019042264898, 63.636721741179855],
            [10.210266823295653, 63.63679632993765],
            [10.210345918102162, 63.63687892289479],
            [10.210428616162142, 63.636976115673214],
            [10.210485167954184, 63.637072435592444],
            [10.210565754870764, 63.63717135649894],
            [10.210645222461366, 63.63726133638333],
            [10.210713257959899, 63.63733996250172],
            [10.210736081554522, 63.63737130235582],
            [10.210816620012507, 63.637469322105844],
            [10.210925162846538, 63.63759435776845],
            [10.211027372752046, 63.63770659100634],
            [10.211132384758997, 63.63781541019724],
            [10.2112109817264, 63.63789978462852],
            [10.211284219100955, 63.63798236129313],
            [10.211353097145086, 63.638065601836686],
            [10.211429266207555, 63.63815358243],
            [10.211498762636538, 63.63824394840605],
            [10.21156023532702, 63.63832433355411],
            [10.211622881038394, 63.63839657370441],
            [10.211678966749574, 63.63845375558294],
            [10.211754007793736, 63.638530456400396],
            [10.21184616846959, 63.63863156129914],
            [10.211931253906434, 63.63873863555372],
            [10.212010241658792, 63.63883390462231],
            [10.21209012058225, 63.63892389719263],
            [10.21216781879466, 63.63900284484338],
            [10.212263488303998, 63.63909516289262],
            [10.212329722571495, 63.639170130504226],
            [10.212397534690878, 63.63925972022461],
            [10.212467287053954, 63.63936178569517],
            [10.212537930494975, 63.63945857467362],
            [10.21258884581822, 63.63956558754464],
            [10.212625697571115, 63.63965765160635],
            [10.212642505685375, 63.63968870041739],
            [10.212669104492472, 63.63972286387046],
            [10.212720324928833, 63.63980290629855],
            [10.212792730097041, 63.63990245193198],
            [10.212844082107052, 63.6399805201145],
            [10.212881725919848, 63.64005831080977],
            [10.212918629411151, 63.64015127583177],
            [10.212946415356997, 63.64025032206],
            [10.212986753687085, 63.64034690911323],
            [10.213034269095719, 63.64043573135184],
            [10.213065742641318, 63.640524917758334],
            [10.213096764414034, 63.64060599491936],
            [10.213119805718994, 63.640684017853715],
            [10.21314615070846, 63.64076763703307],
            [10.213166949072583, 63.64084936240472],
            [10.213205615436214, 63.640930694542035],
            [10.213240510231183, 63.641012800200045],
            [10.213273429026371, 63.64109223180973],
            [10.213305288857805, 63.64114437774198],
            [10.213320071845823, 63.64117544881161],
            [10.213335036553854, 63.64126777175261],
            [10.213356351593363, 63.64138000230972],
            [10.213372389912161, 63.641440793829815],
            [10.213403313751535, 63.64150927669231],
            [10.213449256632883, 63.641620619963085],
            [10.21347288728595, 63.6417095445978],
            [10.213501814374593, 63.64178866309719],
            [10.213543649155275, 63.641901578052206],
            [10.213568387289875, 63.64198154608836],
            [10.21360152495994, 63.642050102722905],
            [10.21363055408545, 63.64211663366877],
            [10.213663260193904, 63.6421745635464],
            [10.21370863433766, 63.64224253899992],
            [10.213759509878383, 63.64232346870668],
            [10.213787684922329, 63.64238547436312],
            [10.213824494829241, 63.642455052752325],
            [10.213834917494037, 63.64252435090028],
            [10.213875921187734, 63.6425926598614],
            [10.213914255905538, 63.642653205630054],
            [10.213952825983881, 63.64273633293346],
            [10.213986366634858, 63.64282648728466],
            [10.21405325158084, 63.64292045175066],
            [10.214104848524586, 63.64299951670086],
            [10.21413502107516, 63.64307247100971],
            [10.21415272151125, 63.64313421715474],
            [10.214165141897073, 63.64318049824822],
            [10.214191981026868, 63.6432372429941],
            [10.214211995732244, 63.6432864754014],
            [10.214229511298155, 63.64332654102037],
            [10.214250381844534, 63.64335871430482],
            [10.214267786956663, 63.64339643792211],
            [10.214297303085731, 63.64342952906604],
            [10.214306605810922, 63.64347031006493],
            [10.214311179829629, 63.64353791387331],
            [10.214325108365767, 63.6436112257436],
            [10.214344467614197, 63.64371349792406],
            [10.214362706188508, 63.64379603695583],
            [10.214367496631922, 63.6438635580391],
            [10.214369455773536, 63.64392387983636],
            [10.21437201901808, 63.64396983217573],
            [10.21436407009921, 63.64402892420782],
            [10.214357428741922, 63.64408985854515],
            [10.214354896819893, 63.64414202635727],
            [10.214359888450247, 63.644209554148006],
            [10.214351536043557, 63.6442938145312],
            [10.21436948861766, 63.6443672605758],
            [10.21438820999454, 63.64446132737194],
            [10.214411376904176, 63.64457460863157],
            [10.21443194394773, 63.64468051844856],
            [10.214462971957461, 63.64480836149941],
            [10.214520037035877, 63.64498572761149],
            [10.2145323706282, 63.64510566250676],
            [10.214538553409312, 63.64521289132912],
            [10.214552380029515, 63.645359946438006],
            [10.214561463635551, 63.645508732018534],
            [10.214574085158635, 63.64560178593438],
            [10.214565397778049, 63.64562928616607],
            [10.21457287405388, 63.64571686234596],
            [10.214567051335132, 63.64581011064864],
            [10.214571373661194, 63.64590558587283],
            [10.214574186360117, 63.64602079645654],
            [10.214584292215877, 63.64614074697663],
            [10.214589619584247, 63.64626503490674],
            [10.214598619155307, 63.646379552432826],
            [10.214603932736313, 63.646467955837146],
            [10.214599770463872, 63.64654057445752],
            [10.214592589559455, 63.64663107942273],
            [10.21459029288134, 63.64671662095398],
            [10.214597950499769, 63.64680312394608],
            [10.214600462648837, 63.64688414920218],
            [10.214613889277814, 63.64698442473469],
            [10.214612527111834, 63.64710039545009],
            [10.214626054517971, 63.64719887563743],
            [10.214646506875086, 63.647342644147976],
            [10.21465116117455, 63.647446944048234],
            [10.214665342837337, 63.64754274798818],
            [10.214667840063926, 63.647623862671416],
            [10.214674527440925, 63.647704127779804],
            [10.214682673079063, 63.64779973045528],
            [10.214693611844007, 63.64785540519234],
            [10.214689459131021, 63.6479393559364],
            [10.214680653705381, 63.6480155070754],
            [10.2146739601106, 63.64811511172271],
            [10.214688358394676, 63.64821083293487],
            [10.214713255467421, 63.648289906481395],
            [10.214741558389322, 63.64836198871331],
            [10.214765997459345, 63.64842539828767],
            [10.214856461346582, 63.64848444392769],
            [10.214972558518504, 63.648563859996415],
            [10.215119189950503, 63.64866497896588],
            [10.215360276519707, 63.64882149881799],
            [10.21556215905232, 63.648954947078124],
            [10.215745300187061, 63.64908075536174],
            [10.215897988694275, 63.64919637494695],
            [10.216023835743469, 63.649288795820766],
            [10.216126658972083, 63.64936417094964],
            [10.216288822683866, 63.6494692237401],
            [10.216491805590707, 63.649597400982344],
            [10.216617520521725, 63.649690626250354],
            [10.21664891186772, 63.64972045157497],
            [10.216788798938797, 63.649816037609504],
            [10.216974481264183, 63.64994004009895],
            [10.217115241002007, 63.650040061644575],
            [10.217266782773333, 63.65014934585092],
            [10.21748440019043, 63.65029878403056],
            [10.217719038954524, 63.650454095103214],
            [10.217890658638545, 63.650577537710966],
            [10.218069343288837, 63.65070589205732],
            [10.218194916449724, 63.650789218145505],
            [10.218339119960048, 63.650882068293186],
            [10.2185113670637, 63.65098862320848],
            [10.218629511934035, 63.65106801407329],
            [10.218750746947679, 63.65115308370754],
            [10.218783985365981, 63.65117797862116],
            [10.218878399117626, 63.65121210606424],
            [10.219012022068137, 63.65125972560912],
            [10.219154787116262, 63.651313135535034],
            [10.219304576499459, 63.651372894817165],
            [10.219436627327507, 63.651428645614],
            [10.219570304107442, 63.65148795787685],
            [10.21972340282433, 63.65156410504891],
            [10.219912778803486, 63.65166754118161],
            [10.220134105573846, 63.65179272596071],
            [10.220334166362681, 63.65190362209746],
            [10.220488715777224, 63.651995195449956],
            [10.220667785606478, 63.652108180060274],
            [10.220872834409635, 63.65223632896892],
            [10.221055075981342, 63.65234492189864],
            [10.221264336463996, 63.65245891080633],
            [10.221494027231241, 63.65258617032128],
            [10.221676456612418, 63.65268046902595],
            [10.221894960453184, 63.65280088012781],
            [10.222074830023224, 63.652910381890045],
            [10.222204848759617, 63.65297946239729],
            [10.222354239081566, 63.65305368425517],
            [10.222451456803908, 63.653125270124406],
            [10.222402547953646, 63.65316330331027],
            [10.222331079751642, 63.65320310377776],
            [10.222248478778083, 63.65324891900352],
            [10.222178706074077, 63.653290664461416],
            [10.222114819863025, 63.65333350516928],
            [10.222029806303876, 63.653393629482565],
            [10.221964299205656, 63.653458090366534],
            [10.221896658716336, 63.653523199689026],
            [10.221823018110884, 63.65359989066417],
            [10.221755912144369, 63.65364981881706],
            [10.221688209783677, 63.65368767588227],
            [10.221621086109794, 63.65372690119973],
            [10.221569984051582, 63.65375272000118],
            [10.221618495659376, 63.65380469816004],
            [10.221663479172575, 63.65384999364279],
            [10.222336325424957, 63.654145790321046],
            [10.223062424732499, 63.654470335933205],
            [10.223648200029505, 63.65474254330034],
            [10.223976690539843, 63.65488297822902],
            [10.224495065813187, 63.65512047299133],
            [10.22477212225943, 63.65524309659509],
            [10.22522997736994, 63.65546868239707],
            [10.225821038141628, 63.65581669018786],
            [10.226151646985816, 63.65600476510075],
            [10.226449125026338, 63.656161249827946],
            [10.226539267089287, 63.65622810040569],
            [10.226825270280438, 63.656366215883054],
            [10.227160511482966, 63.65652926065702],
            [10.227364978542656, 63.65663597510434],
            [10.228273232192262, 63.65703579603935],
            [10.228396276655378, 63.65707316140303],
            [10.22926516763176, 63.6573835318949],
            [10.229958942886801, 63.65761604131012],
            [10.230622396575022, 63.657799065496015],
            [10.231467748910763, 63.65804388728204],
            [10.231633142285045, 63.658119529073],
            [10.232174757375917, 63.658329076056816],
            [10.232716552024641, 63.65857370082093],
            [10.233018964259854, 63.65871324681146],
            [10.233570286825342, 63.65893740972546],
            [10.233853603119876, 63.65913036973824],
            [10.234138565954852, 63.65932680122053],
            [10.234453626437723, 63.65954770369755],
            [10.23485183572271, 63.6597075124865],
            [10.235242848856279, 63.659860785901564],
            [10.235949598971072, 63.6601612340425],
            [10.236719886805837, 63.6604799742993],
            [10.237150547914846, 63.66066243665257],
            [10.237322317358423, 63.66073765310038],
            [10.237956590022069, 63.66112031300777],
            [10.238281843264046, 63.66129289010779],
            [10.238450639305604, 63.66136054197668],
            [10.238803335526091, 63.661563795686966],
            [10.238900722718471, 63.66163357557005],
            [10.239210399951661, 63.66177964313207],
            [10.239555598730915, 63.66192877628846],
            [10.24123812415634, 63.66269852846555],
            [10.241882124918147, 63.663012962227796],
            [10.242212785191931, 63.663159627951856],
            [10.244652292007839, 63.66433537151573],
            [10.244936222906597, 63.66447112964354],
            [10.245018238292227, 63.66451080789461],
            [10.24555631381387, 63.66474392373255],
            [10.245722168520961, 63.66487999721765],
            [10.245891142460481, 63.66496491226141],
            [10.246004284196186, 63.66502180826687],
            [10.246635298385064, 63.665340644415586],
            [10.24726204721876, 63.665658436929874],
            [10.247938814332707, 63.66600522105296],
            [10.24856409619756, 63.666304162760596],
            [10.249210928122208, 63.666636459750556],
            [10.249911893883166, 63.66698772117243],
            [10.25059692268202, 63.66733269598514],
            [10.251569667151598, 63.667822124119844],
            [10.252388317047256, 63.667885299382334],
            [10.253343157485096, 63.66798701079588],
            [10.254185455015955, 63.66811997985932],
            [10.254989004873156, 63.6682788228463],
            [10.25574503327895, 63.668491758837874],
            [10.256498675922169, 63.66874319240042],
            [10.257308349605962, 63.6689381965133],
            [10.25812483918156, 63.669128834333954],
            [10.25900327621501, 63.66926395625956],
            [10.259868087904136, 63.66937164347667],
            [10.260722241626976, 63.669506762345755],
            [10.26156305054177, 63.66966238957765],
            [10.26238722523042, 63.669842463750754],
            [10.263211635591894, 63.67003692966792],
            [10.263618353031456, 63.67012219879655],
            [10.264527564904835, 63.67023222047564],
            [10.266067500265107, 63.67053029940867],
            [10.266460028069293, 63.67067633522114],
            [10.266714317549718, 63.67080261556911],
            [10.26739374987753, 63.671074924101774],
            [10.268101156268594, 63.67138592164689],
            [10.26903011184831, 63.671775123796046],
            [10.273063180830793, 63.67291104676364],
            [10.274438202950037, 63.6732976692992],
            [10.275096418085603, 63.673482457403466],
            [10.27617411354843, 63.6737864372673],
            [10.27779845869601, 63.67424444591492],
            [10.27801064021167, 63.67430430049629],
            [10.281892781358781, 63.67539538162579],
            [10.284606196473883, 63.67616534041642],
            [10.286460059341033, 63.676685455541104],
            [10.286603254140465, 63.67672558645824],
            [10.289645614868531, 63.6775808779255],
            [10.293562610117707, 63.67868796192138],
            [10.296393428518606, 63.67948760777578],
            [10.300288832315927, 63.680603320564586],
            [10.301970271850243, 63.68107207669489],
            [10.303186720171265, 63.681411132167504],
            [10.306478819333083, 63.68234201177029],
            [10.307042221561645, 63.682504211015925],
            [10.310045040898572, 63.68333994220345],
            [10.312746143553174, 63.684097598470025],
            [10.314347047825128, 63.68453389609728],
            [10.315343200315953, 63.68477937180518],
            [10.315474696012949, 63.68478599735241],
            [10.315571470605219, 63.68479279467104],
            [10.315668632018989, 63.6848000092058],
            [10.315734347786144, 63.68480565889537],
            [10.315808443410221, 63.684810862343454],
            [10.31587622772559, 63.68481747867471],
            [10.315969570539565, 63.68482879506858],
            [10.316058981365536, 63.68484061270232],
            [10.316140210484795, 63.684850454945256],
            [10.316221493181068, 63.68486119815548],
            [10.31630927065607, 63.684876154782955],
            [10.316384579206888, 63.68489178401044],
            [10.316449179880916, 63.684905400497456],
            [10.316513789754804, 63.68492018630184],
            [10.316601801063936, 63.68493924203256],
            [10.316663954364106, 63.684952958494776],
            [10.31673024479139, 63.68496860831698],
            [10.316826517899267, 63.6849879332025],
            [10.316931167501007, 63.68500438361129],
            [10.317019712001573, 63.68502021908902],
            [10.31712190861074, 63.6850380282285],
            [10.317243637560887, 63.68506267883839],
            [10.317349045158961, 63.68508679740492],
            [10.317433027543654, 63.68510572129116],
            [10.317532390431655, 63.685129642713164],
            [10.317644970963995, 63.68515939041763],
            [10.317726589314427, 63.68517913634662],
            [10.317825562488482, 63.68520664191987],
            [10.31796503737479, 63.685245269260236],
            [10.31809857111797, 63.685283073371195],
            [10.318197269559404, 63.68531101935107],
            [10.318358748095559, 63.68535135246937],
            [10.318487413567155, 63.68538674939957],
            [10.318573941199226, 63.68541479313448],
            [10.318706685272835, 63.685457381983746],
            [10.318839640531174, 63.68549624562742],
            [10.318964504581887, 63.68552891037547],
            [10.319107445189136, 63.685562523626004],
            [10.319323053754063, 63.685612442676174],
            [10.319484043903701, 63.68565329809583],
            [10.319687356459788, 63.68570407498223],
            [10.319856613181775, 63.685747627253214],
            [10.31998336152089, 63.6857811617748],
            [10.320114330801337, 63.68581735160105],
            [10.32025513579614, 63.68586267444823],
            [10.320403993932063, 63.68590340340264],
            [10.320556951099018, 63.68594507502854],
            [10.320710149105926, 63.6859877435147],
            [10.320822976837697, 63.68601848580189],
            [10.320925534955379, 63.68604394760546],
            [10.321026279679634, 63.68606935027838],
            [10.321193418234468, 63.68611103336291],
            [10.321376765188862, 63.686156391448485],
            [10.321598255719119, 63.68620631854907],
            [10.321811736394869, 63.686254455746536],
            [10.321973177279293, 63.68629262508179],
            [10.322164468887324, 63.686338960174055],
            [10.322307311132606, 63.68638057028422],
            [10.322389699150817, 63.686410410199024],
            [10.32243497423062, 63.686447015632865],
            [10.322522312815854, 63.68648082320752],
            [10.322608586610395, 63.68650431478834],
            [10.322737814914552, 63.68653513973074],
            [10.322904890276586, 63.686576009299486],
            [10.323029818945036, 63.68660588466819],
            [10.323170780296705, 63.68663682133369],
            [10.323309686545393, 63.68667038875011],
            [10.323412450818953, 63.68669585537394],
            [10.323524222392532, 63.686727505246296],
            [10.323593709540853, 63.68674653805337],
            [10.323948508101594, 63.686801429417024],
            [10.324029071896875, 63.68682761190386],
            [10.324117578259605, 63.68685477222284],
            [10.32421631244199, 63.68688379406027],
            [10.324345060875615, 63.68691999742376],
            [10.324473863423732, 63.686957101685955],
            [10.3246328797601, 63.68700876779466],
            [10.324787747042235, 63.68706470509217],
            [10.324892477456347, 63.68709913724726],
            [10.325000878666929, 63.6871371059451],
            [10.325153890477855, 63.68718956525114],
            [10.325302790190772, 63.68723748421958],
            [10.325449578130556, 63.68728101786795],
            [10.325636720127985, 63.687341511272756],
            [10.325775606546621, 63.687381370323976],
            [10.325918498492692, 63.68742396738378],
            [10.326069577450612, 63.6874746541647],
            [10.326190091992183, 63.68751535399227],
            [10.32626853609595, 63.687543354618924],
            [10.326320857378306, 63.68755614703259],
            [10.331145037645548, 63.68908953092396],
            [10.33182080725482, 63.68930419655564],
            [10.33430202084121, 63.69009950788002],
            [10.335930310321297, 63.690607118670776],
            [10.338024069814775, 63.691278457061465],
            [10.339005854573731, 63.691593118344215],
            [10.33919689932371, 63.691657316239926],
            [10.347023373387294, 63.69412046857374],
            [10.347621614275312, 63.694308893744775],
            [10.352092776494322, 63.6957799414917],
            [10.35572341670822, 63.69691326510792],
            [10.356673232199727, 63.69721507288129],
            [10.356734320639088, 63.697234311721026],
            [10.356798564344372, 63.69725778894871],
            [10.356869179033797, 63.697279493638575],
            [10.356931503683581, 63.69729490560942],
            [10.356983906015799, 63.697310266794446],
            [10.357036146954334, 63.697326611904565],
            [10.357098467072046, 63.697348228377294],
            [10.357179150563708, 63.697374034944],
            [10.357236529764975, 63.697396121213245],
            [10.358232408115422, 63.697706419810494],
            [10.362099253647713, 63.698912572025066],
            [10.364054709552248, 63.699522296567324],
            [10.364417029458503, 63.69966131274878],
            [10.364772814623699, 63.6998154940267],
            [10.365790521838521, 63.700255839027626],
            [10.374160523595451, 63.70399301988919],
            [10.383397757958448, 63.708414474660145],
            [10.384592519222595, 63.70898597685846],
            [10.393878906602131, 63.71342875723015],
            [10.397268017360586, 63.715030135435036],
            [10.398837019360789, 63.715833697818205],
            [10.4004476605147, 63.716658579882875],
            [10.400518802480102, 63.716694979915566],
            [10.401411572917063, 63.7171522693202],
            [10.402428880855815, 63.7176732406976],
            [10.405294000932885, 63.71914021860189],
            [10.408136933022702, 63.720595723307234],
            [10.410539721724492, 63.72182554086837],
            [10.41124218893813, 63.72218506119085],
            [10.411893548197542, 63.7225183994399],
            [10.412591165975593, 63.72287550966025],
            [10.413270260298937, 63.72322312339223],
            [10.414077879877945, 63.723636335878986],
            [10.414886992318463, 63.72405049002769],
            [10.415820884576405, 63.72452841182992],
            [10.416956567212004, 63.7251094189116],
            [10.417939605590538, 63.72561244976081],
            [10.419183335141149, 63.72622826031932],
            [10.419917884098922, 63.72704581062908],
            [10.421390103526207, 63.728683693718864],
            [10.421986342282988, 63.7293388416819],
            [10.422332390358449, 63.729718788398955],
            [10.42318878405163, 63.730659515968995],
            [10.42381841318775, 63.7313507845973],
            [10.425006341024208, 63.73265560178294],
            [10.428155501823696, 63.73387815040658],
            [10.435901140515178, 63.736919769285976],
            [10.43958956032461, 63.73836775496582],
            [10.443587771088302, 63.73994836212497],
            [10.443577238097218, 63.7399922676445],
            [10.44341335324822, 63.740659655604304],
            [10.443237742665218, 63.741375766793006],
            [10.442806409999722, 63.7431331989047],
            [10.441981201544033, 63.746145804657004],
            [10.4417361101385, 63.747986013174625],
            [10.441247159284611, 63.75058557949505],
            [10.4412312857651, 63.75067256586626],
            [10.441073324984254, 63.75153633976993],
            [10.44105914323521, 63.75159901225698],
            [10.440971871268783, 63.75198100251816],
            [10.440864006874925, 63.752427620234585],
            [10.440782603249808, 63.752875075982864],
            [10.440678886876958, 63.75332614107337],
            [10.440585415625732, 63.75376278427096],
            [10.440481664220831, 63.75421025156773],
            [10.440382253348796, 63.75465596807824],
            [10.440273636282823, 63.755019119047695],
            [10.440255396146846, 63.75507923523273],
            [10.440220749546947, 63.75519440041584],
            [10.440186096853552, 63.755334742134025],
            [10.44004564321767, 63.75598416918987],
            [10.439980336456426, 63.75642359268958],
            [10.43987478869706, 63.756871992141384],
            [10.439789184949971, 63.757311312269664],
            [10.439703532702605, 63.75775971247361],
            [10.439625584836914, 63.75820691804343],
            [10.43957790313626, 63.75833232548271],
            [10.439341897944127, 63.75841535128757],
            [10.438716483181075, 63.75875772471951],
            [10.438194530568365, 63.75908062488881],
            [10.438070077021015, 63.759162012947705],
            [10.438018781898784, 63.75920669495179],
            [10.438014557859743, 63.75923722282491],
            [10.438040537025591, 63.75928570200036],
            [10.438080564027906, 63.75932077904237],
            [10.438147132301802, 63.75936128277156],
            [10.438336566029246, 63.759468441279125],
            [10.438586058616401, 63.759624978389986],
            [10.438646654179799, 63.759660976618555],
            [10.438713020176609, 63.75970776782745],
            [10.438714844165181, 63.759739206638805],
            [10.438629313177383, 63.75978208494363],
            [10.438588516731013, 63.75980704826379],
            [10.438482293527462, 63.75987867381238],
            [10.438433157355153, 63.759941407777184],
            [10.438434465152124, 63.760008707130694],
            [10.438454225867819, 63.760053572340595],
            [10.438449734056906, 63.76008764345521],
            [10.43831338043684, 63.76015467270606],
            [10.438254248777975, 63.76019128376794],
            [10.438192961076275, 63.76024500065125],
            [10.438123174250961, 63.76033684280578],
            [10.438098290732716, 63.760382091933955],
            [10.438042927610311, 63.760458205987284],
            [10.43799382309101, 63.76050565495438],
            [10.437908286657215, 63.76055482693157],
            [10.437720996116399, 63.7606316162953],
            [10.437574454051703, 63.76070133434243],
            [10.437519172053802, 63.760744271412726],
            [10.437470163610174, 63.76080242340998],
            [10.437465533892617, 63.76083482668815],
            [10.437475465497345, 63.76087515449262],
            [10.437527244345082, 63.760950617127776],
            [10.43751279889759, 63.760984687552494],
            [10.437316896280816, 63.76111973961672],
            [10.437216674662535, 63.761218259977916],
            [10.437130619240559, 63.76129699785535],
            [10.436889807414998, 63.76147234783155],
            [10.436750837498543, 63.76158060985457],
            [10.436518401800539, 63.761731767310515],
            [10.436367391075999, 63.761839107912785],
            [10.436297689795685, 63.76190712407558],
            [10.436211296036086, 63.76202811185752],
            [10.436156076362488, 63.76208444814739],
            [10.436080764343707, 63.762138169399876],
            [10.436000844584385, 63.762199027862735],
            [10.43599048267459, 63.76223044019265],
            [10.436084119244471, 63.76238491854866],
            [10.436124272462688, 63.76243429691264],
            [10.436131973398192, 63.76249091906231],
            [10.436118903486202, 63.76253069778346],
            [10.43608054788743, 63.76258574056479],
            [10.436051677712149, 63.76262567757752],
            [10.436043625948372, 63.76265536479103],
            [10.436089319290822, 63.76269435348654],
            [10.436168484085858, 63.76270473037345],
            [10.436229165386637, 63.76271384701523],
            [10.436284309043396, 63.76276599331496],
            [10.436212004061332, 63.76282246253306],
            [10.436136361194649, 63.76286817074332],
            [10.436076205622973, 63.76291733706106],
            [10.436015783025256, 63.762984478330495],
            [10.435980755058797, 63.76304280334876],
            [10.435957894795402, 63.7631037619585],
            [10.435907476158166, 63.76327858140031],
            [10.435898526982095, 63.76335023149356],
            [10.43585803154322, 63.7635440682353],
            [10.435816187704456, 63.763678426975616],
            [10.435795644390728, 63.763718778063506],
            [10.435753886380523, 63.76381744239253],
            [10.435704450457077, 63.764126809091806],
            [10.43569072000841, 63.764275726342916],
            [10.43568599158723, 63.76433132512879],
            [10.435687577716694, 63.76437174822503],
            [10.435679184044835, 63.76442363414674],
            [10.435657505560895, 63.764699532306764],
            [10.435662199856571, 63.76476469123306],
            [10.435672822939456, 63.764840918060614],
            [10.435688058405999, 63.76493509468539],
            [10.43574297840032, 63.76510291248013],
            [10.435818518325673, 63.76526005422309],
            [10.435856028614468, 63.76532076828141],
            [10.435894015133679, 63.76538230667433],
            [10.435963788736583, 63.76552236111315],
            [10.435972804096169, 63.76555955784181],
            [10.435978234655858, 63.76559003204205],
            [10.435976591731643, 63.76563786086373],
            [10.43601596849444, 63.76576364412408],
            [10.436112775243956, 63.76622133335218],
            [10.436209432958547, 63.766661124193874],
            [10.436346904120867, 63.767109851220575],
            [10.43648418058946, 63.76754975995327],
            [10.43660150145365, 63.768007559029336],
            [10.436738565852119, 63.76845636237144],
            [10.436855724085271, 63.768905164167535],
            [10.43679354695945, 63.76903959831449],
            [10.436667607703555, 63.769487800955226],
            [10.436541512142096, 63.76991810511491],
            [10.436415333340555, 63.77036647994892],
            [10.436248532963218, 63.77081473649748],
            [10.436122391870366, 63.77125403082671],
            [10.435996181614435, 63.771711306365745],
            [10.435849899300427, 63.77215949360869],
            [10.435755779295604, 63.772478684174416],
            [10.435662144046674, 63.772528678111584],
            [10.434930210854192, 63.772915503809784],
            [10.434041988057103, 63.77338396221491],
            [10.432465904418564, 63.77416473770259],
            [10.429061487600318, 63.77598448480754],
            [10.427966768824986, 63.77655335961566],
            [10.424354651353159, 63.77848834563948],
            [10.41759153538654, 63.78205182977422],
            [10.415361819325419, 63.78322041891789],
            [10.424667987327101, 63.78614510093479],
            [10.425116827507626, 63.786285597870524],
            [10.430518341165795, 63.78797624893774],
            [10.433255715271388, 63.788809075614],
            [10.436020433314939, 63.78966860852035],
            [10.437611102111479, 63.78766590726412],
            [10.438849183930232, 63.786248990399955],
            [10.439776354324943, 63.78513720402828],
            [10.440029830073113, 63.78483321525899],
            [10.440347591741785, 63.7844522238251],
            [10.440518802791486, 63.78424705707045],
            [10.440840264586166, 63.783861955865305],
            [10.442669533438462, 63.781670296995465],
            [10.444661316706647, 63.77924332390783],
            [10.447098937366615, 63.77629578114013],
            [10.451273140598296, 63.77124184112527],
            [10.460795523084718, 63.78089335491925],
            [10.464308504437499, 63.784411952911306],
            [10.470849394797632, 63.791100270155816],
            [10.483412761547276, 63.803531727653045],
            [10.490837633420451, 63.810871768682176],
            [10.503527746956713, 63.8233011367295],
            [10.508872291558678, 63.82768143308665],
            [10.51281629643882, 63.832512898231016],
            [10.518558078210793, 63.83771322666186],
            [10.523421173068531, 63.84286237517547],
            [10.571803316610705, 63.86966067918458],
            [10.611410084680896, 63.90798544379466],
            [10.61424216120843, 63.908916287864265],
            [10.628042527991434, 63.91340481385825],
            [10.63813036144608, 63.91668401218327],
            [10.64444138772106, 63.918734805078834],
            [10.650602074604214, 63.92073618979248],
            [10.655698994339458, 63.922391595819626],
            [10.663620054063166, 63.92496333586119],
            [10.669893775554383, 63.92699976694352],
            [10.673591351014919, 63.9281996059092],
            [10.686319742546761, 63.932328508855406],
            [10.696198432288373, 63.93553265080715],
            [10.699274610911024, 63.936529640038735],
            [10.703116746190153, 63.9377739553429],
            [10.705284328286009, 63.93847710274083],
            [10.70777353968174, 63.93928378604677],
            [10.711541342311607, 63.940504440362744],
            [10.714621207127117, 63.94355673834252],
            [10.717090792710097, 63.946014130698615],
            [10.723127742001495, 63.950371664205036],
            [10.726518598226303, 63.9528215576779],
            [10.730020921748483, 63.95535141517974],
            [10.736249853680999, 63.95985905807635],
            [10.734397634497608, 63.96038171665465],
            [10.734597088517152, 63.9604738901487],
            [10.738131631982588, 63.9621062434145],
            [10.74073733803307, 63.96339637894949],
            [10.741297781638476, 63.96374546699142],
            [10.74251651871274, 63.96433855027911],
            [10.74307181118797, 63.964588686304396],
            [10.744560571205014, 63.96515381996223],
            [10.745893134773466, 63.967152549063265],
            [10.74668991213723, 63.96877595665521],
            [10.747210887605105, 63.969249888619686],
            [10.748215570904412, 63.97017813380864],
            [10.749984287644716, 63.972135858954815],
            [10.750246290891281, 63.97243120279613],
            [10.750950957293309, 63.97385411114838],
            [10.751078353378412, 63.97409156891331],
            [10.751670255281388, 63.9750438124062],
            [10.753469941063239, 63.975995504105796],
            [10.753840154243047, 63.97716596880348],
            [10.753866755529648, 63.97720639105447],
            [10.754035766045698, 63.977178174178476],
            [10.754300903513851, 63.977169134682434],
            [10.754498771347011, 63.97716783178354],
            [10.754672640178539, 63.977173646002164],
            [10.754943358065537, 63.97718175852746],
            [10.755195280275075, 63.97717754392902],
            [10.75533487149259, 63.977157093252856],
            [10.755418847648098, 63.977120180782094],
            [10.755530813874282, 63.9770997295867],
            [10.755642779297542, 63.97709141375372],
            [10.755745060313007, 63.97709971388247],
            [10.755847937861375, 63.97713239223945],
            [10.755969260067305, 63.97714466593265],
            [10.756053124514269, 63.977165101149296],
            [10.756118369084872, 63.97718148507328],
            [10.756192997961476, 63.97721423458652],
            [10.75632367748024, 63.9772551880454],
            [10.75647280142963, 63.977279781881656],
            [10.756659410708084, 63.977296034806436],
            [10.756846020293938, 63.97730419719019],
            [10.757004611420827, 63.97730012243183],
            [10.757116359945222, 63.977295934143065],
            [10.7572096647889, 63.97729596991975],
            [10.757321793610105, 63.977300062696955],
            [10.757433501616733, 63.977320413557464],
            [10.757610862970314, 63.97734906922157],
            [10.757843895190033, 63.977369556542754],
            [10.75813314292692, 63.97742279214395],
            [10.758245029242124, 63.97745950795054],
            [10.758385137864781, 63.97748419536817],
            [10.758627597657567, 63.97750864298447],
            [10.758813979416548, 63.97753315648629],
            [10.758972874451834, 63.977590484765365],
            [10.759159369269657, 63.97766417209572],
            [10.759345838876078, 63.977750173642434],
            [10.759560776986326, 63.977836019362016],
            [10.760045967562238, 63.978057241033966],
            [10.760185978796422, 63.97814332001298],
            [10.760307282746526, 63.97829878738664],
            [10.760344765233299, 63.97838492210363],
            [10.760354241226876, 63.97846682135309],
            [10.760345121504496, 63.978532355437274],
            [10.760437721782363, 63.978627474170786],
            [10.760586554809068, 63.978737722086755],
            [10.760782019510017, 63.97886839136833],
            [10.760940280730775, 63.9789745100202],
            [10.76115417942378, 63.979101043693376],
            [10.761256676798626, 63.97913361688434],
            [10.761386788078358, 63.979170323858746],
            [10.761507640274907, 63.97923165990279],
            [10.76177757732987, 63.97939488975708],
            [10.762028893675508, 63.979545978315336],
            [10.762242814465706, 63.979668375789046],
            [10.762373107632756, 63.97971335716347],
            [10.76254990370932, 63.97973371974001],
            [10.762717288826096, 63.97976216680574],
            [10.762866025247728, 63.97979078743081],
            [10.762968512761892, 63.97981940377966],
            [10.763070812000102, 63.979856014916855],
            [10.763219524765583, 63.97989694964476],
            [10.76340567842982, 63.979966306122286],
            [10.76359162927546, 63.98003565640936],
            [10.763824431274866, 63.98011725317213],
            [10.764001163345291, 63.98019478317488],
            [10.764270949958151, 63.980313237363326],
            [10.764540596575582, 63.98040696668606],
            [10.764754802665335, 63.98046410702483],
            [10.764957089738314, 63.980543191774494],
            [10.76514208377283, 63.98061215236352],
            [10.765373325866927, 63.98066898063077],
            [10.765558130720683, 63.980689213853616],
            [10.765770561568631, 63.98070135490508],
            [10.766020039015624, 63.98072968001386],
            [10.766334387735236, 63.98074992226334],
            [10.766657771065432, 63.980774023452895],
            [10.767009143599722, 63.98081871775641],
            [10.767286450647658, 63.98087140525032],
            [10.767434616558521, 63.980907914731574],
            [10.767637851012177, 63.98094836983333],
            [10.767711922341768, 63.98098900704219],
            [10.767748976278796, 63.98105786755911],
            [10.76775816941504, 63.98112285794809],
            [10.767758355269445, 63.98118380979386],
            [10.767721319391285, 63.98123648308316],
            [10.767684460024302, 63.98128934130481],
            [10.767666246075736, 63.98132988967663],
            [10.767666427177645, 63.981415201977235],
            [10.767657415210332, 63.981472019823386],
            [10.76763858226645, 63.98152882047117],
            [10.767601930570788, 63.981593820098716],
            [10.767565083859568, 63.98168308472396],
            [10.76752821891146, 63.98176030335303],
            [10.76749137790547, 63.98182925265957],
            [10.767528402274866, 63.981890201902345],
            [10.767630321104495, 63.9819267085093],
            [10.767722621364111, 63.98195915864529],
            [10.767880012572357, 63.98201993801045],
            [10.76801855904618, 63.98206866068377],
            [10.76816654103051, 63.9821375247959],
            [10.768296080873954, 63.98218220869093],
            [10.768545773602074, 63.98226734675287],
            [10.768666109242458, 63.98235661730394],
            [10.768693947005348, 63.98243365813687],
            [10.768703348086202, 63.9825026995864],
            [10.768721967822378, 63.982559515332944],
            [10.768795842824114, 63.98260419123254],
            [10.768879164150215, 63.98262837802005],
            [10.769008503635126, 63.98267305534997],
            [10.76913805742966, 63.98270955869865],
            [10.769276614415796, 63.98273796490289],
            [10.769378134178652, 63.982750097952],
            [10.769470844459883, 63.982746062954625],
            [10.769535543480835, 63.9827093885482],
            [10.769618439786257, 63.982660660612694],
            [10.769683111325378, 63.98262416512913],
            [10.769784843694032, 63.98259567323032],
            [10.769891024486268, 63.98261216689467],
            [10.770020031241762, 63.982668519442505],
            [10.770139186361478, 63.982716943515584],
            [10.770295643504953, 63.98279342374805],
            [10.770461057731357, 63.98284993971116],
            [10.770598832651254, 63.98288623220746],
            [10.770644916052657, 63.982926590117046],
            [10.770654176385998, 63.982974952230535],
            [10.770626578695321, 63.98301531689545],
            [10.770544115935424, 63.98303142751829],
            [10.770433991685989, 63.983039629258876],
            [10.770360515963558, 63.98304368700514],
            [10.770259226948646, 63.98306383238345],
            [10.770176550242502, 63.98308811666668],
            [10.770149167207656, 63.98312435252501],
            [10.770185847498443, 63.983188976414866],
            [10.770277981951434, 63.9832293303536],
            [10.77040657909532, 63.98327353519617],
            [10.770480068712427, 63.98329779356689],
            [10.770526169951617, 63.98334615234469],
            [10.770563072523275, 63.983418782922215],
            [10.770563151359646, 63.98349941768048],
            [10.770535785555596, 63.983572060071154],
            [10.770480579024518, 63.983632563523756],
            [10.770343097596344, 63.98370927289],
            [10.77021462205522, 63.983785975355914],
            [10.770095356248023, 63.98386267689437],
            [10.769957686034164, 63.98394738075696],
            [10.769856864192263, 63.984048261960844],
            [10.76982027729808, 63.984133129968264],
            [10.769848011759132, 63.98424198896619],
            [10.769884722540668, 63.984342929885905],
            [10.769921860968745, 63.98442752305765],
            [10.770023024184512, 63.98450832204746],
            [10.770169867068896, 63.984572655889295],
            [10.770319135745737, 63.984652072215574],
            [10.77038043481179, 63.9846879302611],
            [10.770462147299998, 63.98474173312091],
            [10.77050297390906, 63.98477762279119],
            [10.770544208182837, 63.984813524346244],
            [10.770584916925255, 63.9848583097818],
            [10.770584883722902, 63.9849031645449],
            [10.770585126462219, 63.98495701648644],
            [10.77058529703638, 63.985001877196886],
            [10.770564790794078, 63.985046763649585],
            [10.770524028744614, 63.985091598234874],
            [10.770462879130296, 63.98514536621753],
            [10.770422116769131, 63.985190200771626],
            [10.770360939650123, 63.985244147699795],
            [10.770316745333659, 63.98530083759556],
            [10.770316796670665, 63.985353245700594],
            [10.770373394771948, 63.985385011283235],
            [10.77043308727105, 63.98540985564164],
            [10.770486674828772, 63.985423644944426],
            [10.770562151243906, 63.985442927222536],
            [10.770653160543795, 63.98547183171252],
            [10.770741291231728, 63.98550352864654],
            [10.770813672561381, 63.985527035231854],
            [10.770892386870644, 63.985554681816936],
            [10.77094901051049, 63.98558087464056],
            [10.771033843947738, 63.9856194866685],
            [10.771087349923214, 63.985659521584836],
            [10.771125244026955, 63.98572292204996],
            [10.771134733179998, 63.98579142639189],
            [10.77113004802085, 63.98585079764256],
            [10.771117885089033, 63.985898714271876],
            [10.771117938547404, 63.98595247077114],
            [10.77113778137936, 63.98599583804729],
            [10.771159011494857, 63.986042212212816],
            [10.771179611168765, 63.98610492817387],
            [10.771240927766387, 63.986167753625914],
            [10.771281711900071, 63.98622153011204],
            [10.771363706707465, 63.986284329676444],
            [10.77144548459853, 63.986320155503314],
            [10.771547723152562, 63.9863560389619],
            [10.771649844210174, 63.986400818139096],
            [10.77175209686295, 63.98643661196112],
            [10.771834007258784, 63.986490509534306],
            [10.771915741254258, 63.98654422212494],
            [10.772018008804066, 63.98660698351468],
            [10.772120117989173, 63.98665185186724],
            [10.772222241040794, 63.98669663065383],
            [10.772304297730075, 63.98674145318871],
            [10.772365590316081, 63.98677739993296],
            [10.772488029503453, 63.986804253633295],
            [10.77261074552169, 63.98684010440956],
            [10.772733461856612, 63.98687595508402],
            [10.77285607466103, 63.986920611952584],
            [10.773019161423539, 63.98699000074258],
            [10.773097519584402, 63.98707417707183],
            [10.773138063452507, 63.987151227697595],
            [10.77313823579121, 63.98721640373626],
            [10.77314386330328, 63.987269873270044],
            [10.773141302769545, 63.98733146384589],
            [10.773117192807316, 63.98739071794774],
            [10.773084820172988, 63.98744640507488],
            [10.773041027018408, 63.9875126359012],
            [10.773020595641874, 63.98756651393695],
            [10.77300030860619, 63.98761131718468],
            [10.772980007965991, 63.98765620992509],
            [10.772959576357406, 63.987710087949935],
            [10.772959764135877, 63.9877548591753],
            [10.77291893700231, 63.98781771568882],
            [10.772898729256859, 63.98787146540294],
            [10.772898686051008, 63.987916409674675],
            [10.772898860184045, 63.987961270394706],
            [10.77291930571839, 63.988006093165055],
            [10.772939678423691, 63.98804192470062],
            [10.77300126487998, 63.98808677887754],
            [10.7731391334271, 63.988141588584575],
            [10.773236130764944, 63.988191880129314],
            [10.773315839603299, 63.98825497124603],
            [10.773380309785022, 63.98830377465685],
            [10.773421124262487, 63.988350629648615],
            [10.773460119679378, 63.98840003841345],
            [10.77348920601585, 63.98844187700193],
            [10.773512516590683, 63.988481299862826],
            [10.773533094191697, 63.98851713726483],
            [10.77355345449955, 63.988553058216596],
            [10.773581128000536, 63.98859476568511],
            [10.7735946830546, 63.988633724239975],
            [10.77362726458456, 63.98869238444892],
            [10.773675185366992, 63.98874978405267],
            [10.773713850680155, 63.98879055356282],
            [10.773742015038879, 63.98883443268796],
            [10.773751281543486, 63.9888814462375],
            [10.773743866256087, 63.988957547449374],
            [10.77374993922455, 63.989027030507906],
            [10.773769674943276, 63.98908603518513],
            [10.773770586797937, 63.98913550182348],
            [10.77376260714089, 63.9891990917292],
            [10.77374077590377, 63.98927576134784],
            [10.773718471568765, 63.989356911718914],
            [10.77372519385057, 63.98942142476107],
            [10.77372649980907, 63.989494679061245],
            [10.7737281614964, 63.9895486621161],
            [10.773713731038422, 63.98961835627593],
            [10.773706978642918, 63.989690072161174],
            [10.773709069238969, 63.98975746148216],
            [10.773711335029645, 63.989822338963684],
            [10.773702883555107, 63.98989310639135],
            [10.773686752264583, 63.98995915531363],
            [10.773659060796966, 63.99000688892124],
            [10.773625825103133, 63.9900777426139],
            [10.773548026480567, 63.99019056398254],
            [10.773513802852435, 63.99023636948547],
            [10.773436673404223, 63.99029965071645],
            [10.773344442702985, 63.99035449120598],
            [10.773243909840298, 63.990410078319066],
            [10.773061273659435, 63.99048196814087],
            [10.77291978491201, 63.990536270655355],
            [10.772775506131582, 63.99058330038104],
            [10.772646577704162, 63.990623586432974],
            [10.772553999390182, 63.990668528319176],
            [10.772480117075016, 63.99073738718493],
            [10.772449850019983, 63.990802124798954],
            [10.77246707837881, 63.99087633802489],
            [10.772492649337174, 63.9909238272702],
            [10.772527727465356, 63.99096260471516],
            [10.77255928432212, 63.990997593904936],
            [10.772578571051353, 63.99103249485912],
            [10.772596944304507, 63.9910869654177],
            [10.772622130225887, 63.99115053390013],
            [10.772632426185046, 63.99121915142159],
            [10.772613236958549, 63.99129050456237],
            [10.772572371911554, 63.991357629816044],
            [10.772550407303305, 63.99144867803561],
            [10.7725214266774, 63.99150626191247],
            [10.77251439260806, 63.991566283756526],
            [10.772539084186114, 63.991645299090514],
            [10.772571333227486, 63.991702781214855],
            [10.772631977114546, 63.9917755639991],
            [10.772706828883008, 63.991836985423134],
            [10.772780426523788, 63.99189045981024],
            [10.772896459100256, 63.9919638691333],
            [10.773042903401056, 63.99203654725494],
            [10.773210017720354, 63.99211063703622],
            [10.773323186611545, 63.992186749078265],
            [10.773371588193621, 63.992232207167795],
            [10.773382698609534, 63.99229545487231],
            [10.773375815052791, 63.9923544923066],
            [10.773334084509148, 63.99245305437733],
            [10.773269227493806, 63.99253125588767],
            [10.773178289389513, 63.99260321342313],
            [10.773100340087534, 63.99267186417961],
            [10.773096233522267, 63.992740960504676],
            [10.773105644160307, 63.99282762022282],
            [10.773032800058914, 63.9929216189955],
            [10.77299633513509, 63.99295468446179],
            [10.772934108264195, 63.99300060180043],
            [10.772836231689363, 63.9930372094198],
            [10.772735627301275, 63.993081018594744],
            [10.77262708573058, 63.99314886679193],
            [10.772551814782792, 63.99319979700318],
            [10.772438598881998, 63.993270115584146],
            [10.772353561988679, 63.993331457894996],
            [10.77230024603953, 63.993373949383134],
            [10.772242175910309, 63.993420796735066],
            [10.772192062484551, 63.99348135982106],
            [10.772148186063575, 63.993541295804555],
            [10.772085589728489, 63.99361398960473],
            [10.771990427127884, 63.993675935287754],
            [10.77194369868369, 63.99371412427561],
            [10.771901182472604, 63.99375153721514],
            [10.771841749628443, 63.99379385013083],
            [10.771774641545342, 63.99385576011565],
            [10.771745334947699, 63.99393576224274],
            [10.771724895943404, 63.99398964001114],
            [10.771725067881375, 63.994034500692166],
            [10.771725121961447, 63.99408825715507],
            [10.771704610355744, 63.99413314369415],
            [10.771704854693981, 63.99418699559891],
            [10.771725506352164, 63.9942318244742],
            [10.771725501461614, 63.99430355743834],
            [10.771745962887081, 63.99437534809108],
            [10.77182800912734, 63.99446502574478],
            [10.771907727003693, 63.99459850227582],
            [10.771939028305505, 63.99463249526186],
            [10.772033639718536, 63.994735213934995],
            [10.772135041865157, 63.99482824258708],
            [10.772176240520407, 63.99486854690186],
            [10.772298769799631, 63.99494915744945],
            [10.772411687249873, 63.99502157712188],
            [10.772544269542433, 63.995092592625205],
            [10.77263857161698, 63.99514325488162],
            [10.77268171797774, 63.99516392969242],
            [10.772769190512077, 63.99520018989016],
            [10.773075963777034, 63.995325724877965],
            [10.773300873697105, 63.995406353609],
            [10.773546106026165, 63.995469056987254],
            [10.773811864296636, 63.995513840851515],
            [10.77401625225786, 63.995540654608746],
            [10.774220771243368, 63.9955584827962],
            [10.774506909269515, 63.99556736377354],
            [10.774752099514922, 63.995576219150486],
            [10.7749154403242, 63.99559419436465],
            [10.775017626794734, 63.995594116634614],
            [10.775078938767667, 63.99560300511653],
            [10.77522201655737, 63.995620928704774],
            [10.77542644979989, 63.99562985346821],
            [10.775732865971936, 63.99563869377043],
            [10.775957854144165, 63.995656576651406],
            [10.776182491021013, 63.99565647078306],
            [10.776366587513001, 63.99565635186482],
            [10.776529985795314, 63.99565634874826],
            [10.776734419779974, 63.995665271673005],
            [10.7769415920675, 63.995703488572964],
            [10.777071750468094, 63.99570665138095],
            [10.777245229239375, 63.995700918454574],
            [10.777388364345981, 63.995700863391896],
            [10.777510889027957, 63.99570982609956],
            [10.777653820327236, 63.995709764836654],
            [10.77781739481105, 63.99572756374629],
            [10.777940035664557, 63.995727630294134],
            [10.778042222690637, 63.99572755043678],
            [10.778164686739972, 63.99572743186345],
            [10.778266860245372, 63.99572744134454],
            [10.778471220788436, 63.995727370594096],
            [10.778675656009085, 63.99573629079089],
            [10.778859549266965, 63.99573616277547],
            [10.779002555518867, 63.99574509142028],
            [10.779145561867052, 63.99575401992477],
            [10.779309083499191, 63.99578979369675],
            [10.7794725920336, 63.995825656784014],
            [10.779636210553345, 63.99589738920371],
            [10.779759085163914, 63.99596910375168],
            [10.779820291941745, 63.996013943321834],
            [10.779881866405765, 63.99607668177945],
            [10.779963868626515, 63.99615736379287],
            [10.780066170178877, 63.996264974631316],
            [10.780148262123916, 63.99635455828663],
            [10.780189099217726, 63.99643530020906],
            [10.780250737058209, 63.99650711925358],
            [10.780312184859834, 63.99657884284192],
            [10.78037350430797, 63.996659551708454],
            [10.78041454633861, 63.996740299507096],
            [10.780435324294285, 63.9968209967569],
            [10.780476216250007, 63.99688376206533],
            [10.780476280207608, 63.996937563373635],
            [10.780476587913752, 63.99697348357352],
            [10.780497108938135, 63.99707215142008],
            [10.780476808352116, 63.99716181052391],
            [10.780415707556035, 63.99726942864115],
            [10.780354504043217, 63.99736823448557],
            [10.780354835297315, 63.99747584302821],
            [10.780314290734339, 63.99759241931849],
            [10.780294125948787, 63.99770015035454],
            [10.780273735500627, 63.99778090767755],
            [10.780233114962083, 63.99788849270032],
            [10.780192609319121, 63.997987181904605],
            [10.780151824375956, 63.99807687392406],
            [10.780111162546136, 63.998193536668],
            [10.780111355856913, 63.99827426395439],
            [10.780111535847189, 63.99836389001094],
            [10.78007066143797, 63.99844468026041],
            [10.779989338571164, 63.99856141778186],
            [10.77996911016507, 63.99866006801711],
            [10.779928398492538, 63.99875875119043],
            [10.779908156182355, 63.99885749090961],
            [10.779846974248954, 63.99895611749388],
            [10.779765587420894, 63.999063774136346],
            [10.779745419259005, 63.999171505058136],
            [10.779704773463955, 63.99925212212442],
            [10.779664134878002, 63.999359796438775],
            [10.779643912074777, 63.99948550387009],
            [10.779664445205341, 63.99958408230491],
            [10.779664610097878, 63.99967379783707],
            [10.779726376462222, 63.99978139712464],
            [10.779787885481053, 63.999906966983374],
            [10.779808459757497, 63.99998765836518],
            [10.779910685648744, 64.00008636762746],
            [10.780053969160129, 64.00019391266025],
            [10.780176884784932, 64.00029259472649],
            [10.78029958934116, 64.00036421349552],
            [10.780463386569771, 64.00045392761513],
            [10.780606603333405, 64.00050771558388],
            [10.78079074975454, 64.00057932435001],
            [10.78097473287273, 64.00063303991607],
            [10.781138307590425, 64.00069577959223],
            [10.781322443101432, 64.00076747719702],
            [10.781445306890493, 64.00081231218319],
            [10.781547496036673, 64.00085708479851],
            [10.781690499544881, 64.00091095528757],
            [10.781925516648396, 64.00099833525091],
            [10.782161109883129, 64.00109004629772],
            [10.782345174824561, 64.00115275140102],
            [10.782508755673447, 64.00121548957084],
            [10.782631495333439, 64.00126930888223],
            [10.78275415953513, 64.0013141368557],
            [10.782897322673302, 64.00135884188471],
            [10.783020149251875, 64.00139174859675],
            [10.783634045167432, 64.0017084595425],
            [10.783860106898935, 64.00225545388798],
            [10.783943246475138, 64.0029013056603],
            [10.783944775015554, 64.00358307728308],
            [10.783823471604839, 64.00420203933214],
            [10.783539596665147, 64.00510814712575],
            [10.783275052586003, 64.00565552570383],
            [10.783010297889273, 64.00613098569539],
            [10.782887849348551, 64.0061849540828],
            [10.78278569851713, 64.00623879362878],
            [10.78270402241828, 64.00629268930317],
            [10.782601870836062, 64.006346528714],
            [10.78252023107345, 64.00642730254683],
            [10.782418319490649, 64.00650802602023],
            [10.782295829197372, 64.00657988092041],
            [10.782132486290838, 64.00668758214171],
            [10.781989745914276, 64.0067863541779],
            [10.781887742342242, 64.00685817552258],
            [10.78178566943198, 64.00692096081255],
            [10.781663054028206, 64.00700175570027],
            [10.781561048818606, 64.00707357680254],
            [10.781459043080613, 64.00714539782895],
            [10.781336507918082, 64.00723513890647],
            [10.781214047344417, 64.00733387110334],
            [10.781071056668358, 64.00745052327667],
            [10.780928179923048, 64.00755827950233],
            [10.780764968184698, 64.00765690430744],
            [10.780683305660707, 64.00773776652987],
            [10.780519949675579, 64.00784546583385],
            [10.780397612326563, 64.0079352120052],
            [10.780275070232822, 64.00802495213183],
            [10.780173132701963, 64.00810576342722],
            [10.78000977256882, 64.00821346212444],
            [10.779907922051041, 64.00830317495115],
            [10.779826105254928, 64.0083660542043],
            [10.779744505570065, 64.00842884984776],
            [10.779642490136284, 64.00850066952106],
            [10.779499541126492, 64.00859934353198],
            [10.779397524431067, 64.00867116302317],
            [10.779315780148716, 64.00874303319546],
            [10.779213891679614, 64.00880586726207],
            [10.779111659466409, 64.00886419673603],
            [10.77902990385291, 64.00892258286957],
            [10.778968716683785, 64.00897635406172],
            [10.778887154448615, 64.00902126218037],
            [10.778805625298176, 64.00909304848734],
            [10.778723803667113, 64.00915592708093],
            [10.778601305664772, 64.00922768920091],
            [10.778519687133901, 64.0092905736104],
            [10.778458498159354, 64.00934434457308],
            [10.77839720742317, 64.00938930327874],
            [10.778295184964994, 64.00946112194983],
            [10.77819317551178, 64.00953285104849],
            [10.778111480790379, 64.00958674399224],
            [10.778050128145255, 64.00962262182456],
            [10.778009531196517, 64.0096675536725],
            [10.777968539721453, 64.00971238413418],
            [10.777907348741705, 64.00976615484845],
            [10.777825949856524, 64.0098560125058],
            [10.777723678274015, 64.00994571181705],
            [10.777662560515632, 64.01000847364068],
            [10.777621642169937, 64.01006229521602],
            [10.777581043872237, 64.01010722693292],
            [10.777519559588875, 64.01015208980743],
            [10.7774914351631, 64.0102046209251],
            [10.777458649815834, 64.01024191469423],
            [10.777417749352537, 64.01027326409528],
            [10.776913991953075, 64.01057860470227],
            [10.77540543987205, 64.01188302472755],
            [10.773276721938643, 64.01335812896116],
            [10.771415501188725, 64.01441851882156],
            [10.768389155922392, 64.01586738538832],
            [10.768102032468793, 64.01600283351691],
            [10.765111619389632, 64.01734490776636],
            [10.763754385280683, 64.01805128128707],
            [10.761932106922705, 64.01885201565771],
            [10.760427621028457, 64.02012055668229],
            [10.759576125863857, 64.02086882519755],
            [10.759199337171076, 64.02119040930475],
            [10.7582333144932, 64.02215097364841],
            [10.758283631678637, 64.02303338580838],
            [10.758550257983078, 64.02384122001266],
            [10.758676556894153, 64.02422254862616],
            [10.760151541252895, 64.0251733939382],
            [10.760827937158066, 64.02584946089326],
            [10.762413600446365, 64.02671371197059],
            [10.762449685253229, 64.02673660967022],
            [10.762740618893496, 64.02697918519948],
            [10.763031648320382, 64.02719146937517],
            [10.763411183952444, 64.02746081178401],
            [10.76352594128551, 64.02757445985364],
            [10.76357583927006, 64.0276859441625],
            [10.763591097685953, 64.0278041475982],
            [10.763641117269824, 64.02790673616056],
            [10.763701168941912, 64.02795271632236],
            [10.763785789391312, 64.02797460380893],
            [10.763870627658623, 64.02799640771181],
            [10.763925575629088, 64.02803145176664],
            [10.763925677481874, 64.02806857992053],
            [10.763885819018132, 64.0281123618376],
            [10.763785987466035, 64.02817578673981],
            [10.76369441555351, 64.02824556538809],
            [10.763602466648987, 64.02834212064651],
            [10.763561617748234, 64.028408616122],
            [10.763545282281, 64.02852697567448],
            [10.763566797771345, 64.02863232754383],
            [10.76358140303845, 64.02866574420801],
            [10.763627713620235, 64.02871177257238],
            [10.763668893784713, 64.02875243740398],
            [10.763714958862506, 64.0287933347503],
            [10.763767500438552, 64.02883208400917],
            [10.763798218442401, 64.02887819636298],
            [10.763802773941732, 64.0289413433068],
            [10.763822374598284, 64.02898236678854],
            [10.763860331293664, 64.0290267128707],
            [10.76390785203489, 64.02906207937046],
            [10.764003160124245, 64.02910000971441],
            [10.764144215013628, 64.02914179259862],
            [10.764319435174771, 64.02917459484956],
            [10.764444377501883, 64.02920098503611],
            [10.764519482746104, 64.02924911217721],
            [10.764623990275213, 64.02928587238229],
            [10.7647203220066, 64.02933057395472],
            [10.764759806661218, 64.0293851220919],
            [10.764744874896817, 64.02942675538422],
            [10.76469479604918, 64.02946628395887],
            [10.764630285397947, 64.02953199907607],
            [10.76461139679409, 64.02958888828219],
            [10.764661770412816, 64.02965948531762],
            [10.764726684958967, 64.0297045281898],
            [10.764853760527405, 64.02976819527437],
            [10.764982724823932, 64.02981672572145],
            [10.765087710640373, 64.02985035329289],
            [10.765223855770474, 64.0298785978776],
            [10.765343846420466, 64.02989306689904],
            [10.765438609941445, 64.02990895691384],
            [10.765592051216696, 64.02994076226209],
            [10.76569981134804, 64.02996287435107],
            [10.765792323000852, 64.02997739497992],
            [10.765871683665674, 64.02996510370333],
            [10.765947633208766, 64.02994286973768],
            [10.76600337658678, 64.02992274280153],
            [10.766059094414988, 64.02990953673122],
            [10.76615539136915, 64.0299072230817],
            [10.766251569895088, 64.02992054699874],
            [10.766389194323292, 64.02994108049955],
            [10.766548239584147, 64.02994745179197],
            [10.766649153325602, 64.0299592955644],
            [10.766692311023293, 64.0299937247077],
            [10.766718390447483, 64.03002316096601],
            [10.766754907791517, 64.03005676709633],
            [10.766837944887357, 64.03007833673159],
            [10.76691521943507, 64.030075737222],
            [10.76701136597242, 64.03006901393344],
            [10.767096383455675, 64.0300680784942],
            [10.767192490367286, 64.0300656687101],
            [10.767290800930452, 64.0300608960887],
            [10.767385984338242, 64.03006457183788],
            [10.767512808063074, 64.03007995749418],
            [10.76760885247873, 64.03009552385107],
            [10.767705252163209, 64.03011550517404],
            [10.767841990316755, 64.03015607960417],
            [10.76790408835722, 64.03018189193432],
            [10.76793848604889, 64.03022002035064],
            [10.767938454774928, 64.03024995320011],
            [10.767885532345211, 64.03028121976402],
            [10.767811770898433, 64.03029309117953],
            [10.767736010273559, 64.03030867967173],
            [10.767705473579374, 64.0303464421078],
            [10.767705622770883, 64.03038869532016],
            [10.767741242167297, 64.0304174208462],
            [10.767802015454146, 64.03042629502232],
            [10.767895225244764, 64.0304240699109],
            [10.767984235316971, 64.0304373633032],
            [10.768075235779536, 64.03046186119943],
            [10.768181928594954, 64.03049508672689],
            [10.768261524009706, 64.03051233022411],
            [10.768338999169519, 64.0305367930184],
            [10.76840860885636, 64.03053945249235],
            [10.76851557376632, 64.03053034697095],
            [10.76858725015146, 64.03056803428319],
            [10.768618379716926, 64.0305952802577],
            [10.768678462782244, 64.03062807462413],
            [10.768747451814738, 64.0306107303372],
            [10.76877646733888, 64.03058433951672],
            [10.768807668094688, 64.03054219158379],
            [10.768826162736087, 64.03050947123067],
            [10.76889006594674, 64.0304787942383],
            [10.768953501290918, 64.03047214944675],
            [10.769007201663689, 64.03048778340603],
            [10.769037582978829, 64.03051455800791],
            [10.76911946696476, 64.03057483570011],
            [10.76922191853881, 64.03067117512319],
            [10.769280301380142, 64.03070798002216],
            [10.769331228957329, 64.03073040966062],
            [10.769413419935411, 64.03075285197012],
            [10.76951200761371, 64.03075572661844],
            [10.76957648997996, 64.03076380926043],
            [10.769619730907673, 64.03078961030852],
            [10.769678561305083, 64.03083833864302],
            [10.769727925753507, 64.03089946559396],
            [10.769765424489256, 64.03096042634847],
            [10.769830373758642, 64.03103099674856],
            [10.769899734077722, 64.03110628015865],
            [10.769986773223186, 64.03118666338446],
            [10.770042976765456, 64.03126488909832],
            [10.7700683553487, 64.03133412593525],
            [10.770104372782875, 64.03139675131492],
            [10.770182363150814, 64.03147462331158],
            [10.770248441116923, 64.0315377654233],
            [10.770316102953496, 64.03157964950404],
            [10.7703567818263, 64.03162506172728],
            [10.770372434683088, 64.03166785668729],
            [10.770434044487637, 64.03171720501123],
            [10.770547058047399, 64.03174800604295],
            [10.770688784798569, 64.03177874503476],
            [10.770802713774698, 64.03181703348866],
            [10.770928172051764, 64.03184621934417],
            [10.771066347182728, 64.03185914591073],
            [10.771305834577252, 64.03185632777604],
            [10.771438106231564, 64.03185883436417],
            [10.771553719355856, 64.0318562709172],
            [10.77164075064322, 64.03187318978331],
            [10.771719351207562, 64.0319037959977],
            [10.771815660809501, 64.03194471633385],
            [10.771944980940015, 64.03197886791915],
            [10.772015285209099, 64.03201822129104],
            [10.772115643739024, 64.03207301269585],
            [10.77215924206121, 64.03212624001458],
            [10.772205840582602, 64.03216373394548],
            [10.772248543447095, 64.03219311406127],
            [10.772358217140072, 64.03228925681415],
            [10.7723950684856, 64.03231801692863],
            [10.77246552926111, 64.03236852107246],
            [10.772573351701872, 64.03246065449467],
            [10.772814600634522, 64.03257069805177],
            [10.772894459014042, 64.03260655386718],
            [10.772929747884389, 64.0326659210683],
            [10.77293669142955, 64.03269992229515],
            [10.772919982296916, 64.03273170631088],
            [10.772846292163948, 64.03275931335048],
            [10.772752620886514, 64.03277941663548],
            [10.772630931082404, 64.03277470270285],
            [10.772502678774798, 64.03276323543362],
            [10.772361408669227, 64.03276325434574],
            [10.772246432373324, 64.03279675952713],
            [10.772165891173211, 64.03284250435237],
            [10.77213563390825, 64.03288926487123],
            [10.772137747970717, 64.03295782330608],
            [10.772179137525837, 64.03302833516032],
            [10.772229457056728, 64.03307510633574],
            [10.772279540408645, 64.03311126348814],
            [10.772413765679932, 64.03314555744053],
            [10.772434680218392, 64.03318410073756],
            [10.772423412024084, 64.0332266503589],
            [10.772356573984673, 64.03327261478013],
            [10.772263950337567, 64.03329661362561],
            [10.772147070803786, 64.0333101974449],
            [10.772027655905267, 64.03334456197653],
            [10.771919515629012, 64.03336406339278],
            [10.771861594899221, 64.03339042157035],
            [10.771786472418158, 64.03341663803116],
            [10.771768723303369, 64.03349989912232],
            [10.771809109349322, 64.03354862824736],
            [10.771860510320687, 64.03357880124302],
            [10.77189435379396, 64.03360441751846],
            [10.7719100050866, 64.03363642527975],
            [10.771912891978463, 64.03367012858705],
            [10.771935213874503, 64.0337068252621],
            [10.771975914984749, 64.03372913559275],
            [10.772040421871461, 64.03372966685117],
            [10.772107916108933, 64.03371590258804],
            [10.772201506114435, 64.03371800031235],
            [10.77226490049183, 64.03372587010567],
            [10.77232771810356, 64.03372266649228],
            [10.772364777648114, 64.03369866671412],
            [10.772386822732575, 64.03366685842265],
            [10.77246831236402, 64.03363651239728],
            [10.772523989479623, 64.03361413369922],
            [10.772571339538466, 64.03359528779183],
            [10.772649129903023, 64.03359881262706],
            [10.772732804155426, 64.03361221704573],
            [10.772784227058798, 64.0336571324208],
            [10.772792815978544, 64.03368839497043],
            [10.772840893500359, 64.03373779729036],
            [10.772856743140913, 64.03378338421307],
            [10.772935358608592, 64.03380311326308],
            [10.77301295769226, 64.03380384570235],
            [10.773087149990964, 64.03385005348649],
            [10.773153886408553, 64.0338724027601],
            [10.773260320152952, 64.0338668736499],
            [10.773342664086243, 64.03385794603014],
            [10.773398265271537, 64.03387394814708],
            [10.773439433784592, 64.03390265389415],
            [10.773470020470851, 64.03394300687106],
            [10.77354190193003, 64.03399229326337],
            [10.773586960203728, 64.03401562892428],
            [10.773542061167921, 64.03403724327798],
            [10.773347650007452, 64.03408209905616],
            [10.773247229462253, 64.03408515163173],
            [10.773271278442573, 64.03411520150027],
            [10.773378381991364, 64.03414043443561],
            [10.773521814169813, 64.03417625387367],
            [10.773542212600322, 64.03422565870525],
            [10.773585392938951, 64.03427491808505],
            [10.773595843881557, 64.03435207907776],
            [10.773544809473497, 64.0344588210618],
            [10.773401819296563, 64.03462571821841],
            [10.773442581981804, 64.03465710884025],
            [10.773514637906318, 64.03475125577032],
            [10.773516846889295, 64.03502485766252],
            [10.773548903385045, 64.03514210998878],
            [10.77365058194104, 64.03522210785816],
            [10.773998348506625, 64.03521668530828],
            [10.77433592805716, 64.03519865024737],
            [10.774509943209171, 64.03517612120528],
            [10.774673608434862, 64.03511769388086],
            [10.774806500862168, 64.03513109189191],
            [10.774859901215068, 64.03514810797658],
            [10.774990880248557, 64.03524316069408],
            [10.775072769268766, 64.03526568049213],
            [10.77528804501809, 64.03528345427402],
            [10.775349157530345, 64.035291525857],
            [10.775389944742825, 64.03533631027535],
            [10.775400580620026, 64.03539468925926],
            [10.775290418151126, 64.03564677135854],
            [10.77528045540016, 64.0357409563421],
            [10.775311235793446, 64.0358260799883],
            [10.775362598260177, 64.0358700935943],
            [10.775567158956601, 64.03591937617307],
            [10.775770402907078, 64.03592727044825],
            [10.775941847891103, 64.03599347667826],
            [10.77610349182832, 64.03612303991221],
            [10.776228064041288, 64.03623201763699],
            [10.776254962661362, 64.03632925313107],
            [10.776194713710066, 64.03642512059739],
            [10.776094076337985, 64.03648844063027],
            [10.776158220123556, 64.0365753441643],
            [10.77641026728001, 64.03665773895773],
            [10.778225592609763, 64.03690607513279],
            [10.77914044788525, 64.03708846784912],
            [10.779624958465181, 64.03734760060573],
            [10.77995344310522, 64.03755239513812],
            [10.78021728930568, 64.03778731018481],
            [10.78158155087631, 64.03843966540438],
            [10.783913058131509, 64.03965594386375],
            [10.787859377759881, 64.0413531332028],
            [10.791502140336743, 64.04343790494896],
            [10.79356712564888, 64.04432169094078],
            [10.796687606054055, 64.04601058776045],
            [10.797861712262488, 64.04657411833267],
            [10.798582110718897, 64.04698113421873],
            [10.799635769328177, 64.04747868970342],
            [10.800585532049746, 64.04793763514816],
            [10.801968469914911, 64.048619351026],
            [10.80213096708253, 64.0486995566783],
            [10.814900860408049, 64.05487645537819],
            [10.815271718069656, 64.05510269543178],
            [10.815185050401686, 64.05525759074798],
            [10.814988587546205, 64.05543035506655],
            [10.8149890687023, 64.05557059370267],
            [10.81489135595159, 64.05577577730773],
            [10.81473150404144, 64.05588919214092],
            [10.814522623420267, 64.05601890137916],
            [10.814547615065962, 64.05621315001764],
            [10.814659035015055, 64.05632108095693],
            [10.81473305905906, 64.0563965630633],
            [10.814659503792228, 64.05645592600396],
            [10.81462270028817, 64.05653153932745],
            [10.814734106282032, 64.05661771695094],
            [10.81491569873043, 64.0566970186198],
            [10.815005303398593, 64.05678490469143],
            [10.815055219002092, 64.05691434340973],
            [10.815068007622331, 64.05706554349406],
            [10.815068425000039, 64.05717342071121],
            [10.815170971181685, 64.05725439873181],
            [10.815438580290367, 64.0573457966686],
            [10.816166027102998, 64.05757269172744],
            [10.816627929701738, 64.05785844939895],
            [10.81684683395873, 64.05820048590085],
            [10.81696327244501, 64.05850334550728],
            [10.817036042710809, 64.05864602590083],
            [10.817092019082578, 64.05875568318912],
            [10.817431305922012, 64.05906963574446],
            [10.817683610948727, 64.05936975627974],
            [10.817776021123658, 64.05964001279679],
            [10.817799392838937, 64.05977003396615],
            [10.817685511116421, 64.05992028178657],
            [10.817754640780093, 64.06011049713634],
            [10.817892323565365, 64.06027059695636],
            [10.818121570300544, 64.0604605694074],
            [10.818487928347588, 64.06065044475142],
            [10.818808432595269, 64.0608505043728],
            [10.818969350542785, 64.06110061999097],
            [10.819245046902605, 64.06150082586764],
            [10.819565714026199, 64.06168075340292],
            [10.819840231102122, 64.06179076770198],
            [10.820160479746294, 64.06188052478794],
            [10.820458067179631, 64.06201052761027],
            [10.8206414906556, 64.06215045764941],
            [10.82089336965942, 64.06227051482549],
            [10.821053801224455, 64.06241050170124],
            [10.8210545516735, 64.06261070209011],
            [10.82113783636028, 64.062818940358],
            [10.821362986538073, 64.06307206940218],
            [10.82156004829851, 64.06333733359138],
            [10.821981633502517, 64.06359045029242],
            [10.822384601490787, 64.06383089529535],
            [10.8226593940163, 64.06400086614202],
            [10.822728593063404, 64.06422101249356],
            [10.822637775563813, 64.06436123080934],
            [10.822659635225495, 64.06466846438681],
            [10.822862609700085, 64.06483834638784],
            [10.822903453645587, 64.06500122794613],
            [10.822750567726578, 64.06517480701118],
            [10.822565036001816, 64.06530600900435],
            [10.822508763703325, 64.06545126588304],
            [10.822517345799238, 64.06557879284055],
            [10.822404625129552, 64.06572404398744],
            [10.822205770121597, 64.06585234555794],
            [10.822186941844084, 64.06593270233701],
            [10.822203455891321, 64.06600050281207],
            [10.822130940952098, 64.0661281239447],
            [10.821937389921573, 64.06624156666089],
            [10.821748893779224, 64.0663062559769],
            [10.821666840743939, 64.06634829965252],
            [10.82160305992442, 64.06640947560771],
            [10.82143356323422, 64.0665212727008],
            [10.82124746493812, 64.06662468189879],
            [10.821252452803177, 64.06671866760446],
            [10.821376185590914, 64.06680654169413],
            [10.821554687264483, 64.06691657549398],
            [10.821641711665611, 64.06699053937633],
            [10.821701484755101, 64.06707648319782],
            [10.821724737031358, 64.06716641003825],
            [10.821763414332903, 64.06728761189673],
            [10.82186589103046, 64.06736121114575],
            [10.822115028665038, 64.06745062453703],
            [10.82237844322298, 64.06756256033661],
            [10.822502957760253, 64.06766169166966],
            [10.822503398216575, 64.06777370362266],
            [10.82241631341431, 64.06788895091377],
            [10.822350448109955, 64.0679817974149],
            [10.822336512616243, 64.06809384531923],
            [10.822388185108785, 64.0682666563273],
            [10.822527799802092, 64.0684266259863],
            [10.822645269331488, 64.06854811612064],
            [10.822747947774896, 64.06866010215778],
            [10.822770520898395, 64.06885859273125],
            [10.822771216445965, 64.06905375749852],
            [10.822629615380295, 64.0692573241653],
            [10.822461991341873, 64.06939623259066],
            [10.822194819481116, 64.06950899685563],
            [10.821888511368073, 64.06963492697764],
            [10.82175035449903, 64.06976074982256],
            [10.821711450962107, 64.06990371976372],
            [10.821820625248982, 64.07003809539158],
            [10.82197941724396, 64.0701852238924],
            [10.822206676129293, 64.07029063633756],
            [10.822398782399606, 64.07037310493318],
            [10.82242604462268, 64.07051159598379],
            [10.822446600433434, 64.07069205117175],
            [10.82258563611136, 64.07084364432771],
            [10.822823944079742, 64.07106020409545],
            [10.823042546476332, 64.07125075871923],
            [10.823259240208555, 64.07147595444239],
            [10.823407571277212, 64.07172713901018],
            [10.823437347324663, 64.07181743269247],
            [10.823430183917386, 64.0718980351179],
            [10.823401027820648, 64.07199796010649],
            [10.823349872400417, 64.07207208419624],
            [10.823342882185347, 64.07212689403936],
            [10.823409092020032, 64.07221383082874],
            [10.823520229848855, 64.07236533975944],
            [10.823660676310006, 64.072519938389],
            [10.823801087575738, 64.07265835618496],
            [10.823867808413475, 64.07281308214644],
            [10.823824202224554, 64.07297101829107],
            [10.823699384681968, 64.0730872491721],
            [10.823615906905571, 64.07324817378539],
            [10.823589215926843, 64.0733959895521],
            [10.823522436863815, 64.07352907983883],
            [10.82352280621073, 64.07364432553959],
            [10.823516299465703, 64.07376845213189],
            [10.823442358921614, 64.07386304466446],
            [10.823346927118367, 64.07391612069566],
            [10.823257261008163, 64.0739636096811],
            [10.823240372574059, 64.07400501143427],
            [10.823213781409272, 64.07414393124343],
            [10.823309145822577, 64.0743390312665],
            [10.823397556511972, 64.07447784180651],
            [10.82349244816587, 64.07462546774711],
            [10.823513172682615, 64.0747377930567],
            [10.823513354932555, 64.07477626991222],
            [10.823435201420164, 64.07490166248638],
            [10.823208087589688, 64.07507967072327],
            [10.82280302701323, 64.07537480838587],
            [10.82240817499608, 64.07577837275727],
            [10.822290028820985, 64.07601695113391],
            [10.822409505624476, 64.0761512623981],
            [10.822726882353665, 64.0762941404466],
            [10.822896189480767, 64.07646314222134],
            [10.822857341964243, 64.07674939395321],
            [10.822798998558303, 64.07700955722171],
            [10.82265144860285, 64.07727848126437],
            [10.822397779417672, 64.07750327541288],
            [10.82216623306316, 64.07765589688894],
            [10.822152023378246, 64.07777656609744],
            [10.822297510894922, 64.07789086136142],
            [10.822559148977783, 64.07803033879617],
            [10.822792127777113, 64.07821438462052],
            [10.822850810977789, 64.07840492440533],
            [10.822749899131386, 64.0785573477293],
            [10.822546965155837, 64.07862737747205],
            [10.822372799370145, 64.07860834715771],
            [10.822227543299064, 64.07855131675214],
            [10.821994857770113, 64.0784816147537],
            [10.821675877871046, 64.07846282351778],
            [10.821356668110012, 64.07849481116324],
            [10.820979594637265, 64.07858391990317],
            [10.820893134265527, 64.07869199407286],
            [10.820966130064951, 64.07878712691152],
            [10.821140255652997, 64.07883788789813],
            [10.821459812949533, 64.07888842696693],
            [10.821836854692407, 64.07893909037207],
            [10.822025868158, 64.07899603115392],
            [10.822055097588102, 64.07907219702152],
            [10.821968667811309, 64.07919923881401],
            [10.82167917382647, 64.079421743561],
            [10.82136032437952, 64.07957437027463],
            [10.82111455105028, 64.0797586710726],
            [10.821172897252154, 64.07988574171941],
            [10.821463390865931, 64.07996169161066],
            [10.8218843542866, 64.0800057975623],
            [10.822218227059887, 64.08006915070749],
            [10.822363686134391, 64.08019602898125],
            [10.822335450571984, 64.08034856434217],
            [10.82219064247276, 64.08041846744845],
            [10.821929318478258, 64.08043135737653],
            [10.821493981173056, 64.08040634381219],
            [10.821014898803186, 64.08034303723258],
            [10.82072488005963, 64.08036238051159],
            [10.820434846727597, 64.08043241914667],
            [10.82033384581741, 64.08057845667493],
            [10.820392489621586, 64.08073088440332],
            [10.820276533289915, 64.08086435693876],
            [10.819943468842592, 64.08099796549155],
            [10.819382704122258, 64.08122407757969],
            [10.818926064986169, 64.08140913931241],
            [10.81857492674134, 64.08160964036365],
            [10.818681085033846, 64.08179435752699],
            [10.819033378397794, 64.08196350571438],
            [10.819491466402626, 64.0821325508189],
            [10.819632969009316, 64.08231720535925],
            [10.819774490743447, 64.0826712975883],
            [10.820057910207236, 64.08310219033413],
            [10.820480680784835, 64.08333286710614],
            [10.820833101863574, 64.08347127253128],
            [10.821572805040073, 64.08365551064078],
            [10.822065805154386, 64.08377835990485],
            [10.822277825590247, 64.08400926322395],
            [10.822454537158476, 64.0843016224917],
            [10.82249153047474, 64.08477899706611],
            [10.822668562408076, 64.08510210644967],
            [10.823162304714486, 64.08537894893428],
            [10.824395414181264, 64.08584009177413],
            [10.824994569815024, 64.0861169001701],
            [10.825417895463694, 64.0863321160493],
            [10.825664842586514, 64.08651673626791],
            [10.825947142031143, 64.08676286519135],
            [10.826404920062178, 64.0868703943938],
            [10.826932967890698, 64.08691621035912],
            [10.827566781308185, 64.0869772857243],
            [10.828235562219598, 64.08702300273926],
            [10.82858764653549, 64.08709980551201],
            [10.828904999976546, 64.08725345223299],
            [10.829222446222632, 64.08743802179276],
            [10.829363556950153, 64.08751487966452],
            [10.82957461106765, 64.08756093605558],
            [10.829892049459618, 64.08768393154806],
            [10.830280595946682, 64.08806855848796],
            [10.830492481680729, 64.08831472435894],
            [10.830634679102486, 64.08863799052713],
            [10.830706512294585, 64.08899213623994],
            [10.8306377412663, 64.08943869622038],
            [10.830392314984348, 64.08966985391777],
            [10.830163351388123, 64.08978292347898],
            [10.830306113020164, 64.08983241212631],
            [10.88038719023375, 64.09788127126482],
            [10.86699560532145, 64.11270839349672],
            [10.786007309521315, 64.11434869846937],
            [10.740794569291031, 64.17706037217157],
            [10.749475862958692, 64.17941857267844],
            [10.883771625847961, 64.20732337767161],
            [10.911608591567422, 64.22965361850862],
            [10.913149414638328, 64.23462390041986],
            [10.9133607553547, 64.23530499517277],
            [10.91367002253823, 64.23630161263043],
            [10.913703098418273, 64.23640895628168],
            [10.927325254768308, 64.28025519539857],
            [10.909082724658573, 64.28065209426455],
            [10.90818665742134, 64.28067014535758],
            [10.907468551356185, 64.280708635002],
            [10.902730236910264, 64.28086013112691],
            [10.898240350357089, 64.28153705902292],
            [10.894536592048539, 64.28209537022668],
            [10.889047379453952, 64.28293970397894],
            [10.885393221069856, 64.28347069444712],
            [10.881272221190692, 64.28412892351969],
            [10.814500583997882, 64.29432381698267],
            [10.796917798136391, 64.30119666430707],
            [10.781041568430595, 64.30739341712221],
            [10.770000900038339, 64.31170182327013],
            [10.761434164868016, 64.31054253197098],
            [10.758428728339739, 64.31013635784788],
            [10.757499003024444, 64.31045950710516],
            [10.754374619362302, 64.31165047796998],
            [10.751174490943113, 64.31287280627137],
            [10.748942780750001, 64.31322305911378],
            [10.744644271963812, 64.31395028888501],
            [10.742310218620387, 64.31594211937097],
            [10.741838085999971, 64.31628407284242],
            [10.74156953630221, 64.31650835269396],
            [10.737871152372897, 64.31932541658925],
            [10.734212924654344, 64.3214784638872],
            [10.729872852053923, 64.32716586826062],
            [10.729232000079337, 64.32797317991366],
            [10.724659805995769, 64.33198978522239],
            [10.72319532699886, 64.33332162061329],
            [10.72308244042454, 64.33342646160347],
            [10.722773869413722, 64.3335433806158],
            [10.7226799378108, 64.33357560279173],
            [10.7225120451154, 64.33365024937346],
            [10.72234052892222, 64.33372353134119],
            [10.722262995823368, 64.33375892951035],
            [10.722169811796185, 64.33378766742723],
            [10.722087139525005, 64.33381545414687],
            [10.722000254394784, 64.33384500538888],
            [10.721938160528047, 64.33387375331172],
            [10.721882240775011, 64.33389611957116],
            [10.721826508659403, 64.33392127797521],
            [10.721743749807128, 64.33395094973491],
            [10.721665106360712, 64.33397148283377],
            [10.721522465302101, 64.3340036732933],
            [10.72144359783279, 64.33405363963477],
            [10.721405851991838, 64.33407509891174],
            [10.721344863376444, 64.3340927322164],
            [10.721234129107515, 64.33411034898317],
            [10.721167364621337, 64.3341344653748],
            [10.72103056398504, 64.33418107421167],
            [10.720917050723115, 64.33421389126525],
            [10.72080342296064, 64.33425677289132],
            [10.720681453186117, 64.33429464612179],
            [10.72059416682874, 64.33431609449914],
            [10.72042821006944, 64.33434890544068],
            [10.720349792059706, 64.33436530939926],
            [10.72025240536413, 64.33439172087667],
            [10.720142908700996, 64.33442002537444],
            [10.720080768119182, 64.3344423888154],
            [10.719996642473436, 64.33447282871764],
            [10.719890023165359, 64.33451861149724],
            [10.719790561007184, 64.33456235626178],
            [10.719736451853711, 64.33457839233834],
            [10.719627673297328, 64.33460073960418],
            [10.719561523670885, 64.33461822122835],
            [10.719485107959143, 64.33465239224878],
            [10.719433320610564, 64.33467748544757],
            [10.719340191809492, 64.33471781950853],
            [10.719249165902385, 64.3347366407229],
            [10.719151727603446, 64.33474871207589],
            [10.719037210406434, 64.33476396926092],
            [10.718963471825244, 64.33477826211316],
            [10.718904285505296, 64.33480161046536],
            [10.718830591721566, 64.3348435916184],
            [10.718749340966871, 64.33487285648037],
            [10.718692104989284, 64.33489032888428],
            [10.71863681490326, 64.33491927462485],
            [10.7185800266953, 64.33496584049219],
            [10.718506535051983, 64.33499852348673],
            [10.718461027814298, 64.33501921560378],
            [10.71827074395636, 64.33505778465936],
            [10.717558811613628, 64.3352062173283],
            [10.71746018286557, 64.33522325711522],
            [10.717364094761008, 64.33523063218212],
            [10.717296100294067, 64.33526527338448],
            [10.717275698003792, 64.33531910648482],
            [10.717251606271057, 64.33536334786292],
            [10.71722794367523, 64.3354061635098],
            [10.717190494943988, 64.33547095900671],
            [10.717170165759859, 64.33554030080775],
            [10.71715313355068, 64.33559778332724],
            [10.71713959078831, 64.3356435020927],
            [10.717122542506845, 64.33568776984754],
            [10.717078243546002, 64.33576593867635],
            [10.71703403630147, 64.33582487304629],
            [10.717006848988817, 64.33585437120183],
            [10.716953801482367, 64.33587421293142],
            [10.716890229654926, 64.33589374656253],
            [10.71683546240617, 64.33592063947076],
            [10.716750721763741, 64.33594831794102],
            [10.716672745481818, 64.33597116037254],
            [10.716613105363106, 64.33599206749673],
            [10.716547042776433, 64.3360222703093],
            [10.716515021403946, 64.33605751487383],
            [10.716487311745048, 64.3360863684057],
            [10.716432033476304, 64.33611387547192],
            [10.716382056847605, 64.33614594250048],
            [10.716341992739853, 64.33618158082376],
            [10.716324799759532, 64.33620746112351],
            [10.716320235198136, 64.33623411566292],
            [10.716326901110962, 64.33626586333543],
            [10.716324852038618, 64.33629367023899],
            [10.71629822290253, 64.3363255668012],
            [10.7162826693694, 64.33635023659183],
            [10.716262098209203, 64.33637983844582],
            [10.716227010191457, 64.33641746524484],
            [10.71616082321727, 64.33645777725997],
            [10.71607796779825, 64.33649463474947],
            [10.716001360675616, 64.33652331506977],
            [10.715897913749146, 64.336564603591],
            [10.715812229617448, 64.3365983217514],
            [10.71572131187591, 64.33664168498679],
            [10.715601511595734, 64.33668680935634],
            [10.715430127116608, 64.33674768263384],
            [10.71528672804289, 64.3367939135972],
            [10.715076183333931, 64.33685597696268],
            [10.714860283881443, 64.33692579383678],
            [10.714712423820567, 64.33697270267311],
            [10.714625654813121, 64.33700405119941],
            [10.714557271144319, 64.33702649935596],
            [10.714456128946866, 64.3370622810624],
            [10.714377153686282, 64.33709017209767],
            [10.71428185079469, 64.33712972045836],
            [10.714186480943503, 64.33717501997673],
            [10.714002396597968, 64.33725349840441],
            [10.713901013319727, 64.33729880139806],
            [10.713824122879956, 64.33732927024695],
            [10.71375498491867, 64.33735655020841],
            [10.71370741754462, 64.33737178705971],
            [10.713599755195665, 64.33738553312986],
            [10.713488751902915, 64.3374047546404],
            [10.713390161296125, 64.33742946363779],
            [10.713289010559665, 64.33746794115656],
            [10.713222278478913, 64.33750239295091],
            [10.713155713611226, 64.33754907512427],
            [10.71313321959163, 64.33760828513039],
            [10.713114353628159, 64.33764953284837],
            [10.713040866446347, 64.33769007920613],
            [10.71296380108412, 64.33771101381805],
            [10.712828870972604, 64.33773609606268],
            [10.712713311722686, 64.33774862131771],
            [10.712578364896167, 64.33774853267808],
            [10.712414431565664, 64.33774022327525],
            [10.71229379179072, 64.33772149618234],
            [10.712203728094087, 64.33771409263504],
            [10.711966040157765, 64.33777463728363],
            [10.711763559769436, 64.33783540435405],
            [10.711639562458691, 64.33786880647054],
            [10.711539272881037, 64.3378950825858],
            [10.711400505721715, 64.33792481546351],
            [10.711285158786584, 64.33795325700717],
            [10.711218141375474, 64.33798751981922],
            [10.711167955028001, 64.33805212060416],
            [10.711121161975571, 64.33808365010711],
            [10.71106624186466, 64.33811943606139],
            [10.711017790833452, 64.33816691799719],
            [10.711002351224224, 64.33821276063301],
            [10.711018880273231, 64.33825567490027],
            [10.711041890187483, 64.3383048918916],
            [10.711056912664912, 64.33835747049893],
            [10.71107869506086, 64.33841456213575],
            [10.711076092044394, 64.33846716347695],
            [10.711072270483497, 64.33851694240037],
            [10.711074977415873, 64.3385700589558],
            [10.711073495728801, 64.33861945699525],
            [10.711067095632309, 64.33865253002706],
            [10.711029752341087, 64.33872982265916],
            [10.710964309786997, 64.33878255974935],
            [10.710864551867251, 64.33884130266156],
            [10.710776115207782, 64.3388819491847],
            [10.71060058175791, 64.33894134732313],
            [10.710400785011647, 64.33899014568651],
            [10.710253364723915, 64.33905405322125],
            [10.710188693365033, 64.33912443177681],
            [10.710119039189385, 64.33920814827688],
            [10.710023793355798, 64.33924059423605],
            [10.70979951268481, 64.33928417935421],
            [10.70965001073397, 64.33931089922409],
            [10.709510649971895, 64.33933108437796],
            [10.70750729045076, 64.34029819838031],
            [10.707304962580539, 64.34040031555583],
            [10.707053717402733, 64.34050764955393],
            [10.706896220945389, 64.34058420317315],
            [10.706644693198404, 64.34068137024136],
            [10.706428903706547, 64.34076475302263],
            [10.706279349688417, 64.3408209533797],
            [10.706004322773618, 64.34092650921869],
            [10.705850110471696, 64.34096738040624],
            [10.705791936622049, 64.34098275314435],
            [10.705395127377837, 64.34115781795508],
            [10.704284052851769, 64.34198324496302],
            [10.69961461947984, 64.34539018657534],
            [10.698490024794244, 64.34621095484977],
            [10.709644061536935, 64.34929350499311],
            [10.705221119850803, 64.35352346896742],
            [10.702196834543559, 64.35519474610138],
            [10.707508845688185, 64.35697659806267],
            [10.72195407755929, 64.36035320170608],
            [10.724994781188073, 64.36148593544537],
            [10.724966881782974, 64.36153123568907],
            [10.724909018363029, 64.36155507569906],
            [10.724808579088212, 64.36156850353974],
            [10.724711208965587, 64.36160755038415],
            [10.724635588426242, 64.36162682665119],
            [10.724594253600918, 64.3616564528206],
            [10.724564121433692, 64.36169009168349],
            [10.724496952763317, 64.36170305252624],
            [10.724414009276828, 64.36171204690162],
            [10.72437060386598, 64.361740309113],
            [10.724322019941777, 64.36178518504231],
            [10.724258957806274, 64.36180442333367],
            [10.724197102183739, 64.36181457274498],
            [10.724122407740888, 64.36182722376701],
            [10.724065109232114, 64.36185009115275],
            [10.724010020293328, 64.36188542820945],
            [10.723971074784538, 64.3619103596992],
            [10.723866952065949, 64.36194678173892],
            [10.7237748438823, 64.36196332877553],
            [10.723683764870653, 64.3619779281784],
            [10.723621454976378, 64.3619996602288],
            [10.723580863462098, 64.36202049838955],
            [10.723540025874923, 64.36204025064312],
            [10.723465626421353, 64.36206100029443],
            [10.723399718872072, 64.36207651448986],
            [10.723343189718594, 64.36210776409543],
            [10.72330954878085, 64.36213060304893],
            [10.723235482895666, 64.36217320622609],
            [10.7231730954638, 64.36220743090429],
            [10.723098586091728, 64.36223554836495],
            [10.723033896301136, 64.36225523303737],
            [10.722969097191548, 64.36228228568108],
            [10.722892498321455, 64.36232382589876],
            [10.722787716521914, 64.36237712779156],
            [10.72272663682493, 64.36241894147997],
            [10.722670913531125, 64.36246100151001],
            [10.722608716838353, 64.36251132232465],
            [10.722542398209436, 64.36255612914903],
            [10.722490545937037, 64.36258931294451],
            [10.722438837576394, 64.36261890522411],
            [10.72235079378408, 64.36265997601369],
            [10.722283654448956, 64.3626933873454],
            [10.72225249740774, 64.36272025393177],
            [10.722196432459386, 64.36274450508891],
            [10.722124190408532, 64.36277403673684],
            [10.722061823723585, 64.36280277815722],
            [10.722010095332319, 64.36284315683613],
            [10.721954159171663, 64.36287990675112],
            [10.72188703923102, 64.36292118409686],
            [10.72185389754636, 64.36297945505574],
            [10.721805331849438, 64.36300284647608],
            [10.721737018202065, 64.36302979595466],
            [10.721691340306037, 64.3630592945248],
            [10.721622839164533, 64.36307545135732],
            [10.721517338049129, 64.36308535822482],
            [10.721459463220443, 64.36311589368123],
            [10.721397377318192, 64.36315614931901],
            [10.721339294176834, 64.36317602636365],
            [10.721252468321321, 64.36319659167617],
            [10.721111535884956, 64.3632234864109],
            [10.721066001941368, 64.36324139285512],
            [10.721024522213655, 64.36326391239626],
            [10.72096245492235, 64.36329338128907],
            [10.72083816000209, 64.36332669489244],
            [10.720781249920734, 64.36335235914841],
            [10.720736690174167, 64.36337200193157],
            [10.720662175157976, 64.36340011811234],
            [10.720579989210421, 64.36342818985842],
            [10.72050300903494, 64.36345614402718],
            [10.7204101804664, 64.36348992745974],
            [10.720301171394013, 64.36353033945676],
            [10.720171576582489, 64.36357635230132],
            [10.720051757153133, 64.363623549692],
            [10.719924331158303, 64.36367295176184],
            [10.719812697454243, 64.36371688242197],
            [10.719730511091496, 64.3637516057868],
            [10.719632036302125, 64.36379897732499],
            [10.71954131066277, 64.36384855297092],
            [10.719463898793354, 64.36389258483881],
            [10.719397219353421, 64.3639343235214],
            [10.719317003796585, 64.36398968975149],
            [10.719258253358994, 64.36402581713902],
            [10.719194001424704, 64.36406528949463],
            [10.719121961737912, 64.36410812986666],
            [10.719052632575586, 64.36415221805815],
            [10.719001836337977, 64.36418390347221],
            [10.718937562228938, 64.3642128576186],
            [10.718869337809664, 64.36424052763962],
            [10.718778111375913, 64.3642839755184],
            [10.718687131915653, 64.36432050881606],
            [10.7186075331705, 64.3643905452877],
            [10.718495708345403, 64.36447429201729],
            [10.718436691509972, 64.36453342391364],
            [10.718381223754037, 64.36456578158834],
            [10.718233017783524, 64.36468190454107],
            [10.718061165667768, 64.3647753121583],
            [10.718002826662465, 64.36480345067586],
            [10.717944383774288, 64.36482826009663],
            [10.717880464407928, 64.36485758378204],
            [10.717813885631518, 64.36489465035876],
            [10.717749590343843, 64.36493304218766],
            [10.717690744301116, 64.36497375078036],
            [10.71762674500943, 64.36501556715142],
            [10.717573026413845, 64.36505399854329],
            [10.71752484863937, 64.36509016485003],
            [10.717473094439628, 64.36512397922608],
            [10.71741762959711, 64.3651536398831],
            [10.717347322899546, 64.36518066407851],
            [10.717290203080065, 64.36520429840834],
            [10.717229084497276, 64.36523028782378],
            [10.71715664680531, 64.36526399158505],
            [10.71710675876179, 64.36529215222411],
            [10.717054782771628, 64.36532272383747],
            [10.716986908770917, 64.36535543734098],
            [10.716920441813855, 64.36539043929605],
            [10.716835595136612, 64.36542885892243],
            [10.716786670688707, 64.3654520585887],
            [10.71672099145669, 64.3654851058584],
            [10.71661194506021, 64.3655376498703],
            [10.716529389769795, 64.36558000176399],
            [10.716462843915568, 64.36561949588005],
            [10.716369547078125, 64.36567483765458],
            [10.716289400219, 64.36571770934779],
            [10.716224390171583, 64.36575333794946],
            [10.716153866631782, 64.36579105256205],
            [10.716097827000603, 64.36582438158098],
            [10.716041449697547, 64.36586120653257],
            [10.716004247467298, 64.36588951322851],
            [10.715977301362784, 64.36591326573304],
            [10.715934596876973, 64.36594491727621],
            [10.715886390161273, 64.3659799136689],
            [10.71584908409892, 64.3660048912509],
            [10.715774424080507, 64.36605115937328],
            [10.715737967825003, 64.36607157724603],
            [10.715689133076001, 64.36609639729114],
            [10.715630582242358, 64.36612452878161],
            [10.715572159587072, 64.36615050656717],
            [10.715500161488016, 64.36618768335317],
            [10.715441750139396, 64.36622157201654],
            [10.715393413669265, 64.36625206981951],
            [10.715358806345543, 64.36627703636273],
            [10.715322499258408, 64.36631157172894],
            [10.715296808937886, 64.36634722676456],
            [10.715274728190213, 64.36638235815894],
            [10.715244987010989, 64.366418703701],
            [10.715223475267305, 64.3664448624269],
            [10.715185403720861, 64.36648671737638],
            [10.715139800240978, 64.36653428487976],
            [10.715072765087209, 64.36659551827961],
            [10.715013275464367, 64.36665094960428],
            [10.714965298068492, 64.36668712106739],
            [10.714928786781073, 64.36671098276426],
            [10.714866801929544, 64.36674248967901],
            [10.714787001081266, 64.36677512297558],
            [10.714699344293694, 64.36681687523388],
            [10.71464369696997, 64.36683834936377],
            [10.714566712390392, 64.36686755913192],
            [10.714484509853103, 64.36689562733851],
            [10.714415573455195, 64.36691581356125],
            [10.71432302711601, 64.36693701677228],
            [10.71423850133419, 64.36695602754128],
            [10.714159129015759, 64.36697393058307],
            [10.714106222457088, 64.36698847306798],
            [10.714034920923627, 64.36701317445636],
            [10.713963192122502, 64.36703795320096],
            [10.713896926660842, 64.36706495935942],
            [10.713819848485453, 64.36709875058155],
            [10.71373727864583, 64.36713714537161],
            [10.71368140927568, 64.36716535466009],
            [10.713606912888476, 64.36720254739978],
            [10.71357225252318, 64.36722517480608],
            [10.713516069885031, 64.36726470141825],
            [10.713454537960855, 64.36730658844434],
            [10.713379775093626, 64.36736543755725],
            [10.713318089155928, 64.3674083088531],
            [10.713253932199622, 64.36745371469944],
            [10.71320035908302, 64.36748981176001],
            [10.713152338772584, 64.36752490273855],
            [10.713088145062704, 64.36756788032997],
            [10.71302803430118, 64.36760796599596],
            [10.712965494382184, 64.36765031775506],
            [10.712922370501875, 64.36768195627792],
            [10.71289045880911, 64.36770691134623],
            [10.71284482452024, 64.36774665664835],
            [10.712788561365784, 64.36779067533529],
            [10.712721546116873, 64.3678450765332],
            [10.712662661251915, 64.36788461365661],
            [10.712606618445351, 64.36792189673918],
            [10.712539929814046, 64.36796489098055],
            [10.712478462161233, 64.36800102637304],
            [10.712409140766168, 64.36803828020462],
            [10.712316172948347, 64.36808342649742],
            [10.712231293425733, 64.36812062926002],
            [10.712167374242876, 64.36814986086728],
            [10.712098038083154, 64.36818720403022],
            [10.712047240264068, 64.36821879743262],
            [10.711996492399823, 64.36825272950975],
            [10.711966837293096, 64.36828449248445],
            [10.711937196083364, 64.36831616596817],
            [10.711918211822846, 64.36834338714294],
            [10.711901418141407, 64.3683831676344],
            [10.711879284902757, 64.3684398715157],
            [10.71185689200398, 64.36849557896551],
            [10.71183728080599, 64.3685387827947],
            [10.711822908541345, 64.368598950083],
            [10.71181115098734, 64.36864103547411],
            [10.711783838884573, 64.36869102549036],
            [10.711753658689073, 64.36874875224423],
            [10.711736939575932, 64.36879204075152],
            [10.71171776213714, 64.3688191663615],
            [10.711690243073155, 64.36886915030738],
            [10.711660440813507, 64.36891115677713],
            [10.71162196154925, 64.36897816919867],
            [10.711591937867555, 64.36902691117862],
            [10.71156187509111, 64.36907457328931],
            [10.711537240456583, 64.3691153826632],
            [10.71150277315625, 64.36917729873052],
            [10.711476494254342, 64.36924260084245],
            [10.711446342024324, 64.3692868443706],
            [10.71142465671836, 64.36931407630414],
            [10.711386831921574, 64.36935827493234],
            [10.711354627991227, 64.3693957163622],
            [10.711316663963755, 64.36943415772278],
            [10.711276138949003, 64.3694783671502],
            [10.71123566380776, 64.36952491525804],
            [10.711184569880752, 64.36957699546099],
            [10.71111453314657, 64.36964272406667],
            [10.711068881971743, 64.36968120993876],
            [10.71103130612714, 64.36971184188384],
            [10.710964520892432, 64.36975806889048],
            [10.710884463750464, 64.3698135257795],
            [10.710828140208763, 64.36985655327763],
            [10.710779895033914, 64.36989037854102],
            [10.710720699789256, 64.36994249103094],
            [10.71068880839769, 64.3699686149295],
            [10.710659217617106, 64.36999462641583],
            [10.710626666457495, 64.3700263043735],
            [10.710600057022956, 64.3700558191194],
            [10.710572816690979, 64.37008405687543],
            [10.710545490381358, 64.37010752775683],
            [10.70929684789005, 64.37200635909284],
            [10.709253673929105, 64.3720674803872],
            [10.709086741837785, 64.37228435723395],
            [10.7088845615861, 64.37253418101193],
            [10.695222401123624, 64.38185616824082],
            [10.656384113779055, 64.3759813338102],
            [10.634287957426704, 64.37555498436294],
            [10.633867642110726, 64.37546752457885],
            [10.631649430598602, 64.37557709149965],
            [10.631355807280576, 64.3758685077469],
            [10.627772732582804, 64.38054901453984],
            [10.627356100044711, 64.38097852499428],
            [10.626812533824046, 64.38135614893964],
            [10.626297701983535, 64.38165758509653],
            [10.624480953588892, 64.38284421905338],
            [10.624059253909989, 64.38316425252532],
            [10.619480714880916, 64.38734595120535],
            [10.61907861886381, 64.38771411649509],
            [10.618306464682565, 64.38814286499229],
            [10.617876658882224, 64.38835916647454],
            [10.617559089439327, 64.38851904024555],
            [10.614518054450622, 64.39002513207505],
            [10.61438819306788, 64.39009163735847],
            [10.614276678115257, 64.39014862282203],
            [10.61417162336345, 64.39020157625505],
            [10.607550085894125, 64.39349974809947],
            [10.606988293947898, 64.39525180056705],
            [10.605868609554655, 64.39612901955554],
            [10.605440587748792, 64.3962665896723],
            [10.597504762985057, 64.39709202900242],
            [10.597185227732416, 64.39712549254045],
            [10.576028670166284, 64.40565202122144],
            [10.570786901206102, 64.40645632669776],
            [10.557760497129427, 64.40845387624672],
            [10.554050005444715, 64.40902268901556],
            [10.548011069984467, 64.41182930990342],
            [10.54374995359966, 64.41380903920292],
            [10.542697625786193, 64.41429787490826],
            [10.528902977613985, 64.42070375584491],
            [10.52627401982519, 64.42192408016874],
            [10.520264742003043, 64.42471306223904],
            [10.518384603783137, 64.4255853545358],
            [10.511446850912353, 64.42880494412373],
            [10.510482042841513, 64.42925259413718],
            [10.50907682106986, 64.42990429675378],
            [10.508985955564002, 64.42994269262643],
            [10.45637552322884, 64.43499930246324],
            [10.112543148801654, 64.56965658434187],
            [10.249956783483716, 64.68068234446478],
            [10.637781326991291, 65.09882367682651],
            [11.132572897732832, 65.36563883458435],
            [11.40040317095477, 65.2957033546197],
            [11.486048403139968, 65.23685779549838],
            [11.836197446568596, 65.15792378115911],
            [11.915473684836993, 65.16044506519471],
            [11.946125747518584, 65.1489401896938],
            [11.935947601967348, 65.12662523925856],
            [11.960207336540122, 65.11682244779803],
            [11.920935428290896, 65.09970540934263],
            [11.917114760762539, 65.07988933795343],
            [11.878613987908032, 65.06635762622851],
            [11.942053175009674, 65.06737370225844],
            [11.959581454005855, 65.07777030651367],
            [11.984131790072647, 65.06802503926879],
            [12.048860802908123, 65.06686899496847],
            [12.036030955580953, 65.03014172377752],
            [12.085053614730239, 64.99994766015962],
            [12.114132890584251, 65.0042532195261],
            [12.13171170640649, 64.99902560617512],
            [12.119992405483657, 65.01292330210254],
            [12.133347929216525, 65.02165846504268],
            [12.149926102919848, 65.01893373749631],
            [12.161407815228177, 65.00644433648114],
            [12.191622985617759, 64.99907410423928],
            [12.187387584777806, 64.97810394242994],
            [12.247736813789068, 64.97137758046065],
            [12.276820703967806, 64.95978663403872],
            [12.389166954207795, 64.99121623419619],
            [12.507786182748486, 64.97709220889222],
            [12.561257230852611, 64.99031124630982],
            [12.580887788201402, 64.9870511514345],
            [12.587158071446163, 64.96252373940216],
            [12.628669435623653, 64.93949726689814],
            [12.715100904851411, 64.9526076973044],
            [12.768324344199641, 64.94077501109174],
            [12.791317848714355, 64.95344862531299],
            [12.774677105339125, 64.97552955741611],
            [12.906963963680157, 64.97424882019499],
            [12.94805049847644, 65.00002293637702],
            [12.910960874413988, 65.01712749485687],
            [12.907894606509956, 65.0290579622087],
            [12.92988587964755, 65.03875574743321],
            [12.967593993808599, 65.03287704271214],
            [12.995960108821512, 65.0684489472268],
            [13.053238729631422, 65.07378890742679],
            [13.085395608625877, 65.10996787149844],
            [13.152544842072656, 65.11587821690402],
            [13.411249828068648, 65.0990780079642],
            [13.52978901123218, 65.11673006681046],
            [13.628920389912583, 65.10531716127133],
            [13.931619077291984, 65.11868725284714],
            [13.948850568592977, 65.126831390034],
            [14.012209310916857, 65.1295053325977],
            [14.063855831105185, 65.12195751232167],
            [14.164296948907745, 65.13924894897147],
            [14.191513185640638, 65.13107930570915],
            [14.252453129208739, 65.13143231058032],
            [14.2966592367091, 65.11505526220567],
            [14.325985837453887, 65.11891514981411],
            [14.07729968629305, 64.93893620586086],
            [13.705473168169396, 64.63995683003515],
            [13.654259625547283, 64.58034097411505],
            [13.891176910396258, 64.50713312124809],
            [14.08523316784382, 64.47824942191191],
            [14.113871619032556, 64.46248276393028],
            [14.157110092041696, 64.19505543508804],
            [13.967526720542418, 64.00797039229379],
            [13.715399082677937, 64.04628990998255],
            [13.211109667100082, 64.09536682525807],
            [12.926718801855394, 64.05795219714233],
            [12.68356811761007, 63.974222248731266],
            [12.330575454385169, 63.71506906556137],
            [12.299462032149561, 63.6719790391799],
            [12.149770693016862, 63.59394499988305],
            [12.21287832833656, 63.47859055888195],
            [12.084090095380459, 63.3555796317745],
            [11.97458217609219, 63.2692252484801],
            [12.052459338263922, 63.18344794318978]
          ]
        ]
      },
      "properties": {
        "objektType": "SkredVarslingsområde",
        "omradeID": 3019,
        "omradeNavn": "Nord-Trøndelag",
        "safeName": "Nord_Trøndelag",
        "regionType": "B",
        "dataUttaksdato": "20200127",
        "eksportType": "NVEs nedlastningsløsning"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [16.81532882782304, 78.33793952226205],
            [17.298797350787794, 78.22122695236885],
            [17.386038881431354, 78.15230870781487],
            [17.312604232776888, 78.08541858026732],
            [17.2259155095288, 78.0574340802448],
            [17.345602205509064, 77.99714073143944],
            [17.332708951733792, 77.97402670308169],
            [17.265234120735816, 77.94836323693734],
            [16.79127635353273, 77.91692085822267],
            [16.735780235127574, 77.90443377257986],
            [16.75074321346473, 77.89404480911799],
            [16.677990324622, 77.88056570315891],
            [16.65706280480737, 77.85860342239337],
            [16.641195499943045, 77.8575143039856],
            [16.4909381282942, 77.85679949582938],
            [16.404859119510146, 77.8475400407298],
            [16.304188099701506, 77.85874053144668],
            [16.251342638239954, 77.85098835118794],
            [16.094844626603447, 77.847148875346],
            [16.03792059462631, 77.83573436261995],
            [15.988544508922425, 77.84195458219635],
            [15.896121540131231, 77.82690741342418],
            [15.70837907424238, 77.836572017061],
            [15.625692993703746, 77.85357245367045],
            [15.360863536355216, 77.87207068751394],
            [15.082842587618464, 77.79909236009624],
            [14.878021157241712, 77.78811095798342],
            [14.67089884801387, 77.87365123087578],
            [14.516978264699675, 77.92303458913551],
            [14.336818899354178, 77.96290054675895],
            [14.291478421887508, 78.00202244092594],
            [14.31492780006843, 78.01035155392127],
            [14.277666062429919, 78.01982905834792],
            [14.300220064336262, 78.02839002106629],
            [14.211213283404566, 78.04293248141073],
            [14.167444643069182, 78.09536524747239],
            [14.194415832311881, 78.10478523155918],
            [14.322467388407519, 78.1065220199969],
            [14.465170610382422, 78.09771343325045],
            [14.814514216145136, 78.12318340798525],
            [14.910221200128634, 78.10057765721898],
            [15.005800370933319, 78.10558277283008],
            [14.983361970839137, 78.14583269012715],
            [15.405763918280325, 78.25105542191213],
            [15.540072215648829, 78.24804756036693],
            [15.579078983166108, 78.2307130741408],
            [15.670639888394643, 78.22256959187996],
            [15.674646022230586, 78.22221236273656],
            [15.710362819521206, 78.2190240532243],
            [15.746608247757468, 78.23311282959781],
            [15.56304614197989, 78.28561174803252],
            [15.588586489395544, 78.3024069660823],
            [15.840881173495061, 78.35157038640274],
            [16.017250995268466, 78.35302099423349],
            [16.13849131495509, 78.36357508379157],
            [16.228721235783954, 78.3500412225407],
            [16.336770883478692, 78.35127443175423],
            [16.461716056649205, 78.33567563656841],
            [16.5314920863841, 78.34229694800237],
            [16.619394110833603, 78.3329533638268],
            [16.81532882782304, 78.33793952226205]
          ]
        ]
      },
      "properties": {
        "objektType": "SkredVarslingsområde",
        "omradeID": 3003,
        "omradeNavn": "Nordenskiöld Land",
        "safeName": "Nordenskioldland",
        "regionType": "A",
        "dataUttaksdato": "20200127",
        "eksportType": "NVEs nedlastningsløsning"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [18.125923898236508, 68.53651485242762],
            [18.103615435077895, 68.43246980871895],
            [18.147857535356415, 68.20201662597518],
            [17.89672002571903, 67.97159258062207],
            [17.679833834261327, 68.03804672540322],
            [17.28062999424164, 68.11936637219611],
            [17.188083719773292, 68.05606179347387],
            [16.726786915310367, 67.91272521980757],
            [16.556285010152724, 67.64719273998497],
            [16.4075678027176, 67.5340260490341],
            [16.316927006440434, 67.56451278269591],
            [16.148557259884946, 67.64264592760662],
            [16.16577586310314, 67.6859606724986],
            [16.11773646646975, 67.70624843377584],
            [16.07115550834255, 67.70691085312907],
            [16.107001276119338, 67.72913422046676],
            [16.07145091865062, 67.71806853825876],
            [16.051167917019537, 67.72169907608813],
            [16.074008265423863, 67.73368765110305],
            [16.057049491523284, 67.73735973201623],
            [15.992536607691411, 67.71276324958171],
            [15.985555385626741, 67.72571245622326],
            [16.009033112564317, 67.73972557708174],
            [15.970273048539877, 67.76574861850915],
            [15.954427551613467, 67.76843511991837],
            [15.935621041440834, 67.75991610245158],
            [15.866257227074787, 67.77691853307593],
            [15.911071876421436, 67.80499911731005],
            [15.87029537595636, 67.81339127782468],
            [15.868759969355779, 67.82637949195005],
            [15.839118954288011, 67.8288220812259],
            [15.818849905399098, 67.84127416580169],
            [15.799410137508689, 67.83785127004973],
            [15.742014154781222, 67.84753370943088],
            [15.762260232005499, 67.867155174277],
            [15.705824493963409, 67.90019163857274],
            [15.720175312987497, 67.92730928579776],
            [15.755076158750569, 67.93165845005403],
            [15.754715376756378, 67.94259430066792],
            [15.719903332371612, 67.95042842430573],
            [15.737787440258652, 67.95809918850215],
            [15.736217014011304, 67.98252997843909],
            [15.368397785743776, 67.9408892247151],
            [15.33787623697641, 67.99145290983228],
            [15.287405017011746, 68.00939780462622],
            [15.245764821959874, 68.05440158268136],
            [15.192754673070791, 68.08066229127584],
            [15.070155780979821, 68.11837335641646],
            [15.121011657131884, 68.14196201892895],
            [15.194535140581804, 68.16998294693077],
            [15.362711194606153, 68.20773305616164],
            [15.79396926323313, 68.24730836524148],
            [15.815883026540904, 68.28675823936754],
            [16.029851431564456, 68.37680948871797],
            [16.040450518417288, 68.42240096031642],
            [16.160819111927314, 68.52207512874888],
            [16.23562183868555, 68.54980687168779],
            [16.381792760504567, 68.5648089402537],
            [16.45631587131733, 68.55262821491688],
            [16.48128512091572, 68.55265751891329],
            [16.55094968728888, 68.57472503098906],
            [16.602588097576817, 68.54526532320902],
            [16.56484475949669, 68.53659254726963],
            [16.556563919437345, 68.52424177236082],
            [16.57779477330953, 68.50194372744488],
            [16.628925121661467, 68.49897638179736],
            [16.71429470186755, 68.51077783179551],
            [16.866878883425354, 68.57276561219827],
            [17.20451184699449, 68.55732912800887],
            [17.33770915117833, 68.5624560039032],
            [17.547589369885582, 68.59700848490196],
            [18.023286448433353, 68.60845523653815],
            [18.125923898236508, 68.53651485242762]
          ]
        ]
      },
      "properties": {
        "objektType": "SkredVarslingsområde",
        "omradeID": 3015,
        "omradeNavn": "Ofoten",
        "safeName": "Ofoten",
        "regionType": "A",
        "dataUttaksdato": "20200127",
        "eksportType": "NVEs nedlastningsløsning"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [11.153986002947322, 60.6051477506487],
            [11.10784518532416, 60.56966544994218],
            [11.092591982482903, 60.51676894022004],
            [11.067134018254096, 60.51866814854456],
            [10.980715896675761, 60.500110283648624],
            [10.922589835520085, 60.47058697190672],
            [10.77942541915483, 60.48916898000804],
            [10.710801312110581, 60.52214382141208],
            [10.711302738684108, 60.497157015968746],
            [10.692413062337247, 60.49202550540807],
            [10.710195109194055, 60.45397320625049],
            [10.671977667485363, 60.43385709721782],
            [10.819523497901514, 60.42737177799953],
            [10.903109406225092, 60.39629218196078],
            [10.902088522591363, 60.37807290813418],
            [10.933902696774423, 60.34669199096342],
            [10.882833612624708, 60.318724506931744],
            [10.872311168206542, 60.32082456777124],
            [10.782218726091063, 60.22958280231634],
            [10.770182787845506, 60.151062251191796],
            [10.722648408201966, 60.15756775987245],
            [10.676881299699096, 60.147582303862045],
            [10.68031961054535, 60.13353032001292],
            [10.600720249305056, 60.13160981872188],
            [10.596928159341562, 60.145196109699896],
            [10.560687255208421, 60.16555751252065],
            [10.495193918959037, 60.17263561563263],
            [10.376291954174198, 60.22360848550853],
            [10.357407244501296, 60.2168469655275],
            [10.310172116727337, 60.245087515876094],
            [10.319490475420087, 60.26319229655807],
            [10.199175995182479, 60.37553781983948],
            [10.156375213300448, 60.52219305057253],
            [10.094054913520276, 60.55956653095894],
            [10.03532987447749, 60.632055005616344],
            [9.962893784014298, 60.63792596374688],
            [9.903134827452298, 60.6342784210815],
            [9.952252698201349, 60.61089984164787],
            [9.853391000500315, 60.567694763557725],
            [9.843245518310868, 60.58663358994803],
            [9.832300639003464, 60.57972599016801],
            [9.81047621813827, 60.55606483682903],
            [9.830494395697379, 60.456421923418404],
            [9.80089629824338, 60.45423283427813],
            [9.611785085625412, 60.50034267194187],
            [9.607069571929259, 60.53885508696744],
            [9.495721570526351, 60.527579288293005],
            [9.417290994101656, 60.547658655659134],
            [9.410588243251617, 60.58275485774111],
            [9.435144329337042, 60.59956434123161],
            [9.42134813748014, 60.61301083685455],
            [9.388980784790238, 60.61688324889144],
            [9.36715926987665, 60.6297555143309],
            [9.352647039150263, 60.66711740441623],
            [9.32131719292488, 60.679489944388166],
            [9.318031204577215, 60.69899482637334],
            [9.332110104958202, 60.729904214566126],
            [9.291303549111717, 60.76186300888666],
            [9.216258959780783, 60.770573371105044],
            [9.19287654752437, 60.79087209179481],
            [9.146906768497253, 60.80683103984089],
            [8.918991014575207, 60.86337604691631],
            [8.890585181996528, 60.8966212521313],
            [8.814491234969273, 60.90058560538342],
            [8.657227798589465, 60.939159587742786],
            [8.678056017707947, 60.96869661046042],
            [8.73820995763849, 61.0045634589217],
            [8.742820244941386, 61.02966778387354],
            [8.679739201372273, 61.05546791977903],
            [8.7979570839958, 61.13708642611508],
            [8.859996587372997, 61.13197306902018],
            [8.875117042300591, 61.18606916987217],
            [9.02377329500077, 61.24758412548689],
            [9.230962732578032, 61.45141502252682],
            [9.211228153815135, 61.56037419736296],
            [9.294271270161438, 61.585897186263125],
            [9.40110756106692, 61.64918628068608],
            [9.437357778726845, 61.638332218252245],
            [9.555197274257104, 61.67053152928485],
            [9.712123806045941, 61.783280402219795],
            [9.746386089180245, 61.824878597110505],
            [9.925393265893742, 61.8333070628187],
            [10.015503479200653, 61.8844452594885],
            [10.011705251447264, 61.90875397969661],
            [10.052874473194034, 61.91342400997874],
            [10.087334404799044, 61.90618550113957],
            [10.124723921883906, 61.884482695760106],
            [10.16482225048629, 61.881925176987735],
            [10.052638464338946, 61.75176698399951],
            [10.19317808826918, 61.719876913445596],
            [10.291015977380196, 61.71337677449978],
            [10.404652996020431, 61.66813860885662],
            [10.490128306561447, 61.72049780654631],
            [10.577684479703123, 61.74396605493445],
            [10.639634406024083, 61.707869052391125],
            [10.654613661562438, 61.59988762362353],
            [10.705044387985177, 61.50139253093223],
            [10.68053475487257, 61.47159292269126],
            [10.753395377354611, 61.4047169371895],
            [10.849054636748885, 61.2660153296083],
            [10.743669817545578, 61.23641180401414],
            [10.722622110465382, 61.20250827832973],
            [10.657365151907708, 61.162786596854176],
            [10.637510761635943, 61.12444346307165],
            [10.626054392785392, 61.12561094213482],
            [10.574299081596653, 61.082424434328324],
            [10.546999630795625, 61.08279105931741],
            [10.510239521562122, 61.06485658572013],
            [10.442950831850824, 61.06229648694662],
            [10.484891482653852, 61.01789170740419],
            [10.59504730577618, 60.98629185899858],
            [10.650988940040795, 60.95580532453468],
            [10.681544250556435, 60.90310951392131],
            [10.722805412313193, 60.8699708016127],
            [10.694695462379144, 60.824000014055265],
            [10.738048793488778, 60.77866185187063],
            [10.778017036455685, 60.76412847747927],
            [10.861811113070038, 60.75096730440065],
            [11.093086022952487, 60.65824620557612],
            [11.153986002947322, 60.6051477506487]
          ]
        ]
      },
      "properties": {
        "objektType": "SkredVarslingsområde",
        "omradeID": 3042,
        "omradeNavn": "Oppland sør",
        "safeName": "Oppland_sor",
        "regionType": "B",
        "dataUttaksdato": "20200127",
        "eksportType": "NVEs nedlastningsløsning"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [10.68031961054535, 60.13353032001292],
            [10.7072627413985, 60.11940333585275],
            [10.73868948433596, 60.12563876204395],
            [10.767744339171443, 60.11298254966289],
            [10.754849709401288, 60.10024668446784],
            [10.785743055257404, 60.069096847049934],
            [10.819631408160067, 60.06471548667971],
            [10.811705830319163, 60.02546660636919],
            [10.821144965713671, 60.01737810600497],
            [10.828334793465379, 60.02215153439113],
            [10.837688556871047, 59.99803551819295],
            [10.849278014703808, 60.00202262945761],
            [10.89315510425073, 59.98080203353044],
            [10.925650263157133, 59.983724240983236],
            [10.936206846424737, 59.97156582299359],
            [10.951389441905965, 59.94924298867558],
            [10.921416189975472, 59.92647496514193],
            [10.907158498257445, 59.869893465966655],
            [10.936608835980394, 59.8317020584302],
            [10.856299511710176, 59.80931131839779],
            [10.812456031784519, 59.8253618409945],
            [10.771553297404523, 59.823506110719336],
            [10.744019668227386, 59.83928320264522],
            [10.73100663891497, 59.877178566827084],
            [10.688962492412386, 59.87592809719597],
            [10.658082484659955, 59.884410483442366],
            [10.647765600970425, 59.90940770820996],
            [10.625689730108778, 59.92270845947743],
            [10.635615448326776, 59.9478452502469],
            [10.613956055887192, 59.974323454967575],
            [10.59065368064662, 59.97717003608584],
            [10.55585521816055, 59.99672657430896],
            [10.518070354830757, 59.999291170702094],
            [10.489165172838883, 60.01725987237466],
            [10.580764868996987, 60.076238420701685],
            [10.597304033458236, 60.07728003527356],
            [10.57278253020766, 60.11678480264957],
            [10.600720249305056, 60.13160981872188],
            [10.68031961054535, 60.13353032001292]
          ]
        ]
      },
      "properties": {
        "objektType": "SkredVarslingsområde",
        "omradeID": 3045,
        "omradeNavn": "Oslo",
        "safeName": "Oslo",
        "regionType": "B",
        "dataUttaksdato": "20200127",
        "eksportType": "NVEs nedlastningsløsning"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [26.260195670381233, 69.81903850270699],
            [26.10532224712103, 69.81768640504862],
            [26.077223709995373, 69.84979480263114],
            [25.953006245691263, 69.84173157489533],
            [25.879837301975527, 69.86541398089362],
            [25.81377028568999, 69.86266233476685],
            [25.832746554894026, 69.89050126833484],
            [25.767371624046337, 69.9031575292314],
            [25.840743759827358, 69.94927487189149],
            [25.914689129684778, 69.97193053726352],
            [25.9555634246834, 69.97969205891054],
            [26.054205651392007, 69.98214922601075],
            [26.125103187509875, 69.97311696668545],
            [26.265345575408865, 69.9979474946054],
            [26.244596714440203, 70.0782474630622],
            [26.743088958501392, 70.14319020938315],
            [27.011495497045487, 70.15637656033677],
            [27.009708264969927, 70.21418613658449],
            [27.367701170810214, 70.29235658457148],
            [27.391039394330527, 70.3784502692092],
            [27.42789121162983, 70.39948477811998],
            [27.495302368284083, 70.4144070546595],
            [27.624800018148555, 70.4985038549241],
            [27.78030092728103, 70.5465447373865],
            [27.921599577301, 70.56116800758865],
            [28.238899297957072, 70.66400971221756],
            [28.31446123868256, 70.75584228608179],
            [28.385282096515436, 70.76160052980589],
            [28.907994463581115, 71.0082233904899],
            [29.119372284365905, 70.96219215729393],
            [30.36001203111818, 70.75393081591747],
            [31.28767040684198, 70.39192218919221],
            [31.27857205919594, 70.23587735953213],
            [30.708268464613667, 69.95951986531871],
            [30.64884186257322, 69.88206714748335],
            [30.821585033019844, 69.79002073126657],
            [30.8903807140777, 69.73729241497759],
            [30.87415811384382, 69.71490149667339],
            [30.94487592856711, 69.6833477370521],
            [30.94651312291934, 69.67443435268372],
            [30.92301137960942, 69.66900741566405],
            [30.954538355734254, 69.63243205364596],
            [30.938864675023684, 69.56073651595017],
            [30.816469618217237, 69.52870792825402],
            [30.664225567028, 69.54068575962029],
            [30.515976254144725, 69.54042410445325],
            [30.417730285945552, 69.58991630354097],
            [30.224023105529643, 69.6531216125377],
            [30.151661467040345, 69.66937301516495],
            [30.085324429340602, 69.65810438261094],
            [30.091287321790965, 69.64283631527351],
            [30.137807600061983, 69.64353310266591],
            [30.18842327193786, 69.56845771165021],
            [30.176707763758642, 69.53741366645953],
            [30.120023732793513, 69.51386638452284],
            [30.11386274587198, 69.46777499386567],
            [29.99234681682885, 69.41203632056913],
            [29.942420698412427, 69.40520753747172],
            [29.917088688069747, 69.41826441921438],
            [29.861886109137366, 69.42410014106237],
            [29.787798523752485, 69.39766222410472],
            [29.7244252731211, 69.38964867093019],
            [29.695083006711766, 69.36345896103893],
            [29.569407812643973, 69.3175592838552],
            [29.53473633891571, 69.31797936657111],
            [29.52276199390057, 69.32911080897071],
            [29.41618896155923, 69.31858394695386],
            [29.395961678206262, 69.32384404698416],
            [29.2884728989041, 69.29618098858116],
            [29.27657619899041, 69.25872029643027],
            [29.313494326525014, 69.2285030611004],
            [29.286145378383424, 69.17581589954032],
            [29.248616718504426, 69.16149228675208],
            [29.242261205384658, 69.11306239139725],
            [29.04151303351329, 69.01082917942799],
            [29.01992937910119, 69.02518387057054],
            [28.854577130567705, 69.07663880887036],
            [28.80543005069157, 69.11115589326275],
            [28.83153908143474, 69.22436171827408],
            [29.219339459891657, 69.39763620917178],
            [29.336495624737022, 69.47832270473464],
            [29.170536975309467, 69.63904145476089],
            [29.133909469528074, 69.69534041857234],
            [28.404225479500454, 69.81842497108627],
            [28.330476046106554, 69.84919257052113],
            [28.345067672843822, 69.8807969453221],
            [28.160712862924843, 69.92099364711632],
            [27.984285298081574, 70.01397068243033],
            [27.959381641040377, 70.09209972587301],
            [27.797692758812378, 70.07730632289655],
            [27.74379132346697, 70.06416121415238],
            [27.69293628746748, 70.07658537946156],
            [27.612460491054726, 70.07456026548107],
            [27.554301159562495, 70.05898373249798],
            [27.525989791086072, 70.02346385499271],
            [27.428559937906634, 70.01921345789727],
            [27.35821223274621, 69.99153288270615],
            [27.288792934960462, 69.98451783973199],
            [27.27471616930962, 69.97590948568143],
            [27.30299690532154, 69.96225645318732],
            [27.295039390337216, 69.95305358235491],
            [27.130835923016406, 69.93220773849622],
            [27.09993704480989, 69.91755804798228],
            [27.03976474754915, 69.91055935239282],
            [26.96972786058489, 69.93848568258981],
            [26.878300869210783, 69.93341490771671],
            [26.851293325142834, 69.96013488101417],
            [26.784759292850215, 69.95855112244813],
            [26.718073909055416, 69.94498654077186],
            [26.678691362619805, 69.96477230120281],
            [26.49048954563697, 69.94502153227506],
            [26.407538553327697, 69.90148204784037],
            [26.418215704445004, 69.88909308536914],
            [26.385938793405984, 69.85534700543121],
            [26.260195670381233, 69.81903850270699]
          ]
        ]
      },
      "properties": {
        "objektType": "SkredVarslingsområde",
        "omradeID": 3005,
        "omradeNavn": "Øst-Finnmark",
        "safeName": "Ost_Finnmark",
        "regionType": "B",
        "dataUttaksdato": "20200127",
        "eksportType": "NVEs nedlastningsløsning"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [10.675019827881227, 59.045287940377804],
            [10.622716238008302, 59.111703211590665],
            [10.650976494533284, 59.132815327775],
            [10.655050150731858, 59.191957592148405],
            [10.590331585006043, 59.26848324610236],
            [10.578244898942453, 59.340935542334414],
            [10.595274638675685, 59.374140625080194],
            [10.584161857567084, 59.39306382470963],
            [10.544031732349035, 59.41230047695761],
            [10.54305966600501, 59.45732694695945],
            [10.616438431657459, 59.5345808270909],
            [10.659291456284887, 59.517231253406855],
            [10.679577355829249, 59.488320276623696],
            [10.708315888849027, 59.49045153412092],
            [10.728702741759161, 59.47249422394309],
            [10.753197826622928, 59.483462682545984],
            [10.74751651782226, 59.49230276179584],
            [10.77933205914076, 59.49570586117872],
            [10.772302834896026, 59.51035089888564],
            [10.786580533261477, 59.535464306937804],
            [10.771343253146238, 59.551585925966826],
            [10.846746253514285, 59.56958980021159],
            [10.852958384262216, 59.57759012572403],
            [10.837395134948224, 59.58311896068593],
            [10.870176561891398, 59.59499188840012],
            [10.867855976099133, 59.607421921570555],
            [10.891606840907894, 59.608078142055696],
            [10.879906148287288, 59.61867649899346],
            [10.906781707768438, 59.62030269668604],
            [10.914461845409049, 59.63207964584025],
            [10.920749213776345, 59.627275057121714],
            [10.935331454227107, 59.63154997155844],
            [10.938318107415556, 59.64727303407683],
            [10.951647156170122, 59.64942944683718],
            [10.960833204397463, 59.63552393769324],
            [10.984361358301099, 59.65921854694139],
            [10.952783317568528, 59.67299619593468],
            [10.970041563879228, 59.70486335898583],
            [11.037982849384623, 59.69146317540447],
            [11.102027744508032, 59.70332595528309],
            [11.105315060602523, 59.691456223654185],
            [11.13266577991558, 59.702156962996185],
            [11.153205980834475, 59.684421183413924],
            [11.230280186071836, 59.68274101622328],
            [11.23729217039854, 59.756958539380946],
            [11.25483596445324, 59.77026130543756],
            [11.343559579164452, 59.754599222299106],
            [11.37312844641378, 59.72777855515567],
            [11.367762396650967, 59.698207208552354],
            [11.420462785580808, 59.67399497521672],
            [11.465915835265395, 59.666306735492405],
            [11.503428600967776, 59.632116359336884],
            [11.499308785197607, 59.62350259649804],
            [11.477294939441418, 59.62416524513555],
            [11.476696295216394, 59.60107722941887],
            [11.492860427148312, 59.59364646112408],
            [11.52049570397293, 59.6017546669351],
            [11.528322030055675, 59.616713625757875],
            [11.545410442860712, 59.618090007667654],
            [11.532047864309517, 59.63887720731926],
            [11.589784099744657, 59.649637794228084],
            [11.626569975087085, 59.66604528908793],
            [11.623890518802764, 59.67721598403649],
            [11.650635979376208, 59.672464927262844],
            [11.66996780611486, 59.69848749456836],
            [11.70762511286343, 59.72001526522872],
            [11.679633383762962, 59.74183560684273],
            [11.72610166679461, 59.760362346922165],
            [11.75790560859153, 59.761150209807724],
            [11.764146910513729, 59.77254842108214],
            [11.793483056320115, 59.78311568269801],
            [11.9064805553631, 59.78125825572429],
            [11.926977599480105, 59.790585722280525],
            [11.933658512215034, 59.76018740533982],
            [11.923025909405201, 59.749940477184154],
            [11.944916853801516, 59.69823828066037],
            [11.889216534193977, 59.69320825270142],
            [11.855709115388903, 59.64829534353768],
            [11.778892385428192, 59.64299446005268],
            [11.720557600719738, 59.625487649927024],
            [11.691128335383578, 59.589548650352114],
            [11.753207089474005, 59.47936924127213],
            [11.779865305952486, 59.38645964489708],
            [11.816245151332135, 59.34474444656028],
            [11.829796256099806, 59.24160713493344],
            [11.782993513152183, 59.206643338412626],
            [11.778015445663199, 59.1360435985265],
            [11.763624444716603, 59.11453732134415],
            [11.780917571027395, 59.099630229155274],
            [11.775721228744674, 59.086948632616185],
            [11.710510062549524, 59.03368052193536],
            [11.683913841032448, 58.98999884997588],
            [11.689082563473761, 58.95684511308939],
            [11.675860383955685, 58.93506438956983],
            [11.658171041476002, 58.93176167159094],
            [11.652003001202836, 58.90623333520496],
            [11.630426337287545, 58.908615081548675],
            [11.590629479461844, 58.890715813734346],
            [11.577822240537925, 58.89749441062469],
            [11.57249482066739, 58.88782536130136],
            [11.55341565847013, 58.89893513345133],
            [11.533708935787658, 58.8860722642892],
            [11.537413095849578, 58.87741823738258],
            [11.500114851254853, 58.889382046222224],
            [11.455812578740412, 58.889183145278146],
            [11.463659675725403, 58.93326177378731],
            [11.453874273716716, 58.985467269845714],
            [11.464598196582848, 58.991152057733295],
            [11.368410030449189, 59.098436627848976],
            [11.339912402257749, 59.11497902048765],
            [11.28904272022816, 59.099576888214045],
            [11.153506179763205, 59.07925679684322],
            [11.092381588996446, 58.99180559107062],
            [11.066417444904936, 58.97739441860369],
            [10.93792357318155, 58.9478515148517],
            [10.882271697622777, 58.98255696479714],
            [10.675019827881227, 59.045287940377804]
          ]
        ]
      },
      "properties": {
        "objektType": "SkredVarslingsområde",
        "omradeID": 3046,
        "omradeNavn": "Østfold",
        "safeName": "Ostfold",
        "regionType": "B",
        "dataUttaksdato": "20200127",
        "eksportType": "NVEs nedlastningsløsning"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [6.118118869080071, 59.585343129112395],
            [6.196530095778948, 59.584929197692055],
            [6.280358949755752, 59.56603565311734],
            [5.984180950937414, 59.13859896098506],
            [6.1556637973646, 58.7982789665251],
            [6.168836951404229, 58.79119110975313],
            [6.2640218199054996, 58.55879691026499],
            [6.606548628210985, 58.53142719517537],
            [6.587697948192539, 58.492770624048475],
            [6.596123743030164, 58.496607905328524],
            [6.607412656450225, 58.48942913568838],
            [6.632150304752484, 58.451400888083604],
            [6.5953206088248955, 58.41631338472347],
            [6.608524392880298, 58.37217495912463],
            [6.543394175498408, 58.319500581453646],
            [6.372950593663838, 58.27650740920263],
            [6.256739186575417, 58.147529983442666],
            [5.892101648775055, 58.315702900203625],
            [5.42696693956523, 58.56326871875086],
            [5.068221306505053, 58.99643702096291],
            [4.748516357421849, 59.298390698444166],
            [4.872082674633404, 59.43631187669407],
            [4.88336571685133, 59.511799000495344],
            [4.976893270578358, 59.4961281036915],
            [5.187412395144026, 59.51547857527121],
            [5.2431714635980375, 59.50467145868042],
            [5.314694597630812, 59.4754208020048],
            [5.36061679189772, 59.49334349194925],
            [5.364883885672899, 59.49500712439179],
            [5.389469927523839, 59.49106765897188],
            [5.389401684906702, 59.49113617870293],
            [5.422718203167291, 59.49968203333672],
            [5.4531065881178, 59.49767690830838],
            [5.453296054650378, 59.49725191226763],
            [5.456245742900315, 59.499516956215516],
            [5.4677141508505045, 59.511786322911085],
            [5.467802023777011, 59.512148413520904],
            [5.491827235963186, 59.510635097160325],
            [5.51411264964784, 59.51732033486476],
            [5.531989178969979, 59.53576777242879],
            [5.533498179492428, 59.53736722198912],
            [5.534166574676251, 59.53692194967404],
            [5.548012848077654, 59.54425883053722],
            [5.555410855950652, 59.54937656828436],
            [5.567199931877058, 59.558593953076674],
            [5.563961935017192, 59.58225773326855],
            [5.555836149069405, 59.60000894056492],
            [5.554562811569, 59.600431499326355],
            [5.554590688116327, 59.602727825481594],
            [5.555136248649876, 59.64785421379444],
            [5.594448633136881, 59.685590214642474],
            [5.612846306950833, 59.68527382557616],
            [5.6369746119873465, 59.66891550354487],
            [5.667060447470683, 59.66383759151924],
            [5.679816638667252, 59.66836797037611],
            [5.771083149028003, 59.649216894235664],
            [5.772206638544088, 59.64758110206977],
            [5.808557783933457, 59.64397564125702],
            [5.823429095969827, 59.645405285065294],
            [5.834139990193743, 59.631643997081085],
            [5.891525382710388, 59.62571326485311],
            [5.907024288058036, 59.60787390216673],
            [5.963017461537923, 59.60105564157473],
            [5.969413400074668, 59.57896789502067],
            [6.004635701097077, 59.585107858148604],
            [6.008278111173128, 59.59531457933184],
            [6.0424927651284195, 59.591065324287506],
            [6.059179387991616, 59.59825145681279],
            [6.118118869080071, 59.585343129112395]
          ]
        ]
      },
      "properties": {
        "objektType": "SkredVarslingsområde",
        "omradeID": 3036,
        "omradeNavn": "Rogalandskysten",
        "safeName": "Rogalandskysten",
        "regionType": "B",
        "dataUttaksdato": "20200127",
        "eksportType": "NVEs nedlastningsløsning"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [7.987612416387952, 62.98767712445336],
            [8.130057111771869, 62.92956456386004],
            [8.138852740538663, 62.851346732255074],
            [8.166168411055454, 62.82521611043347],
            [8.234475011128444, 62.8000184951085],
            [8.294040651420358, 62.800373782740266],
            [8.324456323463084, 62.78781916688374],
            [8.206132069952552, 62.738137765343964],
            [8.291090837711986, 62.67639034108231],
            [8.26947462393742, 62.64772904589156],
            [8.246527037651187, 62.640411089811835],
            [8.217772173182404, 62.577200591148056],
            [8.2485682655671, 62.566304944931616],
            [8.25697472007471, 62.57709391854003],
            [8.31685237587739, 62.574536157007024],
            [8.368875835680443, 62.530594765608974],
            [8.346391405725091, 62.508196708166146],
            [8.513879425386436, 62.45894094818475],
            [8.520990908481675, 62.434783107835386],
            [8.587360117501474, 62.40833631456265],
            [8.666671672463474, 62.4046473401642],
            [8.731640233366708, 62.376872972967526],
            [8.391711054983492, 62.36386583297851],
            [8.205852119942364, 62.33174420038932],
            [8.13125213005481, 62.290660544850255],
            [7.983609909673337, 62.177458831341184],
            [7.863971867755428, 62.17077792133224],
            [7.827342028341916, 62.189686860754755],
            [7.734595489016545, 62.184633181976004],
            [7.683997127431966, 62.19939633746778],
            [7.707879793243752, 62.22687598782987],
            [7.685363213303304, 62.242214637527084],
            [7.633394906313481, 62.255594846612645],
            [7.633493655944448, 62.26598964150698],
            [7.704675313931234, 62.27661135923957],
            [7.691655190772798, 62.29191247515137],
            [7.718228982501359, 62.310791242934805],
            [7.767889835994855, 62.32894266048865],
            [7.7804483361736105, 62.353637943685456],
            [7.82857987495981, 62.36290167357965],
            [7.825506984935378, 62.373923144686934],
            [7.748135603191346, 62.42011214818158],
            [7.670784842013426, 62.423368152150786],
            [7.623830400626478, 62.43686630959571],
            [7.598607315775895, 62.432825761056606],
            [7.608318868387198, 62.41950792951294],
            [7.507696410339896, 62.41620320020387],
            [7.505155433281317, 62.40852500923321],
            [7.458199386485341, 62.39438364029595],
            [7.447544882738345, 62.398225422755054],
            [7.439220008138931, 62.38872089655415],
            [7.376613600700867, 62.387788680561144],
            [7.335402536764973, 62.41651031823167],
            [7.326242644247022, 62.45988502229849],
            [7.252162893652413, 62.47129627227144],
            [7.233262798546348, 62.48430672492286],
            [7.1655503608696804, 62.44655874164201],
            [7.140319355815013, 62.45430882454858],
            [7.102653298945103, 62.44688851146385],
            [7.047320464101079, 62.45628035027663],
            [7.014394297557239, 62.474671279737265],
            [6.9977358594452586, 62.506505672581504],
            [6.978849895449827, 62.5160625701405],
            [6.99113682962289, 62.51795722462083],
            [6.988538059590091, 62.53215377043941],
            [6.9635209429256175, 62.528125081391494],
            [6.902951923351396, 62.544410279334436],
            [6.863981062893466, 62.540597218109426],
            [6.824591711569308, 62.56898123233494],
            [6.783214032129566, 62.5735019142749],
            [6.77105168845717, 62.58821546073065],
            [6.735163681547628, 62.595048084337314],
            [6.765056344522908, 62.60993175429412],
            [6.732577708297184, 62.61819140772498],
            [6.718973090884489, 62.63141065142715],
            [6.691612980664667, 62.62818596126737],
            [6.676576692282994, 62.64823671618854],
            [6.495863327123124, 62.62716214953559],
            [6.4470029814653325, 62.65097741641468],
            [6.516113630258742, 62.699816754928676],
            [6.3292348865543016, 62.74039031317884],
            [6.141786140930312, 62.8123398872141],
            [7.055325480807583, 63.120283117457085],
            [7.139563956759581, 63.17983650222433],
            [7.215076977810782, 63.1543387011524],
            [7.360448611619669, 63.010280729892386],
            [7.33991212629958, 62.999717049550306],
            [7.352629294117444, 62.983935486223224],
            [7.445499044971597, 62.956211061709794],
            [7.489066728205657, 62.92194173651692],
            [7.521395048732485, 62.925246443542854],
            [7.660702735446091, 62.9713414876923],
            [7.752043223005793, 62.989592137078844],
            [7.75630693691404, 63.00533903702276],
            [7.845594706118378, 63.01235637096225],
            [7.900271192086131, 62.97481700442008],
            [7.987612416387952, 62.98767712445336]
          ]
        ]
      },
      "properties": {
        "objektType": "SkredVarslingsområde",
        "omradeID": 3023,
        "omradeNavn": "Romsdal",
        "safeName": "Romsdal",
        "regionType": "A",
        "dataUttaksdato": "20200127",
        "eksportType": "NVEs nedlastningsløsning"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [16.4075678027176, 67.5340260490341],
            [16.158001925775125, 67.51915787685171],
            [16.089829849654382, 67.43527832228918],
            [16.40409981913553, 67.20497337808274],
            [16.387759275817437, 67.04546130889216],
            [16.194017679722997, 66.98259232973069],
            [16.03876189547061, 66.91244708440193],
            [15.7894351643963, 66.7210054581923],
            [14.982986214745091, 66.87367005468249],
            [15.022235426323375, 66.92938499565871],
            [14.912784253313072, 67.03352700069618],
            [14.769473689855785, 67.06775001414086],
            [14.743790485587246, 67.08660297674795],
            [14.71590113958693, 67.08011500388598],
            [14.661005995309843, 67.1273632917814],
            [14.544685517713049, 67.10205521534517],
            [14.48440543150502, 67.1229172736772],
            [14.462778467664478, 67.11793024053516],
            [14.417325879789527, 67.12459687375579],
            [14.382545226555543, 67.13801986172896],
            [14.39506634865766, 67.14259027308994],
            [14.370454434045872, 67.15577946014231],
            [14.30684101453364, 67.15529920337607],
            [14.327773847572894, 67.19109183747801],
            [14.296476166750658, 67.2258533704311],
            [14.17720415489591, 67.22716960795135],
            [14.050315800654362, 67.19811977784885],
            [13.901690685185484, 67.18640407693475],
            [13.863290132804378, 67.20872505212306],
            [13.545607970876581, 67.34520266066501],
            [13.652798945091215, 67.41299018201605],
            [14.135099861108017, 67.58667330651106],
            [14.39669024049599, 67.82986120247101],
            [14.752086982133056, 67.96937860423773],
            [15.070155780979821, 68.11837335641646],
            [15.192754673070791, 68.08066229127584],
            [15.245764821959874, 68.05440158268136],
            [15.287405017011746, 68.00939780462622],
            [15.33787623697641, 67.99145290983228],
            [15.368397785743776, 67.9408892247151],
            [15.736217014011304, 67.98252997843909],
            [15.737787440258652, 67.95809918850215],
            [15.719903332371612, 67.95042842430573],
            [15.754715376756378, 67.94259430066792],
            [15.755076158750569, 67.93165845005403],
            [15.720175312987497, 67.92730928579776],
            [15.705824493963409, 67.90019163857274],
            [15.762260232005499, 67.867155174277],
            [15.742014154781222, 67.84753370943088],
            [15.799410137508689, 67.83785127004973],
            [15.818849905399098, 67.84127416580169],
            [15.839118954288011, 67.8288220812259],
            [15.868759969355779, 67.82637949195005],
            [15.87029537595636, 67.81339127782468],
            [15.911071876421436, 67.80499911731005],
            [15.866257227074787, 67.77691853307593],
            [15.935621041440834, 67.75991610245158],
            [15.954427551613467, 67.76843511991837],
            [15.970273048539877, 67.76574861850915],
            [16.009033112564317, 67.73972557708174],
            [15.985555385626741, 67.72571245622326],
            [15.992536607691411, 67.71276324958171],
            [16.057049491523284, 67.73735973201623],
            [16.074008265423863, 67.73368765110305],
            [16.051167917019537, 67.72169907608813],
            [16.07145091865062, 67.71806853825876],
            [16.107001276119338, 67.72913422046676],
            [16.07115550834255, 67.70691085312907],
            [16.11773646646975, 67.70624843377584],
            [16.16577586310314, 67.6859606724986],
            [16.148557259884946, 67.64264592760662],
            [16.316927006440434, 67.56451278269591],
            [16.4075678027176, 67.5340260490341]
          ]
        ]
      },
      "properties": {
        "objektType": "SkredVarslingsområde",
        "omradeID": 3016,
        "omradeNavn": "Salten",
        "safeName": "Salten",
        "regionType": "A",
        "dataUttaksdato": "20200127",
        "eksportType": "NVEs nedlastningsløsning"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [18.54879828919865, 69.37718614511635],
            [18.508648266028175, 69.33246117690877],
            [18.52004526316586, 69.29511222562215],
            [18.453596021199257, 69.29905104292791],
            [18.260890421335784, 69.24648139593947],
            [18.276805494800584, 69.21742111114281],
            [18.310843560888642, 69.2199102907775],
            [18.34311988650561, 69.20716412232666],
            [18.342428710337714, 69.1886152663342],
            [18.31545781827879, 69.17926075668652],
            [18.19719693413636, 69.18667417586228],
            [18.17827873063258, 69.18077717370323],
            [18.361184686116992, 69.13361084256553],
            [18.44593466776043, 69.13064858987019],
            [18.42264237984085, 69.10146509977032],
            [18.42971564316417, 69.07349653303602],
            [18.460828683624577, 69.05854459920467],
            [18.452446128578266, 69.04366092692166],
            [18.37891424983301, 69.04882625073189],
            [18.368067939777205, 69.0376145482186],
            [18.22694482240944, 68.99543057113587],
            [18.14427062125836, 68.9117550203225],
            [18.179217107209606, 68.88318789208175],
            [18.118509156538067, 68.86764381838407],
            [18.071740435396304, 68.86537342871027],
            [18.13592741020984, 68.83465972653423],
            [18.092453748144862, 68.76881627592658],
            [17.98479643820385, 68.7573694468301],
            [18.0107432399244, 68.73909176774451],
            [17.99489961545073, 68.72592465519628],
            [18.04429593976274, 68.71145052490812],
            [18.050160715959443, 68.69846148474932],
            [18.045572389904212, 68.6552441719098],
            [17.999284453463876, 68.65004046419345],
            [18.023286448433353, 68.60845523653815],
            [17.547589369885582, 68.59700848490196],
            [17.33770915117833, 68.5624560039032],
            [17.20451184699449, 68.55732912800887],
            [16.866878883425354, 68.57276561219827],
            [16.71429470186755, 68.51077783179551],
            [16.628925121661467, 68.49897638179736],
            [16.57779477330953, 68.50194372744488],
            [16.556563919437345, 68.52424177236082],
            [16.56484475949669, 68.53659254726963],
            [16.602588097576817, 68.54526532320902],
            [16.55094968728888, 68.57472503098906],
            [16.48128512091572, 68.55265751891329],
            [16.45631587131733, 68.55262821491688],
            [16.4577998042509, 68.56752388765845],
            [16.429844923738177, 68.58027158782855],
            [16.395667424667657, 68.57967515533221],
            [16.329137038158418, 68.6025141278048],
            [16.307854135802998, 68.60185414173371],
            [16.268136919155705, 68.63111513002035],
            [16.19900769503344, 68.61705289851075],
            [16.154868819774894, 68.61719060463652],
            [16.140706779078315, 68.60647821209761],
            [16.12493010656441, 68.61131141770133],
            [16.120241475855277, 68.60549416463883],
            [16.074131763203425, 68.60247562664965],
            [16.06299639114314, 68.58361975621284],
            [16.02332485261292, 68.5769229470278],
            [15.962338153751848, 68.61389755053719],
            [15.998937408522073, 68.64405078109608],
            [15.995717239888268, 68.67485678334317],
            [16.045701672755904, 68.75783802441782],
            [16.024027233938465, 68.81367115215389],
            [15.938634257230618, 68.81147367653676],
            [15.930780825924755, 68.82523994645729],
            [16.02646020437358, 68.9092709052694],
            [16.11226698060729, 68.93178451578264],
            [16.052313806898393, 69.00862947141752],
            [16.32720929461984, 69.1838812390295],
            [16.364723652339084, 69.11172811017369],
            [16.526389291364232, 69.0885829361048],
            [16.711243644542535, 69.02003915706257],
            [16.748670531012166, 69.32678738233845],
            [16.877486634638384, 69.44453343443939],
            [17.15723381550472, 69.54275353804098],
            [17.427700116222965, 69.5921489117171],
            [17.664222002413492, 69.71550066342022],
            [18.00492905209568, 69.53661090565633],
            [18.073816836082045, 69.52440374769573],
            [18.14762288204993, 69.49582476575057],
            [18.25900275306697, 69.50380435659594],
            [18.36000634001469, 69.5009646371104],
            [18.412921364794013, 69.4593072020838],
            [18.4180848500325, 69.41424170143135],
            [18.519382633335013, 69.39830677590649],
            [18.54879828919865, 69.37718614511635]
          ]
        ]
      },
      "properties": {
        "objektType": "SkredVarslingsområde",
        "omradeID": 3012,
        "omradeNavn": "Sør-Troms",
        "safeName": "Sor_Troms",
        "regionType": "A",
        "dataUttaksdato": "20200127",
        "eksportType": "NVEs nedlastningsløsning"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [12.052459338263922, 63.18344794318978],
            [12.21823295751056, 63.000334468170536],
            [12.07468898103862, 62.90254629651037],
            [12.136384549870206, 62.74791694389485],
            [12.05614400473314, 62.61191913728687],
            [12.254665262295756, 62.33102492413106],
            [12.208930962456193, 62.33112375606931],
            [12.166634724173365, 62.31285097886767],
            [12.130958699575224, 62.31004406151404],
            [12.05039940014038, 62.3484924996671],
            [11.775646584160699, 62.382642109612995],
            [11.74774135832055, 62.36192170903887],
            [11.724647310695925, 62.35910663920876],
            [11.727132436753765, 62.34758156480137],
            [11.688839930989518, 62.350451025710385],
            [11.671719764100503, 62.38178765503374],
            [11.556107244544679, 62.371585786129735],
            [11.44653954033598, 62.47032151326293],
            [11.370960923355135, 62.49374842616339],
            [11.340369600654524, 62.51452019665278],
            [11.298517707344523, 62.52182360160946],
            [11.285470597913937, 62.53128497523235],
            [11.254266763449246, 62.532485473712306],
            [11.243888425458069, 62.5668602859084],
            [11.196123072967255, 62.5707594095664],
            [11.196428949210533, 62.59403497437975],
            [11.164457032812352, 62.61601746209183],
            [11.16012209511618, 62.64737904027614],
            [11.131453209457412, 62.64987906776242],
            [11.12453962738762, 62.661668169071035],
            [11.04382047860382, 62.66683504461746],
            [10.928247934715626, 62.69629568212847],
            [10.825307920240277, 62.68830488493655],
            [10.792361591269955, 62.67908459889524],
            [10.740345128470612, 62.64546668282717],
            [10.718072602148615, 62.65017594141677],
            [10.711754506354541, 62.666012186869764],
            [10.673069860175167, 62.67505323527517],
            [10.649512361334608, 62.676579971288454],
            [10.592832508100594, 62.66381116267349],
            [10.325076717304867, 62.695295656522646],
            [10.317560424383197, 62.726638095594105],
            [10.18789855061616, 62.758735216953774],
            [10.12813497883197, 62.86596911315768],
            [10.001190178543169, 62.9454334610064],
            [9.987917124583086, 62.96481421917301],
            [10.009657622215547, 62.99325400093694],
            [10.013851233609536, 63.03317814733756],
            [9.992769587726121, 63.06157756685752],
            [9.943776632390257, 63.09240992522271],
            [9.928251749637688, 63.09368951560752],
            [9.922836938828636, 63.08041638061473],
            [9.908124056084265, 63.08403569241895],
            [9.887308405975704, 63.1439469889254],
            [9.657430740685886, 63.1504877536824],
            [9.547216293597208, 63.18284278082309],
            [9.468545408432762, 63.1778741379551],
            [9.383728968789686, 63.186025905969075],
            [9.361128051433514, 63.211895405532566],
            [9.342995890823154, 63.26421767633488],
            [9.36926128363354, 63.274182381933464],
            [9.423498603102754, 63.27872630859505],
            [9.39877753169378, 63.29085909103089],
            [9.381996942324266, 63.286839952823485],
            [9.364367739040935, 63.30194294620792],
            [9.292888559440565, 63.293023616282504],
            [9.240115508467907, 63.31337356141329],
            [9.146866943423229, 63.428129310341994],
            [9.120253280575968, 63.43623180910111],
            [9.100306768144279, 63.463440868332135],
            [9.045167794686602, 63.481507792473074],
            [8.742727377525458, 63.44748109920632],
            [8.43390945562709, 63.38870336243867],
            [8.342934303956621, 63.35941352380724],
            [8.240533152702376, 63.42209247011288],
            [8.108651561020613, 63.59814741995015],
            [8.008934963768201, 63.649300871848446],
            [7.944616963614216, 63.67063063068193],
            [8.354398649345502, 63.8741988902172],
            [9.556557420763045, 64.36704981492464],
            [10.112543148801654, 64.56965658434187],
            [10.45637552322884, 64.43499930246324],
            [10.508985955564002, 64.42994269262643],
            [10.50907682106986, 64.42990429675378],
            [10.510482042841513, 64.42925259413718],
            [10.511446850912353, 64.42880494412373],
            [10.518384603783137, 64.4255853545358],
            [10.520264742003043, 64.42471306223904],
            [10.52627401982519, 64.42192408016874],
            [10.528902977613985, 64.42070375584491],
            [10.542697625786193, 64.41429787490826],
            [10.54374995359966, 64.41380903920292],
            [10.548011069984467, 64.41182930990342],
            [10.554050005444715, 64.40902268901556],
            [10.557760497129427, 64.40845387624672],
            [10.570786901206102, 64.40645632669776],
            [10.576028670166284, 64.40565202122144],
            [10.597185227732416, 64.39712549254045],
            [10.597504762985057, 64.39709202900242],
            [10.605440587748792, 64.3962665896723],
            [10.605868609554655, 64.39612901955554],
            [10.606988293947898, 64.39525180056705],
            [10.607550085894125, 64.39349974809947],
            [10.61417162336345, 64.39020157625505],
            [10.614276678115257, 64.39014862282203],
            [10.61438819306788, 64.39009163735847],
            [10.614518054450622, 64.39002513207505],
            [10.617559089439327, 64.38851904024555],
            [10.617876658882224, 64.38835916647454],
            [10.618306464682565, 64.38814286499229],
            [10.61907861886381, 64.38771411649509],
            [10.619480714880916, 64.38734595120535],
            [10.624059253909989, 64.38316425252532],
            [10.624480953588892, 64.38284421905338],
            [10.626297701983535, 64.38165758509653],
            [10.626812533824046, 64.38135614893964],
            [10.627356100044711, 64.38097852499428],
            [10.627772732582804, 64.38054901453984],
            [10.631355807280576, 64.3758685077469],
            [10.631649430598602, 64.37557709149965],
            [10.633867642110726, 64.37546752457885],
            [10.634287957426704, 64.37555498436294],
            [10.656384113779055, 64.3759813338102],
            [10.695222401123624, 64.38185616824082],
            [10.7088845615861, 64.37253418101193],
            [10.709086741837785, 64.37228435723395],
            [10.709253673929105, 64.3720674803872],
            [10.70929684789005, 64.37200635909284],
            [10.710545490381358, 64.37010752775683],
            [10.710572816690979, 64.37008405687543],
            [10.710600057022956, 64.3700558191194],
            [10.710626666457495, 64.3700263043735],
            [10.710659217617106, 64.36999462641583],
            [10.71068880839769, 64.3699686149295],
            [10.710720699789256, 64.36994249103094],
            [10.710779895033914, 64.36989037854102],
            [10.710828140208763, 64.36985655327763],
            [10.710884463750464, 64.3698135257795],
            [10.710964520892432, 64.36975806889048],
            [10.71103130612714, 64.36971184188384],
            [10.711068881971743, 64.36968120993876],
            [10.71111453314657, 64.36964272406667],
            [10.711184569880752, 64.36957699546099],
            [10.71123566380776, 64.36952491525804],
            [10.711276138949003, 64.3694783671502],
            [10.711316663963755, 64.36943415772278],
            [10.711354627991227, 64.3693957163622],
            [10.711386831921574, 64.36935827493234],
            [10.71142465671836, 64.36931407630414],
            [10.711446342024324, 64.3692868443706],
            [10.711476494254342, 64.36924260084245],
            [10.71150277315625, 64.36917729873052],
            [10.711537240456583, 64.3691153826632],
            [10.71156187509111, 64.36907457328931],
            [10.711591937867555, 64.36902691117862],
            [10.71162196154925, 64.36897816919867],
            [10.711660440813507, 64.36891115677713],
            [10.711690243073155, 64.36886915030738],
            [10.71171776213714, 64.3688191663615],
            [10.711736939575932, 64.36879204075152],
            [10.711753658689073, 64.36874875224423],
            [10.711783838884573, 64.36869102549036],
            [10.71181115098734, 64.36864103547411],
            [10.711822908541345, 64.368598950083],
            [10.71183728080599, 64.3685387827947],
            [10.71185689200398, 64.36849557896551],
            [10.711879284902757, 64.3684398715157],
            [10.711901418141407, 64.3683831676344],
            [10.711918211822846, 64.36834338714294],
            [10.711937196083364, 64.36831616596817],
            [10.711966837293096, 64.36828449248445],
            [10.711996492399823, 64.36825272950975],
            [10.712047240264068, 64.36821879743262],
            [10.712098038083154, 64.36818720403022],
            [10.712167374242876, 64.36814986086728],
            [10.712231293425733, 64.36812062926002],
            [10.712316172948347, 64.36808342649742],
            [10.712409140766168, 64.36803828020462],
            [10.712478462161233, 64.36800102637304],
            [10.712539929814046, 64.36796489098055],
            [10.712606618445351, 64.36792189673918],
            [10.712662661251915, 64.36788461365661],
            [10.712721546116873, 64.3678450765332],
            [10.712788561365784, 64.36779067533529],
            [10.71284482452024, 64.36774665664835],
            [10.71289045880911, 64.36770691134623],
            [10.712922370501875, 64.36768195627792],
            [10.712965494382184, 64.36765031775506],
            [10.71302803430118, 64.36760796599596],
            [10.713088145062704, 64.36756788032997],
            [10.713152338772584, 64.36752490273855],
            [10.71320035908302, 64.36748981176001],
            [10.713253932199622, 64.36745371469944],
            [10.713318089155928, 64.3674083088531],
            [10.713379775093626, 64.36736543755725],
            [10.713454537960855, 64.36730658844434],
            [10.713516069885031, 64.36726470141825],
            [10.71357225252318, 64.36722517480608],
            [10.713606912888476, 64.36720254739978],
            [10.71368140927568, 64.36716535466009],
            [10.71373727864583, 64.36713714537161],
            [10.713819848485453, 64.36709875058155],
            [10.713896926660842, 64.36706495935942],
            [10.713963192122502, 64.36703795320096],
            [10.714034920923627, 64.36701317445636],
            [10.714106222457088, 64.36698847306798],
            [10.714159129015759, 64.36697393058307],
            [10.71423850133419, 64.36695602754128],
            [10.71432302711601, 64.36693701677228],
            [10.714415573455195, 64.36691581356125],
            [10.714484509853103, 64.36689562733851],
            [10.714566712390392, 64.36686755913192],
            [10.71464369696997, 64.36683834936377],
            [10.714699344293694, 64.36681687523388],
            [10.714787001081266, 64.36677512297558],
            [10.714866801929544, 64.36674248967901],
            [10.714928786781073, 64.36671098276426],
            [10.714965298068492, 64.36668712106739],
            [10.715013275464367, 64.36665094960428],
            [10.715072765087209, 64.36659551827961],
            [10.715139800240978, 64.36653428487976],
            [10.715185403720861, 64.36648671737638],
            [10.715223475267305, 64.3664448624269],
            [10.715244987010989, 64.366418703701],
            [10.715274728190213, 64.36638235815894],
            [10.715296808937886, 64.36634722676456],
            [10.715322499258408, 64.36631157172894],
            [10.715358806345543, 64.36627703636273],
            [10.715393413669265, 64.36625206981951],
            [10.715441750139396, 64.36622157201654],
            [10.715500161488016, 64.36618768335317],
            [10.715572159587072, 64.36615050656717],
            [10.715630582242358, 64.36612452878161],
            [10.715689133076001, 64.36609639729114],
            [10.715737967825003, 64.36607157724603],
            [10.715774424080507, 64.36605115937328],
            [10.71584908409892, 64.3660048912509],
            [10.715886390161273, 64.3659799136689],
            [10.715934596876973, 64.36594491727621],
            [10.715977301362784, 64.36591326573304],
            [10.716004247467298, 64.36588951322851],
            [10.716041449697547, 64.36586120653257],
            [10.716097827000603, 64.36582438158098],
            [10.716153866631782, 64.36579105256205],
            [10.716224390171583, 64.36575333794946],
            [10.716289400219, 64.36571770934779],
            [10.716369547078125, 64.36567483765458],
            [10.716462843915568, 64.36561949588005],
            [10.716529389769795, 64.36558000176399],
            [10.71661194506021, 64.3655376498703],
            [10.71672099145669, 64.3654851058584],
            [10.716786670688707, 64.3654520585887],
            [10.716835595136612, 64.36542885892243],
            [10.716920441813855, 64.36539043929605],
            [10.716986908770917, 64.36535543734098],
            [10.717054782771628, 64.36532272383747],
            [10.71710675876179, 64.36529215222411],
            [10.71715664680531, 64.36526399158505],
            [10.717229084497276, 64.36523028782378],
            [10.717290203080065, 64.36520429840834],
            [10.717347322899546, 64.36518066407851],
            [10.71741762959711, 64.3651536398831],
            [10.717473094439628, 64.36512397922608],
            [10.71752484863937, 64.36509016485003],
            [10.717573026413845, 64.36505399854329],
            [10.71762674500943, 64.36501556715142],
            [10.717690744301116, 64.36497375078036],
            [10.717749590343843, 64.36493304218766],
            [10.717813885631518, 64.36489465035876],
            [10.717880464407928, 64.36485758378204],
            [10.717944383774288, 64.36482826009663],
            [10.718002826662465, 64.36480345067586],
            [10.718061165667768, 64.3647753121583],
            [10.718233017783524, 64.36468190454107],
            [10.718381223754037, 64.36456578158834],
            [10.718436691509972, 64.36453342391364],
            [10.718495708345403, 64.36447429201729],
            [10.7186075331705, 64.3643905452877],
            [10.718687131915653, 64.36432050881606],
            [10.718778111375913, 64.3642839755184],
            [10.718869337809664, 64.36424052763962],
            [10.718937562228938, 64.3642128576186],
            [10.719001836337977, 64.36418390347221],
            [10.719052632575586, 64.36415221805815],
            [10.719121961737912, 64.36410812986666],
            [10.719194001424704, 64.36406528949463],
            [10.719258253358994, 64.36402581713902],
            [10.719317003796585, 64.36398968975149],
            [10.719397219353421, 64.3639343235214],
            [10.719463898793354, 64.36389258483881],
            [10.71954131066277, 64.36384855297092],
            [10.719632036302125, 64.36379897732499],
            [10.719730511091496, 64.3637516057868],
            [10.719812697454243, 64.36371688242197],
            [10.719924331158303, 64.36367295176184],
            [10.720051757153133, 64.363623549692],
            [10.720171576582489, 64.36357635230132],
            [10.720301171394013, 64.36353033945676],
            [10.7204101804664, 64.36348992745974],
            [10.72050300903494, 64.36345614402718],
            [10.720579989210421, 64.36342818985842],
            [10.720662175157976, 64.36340011811234],
            [10.720736690174167, 64.36337200193157],
            [10.720781249920734, 64.36335235914841],
            [10.72083816000209, 64.36332669489244],
            [10.72096245492235, 64.36329338128907],
            [10.721024522213655, 64.36326391239626],
            [10.721066001941368, 64.36324139285512],
            [10.721111535884956, 64.3632234864109],
            [10.721252468321321, 64.36319659167617],
            [10.721339294176834, 64.36317602636365],
            [10.721397377318192, 64.36315614931901],
            [10.721459463220443, 64.36311589368123],
            [10.721517338049129, 64.36308535822482],
            [10.721622839164533, 64.36307545135732],
            [10.721691340306037, 64.3630592945248],
            [10.721737018202065, 64.36302979595466],
            [10.721805331849438, 64.36300284647608],
            [10.72185389754636, 64.36297945505574],
            [10.72188703923102, 64.36292118409686],
            [10.721954159171663, 64.36287990675112],
            [10.722010095332319, 64.36284315683613],
            [10.722061823723585, 64.36280277815722],
            [10.722124190408532, 64.36277403673684],
            [10.722196432459386, 64.36274450508891],
            [10.72225249740774, 64.36272025393177],
            [10.722283654448956, 64.3626933873454],
            [10.72235079378408, 64.36265997601369],
            [10.722438837576394, 64.36261890522411],
            [10.722490545937037, 64.36258931294451],
            [10.722542398209436, 64.36255612914903],
            [10.722608716838353, 64.36251132232465],
            [10.722670913531125, 64.36246100151001],
            [10.72272663682493, 64.36241894147997],
            [10.722787716521914, 64.36237712779156],
            [10.722892498321455, 64.36232382589876],
            [10.722969097191548, 64.36228228568108],
            [10.723033896301136, 64.36225523303737],
            [10.723098586091728, 64.36223554836495],
            [10.7231730954638, 64.36220743090429],
            [10.723235482895666, 64.36217320622609],
            [10.72330954878085, 64.36213060304893],
            [10.723343189718594, 64.36210776409543],
            [10.723399718872072, 64.36207651448986],
            [10.723465626421353, 64.36206100029443],
            [10.723540025874923, 64.36204025064312],
            [10.723580863462098, 64.36202049838955],
            [10.723621454976378, 64.3619996602288],
            [10.723683764870653, 64.3619779281784],
            [10.7237748438823, 64.36196332877553],
            [10.723866952065949, 64.36194678173892],
            [10.723971074784538, 64.3619103596992],
            [10.724010020293328, 64.36188542820945],
            [10.724065109232114, 64.36185009115275],
            [10.724122407740888, 64.36182722376701],
            [10.724197102183739, 64.36181457274498],
            [10.724258957806274, 64.36180442333367],
            [10.724322019941777, 64.36178518504231],
            [10.72437060386598, 64.361740309113],
            [10.724414009276828, 64.36171204690162],
            [10.724496952763317, 64.36170305252624],
            [10.724564121433692, 64.36169009168349],
            [10.724594253600918, 64.3616564528206],
            [10.724635588426242, 64.36162682665119],
            [10.724711208965587, 64.36160755038415],
            [10.724808579088212, 64.36156850353974],
            [10.724909018363029, 64.36155507569906],
            [10.724966881782974, 64.36153123568907],
            [10.724994781188073, 64.36148593544537],
            [10.72195407755929, 64.36035320170608],
            [10.707508845688185, 64.35697659806267],
            [10.702196834543559, 64.35519474610138],
            [10.705221119850803, 64.35352346896742],
            [10.709644061536935, 64.34929350499311],
            [10.698490024794244, 64.34621095484977],
            [10.69961461947984, 64.34539018657534],
            [10.704284052851769, 64.34198324496302],
            [10.705395127377837, 64.34115781795508],
            [10.705791936622049, 64.34098275314435],
            [10.705850110471696, 64.34096738040624],
            [10.706004322773618, 64.34092650921869],
            [10.706279349688417, 64.3408209533797],
            [10.706428903706547, 64.34076475302263],
            [10.706644693198404, 64.34068137024136],
            [10.706896220945389, 64.34058420317315],
            [10.707053717402733, 64.34050764955393],
            [10.707304962580539, 64.34040031555583],
            [10.70750729045076, 64.34029819838031],
            [10.709510649971895, 64.33933108437796],
            [10.70965001073397, 64.33931089922409],
            [10.70979951268481, 64.33928417935421],
            [10.710023793355798, 64.33924059423605],
            [10.710119039189385, 64.33920814827688],
            [10.710188693365033, 64.33912443177681],
            [10.710253364723915, 64.33905405322125],
            [10.710400785011647, 64.33899014568651],
            [10.71060058175791, 64.33894134732313],
            [10.710776115207782, 64.3388819491847],
            [10.710864551867251, 64.33884130266156],
            [10.710964309786997, 64.33878255974935],
            [10.711029752341087, 64.33872982265916],
            [10.711067095632309, 64.33865253002706],
            [10.711073495728801, 64.33861945699525],
            [10.711074977415873, 64.3385700589558],
            [10.711072270483497, 64.33851694240037],
            [10.711076092044394, 64.33846716347695],
            [10.71107869506086, 64.33841456213575],
            [10.711056912664912, 64.33835747049893],
            [10.711041890187483, 64.3383048918916],
            [10.711018880273231, 64.33825567490027],
            [10.711002351224224, 64.33821276063301],
            [10.711017790833452, 64.33816691799719],
            [10.71106624186466, 64.33811943606139],
            [10.711121161975571, 64.33808365010711],
            [10.711167955028001, 64.33805212060416],
            [10.711218141375474, 64.33798751981922],
            [10.711285158786584, 64.33795325700717],
            [10.711400505721715, 64.33792481546351],
            [10.711539272881037, 64.3378950825858],
            [10.711639562458691, 64.33786880647054],
            [10.711763559769436, 64.33783540435405],
            [10.711966040157765, 64.33777463728363],
            [10.712203728094087, 64.33771409263504],
            [10.71229379179072, 64.33772149618234],
            [10.712414431565664, 64.33774022327525],
            [10.712578364896167, 64.33774853267808],
            [10.712713311722686, 64.33774862131771],
            [10.712828870972604, 64.33773609606268],
            [10.71296380108412, 64.33771101381805],
            [10.713040866446347, 64.33769007920613],
            [10.713114353628159, 64.33764953284837],
            [10.71313321959163, 64.33760828513039],
            [10.713155713611226, 64.33754907512427],
            [10.713222278478913, 64.33750239295091],
            [10.713289010559665, 64.33746794115656],
            [10.713390161296125, 64.33742946363779],
            [10.713488751902915, 64.3374047546404],
            [10.713599755195665, 64.33738553312986],
            [10.71370741754462, 64.33737178705971],
            [10.71375498491867, 64.33735655020841],
            [10.713824122879956, 64.33732927024695],
            [10.713901013319727, 64.33729880139806],
            [10.714002396597968, 64.33725349840441],
            [10.714186480943503, 64.33717501997673],
            [10.71428185079469, 64.33712972045836],
            [10.714377153686282, 64.33709017209767],
            [10.714456128946866, 64.3370622810624],
            [10.714557271144319, 64.33702649935596],
            [10.714625654813121, 64.33700405119941],
            [10.714712423820567, 64.33697270267311],
            [10.714860283881443, 64.33692579383678],
            [10.715076183333931, 64.33685597696268],
            [10.71528672804289, 64.3367939135972],
            [10.715430127116608, 64.33674768263384],
            [10.715601511595734, 64.33668680935634],
            [10.71572131187591, 64.33664168498679],
            [10.715812229617448, 64.3365983217514],
            [10.715897913749146, 64.336564603591],
            [10.716001360675616, 64.33652331506977],
            [10.71607796779825, 64.33649463474947],
            [10.71616082321727, 64.33645777725997],
            [10.716227010191457, 64.33641746524484],
            [10.716262098209203, 64.33637983844582],
            [10.7162826693694, 64.33635023659183],
            [10.71629822290253, 64.3363255668012],
            [10.716324852038618, 64.33629367023899],
            [10.716326901110962, 64.33626586333543],
            [10.716320235198136, 64.33623411566292],
            [10.716324799759532, 64.33620746112351],
            [10.716341992739853, 64.33618158082376],
            [10.716382056847605, 64.33614594250048],
            [10.716432033476304, 64.33611387547192],
            [10.716487311745048, 64.3360863684057],
            [10.716515021403946, 64.33605751487383],
            [10.716547042776433, 64.3360222703093],
            [10.716613105363106, 64.33599206749673],
            [10.716672745481818, 64.33597116037254],
            [10.716750721763741, 64.33594831794102],
            [10.71683546240617, 64.33592063947076],
            [10.716890229654926, 64.33589374656253],
            [10.716953801482367, 64.33587421293142],
            [10.717006848988817, 64.33585437120183],
            [10.71703403630147, 64.33582487304629],
            [10.717078243546002, 64.33576593867635],
            [10.717122542506845, 64.33568776984754],
            [10.71713959078831, 64.3356435020927],
            [10.71715313355068, 64.33559778332724],
            [10.717170165759859, 64.33554030080775],
            [10.717190494943988, 64.33547095900671],
            [10.71722794367523, 64.3354061635098],
            [10.717251606271057, 64.33536334786292],
            [10.717275698003792, 64.33531910648482],
            [10.717296100294067, 64.33526527338448],
            [10.717364094761008, 64.33523063218212],
            [10.71746018286557, 64.33522325711522],
            [10.717558811613628, 64.3352062173283],
            [10.71827074395636, 64.33505778465936],
            [10.718461027814298, 64.33501921560378],
            [10.718506535051983, 64.33499852348673],
            [10.7185800266953, 64.33496584049219],
            [10.71863681490326, 64.33491927462485],
            [10.718692104989284, 64.33489032888428],
            [10.718749340966871, 64.33487285648037],
            [10.718830591721566, 64.3348435916184],
            [10.718904285505296, 64.33480161046536],
            [10.718963471825244, 64.33477826211316],
            [10.719037210406434, 64.33476396926092],
            [10.719151727603446, 64.33474871207589],
            [10.719249165902385, 64.3347366407229],
            [10.719340191809492, 64.33471781950853],
            [10.719433320610564, 64.33467748544757],
            [10.719485107959143, 64.33465239224878],
            [10.719561523670885, 64.33461822122835],
            [10.719627673297328, 64.33460073960418],
            [10.719736451853711, 64.33457839233834],
            [10.719790561007184, 64.33456235626178],
            [10.719890023165359, 64.33451861149724],
            [10.719996642473436, 64.33447282871764],
            [10.720080768119182, 64.3344423888154],
            [10.720142908700996, 64.33442002537444],
            [10.72025240536413, 64.33439172087667],
            [10.720349792059706, 64.33436530939926],
            [10.72042821006944, 64.33434890544068],
            [10.72059416682874, 64.33431609449914],
            [10.720681453186117, 64.33429464612179],
            [10.72080342296064, 64.33425677289132],
            [10.720917050723115, 64.33421389126525],
            [10.72103056398504, 64.33418107421167],
            [10.721167364621337, 64.3341344653748],
            [10.721234129107515, 64.33411034898317],
            [10.721344863376444, 64.3340927322164],
            [10.721405851991838, 64.33407509891174],
            [10.72144359783279, 64.33405363963477],
            [10.721522465302101, 64.3340036732933],
            [10.721665106360712, 64.33397148283377],
            [10.721743749807128, 64.33395094973491],
            [10.721826508659403, 64.33392127797521],
            [10.721882240775011, 64.33389611957116],
            [10.721938160528047, 64.33387375331172],
            [10.722000254394784, 64.33384500538888],
            [10.722087139525005, 64.33381545414687],
            [10.722169811796185, 64.33378766742723],
            [10.722262995823368, 64.33375892951035],
            [10.72234052892222, 64.33372353134119],
            [10.7225120451154, 64.33365024937346],
            [10.7226799378108, 64.33357560279173],
            [10.722773869413722, 64.3335433806158],
            [10.72308244042454, 64.33342646160347],
            [10.72319532699886, 64.33332162061329],
            [10.724659805995769, 64.33198978522239],
            [10.729232000079337, 64.32797317991366],
            [10.729872852053923, 64.32716586826062],
            [10.734212924654344, 64.3214784638872],
            [10.737871152372897, 64.31932541658925],
            [10.74156953630221, 64.31650835269396],
            [10.741838085999971, 64.31628407284242],
            [10.742310218620387, 64.31594211937097],
            [10.744644271963812, 64.31395028888501],
            [10.748942780750001, 64.31322305911378],
            [10.751174490943113, 64.31287280627137],
            [10.754374619362302, 64.31165047796998],
            [10.757499003024444, 64.31045950710516],
            [10.758428728339739, 64.31013635784788],
            [10.761434164868016, 64.31054253197098],
            [10.770000900038339, 64.31170182327013],
            [10.781041568430595, 64.30739341712221],
            [10.796917798136391, 64.30119666430707],
            [10.814500583997882, 64.29432381698267],
            [10.881272221190692, 64.28412892351969],
            [10.885393221069856, 64.28347069444712],
            [10.889047379453952, 64.28293970397894],
            [10.894536592048539, 64.28209537022668],
            [10.898240350357089, 64.28153705902292],
            [10.902730236910264, 64.28086013112691],
            [10.907468551356185, 64.280708635002],
            [10.90818665742134, 64.28067014535758],
            [10.909082724658573, 64.28065209426455],
            [10.927325254768308, 64.28025519539857],
            [10.913703098418273, 64.23640895628168],
            [10.91367002253823, 64.23630161263043],
            [10.9133607553547, 64.23530499517277],
            [10.913149414638328, 64.23462390041986],
            [10.911608591567422, 64.22965361850862],
            [10.883771625847961, 64.20732337767161],
            [10.749475862958692, 64.17941857267844],
            [10.740794569291031, 64.17706037217157],
            [10.786007309521315, 64.11434869846937],
            [10.86699560532145, 64.11270839349672],
            [10.88038719023375, 64.09788127126482],
            [10.830306113020164, 64.08983241212631],
            [10.830163351388123, 64.08978292347898],
            [10.830392314984348, 64.08966985391777],
            [10.8306377412663, 64.08943869622038],
            [10.830706512294585, 64.08899213623994],
            [10.830634679102486, 64.08863799052713],
            [10.830492481680729, 64.08831472435894],
            [10.830280595946682, 64.08806855848796],
            [10.829892049459618, 64.08768393154806],
            [10.82957461106765, 64.08756093605558],
            [10.829363556950153, 64.08751487966452],
            [10.829222446222632, 64.08743802179276],
            [10.828904999976546, 64.08725345223299],
            [10.82858764653549, 64.08709980551201],
            [10.828235562219598, 64.08702300273926],
            [10.827566781308185, 64.0869772857243],
            [10.826932967890698, 64.08691621035912],
            [10.826404920062178, 64.0868703943938],
            [10.825947142031143, 64.08676286519135],
            [10.825664842586514, 64.08651673626791],
            [10.825417895463694, 64.0863321160493],
            [10.824994569815024, 64.0861169001701],
            [10.824395414181264, 64.08584009177413],
            [10.823162304714486, 64.08537894893428],
            [10.822668562408076, 64.08510210644967],
            [10.82249153047474, 64.08477899706611],
            [10.822454537158476, 64.0843016224917],
            [10.822277825590247, 64.08400926322395],
            [10.822065805154386, 64.08377835990485],
            [10.821572805040073, 64.08365551064078],
            [10.820833101863574, 64.08347127253128],
            [10.820480680784835, 64.08333286710614],
            [10.820057910207236, 64.08310219033413],
            [10.819774490743447, 64.0826712975883],
            [10.819632969009316, 64.08231720535925],
            [10.819491466402626, 64.0821325508189],
            [10.819033378397794, 64.08196350571438],
            [10.818681085033846, 64.08179435752699],
            [10.81857492674134, 64.08160964036365],
            [10.818926064986169, 64.08140913931241],
            [10.819382704122258, 64.08122407757969],
            [10.819943468842592, 64.08099796549155],
            [10.820276533289915, 64.08086435693876],
            [10.820392489621586, 64.08073088440332],
            [10.82033384581741, 64.08057845667493],
            [10.820434846727597, 64.08043241914667],
            [10.82072488005963, 64.08036238051159],
            [10.821014898803186, 64.08034303723258],
            [10.821493981173056, 64.08040634381219],
            [10.821929318478258, 64.08043135737653],
            [10.82219064247276, 64.08041846744845],
            [10.822335450571984, 64.08034856434217],
            [10.822363686134391, 64.08019602898125],
            [10.822218227059887, 64.08006915070749],
            [10.8218843542866, 64.0800057975623],
            [10.821463390865931, 64.07996169161066],
            [10.821172897252154, 64.07988574171941],
            [10.82111455105028, 64.0797586710726],
            [10.82136032437952, 64.07957437027463],
            [10.82167917382647, 64.079421743561],
            [10.821968667811309, 64.07919923881401],
            [10.822055097588102, 64.07907219702152],
            [10.822025868158, 64.07899603115392],
            [10.821836854692407, 64.07893909037207],
            [10.821459812949533, 64.07888842696693],
            [10.821140255652997, 64.07883788789813],
            [10.820966130064951, 64.07878712691152],
            [10.820893134265527, 64.07869199407286],
            [10.820979594637265, 64.07858391990317],
            [10.821356668110012, 64.07849481116324],
            [10.821675877871046, 64.07846282351778],
            [10.821994857770113, 64.0784816147537],
            [10.822227543299064, 64.07855131675214],
            [10.822372799370145, 64.07860834715771],
            [10.822546965155837, 64.07862737747205],
            [10.822749899131386, 64.0785573477293],
            [10.822850810977789, 64.07840492440533],
            [10.822792127777113, 64.07821438462052],
            [10.822559148977783, 64.07803033879617],
            [10.822297510894922, 64.07789086136142],
            [10.822152023378246, 64.07777656609744],
            [10.82216623306316, 64.07765589688894],
            [10.822397779417672, 64.07750327541288],
            [10.82265144860285, 64.07727848126437],
            [10.822798998558303, 64.07700955722171],
            [10.822857341964243, 64.07674939395321],
            [10.822896189480767, 64.07646314222134],
            [10.822726882353665, 64.0762941404466],
            [10.822409505624476, 64.0761512623981],
            [10.822290028820985, 64.07601695113391],
            [10.82240817499608, 64.07577837275727],
            [10.82280302701323, 64.07537480838587],
            [10.823208087589688, 64.07507967072327],
            [10.823435201420164, 64.07490166248638],
            [10.823513354932555, 64.07477626991222],
            [10.823513172682615, 64.0747377930567],
            [10.82349244816587, 64.07462546774711],
            [10.823397556511972, 64.07447784180651],
            [10.823309145822577, 64.0743390312665],
            [10.823213781409272, 64.07414393124343],
            [10.823240372574059, 64.07400501143427],
            [10.823257261008163, 64.0739636096811],
            [10.823346927118367, 64.07391612069566],
            [10.823442358921614, 64.07386304466446],
            [10.823516299465703, 64.07376845213189],
            [10.82352280621073, 64.07364432553959],
            [10.823522436863815, 64.07352907983883],
            [10.823589215926843, 64.0733959895521],
            [10.823615906905571, 64.07324817378539],
            [10.823699384681968, 64.0730872491721],
            [10.823824202224554, 64.07297101829107],
            [10.823867808413475, 64.07281308214644],
            [10.823801087575738, 64.07265835618496],
            [10.823660676310006, 64.072519938389],
            [10.823520229848855, 64.07236533975944],
            [10.823409092020032, 64.07221383082874],
            [10.823342882185347, 64.07212689403936],
            [10.823349872400417, 64.07207208419624],
            [10.823401027820648, 64.07199796010649],
            [10.823430183917386, 64.0718980351179],
            [10.823437347324663, 64.07181743269247],
            [10.823407571277212, 64.07172713901018],
            [10.823259240208555, 64.07147595444239],
            [10.823042546476332, 64.07125075871923],
            [10.822823944079742, 64.07106020409545],
            [10.82258563611136, 64.07084364432771],
            [10.822446600433434, 64.07069205117175],
            [10.82242604462268, 64.07051159598379],
            [10.822398782399606, 64.07037310493318],
            [10.822206676129293, 64.07029063633756],
            [10.82197941724396, 64.0701852238924],
            [10.821820625248982, 64.07003809539158],
            [10.821711450962107, 64.06990371976372],
            [10.82175035449903, 64.06976074982256],
            [10.821888511368073, 64.06963492697764],
            [10.822194819481116, 64.06950899685563],
            [10.822461991341873, 64.06939623259066],
            [10.822629615380295, 64.0692573241653],
            [10.822771216445965, 64.06905375749852],
            [10.822770520898395, 64.06885859273125],
            [10.822747947774896, 64.06866010215778],
            [10.822645269331488, 64.06854811612064],
            [10.822527799802092, 64.0684266259863],
            [10.822388185108785, 64.0682666563273],
            [10.822336512616243, 64.06809384531923],
            [10.822350448109955, 64.0679817974149],
            [10.82241631341431, 64.06788895091377],
            [10.822503398216575, 64.06777370362266],
            [10.822502957760253, 64.06766169166966],
            [10.82237844322298, 64.06756256033661],
            [10.822115028665038, 64.06745062453703],
            [10.82186589103046, 64.06736121114575],
            [10.821763414332903, 64.06728761189673],
            [10.821724737031358, 64.06716641003825],
            [10.821701484755101, 64.06707648319782],
            [10.821641711665611, 64.06699053937633],
            [10.821554687264483, 64.06691657549398],
            [10.821376185590914, 64.06680654169413],
            [10.821252452803177, 64.06671866760446],
            [10.82124746493812, 64.06662468189879],
            [10.82143356323422, 64.0665212727008],
            [10.82160305992442, 64.06640947560771],
            [10.821666840743939, 64.06634829965252],
            [10.821748893779224, 64.0663062559769],
            [10.821937389921573, 64.06624156666089],
            [10.822130940952098, 64.0661281239447],
            [10.822203455891321, 64.06600050281207],
            [10.822186941844084, 64.06593270233701],
            [10.822205770121597, 64.06585234555794],
            [10.822404625129552, 64.06572404398744],
            [10.822517345799238, 64.06557879284055],
            [10.822508763703325, 64.06545126588304],
            [10.822565036001816, 64.06530600900435],
            [10.822750567726578, 64.06517480701118],
            [10.822903453645587, 64.06500122794613],
            [10.822862609700085, 64.06483834638784],
            [10.822659635225495, 64.06466846438681],
            [10.822637775563813, 64.06436123080934],
            [10.822728593063404, 64.06422101249356],
            [10.8226593940163, 64.06400086614202],
            [10.822384601490787, 64.06383089529535],
            [10.821981633502517, 64.06359045029242],
            [10.82156004829851, 64.06333733359138],
            [10.821362986538073, 64.06307206940218],
            [10.82113783636028, 64.062818940358],
            [10.8210545516735, 64.06261070209011],
            [10.821053801224455, 64.06241050170124],
            [10.82089336965942, 64.06227051482549],
            [10.8206414906556, 64.06215045764941],
            [10.820458067179631, 64.06201052761027],
            [10.820160479746294, 64.06188052478794],
            [10.819840231102122, 64.06179076770198],
            [10.819565714026199, 64.06168075340292],
            [10.819245046902605, 64.06150082586764],
            [10.818969350542785, 64.06110061999097],
            [10.818808432595269, 64.0608505043728],
            [10.818487928347588, 64.06065044475142],
            [10.818121570300544, 64.0604605694074],
            [10.817892323565365, 64.06027059695636],
            [10.817754640780093, 64.06011049713634],
            [10.817685511116421, 64.05992028178657],
            [10.817799392838937, 64.05977003396615],
            [10.817776021123658, 64.05964001279679],
            [10.817683610948727, 64.05936975627974],
            [10.817431305922012, 64.05906963574446],
            [10.817092019082578, 64.05875568318912],
            [10.817036042710809, 64.05864602590083],
            [10.81696327244501, 64.05850334550728],
            [10.81684683395873, 64.05820048590085],
            [10.816627929701738, 64.05785844939895],
            [10.816166027102998, 64.05757269172744],
            [10.815438580290367, 64.0573457966686],
            [10.815170971181685, 64.05725439873181],
            [10.815068425000039, 64.05717342071121],
            [10.815068007622331, 64.05706554349406],
            [10.815055219002092, 64.05691434340973],
            [10.815005303398593, 64.05678490469143],
            [10.81491569873043, 64.0566970186198],
            [10.814734106282032, 64.05661771695094],
            [10.81462270028817, 64.05653153932745],
            [10.814659503792228, 64.05645592600396],
            [10.81473305905906, 64.0563965630633],
            [10.814659035015055, 64.05632108095693],
            [10.814547615065962, 64.05621315001764],
            [10.814522623420267, 64.05601890137916],
            [10.81473150404144, 64.05588919214092],
            [10.81489135595159, 64.05577577730773],
            [10.8149890687023, 64.05557059370267],
            [10.814988587546205, 64.05543035506655],
            [10.815185050401686, 64.05525759074798],
            [10.815271718069656, 64.05510269543178],
            [10.814900860408049, 64.05487645537819],
            [10.80213096708253, 64.0486995566783],
            [10.801968469914911, 64.048619351026],
            [10.800585532049746, 64.04793763514816],
            [10.799635769328177, 64.04747868970342],
            [10.798582110718897, 64.04698113421873],
            [10.797861712262488, 64.04657411833267],
            [10.796687606054055, 64.04601058776045],
            [10.79356712564888, 64.04432169094078],
            [10.791502140336743, 64.04343790494896],
            [10.787859377759881, 64.0413531332028],
            [10.783913058131509, 64.03965594386375],
            [10.78158155087631, 64.03843966540438],
            [10.78021728930568, 64.03778731018481],
            [10.77995344310522, 64.03755239513812],
            [10.779624958465181, 64.03734760060573],
            [10.77914044788525, 64.03708846784912],
            [10.778225592609763, 64.03690607513279],
            [10.77641026728001, 64.03665773895773],
            [10.776158220123556, 64.0365753441643],
            [10.776094076337985, 64.03648844063027],
            [10.776194713710066, 64.03642512059739],
            [10.776254962661362, 64.03632925313107],
            [10.776228064041288, 64.03623201763699],
            [10.77610349182832, 64.03612303991221],
            [10.775941847891103, 64.03599347667826],
            [10.775770402907078, 64.03592727044825],
            [10.775567158956601, 64.03591937617307],
            [10.775362598260177, 64.0358700935943],
            [10.775311235793446, 64.0358260799883],
            [10.77528045540016, 64.0357409563421],
            [10.775290418151126, 64.03564677135854],
            [10.775400580620026, 64.03539468925926],
            [10.775389944742825, 64.03533631027535],
            [10.775349157530345, 64.035291525857],
            [10.77528804501809, 64.03528345427402],
            [10.775072769268766, 64.03526568049213],
            [10.774990880248557, 64.03524316069408],
            [10.774859901215068, 64.03514810797658],
            [10.774806500862168, 64.03513109189191],
            [10.774673608434862, 64.03511769388086],
            [10.774509943209171, 64.03517612120528],
            [10.77433592805716, 64.03519865024737],
            [10.773998348506625, 64.03521668530828],
            [10.77365058194104, 64.03522210785816],
            [10.773548903385045, 64.03514210998878],
            [10.773516846889295, 64.03502485766252],
            [10.773514637906318, 64.03475125577032],
            [10.773442581981804, 64.03465710884025],
            [10.773401819296563, 64.03462571821841],
            [10.773544809473497, 64.0344588210618],
            [10.773595843881557, 64.03435207907776],
            [10.773585392938951, 64.03427491808505],
            [10.773542212600322, 64.03422565870525],
            [10.773521814169813, 64.03417625387367],
            [10.773378381991364, 64.03414043443561],
            [10.773271278442573, 64.03411520150027],
            [10.773247229462253, 64.03408515163173],
            [10.773347650007452, 64.03408209905616],
            [10.773542061167921, 64.03403724327798],
            [10.773586960203728, 64.03401562892428],
            [10.77354190193003, 64.03399229326337],
            [10.773470020470851, 64.03394300687106],
            [10.773439433784592, 64.03390265389415],
            [10.773398265271537, 64.03387394814708],
            [10.773342664086243, 64.03385794603014],
            [10.773260320152952, 64.0338668736499],
            [10.773153886408553, 64.0338724027601],
            [10.773087149990964, 64.03385005348649],
            [10.77301295769226, 64.03380384570235],
            [10.772935358608592, 64.03380311326308],
            [10.772856743140913, 64.03378338421307],
            [10.772840893500359, 64.03373779729036],
            [10.772792815978544, 64.03368839497043],
            [10.772784227058798, 64.0336571324208],
            [10.772732804155426, 64.03361221704573],
            [10.772649129903023, 64.03359881262706],
            [10.772571339538466, 64.03359528779183],
            [10.772523989479623, 64.03361413369922],
            [10.77246831236402, 64.03363651239728],
            [10.772386822732575, 64.03366685842265],
            [10.772364777648114, 64.03369866671412],
            [10.77232771810356, 64.03372266649228],
            [10.77226490049183, 64.03372587010567],
            [10.772201506114435, 64.03371800031235],
            [10.772107916108933, 64.03371590258804],
            [10.772040421871461, 64.03372966685117],
            [10.771975914984749, 64.03372913559275],
            [10.771935213874503, 64.0337068252621],
            [10.771912891978463, 64.03367012858705],
            [10.7719100050866, 64.03363642527975],
            [10.77189435379396, 64.03360441751846],
            [10.771860510320687, 64.03357880124302],
            [10.771809109349322, 64.03354862824736],
            [10.771768723303369, 64.03349989912232],
            [10.771786472418158, 64.03341663803116],
            [10.771861594899221, 64.03339042157035],
            [10.771919515629012, 64.03336406339278],
            [10.772027655905267, 64.03334456197653],
            [10.772147070803786, 64.0333101974449],
            [10.772263950337567, 64.03329661362561],
            [10.772356573984673, 64.03327261478013],
            [10.772423412024084, 64.0332266503589],
            [10.772434680218392, 64.03318410073756],
            [10.772413765679932, 64.03314555744053],
            [10.772279540408645, 64.03311126348814],
            [10.772229457056728, 64.03307510633574],
            [10.772179137525837, 64.03302833516032],
            [10.772137747970717, 64.03295782330608],
            [10.77213563390825, 64.03288926487123],
            [10.772165891173211, 64.03284250435237],
            [10.772246432373324, 64.03279675952713],
            [10.772361408669227, 64.03276325434574],
            [10.772502678774798, 64.03276323543362],
            [10.772630931082404, 64.03277470270285],
            [10.772752620886514, 64.03277941663548],
            [10.772846292163948, 64.03275931335048],
            [10.772919982296916, 64.03273170631088],
            [10.77293669142955, 64.03269992229515],
            [10.772929747884389, 64.0326659210683],
            [10.772894459014042, 64.03260655386718],
            [10.772814600634522, 64.03257069805177],
            [10.772573351701872, 64.03246065449467],
            [10.77246552926111, 64.03236852107246],
            [10.7723950684856, 64.03231801692863],
            [10.772358217140072, 64.03228925681415],
            [10.772248543447095, 64.03219311406127],
            [10.772205840582602, 64.03216373394548],
            [10.77215924206121, 64.03212624001458],
            [10.772115643739024, 64.03207301269585],
            [10.772015285209099, 64.03201822129104],
            [10.771944980940015, 64.03197886791915],
            [10.771815660809501, 64.03194471633385],
            [10.771719351207562, 64.0319037959977],
            [10.77164075064322, 64.03187318978331],
            [10.771553719355856, 64.0318562709172],
            [10.771438106231564, 64.03185883436417],
            [10.771305834577252, 64.03185632777604],
            [10.771066347182728, 64.03185914591073],
            [10.770928172051764, 64.03184621934417],
            [10.770802713774698, 64.03181703348866],
            [10.770688784798569, 64.03177874503476],
            [10.770547058047399, 64.03174800604295],
            [10.770434044487637, 64.03171720501123],
            [10.770372434683088, 64.03166785668729],
            [10.7703567818263, 64.03162506172728],
            [10.770316102953496, 64.03157964950404],
            [10.770248441116923, 64.0315377654233],
            [10.770182363150814, 64.03147462331158],
            [10.770104372782875, 64.03139675131492],
            [10.7700683553487, 64.03133412593525],
            [10.770042976765456, 64.03126488909832],
            [10.769986773223186, 64.03118666338446],
            [10.769899734077722, 64.03110628015865],
            [10.769830373758642, 64.03103099674856],
            [10.769765424489256, 64.03096042634847],
            [10.769727925753507, 64.03089946559396],
            [10.769678561305083, 64.03083833864302],
            [10.769619730907673, 64.03078961030852],
            [10.76957648997996, 64.03076380926043],
            [10.76951200761371, 64.03075572661844],
            [10.769413419935411, 64.03075285197012],
            [10.769331228957329, 64.03073040966062],
            [10.769280301380142, 64.03070798002216],
            [10.76922191853881, 64.03067117512319],
            [10.76911946696476, 64.03057483570011],
            [10.769037582978829, 64.03051455800791],
            [10.769007201663689, 64.03048778340603],
            [10.768953501290918, 64.03047214944675],
            [10.76889006594674, 64.0304787942383],
            [10.768826162736087, 64.03050947123067],
            [10.768807668094688, 64.03054219158379],
            [10.76877646733888, 64.03058433951672],
            [10.768747451814738, 64.0306107303372],
            [10.768678462782244, 64.03062807462413],
            [10.768618379716926, 64.0305952802577],
            [10.76858725015146, 64.03056803428319],
            [10.76851557376632, 64.03053034697095],
            [10.76840860885636, 64.03053945249235],
            [10.768338999169519, 64.0305367930184],
            [10.768261524009706, 64.03051233022411],
            [10.768181928594954, 64.03049508672689],
            [10.768075235779536, 64.03046186119943],
            [10.767984235316971, 64.0304373633032],
            [10.767895225244764, 64.0304240699109],
            [10.767802015454146, 64.03042629502232],
            [10.767741242167297, 64.0304174208462],
            [10.767705622770883, 64.03038869532016],
            [10.767705473579374, 64.0303464421078],
            [10.767736010273559, 64.03030867967173],
            [10.767811770898433, 64.03029309117953],
            [10.767885532345211, 64.03028121976402],
            [10.767938454774928, 64.03024995320011],
            [10.76793848604889, 64.03022002035064],
            [10.76790408835722, 64.03018189193432],
            [10.767841990316755, 64.03015607960417],
            [10.767705252163209, 64.03011550517404],
            [10.76760885247873, 64.03009552385107],
            [10.767512808063074, 64.03007995749418],
            [10.767385984338242, 64.03006457183788],
            [10.767290800930452, 64.0300608960887],
            [10.767192490367286, 64.0300656687101],
            [10.767096383455675, 64.0300680784942],
            [10.76701136597242, 64.03006901393344],
            [10.76691521943507, 64.030075737222],
            [10.766837944887357, 64.03007833673159],
            [10.766754907791517, 64.03005676709633],
            [10.766718390447483, 64.03002316096601],
            [10.766692311023293, 64.0299937247077],
            [10.766649153325602, 64.0299592955644],
            [10.766548239584147, 64.02994745179197],
            [10.766389194323292, 64.02994108049955],
            [10.766251569895088, 64.02992054699874],
            [10.76615539136915, 64.0299072230817],
            [10.766059094414988, 64.02990953673122],
            [10.76600337658678, 64.02992274280153],
            [10.765947633208766, 64.02994286973768],
            [10.765871683665674, 64.02996510370333],
            [10.765792323000852, 64.02997739497992],
            [10.76569981134804, 64.02996287435107],
            [10.765592051216696, 64.02994076226209],
            [10.765438609941445, 64.02990895691384],
            [10.765343846420466, 64.02989306689904],
            [10.765223855770474, 64.0298785978776],
            [10.765087710640373, 64.02985035329289],
            [10.764982724823932, 64.02981672572145],
            [10.764853760527405, 64.02976819527437],
            [10.764726684958967, 64.0297045281898],
            [10.764661770412816, 64.02965948531762],
            [10.76461139679409, 64.02958888828219],
            [10.764630285397947, 64.02953199907607],
            [10.76469479604918, 64.02946628395887],
            [10.764744874896817, 64.02942675538422],
            [10.764759806661218, 64.0293851220919],
            [10.7647203220066, 64.02933057395472],
            [10.764623990275213, 64.02928587238229],
            [10.764519482746104, 64.02924911217721],
            [10.764444377501883, 64.02920098503611],
            [10.764319435174771, 64.02917459484956],
            [10.764144215013628, 64.02914179259862],
            [10.764003160124245, 64.02910000971441],
            [10.76390785203489, 64.02906207937046],
            [10.763860331293664, 64.0290267128707],
            [10.763822374598284, 64.02898236678854],
            [10.763802773941732, 64.0289413433068],
            [10.763798218442401, 64.02887819636298],
            [10.763767500438552, 64.02883208400917],
            [10.763714958862506, 64.0287933347503],
            [10.763668893784713, 64.02875243740398],
            [10.763627713620235, 64.02871177257238],
            [10.76358140303845, 64.02866574420801],
            [10.763566797771345, 64.02863232754383],
            [10.763545282281, 64.02852697567448],
            [10.763561617748234, 64.028408616122],
            [10.763602466648987, 64.02834212064651],
            [10.76369441555351, 64.02824556538809],
            [10.763785987466035, 64.02817578673981],
            [10.763885819018132, 64.0281123618376],
            [10.763925677481874, 64.02806857992053],
            [10.763925575629088, 64.02803145176664],
            [10.763870627658623, 64.02799640771181],
            [10.763785789391312, 64.02797460380893],
            [10.763701168941912, 64.02795271632236],
            [10.763641117269824, 64.02790673616056],
            [10.763591097685953, 64.0278041475982],
            [10.76357583927006, 64.0276859441625],
            [10.76352594128551, 64.02757445985364],
            [10.763411183952444, 64.02746081178401],
            [10.763031648320382, 64.02719146937517],
            [10.762740618893496, 64.02697918519948],
            [10.762449685253229, 64.02673660967022],
            [10.762413600446365, 64.02671371197059],
            [10.760827937158066, 64.02584946089326],
            [10.760151541252895, 64.0251733939382],
            [10.758676556894153, 64.02422254862616],
            [10.758550257983078, 64.02384122001266],
            [10.758283631678637, 64.02303338580838],
            [10.7582333144932, 64.02215097364841],
            [10.759199337171076, 64.02119040930475],
            [10.759576125863857, 64.02086882519755],
            [10.760427621028457, 64.02012055668229],
            [10.761932106922705, 64.01885201565771],
            [10.763754385280683, 64.01805128128707],
            [10.765111619389632, 64.01734490776636],
            [10.768102032468793, 64.01600283351691],
            [10.768389155922392, 64.01586738538832],
            [10.771415501188725, 64.01441851882156],
            [10.773276721938643, 64.01335812896116],
            [10.77540543987205, 64.01188302472755],
            [10.776913991953075, 64.01057860470227],
            [10.777417749352537, 64.01027326409528],
            [10.777458649815834, 64.01024191469423],
            [10.7774914351631, 64.0102046209251],
            [10.777519559588875, 64.01015208980743],
            [10.777581043872237, 64.01010722693292],
            [10.777621642169937, 64.01006229521602],
            [10.777662560515632, 64.01000847364068],
            [10.777723678274015, 64.00994571181705],
            [10.777825949856524, 64.0098560125058],
            [10.777907348741705, 64.00976615484845],
            [10.777968539721453, 64.00971238413418],
            [10.778009531196517, 64.0096675536725],
            [10.778050128145255, 64.00962262182456],
            [10.778111480790379, 64.00958674399224],
            [10.77819317551178, 64.00953285104849],
            [10.778295184964994, 64.00946112194983],
            [10.77839720742317, 64.00938930327874],
            [10.778458498159354, 64.00934434457308],
            [10.778519687133901, 64.0092905736104],
            [10.778601305664772, 64.00922768920091],
            [10.778723803667113, 64.00915592708093],
            [10.778805625298176, 64.00909304848734],
            [10.778887154448615, 64.00902126218037],
            [10.778968716683785, 64.00897635406172],
            [10.77902990385291, 64.00892258286957],
            [10.779111659466409, 64.00886419673603],
            [10.779213891679614, 64.00880586726207],
            [10.779315780148716, 64.00874303319546],
            [10.779397524431067, 64.00867116302317],
            [10.779499541126492, 64.00859934353198],
            [10.779642490136284, 64.00850066952106],
            [10.779744505570065, 64.00842884984776],
            [10.779826105254928, 64.0083660542043],
            [10.779907922051041, 64.00830317495115],
            [10.78000977256882, 64.00821346212444],
            [10.780173132701963, 64.00810576342722],
            [10.780275070232822, 64.00802495213183],
            [10.780397612326563, 64.0079352120052],
            [10.780519949675579, 64.00784546583385],
            [10.780683305660707, 64.00773776652987],
            [10.780764968184698, 64.00765690430744],
            [10.780928179923048, 64.00755827950233],
            [10.781071056668358, 64.00745052327667],
            [10.781214047344417, 64.00733387110334],
            [10.781336507918082, 64.00723513890647],
            [10.781459043080613, 64.00714539782895],
            [10.781561048818606, 64.00707357680254],
            [10.781663054028206, 64.00700175570027],
            [10.78178566943198, 64.00692096081255],
            [10.781887742342242, 64.00685817552258],
            [10.781989745914276, 64.0067863541779],
            [10.782132486290838, 64.00668758214171],
            [10.782295829197372, 64.00657988092041],
            [10.782418319490649, 64.00650802602023],
            [10.78252023107345, 64.00642730254683],
            [10.782601870836062, 64.006346528714],
            [10.78270402241828, 64.00629268930317],
            [10.78278569851713, 64.00623879362878],
            [10.782887849348551, 64.0061849540828],
            [10.783010297889273, 64.00613098569539],
            [10.783275052586003, 64.00565552570383],
            [10.783539596665147, 64.00510814712575],
            [10.783823471604839, 64.00420203933214],
            [10.783944775015554, 64.00358307728308],
            [10.783943246475138, 64.0029013056603],
            [10.783860106898935, 64.00225545388798],
            [10.783634045167432, 64.0017084595425],
            [10.783020149251875, 64.00139174859675],
            [10.782897322673302, 64.00135884188471],
            [10.78275415953513, 64.0013141368557],
            [10.782631495333439, 64.00126930888223],
            [10.782508755673447, 64.00121548957084],
            [10.782345174824561, 64.00115275140102],
            [10.782161109883129, 64.00109004629772],
            [10.781925516648396, 64.00099833525091],
            [10.781690499544881, 64.00091095528757],
            [10.781547496036673, 64.00085708479851],
            [10.781445306890493, 64.00081231218319],
            [10.781322443101432, 64.00076747719702],
            [10.781138307590425, 64.00069577959223],
            [10.78097473287273, 64.00063303991607],
            [10.78079074975454, 64.00057932435001],
            [10.780606603333405, 64.00050771558388],
            [10.780463386569771, 64.00045392761513],
            [10.78029958934116, 64.00036421349552],
            [10.780176884784932, 64.00029259472649],
            [10.780053969160129, 64.00019391266025],
            [10.779910685648744, 64.00008636762746],
            [10.779808459757497, 63.99998765836518],
            [10.779787885481053, 63.999906966983374],
            [10.779726376462222, 63.99978139712464],
            [10.779664610097878, 63.99967379783707],
            [10.779664445205341, 63.99958408230491],
            [10.779643912074777, 63.99948550387009],
            [10.779664134878002, 63.999359796438775],
            [10.779704773463955, 63.99925212212442],
            [10.779745419259005, 63.999171505058136],
            [10.779765587420894, 63.999063774136346],
            [10.779846974248954, 63.99895611749388],
            [10.779908156182355, 63.99885749090961],
            [10.779928398492538, 63.99875875119043],
            [10.77996911016507, 63.99866006801711],
            [10.779989338571164, 63.99856141778186],
            [10.78007066143797, 63.99844468026041],
            [10.780111535847189, 63.99836389001094],
            [10.780111355856913, 63.99827426395439],
            [10.780111162546136, 63.998193536668],
            [10.780151824375956, 63.99807687392406],
            [10.780192609319121, 63.997987181904605],
            [10.780233114962083, 63.99788849270032],
            [10.780273735500627, 63.99778090767755],
            [10.780294125948787, 63.99770015035454],
            [10.780314290734339, 63.99759241931849],
            [10.780354835297315, 63.99747584302821],
            [10.780354504043217, 63.99736823448557],
            [10.780415707556035, 63.99726942864115],
            [10.780476808352116, 63.99716181052391],
            [10.780497108938135, 63.99707215142008],
            [10.780476587913752, 63.99697348357352],
            [10.780476280207608, 63.996937563373635],
            [10.780476216250007, 63.99688376206533],
            [10.780435324294285, 63.9968209967569],
            [10.78041454633861, 63.996740299507096],
            [10.78037350430797, 63.996659551708454],
            [10.780312184859834, 63.99657884284192],
            [10.780250737058209, 63.99650711925358],
            [10.780189099217726, 63.99643530020906],
            [10.780148262123916, 63.99635455828663],
            [10.780066170178877, 63.996264974631316],
            [10.779963868626515, 63.99615736379287],
            [10.779881866405765, 63.99607668177945],
            [10.779820291941745, 63.996013943321834],
            [10.779759085163914, 63.99596910375168],
            [10.779636210553345, 63.99589738920371],
            [10.7794725920336, 63.995825656784014],
            [10.779309083499191, 63.99578979369675],
            [10.779145561867052, 63.99575401992477],
            [10.779002555518867, 63.99574509142028],
            [10.778859549266965, 63.99573616277547],
            [10.778675656009085, 63.99573629079089],
            [10.778471220788436, 63.995727370594096],
            [10.778266860245372, 63.99572744134454],
            [10.778164686739972, 63.99572743186345],
            [10.778042222690637, 63.99572755043678],
            [10.777940035664557, 63.995727630294134],
            [10.77781739481105, 63.99572756374629],
            [10.777653820327236, 63.995709764836654],
            [10.777510889027957, 63.99570982609956],
            [10.777388364345981, 63.995700863391896],
            [10.777245229239375, 63.995700918454574],
            [10.777071750468094, 63.99570665138095],
            [10.7769415920675, 63.995703488572964],
            [10.776734419779974, 63.995665271673005],
            [10.776529985795314, 63.99565634874826],
            [10.776366587513001, 63.99565635186482],
            [10.776182491021013, 63.99565647078306],
            [10.775957854144165, 63.995656576651406],
            [10.775732865971936, 63.99563869377043],
            [10.77542644979989, 63.99562985346821],
            [10.77522201655737, 63.995620928704774],
            [10.775078938767667, 63.99560300511653],
            [10.775017626794734, 63.995594116634614],
            [10.7749154403242, 63.99559419436465],
            [10.774752099514922, 63.995576219150486],
            [10.774506909269515, 63.99556736377354],
            [10.774220771243368, 63.9955584827962],
            [10.77401625225786, 63.995540654608746],
            [10.773811864296636, 63.995513840851515],
            [10.773546106026165, 63.995469056987254],
            [10.773300873697105, 63.995406353609],
            [10.773075963777034, 63.995325724877965],
            [10.772769190512077, 63.99520018989016],
            [10.77268171797774, 63.99516392969242],
            [10.77263857161698, 63.99514325488162],
            [10.772544269542433, 63.995092592625205],
            [10.772411687249873, 63.99502157712188],
            [10.772298769799631, 63.99494915744945],
            [10.772176240520407, 63.99486854690186],
            [10.772135041865157, 63.99482824258708],
            [10.772033639718536, 63.994735213934995],
            [10.771939028305505, 63.99463249526186],
            [10.771907727003693, 63.99459850227582],
            [10.77182800912734, 63.99446502574478],
            [10.771745962887081, 63.99437534809108],
            [10.771725501461614, 63.99430355743834],
            [10.771725506352164, 63.9942318244742],
            [10.771704854693981, 63.99418699559891],
            [10.771704610355744, 63.99413314369415],
            [10.771725121961447, 63.99408825715507],
            [10.771725067881375, 63.994034500692166],
            [10.771724895943404, 63.99398964001114],
            [10.771745334947699, 63.99393576224274],
            [10.771774641545342, 63.99385576011565],
            [10.771841749628443, 63.99379385013083],
            [10.771901182472604, 63.99375153721514],
            [10.77194369868369, 63.99371412427561],
            [10.771990427127884, 63.993675935287754],
            [10.772085589728489, 63.99361398960473],
            [10.772148186063575, 63.993541295804555],
            [10.772192062484551, 63.99348135982106],
            [10.772242175910309, 63.993420796735066],
            [10.77230024603953, 63.993373949383134],
            [10.772353561988679, 63.993331457894996],
            [10.772438598881998, 63.993270115584146],
            [10.772551814782792, 63.99319979700318],
            [10.77262708573058, 63.99314886679193],
            [10.772735627301275, 63.993081018594744],
            [10.772836231689363, 63.9930372094198],
            [10.772934108264195, 63.99300060180043],
            [10.77299633513509, 63.99295468446179],
            [10.773032800058914, 63.9929216189955],
            [10.773105644160307, 63.99282762022282],
            [10.773096233522267, 63.992740960504676],
            [10.773100340087534, 63.99267186417961],
            [10.773178289389513, 63.99260321342313],
            [10.773269227493806, 63.99253125588767],
            [10.773334084509148, 63.99245305437733],
            [10.773375815052791, 63.9923544923066],
            [10.773382698609534, 63.99229545487231],
            [10.773371588193621, 63.992232207167795],
            [10.773323186611545, 63.992186749078265],
            [10.773210017720354, 63.99211063703622],
            [10.773042903401056, 63.99203654725494],
            [10.772896459100256, 63.9919638691333],
            [10.772780426523788, 63.99189045981024],
            [10.772706828883008, 63.991836985423134],
            [10.772631977114546, 63.9917755639991],
            [10.772571333227486, 63.991702781214855],
            [10.772539084186114, 63.991645299090514],
            [10.77251439260806, 63.991566283756526],
            [10.7725214266774, 63.99150626191247],
            [10.772550407303305, 63.99144867803561],
            [10.772572371911554, 63.991357629816044],
            [10.772613236958549, 63.99129050456237],
            [10.772632426185046, 63.99121915142159],
            [10.772622130225887, 63.99115053390013],
            [10.772596944304507, 63.9910869654177],
            [10.772578571051353, 63.99103249485912],
            [10.77255928432212, 63.990997593904936],
            [10.772527727465356, 63.99096260471516],
            [10.772492649337174, 63.9909238272702],
            [10.77246707837881, 63.99087633802489],
            [10.772449850019983, 63.990802124798954],
            [10.772480117075016, 63.99073738718493],
            [10.772553999390182, 63.990668528319176],
            [10.772646577704162, 63.990623586432974],
            [10.772775506131582, 63.99058330038104],
            [10.77291978491201, 63.990536270655355],
            [10.773061273659435, 63.99048196814087],
            [10.773243909840298, 63.990410078319066],
            [10.773344442702985, 63.99035449120598],
            [10.773436673404223, 63.99029965071645],
            [10.773513802852435, 63.99023636948547],
            [10.773548026480567, 63.99019056398254],
            [10.773625825103133, 63.9900777426139],
            [10.773659060796966, 63.99000688892124],
            [10.773686752264583, 63.98995915531363],
            [10.773702883555107, 63.98989310639135],
            [10.773711335029645, 63.989822338963684],
            [10.773709069238969, 63.98975746148216],
            [10.773706978642918, 63.989690072161174],
            [10.773713731038422, 63.98961835627593],
            [10.7737281614964, 63.9895486621161],
            [10.77372649980907, 63.989494679061245],
            [10.77372519385057, 63.98942142476107],
            [10.773718471568765, 63.989356911718914],
            [10.77374077590377, 63.98927576134784],
            [10.77376260714089, 63.9891990917292],
            [10.773770586797937, 63.98913550182348],
            [10.773769674943276, 63.98908603518513],
            [10.77374993922455, 63.989027030507906],
            [10.773743866256087, 63.988957547449374],
            [10.773751281543486, 63.9888814462375],
            [10.773742015038879, 63.98883443268796],
            [10.773713850680155, 63.98879055356282],
            [10.773675185366992, 63.98874978405267],
            [10.77362726458456, 63.98869238444892],
            [10.7735946830546, 63.988633724239975],
            [10.773581128000536, 63.98859476568511],
            [10.77355345449955, 63.988553058216596],
            [10.773533094191697, 63.98851713726483],
            [10.773512516590683, 63.988481299862826],
            [10.77348920601585, 63.98844187700193],
            [10.773460119679378, 63.98840003841345],
            [10.773421124262487, 63.988350629648615],
            [10.773380309785022, 63.98830377465685],
            [10.773315839603299, 63.98825497124603],
            [10.773236130764944, 63.988191880129314],
            [10.7731391334271, 63.988141588584575],
            [10.77300126487998, 63.98808677887754],
            [10.772939678423691, 63.98804192470062],
            [10.77291930571839, 63.988006093165055],
            [10.772898860184045, 63.987961270394706],
            [10.772898686051008, 63.987916409674675],
            [10.772898729256859, 63.98787146540294],
            [10.77291893700231, 63.98781771568882],
            [10.772959764135877, 63.9877548591753],
            [10.772959576357406, 63.987710087949935],
            [10.772980007965991, 63.98765620992509],
            [10.77300030860619, 63.98761131718468],
            [10.773020595641874, 63.98756651393695],
            [10.773041027018408, 63.9875126359012],
            [10.773084820172988, 63.98744640507488],
            [10.773117192807316, 63.98739071794774],
            [10.773141302769545, 63.98733146384589],
            [10.77314386330328, 63.987269873270044],
            [10.77313823579121, 63.98721640373626],
            [10.773138063452507, 63.987151227697595],
            [10.773097519584402, 63.98707417707183],
            [10.773019161423539, 63.98699000074258],
            [10.77285607466103, 63.986920611952584],
            [10.772733461856612, 63.98687595508402],
            [10.77261074552169, 63.98684010440956],
            [10.772488029503453, 63.986804253633295],
            [10.772365590316081, 63.98677739993296],
            [10.772304297730075, 63.98674145318871],
            [10.772222241040794, 63.98669663065383],
            [10.772120117989173, 63.98665185186724],
            [10.772018008804066, 63.98660698351468],
            [10.771915741254258, 63.98654422212494],
            [10.771834007258784, 63.986490509534306],
            [10.77175209686295, 63.98643661196112],
            [10.771649844210174, 63.986400818139096],
            [10.771547723152562, 63.9863560389619],
            [10.77144548459853, 63.986320155503314],
            [10.771363706707465, 63.986284329676444],
            [10.771281711900071, 63.98622153011204],
            [10.771240927766387, 63.986167753625914],
            [10.771179611168765, 63.98610492817387],
            [10.771159011494857, 63.986042212212816],
            [10.77113778137936, 63.98599583804729],
            [10.771117938547404, 63.98595247077114],
            [10.771117885089033, 63.985898714271876],
            [10.77113004802085, 63.98585079764256],
            [10.771134733179998, 63.98579142639189],
            [10.771125244026955, 63.98572292204996],
            [10.771087349923214, 63.985659521584836],
            [10.771033843947738, 63.9856194866685],
            [10.77094901051049, 63.98558087464056],
            [10.770892386870644, 63.985554681816936],
            [10.770813672561381, 63.985527035231854],
            [10.770741291231728, 63.98550352864654],
            [10.770653160543795, 63.98547183171252],
            [10.770562151243906, 63.985442927222536],
            [10.770486674828772, 63.985423644944426],
            [10.77043308727105, 63.98540985564164],
            [10.770373394771948, 63.985385011283235],
            [10.770316796670665, 63.985353245700594],
            [10.770316745333659, 63.98530083759556],
            [10.770360939650123, 63.985244147699795],
            [10.770422116769131, 63.985190200771626],
            [10.770462879130296, 63.98514536621753],
            [10.770524028744614, 63.985091598234874],
            [10.770564790794078, 63.985046763649585],
            [10.77058529703638, 63.985001877196886],
            [10.770585126462219, 63.98495701648644],
            [10.770584883722902, 63.9849031645449],
            [10.770584916925255, 63.9848583097818],
            [10.770544208182837, 63.984813524346244],
            [10.77050297390906, 63.98477762279119],
            [10.770462147299998, 63.98474173312091],
            [10.77038043481179, 63.9846879302611],
            [10.770319135745737, 63.984652072215574],
            [10.770169867068896, 63.984572655889295],
            [10.770023024184512, 63.98450832204746],
            [10.769921860968745, 63.98442752305765],
            [10.769884722540668, 63.984342929885905],
            [10.769848011759132, 63.98424198896619],
            [10.76982027729808, 63.984133129968264],
            [10.769856864192263, 63.984048261960844],
            [10.769957686034164, 63.98394738075696],
            [10.770095356248023, 63.98386267689437],
            [10.77021462205522, 63.983785975355914],
            [10.770343097596344, 63.98370927289],
            [10.770480579024518, 63.983632563523756],
            [10.770535785555596, 63.983572060071154],
            [10.770563151359646, 63.98349941768048],
            [10.770563072523275, 63.983418782922215],
            [10.770526169951617, 63.98334615234469],
            [10.770480068712427, 63.98329779356689],
            [10.77040657909532, 63.98327353519617],
            [10.770277981951434, 63.9832293303536],
            [10.770185847498443, 63.983188976414866],
            [10.770149167207656, 63.98312435252501],
            [10.770176550242502, 63.98308811666668],
            [10.770259226948646, 63.98306383238345],
            [10.770360515963558, 63.98304368700514],
            [10.770433991685989, 63.983039629258876],
            [10.770544115935424, 63.98303142751829],
            [10.770626578695321, 63.98301531689545],
            [10.770654176385998, 63.982974952230535],
            [10.770644916052657, 63.982926590117046],
            [10.770598832651254, 63.98288623220746],
            [10.770461057731357, 63.98284993971116],
            [10.770295643504953, 63.98279342374805],
            [10.770139186361478, 63.982716943515584],
            [10.770020031241762, 63.982668519442505],
            [10.769891024486268, 63.98261216689467],
            [10.769784843694032, 63.98259567323032],
            [10.769683111325378, 63.98262416512913],
            [10.769618439786257, 63.982660660612694],
            [10.769535543480835, 63.9827093885482],
            [10.769470844459883, 63.982746062954625],
            [10.769378134178652, 63.982750097952],
            [10.769276614415796, 63.98273796490289],
            [10.76913805742966, 63.98270955869865],
            [10.769008503635126, 63.98267305534997],
            [10.768879164150215, 63.98262837802005],
            [10.768795842824114, 63.98260419123254],
            [10.768721967822378, 63.982559515332944],
            [10.768703348086202, 63.9825026995864],
            [10.768693947005348, 63.98243365813687],
            [10.768666109242458, 63.98235661730394],
            [10.768545773602074, 63.98226734675287],
            [10.768296080873954, 63.98218220869093],
            [10.76816654103051, 63.9821375247959],
            [10.76801855904618, 63.98206866068377],
            [10.767880012572357, 63.98201993801045],
            [10.767722621364111, 63.98195915864529],
            [10.767630321104495, 63.9819267085093],
            [10.767528402274866, 63.981890201902345],
            [10.76749137790547, 63.98182925265957],
            [10.76752821891146, 63.98176030335303],
            [10.767565083859568, 63.98168308472396],
            [10.767601930570788, 63.981593820098716],
            [10.76763858226645, 63.98152882047117],
            [10.767657415210332, 63.981472019823386],
            [10.767666427177645, 63.981415201977235],
            [10.767666246075736, 63.98132988967663],
            [10.767684460024302, 63.98128934130481],
            [10.767721319391285, 63.98123648308316],
            [10.767758355269445, 63.98118380979386],
            [10.76775816941504, 63.98112285794809],
            [10.767748976278796, 63.98105786755911],
            [10.767711922341768, 63.98098900704219],
            [10.767637851012177, 63.98094836983333],
            [10.767434616558521, 63.980907914731574],
            [10.767286450647658, 63.98087140525032],
            [10.767009143599722, 63.98081871775641],
            [10.766657771065432, 63.980774023452895],
            [10.766334387735236, 63.98074992226334],
            [10.766020039015624, 63.98072968001386],
            [10.765770561568631, 63.98070135490508],
            [10.765558130720683, 63.980689213853616],
            [10.765373325866927, 63.98066898063077],
            [10.76514208377283, 63.98061215236352],
            [10.764957089738314, 63.980543191774494],
            [10.764754802665335, 63.98046410702483],
            [10.764540596575582, 63.98040696668606],
            [10.764270949958151, 63.980313237363326],
            [10.764001163345291, 63.98019478317488],
            [10.763824431274866, 63.98011725317213],
            [10.76359162927546, 63.98003565640936],
            [10.76340567842982, 63.979966306122286],
            [10.763219524765583, 63.97989694964476],
            [10.763070812000102, 63.979856014916855],
            [10.762968512761892, 63.97981940377966],
            [10.762866025247728, 63.97979078743081],
            [10.762717288826096, 63.97976216680574],
            [10.76254990370932, 63.97973371974001],
            [10.762373107632756, 63.97971335716347],
            [10.762242814465706, 63.979668375789046],
            [10.762028893675508, 63.979545978315336],
            [10.76177757732987, 63.97939488975708],
            [10.761507640274907, 63.97923165990279],
            [10.761386788078358, 63.979170323858746],
            [10.761256676798626, 63.97913361688434],
            [10.76115417942378, 63.979101043693376],
            [10.760940280730775, 63.9789745100202],
            [10.760782019510017, 63.97886839136833],
            [10.760586554809068, 63.978737722086755],
            [10.760437721782363, 63.978627474170786],
            [10.760345121504496, 63.978532355437274],
            [10.760354241226876, 63.97846682135309],
            [10.760344765233299, 63.97838492210363],
            [10.760307282746526, 63.97829878738664],
            [10.760185978796422, 63.97814332001298],
            [10.760045967562238, 63.978057241033966],
            [10.759560776986326, 63.977836019362016],
            [10.759345838876078, 63.977750173642434],
            [10.759159369269657, 63.97766417209572],
            [10.758972874451834, 63.977590484765365],
            [10.758813979416548, 63.97753315648629],
            [10.758627597657567, 63.97750864298447],
            [10.758385137864781, 63.97748419536817],
            [10.758245029242124, 63.97745950795054],
            [10.75813314292692, 63.97742279214395],
            [10.757843895190033, 63.977369556542754],
            [10.757610862970314, 63.97734906922157],
            [10.757433501616733, 63.977320413557464],
            [10.757321793610105, 63.977300062696955],
            [10.7572096647889, 63.97729596991975],
            [10.757116359945222, 63.977295934143065],
            [10.757004611420827, 63.97730012243183],
            [10.756846020293938, 63.97730419719019],
            [10.756659410708084, 63.977296034806436],
            [10.75647280142963, 63.977279781881656],
            [10.75632367748024, 63.9772551880454],
            [10.756192997961476, 63.97721423458652],
            [10.756118369084872, 63.97718148507328],
            [10.756053124514269, 63.977165101149296],
            [10.755969260067305, 63.97714466593265],
            [10.755847937861375, 63.97713239223945],
            [10.755745060313007, 63.97709971388247],
            [10.755642779297542, 63.97709141375372],
            [10.755530813874282, 63.9770997295867],
            [10.755418847648098, 63.977120180782094],
            [10.75533487149259, 63.977157093252856],
            [10.755195280275075, 63.97717754392902],
            [10.754943358065537, 63.97718175852746],
            [10.754672640178539, 63.977173646002164],
            [10.754498771347011, 63.97716783178354],
            [10.754300903513851, 63.977169134682434],
            [10.754035766045698, 63.977178174178476],
            [10.753866755529648, 63.97720639105447],
            [10.753840154243047, 63.97716596880348],
            [10.753469941063239, 63.975995504105796],
            [10.751670255281388, 63.9750438124062],
            [10.751078353378412, 63.97409156891331],
            [10.750950957293309, 63.97385411114838],
            [10.750246290891281, 63.97243120279613],
            [10.749984287644716, 63.972135858954815],
            [10.748215570904412, 63.97017813380864],
            [10.747210887605105, 63.969249888619686],
            [10.74668991213723, 63.96877595665521],
            [10.745893134773466, 63.967152549063265],
            [10.744560571205014, 63.96515381996223],
            [10.74307181118797, 63.964588686304396],
            [10.74251651871274, 63.96433855027911],
            [10.741297781638476, 63.96374546699142],
            [10.74073733803307, 63.96339637894949],
            [10.738131631982588, 63.9621062434145],
            [10.734597088517152, 63.9604738901487],
            [10.734397634497608, 63.96038171665465],
            [10.736249853680999, 63.95985905807635],
            [10.730020921748483, 63.95535141517974],
            [10.726518598226303, 63.9528215576779],
            [10.723127742001495, 63.950371664205036],
            [10.717090792710097, 63.946014130698615],
            [10.714621207127117, 63.94355673834252],
            [10.711541342311607, 63.940504440362744],
            [10.70777353968174, 63.93928378604677],
            [10.705284328286009, 63.93847710274083],
            [10.703116746190153, 63.9377739553429],
            [10.699274610911024, 63.936529640038735],
            [10.696198432288373, 63.93553265080715],
            [10.686319742546761, 63.932328508855406],
            [10.673591351014919, 63.9281996059092],
            [10.669893775554383, 63.92699976694352],
            [10.663620054063166, 63.92496333586119],
            [10.655698994339458, 63.922391595819626],
            [10.650602074604214, 63.92073618979248],
            [10.64444138772106, 63.918734805078834],
            [10.63813036144608, 63.91668401218327],
            [10.628042527991434, 63.91340481385825],
            [10.61424216120843, 63.908916287864265],
            [10.611410084680896, 63.90798544379466],
            [10.571803316610705, 63.86966067918458],
            [10.523421173068531, 63.84286237517547],
            [10.518558078210793, 63.83771322666186],
            [10.51281629643882, 63.832512898231016],
            [10.508872291558678, 63.82768143308665],
            [10.503527746956713, 63.8233011367295],
            [10.490837633420451, 63.810871768682176],
            [10.483412761547276, 63.803531727653045],
            [10.470849394797632, 63.791100270155816],
            [10.464308504437499, 63.784411952911306],
            [10.460795523084718, 63.78089335491925],
            [10.451273140598296, 63.77124184112527],
            [10.447098937366615, 63.77629578114013],
            [10.444661316706647, 63.77924332390783],
            [10.442669533438462, 63.781670296995465],
            [10.440840264586166, 63.783861955865305],
            [10.440518802791486, 63.78424705707045],
            [10.440347591741785, 63.7844522238251],
            [10.440029830073113, 63.78483321525899],
            [10.439776354324943, 63.78513720402828],
            [10.438849183930232, 63.786248990399955],
            [10.437611102111479, 63.78766590726412],
            [10.436020433314939, 63.78966860852035],
            [10.433255715271388, 63.788809075614],
            [10.430518341165795, 63.78797624893774],
            [10.425116827507626, 63.786285597870524],
            [10.424667987327101, 63.78614510093479],
            [10.415361819325419, 63.78322041891789],
            [10.41759153538654, 63.78205182977422],
            [10.424354651353159, 63.77848834563948],
            [10.427966768824986, 63.77655335961566],
            [10.429061487600318, 63.77598448480754],
            [10.432465904418564, 63.77416473770259],
            [10.434041988057103, 63.77338396221491],
            [10.434930210854192, 63.772915503809784],
            [10.435662144046674, 63.772528678111584],
            [10.435755779295604, 63.772478684174416],
            [10.435849899300427, 63.77215949360869],
            [10.435996181614435, 63.771711306365745],
            [10.436122391870366, 63.77125403082671],
            [10.436248532963218, 63.77081473649748],
            [10.436415333340555, 63.77036647994892],
            [10.436541512142096, 63.76991810511491],
            [10.436667607703555, 63.769487800955226],
            [10.43679354695945, 63.76903959831449],
            [10.436855724085271, 63.768905164167535],
            [10.436738565852119, 63.76845636237144],
            [10.43660150145365, 63.768007559029336],
            [10.43648418058946, 63.76754975995327],
            [10.436346904120867, 63.767109851220575],
            [10.436209432958547, 63.766661124193874],
            [10.436112775243956, 63.76622133335218],
            [10.43601596849444, 63.76576364412408],
            [10.435976591731643, 63.76563786086373],
            [10.435978234655858, 63.76559003204205],
            [10.435972804096169, 63.76555955784181],
            [10.435963788736583, 63.76552236111315],
            [10.435894015133679, 63.76538230667433],
            [10.435856028614468, 63.76532076828141],
            [10.435818518325673, 63.76526005422309],
            [10.43574297840032, 63.76510291248013],
            [10.435688058405999, 63.76493509468539],
            [10.435672822939456, 63.764840918060614],
            [10.435662199856571, 63.76476469123306],
            [10.435657505560895, 63.764699532306764],
            [10.435679184044835, 63.76442363414674],
            [10.435687577716694, 63.76437174822503],
            [10.43568599158723, 63.76433132512879],
            [10.43569072000841, 63.764275726342916],
            [10.435704450457077, 63.764126809091806],
            [10.435753886380523, 63.76381744239253],
            [10.435795644390728, 63.763718778063506],
            [10.435816187704456, 63.763678426975616],
            [10.43585803154322, 63.7635440682353],
            [10.435898526982095, 63.76335023149356],
            [10.435907476158166, 63.76327858140031],
            [10.435957894795402, 63.7631037619585],
            [10.435980755058797, 63.76304280334876],
            [10.436015783025256, 63.762984478330495],
            [10.436076205622973, 63.76291733706106],
            [10.436136361194649, 63.76286817074332],
            [10.436212004061332, 63.76282246253306],
            [10.436284309043396, 63.76276599331496],
            [10.436229165386637, 63.76271384701523],
            [10.436168484085858, 63.76270473037345],
            [10.436089319290822, 63.76269435348654],
            [10.436043625948372, 63.76265536479103],
            [10.436051677712149, 63.76262567757752],
            [10.43608054788743, 63.76258574056479],
            [10.436118903486202, 63.76253069778346],
            [10.436131973398192, 63.76249091906231],
            [10.436124272462688, 63.76243429691264],
            [10.436084119244471, 63.76238491854866],
            [10.43599048267459, 63.76223044019265],
            [10.436000844584385, 63.762199027862735],
            [10.436080764343707, 63.762138169399876],
            [10.436156076362488, 63.76208444814739],
            [10.436211296036086, 63.76202811185752],
            [10.436297689795685, 63.76190712407558],
            [10.436367391075999, 63.761839107912785],
            [10.436518401800539, 63.761731767310515],
            [10.436750837498543, 63.76158060985457],
            [10.436889807414998, 63.76147234783155],
            [10.437130619240559, 63.76129699785535],
            [10.437216674662535, 63.761218259977916],
            [10.437316896280816, 63.76111973961672],
            [10.43751279889759, 63.760984687552494],
            [10.437527244345082, 63.760950617127776],
            [10.437475465497345, 63.76087515449262],
            [10.437465533892617, 63.76083482668815],
            [10.437470163610174, 63.76080242340998],
            [10.437519172053802, 63.760744271412726],
            [10.437574454051703, 63.76070133434243],
            [10.437720996116399, 63.7606316162953],
            [10.437908286657215, 63.76055482693157],
            [10.43799382309101, 63.76050565495438],
            [10.438042927610311, 63.760458205987284],
            [10.438098290732716, 63.760382091933955],
            [10.438123174250961, 63.76033684280578],
            [10.438192961076275, 63.76024500065125],
            [10.438254248777975, 63.76019128376794],
            [10.43831338043684, 63.76015467270606],
            [10.438449734056906, 63.76008764345521],
            [10.438454225867819, 63.760053572340595],
            [10.438434465152124, 63.760008707130694],
            [10.438433157355153, 63.759941407777184],
            [10.438482293527462, 63.75987867381238],
            [10.438588516731013, 63.75980704826379],
            [10.438629313177383, 63.75978208494363],
            [10.438714844165181, 63.759739206638805],
            [10.438713020176609, 63.75970776782745],
            [10.438646654179799, 63.759660976618555],
            [10.438586058616401, 63.759624978389986],
            [10.438336566029246, 63.759468441279125],
            [10.438147132301802, 63.75936128277156],
            [10.438080564027906, 63.75932077904237],
            [10.438040537025591, 63.75928570200036],
            [10.438014557859743, 63.75923722282491],
            [10.438018781898784, 63.75920669495179],
            [10.438070077021015, 63.759162012947705],
            [10.438194530568365, 63.75908062488881],
            [10.438716483181075, 63.75875772471951],
            [10.439341897944127, 63.75841535128757],
            [10.43957790313626, 63.75833232548271],
            [10.439625584836914, 63.75820691804343],
            [10.439703532702605, 63.75775971247361],
            [10.439789184949971, 63.757311312269664],
            [10.43987478869706, 63.756871992141384],
            [10.439980336456426, 63.75642359268958],
            [10.44004564321767, 63.75598416918987],
            [10.440186096853552, 63.755334742134025],
            [10.440220749546947, 63.75519440041584],
            [10.440255396146846, 63.75507923523273],
            [10.440273636282823, 63.755019119047695],
            [10.440382253348796, 63.75465596807824],
            [10.440481664220831, 63.75421025156773],
            [10.440585415625732, 63.75376278427096],
            [10.440678886876958, 63.75332614107337],
            [10.440782603249808, 63.752875075982864],
            [10.440864006874925, 63.752427620234585],
            [10.440971871268783, 63.75198100251816],
            [10.44105914323521, 63.75159901225698],
            [10.441073324984254, 63.75153633976993],
            [10.4412312857651, 63.75067256586626],
            [10.441247159284611, 63.75058557949505],
            [10.4417361101385, 63.747986013174625],
            [10.441981201544033, 63.746145804657004],
            [10.442806409999722, 63.7431331989047],
            [10.443237742665218, 63.741375766793006],
            [10.44341335324822, 63.740659655604304],
            [10.443577238097218, 63.7399922676445],
            [10.443587771088302, 63.73994836212497],
            [10.43958956032461, 63.73836775496582],
            [10.435901140515178, 63.736919769285976],
            [10.428155501823696, 63.73387815040658],
            [10.425006341024208, 63.73265560178294],
            [10.42381841318775, 63.7313507845973],
            [10.42318878405163, 63.730659515968995],
            [10.422332390358449, 63.729718788398955],
            [10.421986342282988, 63.7293388416819],
            [10.421390103526207, 63.728683693718864],
            [10.419917884098922, 63.72704581062908],
            [10.419183335141149, 63.72622826031932],
            [10.417939605590538, 63.72561244976081],
            [10.416956567212004, 63.7251094189116],
            [10.415820884576405, 63.72452841182992],
            [10.414886992318463, 63.72405049002769],
            [10.414077879877945, 63.723636335878986],
            [10.413270260298937, 63.72322312339223],
            [10.412591165975593, 63.72287550966025],
            [10.411893548197542, 63.7225183994399],
            [10.41124218893813, 63.72218506119085],
            [10.410539721724492, 63.72182554086837],
            [10.408136933022702, 63.720595723307234],
            [10.405294000932885, 63.71914021860189],
            [10.402428880855815, 63.7176732406976],
            [10.401411572917063, 63.7171522693202],
            [10.400518802480102, 63.716694979915566],
            [10.4004476605147, 63.716658579882875],
            [10.398837019360789, 63.715833697818205],
            [10.397268017360586, 63.715030135435036],
            [10.393878906602131, 63.71342875723015],
            [10.384592519222595, 63.70898597685846],
            [10.383397757958448, 63.708414474660145],
            [10.374160523595451, 63.70399301988919],
            [10.365790521838521, 63.700255839027626],
            [10.364772814623699, 63.6998154940267],
            [10.364417029458503, 63.69966131274878],
            [10.364054709552248, 63.699522296567324],
            [10.362099253647713, 63.698912572025066],
            [10.358232408115422, 63.697706419810494],
            [10.357236529764975, 63.697396121213245],
            [10.357179150563708, 63.697374034944],
            [10.357098467072046, 63.697348228377294],
            [10.357036146954334, 63.697326611904565],
            [10.356983906015799, 63.697310266794446],
            [10.356931503683581, 63.69729490560942],
            [10.356869179033797, 63.697279493638575],
            [10.356798564344372, 63.69725778894871],
            [10.356734320639088, 63.697234311721026],
            [10.356673232199727, 63.69721507288129],
            [10.35572341670822, 63.69691326510792],
            [10.352092776494322, 63.6957799414917],
            [10.347621614275312, 63.694308893744775],
            [10.347023373387294, 63.69412046857374],
            [10.33919689932371, 63.691657316239926],
            [10.339005854573731, 63.691593118344215],
            [10.338024069814775, 63.691278457061465],
            [10.335930310321297, 63.690607118670776],
            [10.33430202084121, 63.69009950788002],
            [10.33182080725482, 63.68930419655564],
            [10.331145037645548, 63.68908953092396],
            [10.326320857378306, 63.68755614703259],
            [10.32626853609595, 63.687543354618924],
            [10.326190091992183, 63.68751535399227],
            [10.326069577450612, 63.6874746541647],
            [10.325918498492692, 63.68742396738378],
            [10.325775606546621, 63.687381370323976],
            [10.325636720127985, 63.687341511272756],
            [10.325449578130556, 63.68728101786795],
            [10.325302790190772, 63.68723748421958],
            [10.325153890477855, 63.68718956525114],
            [10.325000878666929, 63.6871371059451],
            [10.324892477456347, 63.68709913724726],
            [10.324787747042235, 63.68706470509217],
            [10.3246328797601, 63.68700876779466],
            [10.324473863423732, 63.686957101685955],
            [10.324345060875615, 63.68691999742376],
            [10.32421631244199, 63.68688379406027],
            [10.324117578259605, 63.68685477222284],
            [10.324029071896875, 63.68682761190386],
            [10.323948508101594, 63.686801429417024],
            [10.323593709540853, 63.68674653805337],
            [10.323524222392532, 63.686727505246296],
            [10.323412450818953, 63.68669585537394],
            [10.323309686545393, 63.68667038875011],
            [10.323170780296705, 63.68663682133369],
            [10.323029818945036, 63.68660588466819],
            [10.322904890276586, 63.686576009299486],
            [10.322737814914552, 63.68653513973074],
            [10.322608586610395, 63.68650431478834],
            [10.322522312815854, 63.68648082320752],
            [10.32243497423062, 63.686447015632865],
            [10.322389699150817, 63.686410410199024],
            [10.322307311132606, 63.68638057028422],
            [10.322164468887324, 63.686338960174055],
            [10.321973177279293, 63.68629262508179],
            [10.321811736394869, 63.686254455746536],
            [10.321598255719119, 63.68620631854907],
            [10.321376765188862, 63.686156391448485],
            [10.321193418234468, 63.68611103336291],
            [10.321026279679634, 63.68606935027838],
            [10.320925534955379, 63.68604394760546],
            [10.320822976837697, 63.68601848580189],
            [10.320710149105926, 63.6859877435147],
            [10.320556951099018, 63.68594507502854],
            [10.320403993932063, 63.68590340340264],
            [10.32025513579614, 63.68586267444823],
            [10.320114330801337, 63.68581735160105],
            [10.31998336152089, 63.6857811617748],
            [10.319856613181775, 63.685747627253214],
            [10.319687356459788, 63.68570407498223],
            [10.319484043903701, 63.68565329809583],
            [10.319323053754063, 63.685612442676174],
            [10.319107445189136, 63.685562523626004],
            [10.318964504581887, 63.68552891037547],
            [10.318839640531174, 63.68549624562742],
            [10.318706685272835, 63.685457381983746],
            [10.318573941199226, 63.68541479313448],
            [10.318487413567155, 63.68538674939957],
            [10.318358748095559, 63.68535135246937],
            [10.318197269559404, 63.68531101935107],
            [10.31809857111797, 63.685283073371195],
            [10.31796503737479, 63.685245269260236],
            [10.317825562488482, 63.68520664191987],
            [10.317726589314427, 63.68517913634662],
            [10.317644970963995, 63.68515939041763],
            [10.317532390431655, 63.685129642713164],
            [10.317433027543654, 63.68510572129116],
            [10.317349045158961, 63.68508679740492],
            [10.317243637560887, 63.68506267883839],
            [10.31712190861074, 63.6850380282285],
            [10.317019712001573, 63.68502021908902],
            [10.316931167501007, 63.68500438361129],
            [10.316826517899267, 63.6849879332025],
            [10.31673024479139, 63.68496860831698],
            [10.316663954364106, 63.684952958494776],
            [10.316601801063936, 63.68493924203256],
            [10.316513789754804, 63.68492018630184],
            [10.316449179880916, 63.684905400497456],
            [10.316384579206888, 63.68489178401044],
            [10.31630927065607, 63.684876154782955],
            [10.316221493181068, 63.68486119815548],
            [10.316140210484795, 63.684850454945256],
            [10.316058981365536, 63.68484061270232],
            [10.315969570539565, 63.68482879506858],
            [10.31587622772559, 63.68481747867471],
            [10.315808443410221, 63.684810862343454],
            [10.315734347786144, 63.68480565889537],
            [10.315668632018989, 63.6848000092058],
            [10.315571470605219, 63.68479279467104],
            [10.315474696012949, 63.68478599735241],
            [10.315343200315953, 63.68477937180518],
            [10.314347047825128, 63.68453389609728],
            [10.312746143553174, 63.684097598470025],
            [10.310045040898572, 63.68333994220345],
            [10.307042221561645, 63.682504211015925],
            [10.306478819333083, 63.68234201177029],
            [10.303186720171265, 63.681411132167504],
            [10.301970271850243, 63.68107207669489],
            [10.300288832315927, 63.680603320564586],
            [10.296393428518606, 63.67948760777578],
            [10.293562610117707, 63.67868796192138],
            [10.289645614868531, 63.6775808779255],
            [10.286603254140465, 63.67672558645824],
            [10.286460059341033, 63.676685455541104],
            [10.284606196473883, 63.67616534041642],
            [10.281892781358781, 63.67539538162579],
            [10.27801064021167, 63.67430430049629],
            [10.27779845869601, 63.67424444591492],
            [10.27617411354843, 63.6737864372673],
            [10.275096418085603, 63.673482457403466],
            [10.274438202950037, 63.6732976692992],
            [10.273063180830793, 63.67291104676364],
            [10.26903011184831, 63.671775123796046],
            [10.268101156268594, 63.67138592164689],
            [10.26739374987753, 63.671074924101774],
            [10.266714317549718, 63.67080261556911],
            [10.266460028069293, 63.67067633522114],
            [10.266067500265107, 63.67053029940867],
            [10.264527564904835, 63.67023222047564],
            [10.263618353031456, 63.67012219879655],
            [10.263211635591894, 63.67003692966792],
            [10.26238722523042, 63.669842463750754],
            [10.26156305054177, 63.66966238957765],
            [10.260722241626976, 63.669506762345755],
            [10.259868087904136, 63.66937164347667],
            [10.25900327621501, 63.66926395625956],
            [10.25812483918156, 63.669128834333954],
            [10.257308349605962, 63.6689381965133],
            [10.256498675922169, 63.66874319240042],
            [10.25574503327895, 63.668491758837874],
            [10.254989004873156, 63.6682788228463],
            [10.254185455015955, 63.66811997985932],
            [10.253343157485096, 63.66798701079588],
            [10.252388317047256, 63.667885299382334],
            [10.251569667151598, 63.667822124119844],
            [10.25059692268202, 63.66733269598514],
            [10.249911893883166, 63.66698772117243],
            [10.249210928122208, 63.666636459750556],
            [10.24856409619756, 63.666304162760596],
            [10.247938814332707, 63.66600522105296],
            [10.24726204721876, 63.665658436929874],
            [10.246635298385064, 63.665340644415586],
            [10.246004284196186, 63.66502180826687],
            [10.245891142460481, 63.66496491226141],
            [10.245722168520961, 63.66487999721765],
            [10.24555631381387, 63.66474392373255],
            [10.245018238292227, 63.66451080789461],
            [10.244936222906597, 63.66447112964354],
            [10.244652292007839, 63.66433537151573],
            [10.242212785191931, 63.663159627951856],
            [10.241882124918147, 63.663012962227796],
            [10.24123812415634, 63.66269852846555],
            [10.239555598730915, 63.66192877628846],
            [10.239210399951661, 63.66177964313207],
            [10.238900722718471, 63.66163357557005],
            [10.238803335526091, 63.661563795686966],
            [10.238450639305604, 63.66136054197668],
            [10.238281843264046, 63.66129289010779],
            [10.237956590022069, 63.66112031300777],
            [10.237322317358423, 63.66073765310038],
            [10.237150547914846, 63.66066243665257],
            [10.236719886805837, 63.6604799742993],
            [10.235949598971072, 63.6601612340425],
            [10.235242848856279, 63.659860785901564],
            [10.23485183572271, 63.6597075124865],
            [10.234453626437723, 63.65954770369755],
            [10.234138565954852, 63.65932680122053],
            [10.233853603119876, 63.65913036973824],
            [10.233570286825342, 63.65893740972546],
            [10.233018964259854, 63.65871324681146],
            [10.232716552024641, 63.65857370082093],
            [10.232174757375917, 63.658329076056816],
            [10.231633142285045, 63.658119529073],
            [10.231467748910763, 63.65804388728204],
            [10.230622396575022, 63.657799065496015],
            [10.229958942886801, 63.65761604131012],
            [10.22926516763176, 63.6573835318949],
            [10.228396276655378, 63.65707316140303],
            [10.228273232192262, 63.65703579603935],
            [10.227364978542656, 63.65663597510434],
            [10.227160511482966, 63.65652926065702],
            [10.226825270280438, 63.656366215883054],
            [10.226539267089287, 63.65622810040569],
            [10.226449125026338, 63.656161249827946],
            [10.226151646985816, 63.65600476510075],
            [10.225821038141628, 63.65581669018786],
            [10.22522997736994, 63.65546868239707],
            [10.22477212225943, 63.65524309659509],
            [10.224495065813187, 63.65512047299133],
            [10.223976690539843, 63.65488297822902],
            [10.223648200029505, 63.65474254330034],
            [10.223062424732499, 63.654470335933205],
            [10.222336325424957, 63.654145790321046],
            [10.221663479172575, 63.65384999364279],
            [10.221618495659376, 63.65380469816004],
            [10.221569984051582, 63.65375272000118],
            [10.221621086109794, 63.65372690119973],
            [10.221688209783677, 63.65368767588227],
            [10.221755912144369, 63.65364981881706],
            [10.221823018110884, 63.65359989066417],
            [10.221896658716336, 63.653523199689026],
            [10.221964299205656, 63.653458090366534],
            [10.222029806303876, 63.653393629482565],
            [10.222114819863025, 63.65333350516928],
            [10.222178706074077, 63.653290664461416],
            [10.222248478778083, 63.65324891900352],
            [10.222331079751642, 63.65320310377776],
            [10.222402547953646, 63.65316330331027],
            [10.222451456803908, 63.653125270124406],
            [10.222354239081566, 63.65305368425517],
            [10.222204848759617, 63.65297946239729],
            [10.222074830023224, 63.652910381890045],
            [10.221894960453184, 63.65280088012781],
            [10.221676456612418, 63.65268046902595],
            [10.221494027231241, 63.65258617032128],
            [10.221264336463996, 63.65245891080633],
            [10.221055075981342, 63.65234492189864],
            [10.220872834409635, 63.65223632896892],
            [10.220667785606478, 63.652108180060274],
            [10.220488715777224, 63.651995195449956],
            [10.220334166362681, 63.65190362209746],
            [10.220134105573846, 63.65179272596071],
            [10.219912778803486, 63.65166754118161],
            [10.21972340282433, 63.65156410504891],
            [10.219570304107442, 63.65148795787685],
            [10.219436627327507, 63.651428645614],
            [10.219304576499459, 63.651372894817165],
            [10.219154787116262, 63.651313135535034],
            [10.219012022068137, 63.65125972560912],
            [10.218878399117626, 63.65121210606424],
            [10.218783985365981, 63.65117797862116],
            [10.218750746947679, 63.65115308370754],
            [10.218629511934035, 63.65106801407329],
            [10.2185113670637, 63.65098862320848],
            [10.218339119960048, 63.650882068293186],
            [10.218194916449724, 63.650789218145505],
            [10.218069343288837, 63.65070589205732],
            [10.217890658638545, 63.650577537710966],
            [10.217719038954524, 63.650454095103214],
            [10.21748440019043, 63.65029878403056],
            [10.217266782773333, 63.65014934585092],
            [10.217115241002007, 63.650040061644575],
            [10.216974481264183, 63.64994004009895],
            [10.216788798938797, 63.649816037609504],
            [10.21664891186772, 63.64972045157497],
            [10.216617520521725, 63.649690626250354],
            [10.216491805590707, 63.649597400982344],
            [10.216288822683866, 63.6494692237401],
            [10.216126658972083, 63.64936417094964],
            [10.216023835743469, 63.649288795820766],
            [10.215897988694275, 63.64919637494695],
            [10.215745300187061, 63.64908075536174],
            [10.21556215905232, 63.648954947078124],
            [10.215360276519707, 63.64882149881799],
            [10.215119189950503, 63.64866497896588],
            [10.214972558518504, 63.648563859996415],
            [10.214856461346582, 63.64848444392769],
            [10.214765997459345, 63.64842539828767],
            [10.214741558389322, 63.64836198871331],
            [10.214713255467421, 63.648289906481395],
            [10.214688358394676, 63.64821083293487],
            [10.2146739601106, 63.64811511172271],
            [10.214680653705381, 63.6480155070754],
            [10.214689459131021, 63.6479393559364],
            [10.214693611844007, 63.64785540519234],
            [10.214682673079063, 63.64779973045528],
            [10.214674527440925, 63.647704127779804],
            [10.214667840063926, 63.647623862671416],
            [10.214665342837337, 63.64754274798818],
            [10.21465116117455, 63.647446944048234],
            [10.214646506875086, 63.647342644147976],
            [10.214626054517971, 63.64719887563743],
            [10.214612527111834, 63.64710039545009],
            [10.214613889277814, 63.64698442473469],
            [10.214600462648837, 63.64688414920218],
            [10.214597950499769, 63.64680312394608],
            [10.21459029288134, 63.64671662095398],
            [10.214592589559455, 63.64663107942273],
            [10.214599770463872, 63.64654057445752],
            [10.214603932736313, 63.646467955837146],
            [10.214598619155307, 63.646379552432826],
            [10.214589619584247, 63.64626503490674],
            [10.214584292215877, 63.64614074697663],
            [10.214574186360117, 63.64602079645654],
            [10.214571373661194, 63.64590558587283],
            [10.214567051335132, 63.64581011064864],
            [10.21457287405388, 63.64571686234596],
            [10.214565397778049, 63.64562928616607],
            [10.214574085158635, 63.64560178593438],
            [10.214561463635551, 63.645508732018534],
            [10.214552380029515, 63.645359946438006],
            [10.214538553409312, 63.64521289132912],
            [10.2145323706282, 63.64510566250676],
            [10.214520037035877, 63.64498572761149],
            [10.214462971957461, 63.64480836149941],
            [10.21443194394773, 63.64468051844856],
            [10.214411376904176, 63.64457460863157],
            [10.21438820999454, 63.64446132737194],
            [10.21436948861766, 63.6443672605758],
            [10.214351536043557, 63.6442938145312],
            [10.214359888450247, 63.644209554148006],
            [10.214354896819893, 63.64414202635727],
            [10.214357428741922, 63.64408985854515],
            [10.21436407009921, 63.64402892420782],
            [10.21437201901808, 63.64396983217573],
            [10.214369455773536, 63.64392387983636],
            [10.214367496631922, 63.6438635580391],
            [10.214362706188508, 63.64379603695583],
            [10.214344467614197, 63.64371349792406],
            [10.214325108365767, 63.6436112257436],
            [10.214311179829629, 63.64353791387331],
            [10.214306605810922, 63.64347031006493],
            [10.214297303085731, 63.64342952906604],
            [10.214267786956663, 63.64339643792211],
            [10.214250381844534, 63.64335871430482],
            [10.214229511298155, 63.64332654102037],
            [10.214211995732244, 63.6432864754014],
            [10.214191981026868, 63.6432372429941],
            [10.214165141897073, 63.64318049824822],
            [10.21415272151125, 63.64313421715474],
            [10.21413502107516, 63.64307247100971],
            [10.214104848524586, 63.64299951670086],
            [10.21405325158084, 63.64292045175066],
            [10.213986366634858, 63.64282648728466],
            [10.213952825983881, 63.64273633293346],
            [10.213914255905538, 63.642653205630054],
            [10.213875921187734, 63.6425926598614],
            [10.213834917494037, 63.64252435090028],
            [10.213824494829241, 63.642455052752325],
            [10.213787684922329, 63.64238547436312],
            [10.213759509878383, 63.64232346870668],
            [10.21370863433766, 63.64224253899992],
            [10.213663260193904, 63.6421745635464],
            [10.21363055408545, 63.64211663366877],
            [10.21360152495994, 63.642050102722905],
            [10.213568387289875, 63.64198154608836],
            [10.213543649155275, 63.641901578052206],
            [10.213501814374593, 63.64178866309719],
            [10.21347288728595, 63.6417095445978],
            [10.213449256632883, 63.641620619963085],
            [10.213403313751535, 63.64150927669231],
            [10.213372389912161, 63.641440793829815],
            [10.213356351593363, 63.64138000230972],
            [10.213335036553854, 63.64126777175261],
            [10.213320071845823, 63.64117544881161],
            [10.213305288857805, 63.64114437774198],
            [10.213273429026371, 63.64109223180973],
            [10.213240510231183, 63.641012800200045],
            [10.213205615436214, 63.640930694542035],
            [10.213166949072583, 63.64084936240472],
            [10.21314615070846, 63.64076763703307],
            [10.213119805718994, 63.640684017853715],
            [10.213096764414034, 63.64060599491936],
            [10.213065742641318, 63.640524917758334],
            [10.213034269095719, 63.64043573135184],
            [10.212986753687085, 63.64034690911323],
            [10.212946415356997, 63.64025032206],
            [10.212918629411151, 63.64015127583177],
            [10.212881725919848, 63.64005831080977],
            [10.212844082107052, 63.6399805201145],
            [10.212792730097041, 63.63990245193198],
            [10.212720324928833, 63.63980290629855],
            [10.212669104492472, 63.63972286387046],
            [10.212642505685375, 63.63968870041739],
            [10.212625697571115, 63.63965765160635],
            [10.21258884581822, 63.63956558754464],
            [10.212537930494975, 63.63945857467362],
            [10.212467287053954, 63.63936178569517],
            [10.212397534690878, 63.63925972022461],
            [10.212329722571495, 63.639170130504226],
            [10.212263488303998, 63.63909516289262],
            [10.21216781879466, 63.63900284484338],
            [10.21209012058225, 63.63892389719263],
            [10.212010241658792, 63.63883390462231],
            [10.211931253906434, 63.63873863555372],
            [10.21184616846959, 63.63863156129914],
            [10.211754007793736, 63.638530456400396],
            [10.211678966749574, 63.63845375558294],
            [10.211622881038394, 63.63839657370441],
            [10.21156023532702, 63.63832433355411],
            [10.211498762636538, 63.63824394840605],
            [10.211429266207555, 63.63815358243],
            [10.211353097145086, 63.638065601836686],
            [10.211284219100955, 63.63798236129313],
            [10.2112109817264, 63.63789978462852],
            [10.211132384758997, 63.63781541019724],
            [10.211027372752046, 63.63770659100634],
            [10.210925162846538, 63.63759435776845],
            [10.210816620012507, 63.637469322105844],
            [10.210736081554522, 63.63737130235582],
            [10.210713257959899, 63.63733996250172],
            [10.210645222461366, 63.63726133638333],
            [10.210565754870764, 63.63717135649894],
            [10.210485167954184, 63.637072435592444],
            [10.210428616162142, 63.636976115673214],
            [10.210345918102162, 63.63687892289479],
            [10.210266823295653, 63.63679632993765],
            [10.21019042264898, 63.636721741179855],
            [10.210088169340423, 63.636608606364895],
            [10.209995067042572, 63.63650117308986],
            [10.209911719636688, 63.63639586412159],
            [10.209804793970076, 63.63627447886609],
            [10.20973547158173, 63.63619392057548],
            [10.209666013664588, 63.63611416713494],
            [10.209616784213063, 63.63605955148543],
            [10.209536054734686, 63.63595073221986],
            [10.209396552981632, 63.63581746662905],
            [10.209269672934582, 63.635683722968],
            [10.20915285300319, 63.63553592541734],
            [10.209037403239178, 63.635405171299496],
            [10.20894541366912, 63.63530317042422],
            [10.2088160236192, 63.63517114113842],
            [10.20869603868285, 63.635031331600146],
            [10.208566286213538, 63.634889486952126],
            [10.20847626351806, 63.63477585975781],
            [10.208392173898046, 63.63466422935313],
            [10.208325036551768, 63.63458275386051],
            [10.208288329437133, 63.63453665004853],
            [10.20825781931126, 63.63450055617367],
            [10.208214966965889, 63.63441899235553],
            [10.208171098583158, 63.63431949740747],
            [10.208130449990591, 63.63421291513569],
            [10.208097436627401, 63.63407430100116],
            [10.208060571152707, 63.633981245450954],
            [10.208015851233688, 63.63387362777943],
            [10.207963735574634, 63.63372718069244],
            [10.207900466559007, 63.633610849181814],
            [10.20784037618889, 63.6335116216313],
            [10.207759660399063, 63.63340280145641],
            [10.207678545806107, 63.63328317562667],
            [10.207608813417282, 63.633147651612525],
            [10.207540100353041, 63.633038422795586],
            [10.207498039495018, 63.632964169875066],
            [10.207476680566753, 63.63293377760513],
            [10.207399554505844, 63.63281689292616],
            [10.207296379156816, 63.632672247193504],
            [10.207195656864831, 63.632514282902164],
            [10.207100882570591, 63.63235822600656],
            [10.206993156368155, 63.63219265279464],
            [10.206894441112794, 63.63205993724446],
            [10.206808106429493, 63.63193653889062],
            [10.206688248675917, 63.631784140312554],
            [10.206621180132029, 63.631678383380354],
            [10.20658575738698, 63.63161154673292],
            [10.206573760093777, 63.63155088894712],
            [10.206511199198072, 63.63145436606066],
            [10.206433008189592, 63.63134383050302],
            [10.206365876464686, 63.63123726186657],
            [10.206277689968381, 63.63110210954538],
            [10.206191112966684, 63.630967010932345],
            [10.206113385576954, 63.63082861054907],
            [10.206036309902931, 63.63069832609924],
            [10.205950497836211, 63.630583848126875],
            [10.20587375716136, 63.63046355761641],
            [10.20580764769441, 63.63036412769736],
            [10.20573919545769, 63.63026659802552],
            [10.205723836688444, 63.63023901405892],
            [10.205675980998388, 63.6301871405796],
            [10.205588820178404, 63.630055529438145],
            [10.205515421804945, 63.62991547455717],
            [10.205419847855007, 63.629752284426914],
            [10.205309917464264, 63.62957593340286],
            [10.205198286412449, 63.62942281878831],
            [10.205108053802634, 63.62927590540638],
            [10.20504307836426, 63.629168598546016],
            [10.204967192240582, 63.629055260973054],
            [10.204896340602364, 63.62893606593491],
            [10.204870741399919, 63.628872165185875],
            [10.204861990513429, 63.628841384411615],
            [10.204785230226573, 63.62874519522508],
            [10.204685218785592, 63.62864301243131],
            [10.20459719334761, 63.6285644336966],
            [10.204512716001211, 63.628503151261846],
            [10.204391084461921, 63.62842003132646],
            [10.204217300912443, 63.62831169440909],
            [10.204078093654282, 63.62822609789777],
            [10.20387708547483, 63.62811136417814],
            [10.203747223350298, 63.628042268222806],
            [10.2036401290586, 63.6279820276682],
            [10.203553338266696, 63.627933258247424],
            [10.20343167138347, 63.62786353663925],
            [10.203355735745133, 63.62782232494305],
            [10.203297162827422, 63.62779203644797],
            [10.203091018122532, 63.62770294132831],
            [10.202899204415903, 63.62761639367888],
            [10.202784116441437, 63.62756757674601],
            [10.20268067366353, 63.62752283655644],
            [10.20255735813561, 63.62747365431865],
            [10.20237728261252, 63.627414569228364],
            [10.202125315208942, 63.62735137044252],
            [10.20182046101698, 63.627263738195616],
            [10.20160312452366, 63.62720979110648],
            [10.201349981197414, 63.6271535665484],
            [10.201101243533094, 63.62710477374165],
            [10.20081869723672, 63.62701797548649],
            [10.200598568514978, 63.62695664852456],
            [10.20039070507438, 63.626895731611604],
            [10.20016315621894, 63.62683046826151],
            [10.200048704675277, 63.626800646773574],
            [10.19993261027921, 63.62676978091231],
            [10.199538793082363, 63.62667026265528],
            [10.199263727556989, 63.626588298217136],
            [10.198938898959154, 63.626476607433574],
            [10.198614511693812, 63.62636232246806],
            [10.19835826822772, 63.62627550008182],
            [10.198009305837964, 63.62616308904017],
            [10.197673014392594, 63.62604750385769],
            [10.19730751979479, 63.62593723554409],
            [10.197021698102368, 63.62584483341755],
            [10.196778636105083, 63.62575305316638],
            [10.196587142479212, 63.625664798171],
            [10.196411724285262, 63.62559147110433],
            [10.196337115589339, 63.6255598329879],
            [10.196094426069738, 63.62548200409831],
            [10.195766197781817, 63.625380984011066],
            [10.195500957163107, 63.62529844147704],
            [10.195228615117266, 63.625210084453144],
            [10.194951220987425, 63.625118140027105],
            [10.194629488994133, 63.6250110391915],
            [10.19440100308959, 63.62493952894834],
            [10.194202296102235, 63.62488439527365],
            [10.1940343090112, 63.6248364962888],
            [10.193892522131499, 63.62479028445708],
            [10.193810517277377, 63.624762354281984],
            [10.193727008787212, 63.624728977464635],
            [10.193647707124768, 63.62469583150274],
            [10.193478348781838, 63.624622613631786],
            [10.193325440549362, 63.62455732164361],
            [10.19315325149844, 63.62448769588972],
            [10.19298805959212, 63.62442451005813],
            [10.192759995749837, 63.62433862122748],
            [10.192619864505364, 63.62428266039745],
            [10.192443188609412, 63.62421567135624],
            [10.192241807359686, 63.62414056905124],
            [10.19203046237787, 63.62406342362899],
            [10.191882459317116, 63.62400620881928],
            [10.191657362305119, 63.623926713105654],
            [10.19151742751787, 63.62388155010796],
            [10.191386165955095, 63.62384486201074],
            [10.191138215935778, 63.62376900612928],
            [10.190845935745266, 63.62367916212204],
            [10.190583239858597, 63.62359489630686],
            [10.190420261005626, 63.6235425738897],
            [10.190190393534794, 63.623467412553204],
            [10.189992085349546, 63.62339690671046],
            [10.189763163856181, 63.62331736943898],
            [10.189514465011866, 63.62324598226076],
            [10.189255246311442, 63.623177029807884],
            [10.189053910946592, 63.62312440844227],
            [10.18876710805672, 63.623050032905404],
            [10.188549653110838, 63.62298517820434],
            [10.188337769873684, 63.6229125056648],
            [10.188125325039765, 63.62282884160381],
            [10.187976675443423, 63.62276359629279],
            [10.187831249646916, 63.622691263999926],
            [10.18766216721689, 63.62260464717839],
            [10.187538350950677, 63.62253483838141],
            [10.187412862578645, 63.62246416391732],
            [10.187294585527306, 63.62239984705159],
            [10.18724636524572, 63.62237304648271],
            [10.187157658946392, 63.62232510107243],
            [10.187074774851279, 63.622268656746805],
            [10.18702031307487, 63.622217064074626],
            [10.186930521299585, 63.622149295867814],
            [10.186825163472033, 63.62206841396695],
            [10.186773794905125, 63.622024419465546],
            [10.186731681331578, 63.621987840598955],
            [10.186700335942994, 63.62195809860083],
            [10.186636549636173, 63.62190388411299],
            [10.186588948021763, 63.62186271407643],
            [10.186529428933548, 63.62180837293586],
            [10.186332238771634, 63.621695628471215],
            [10.185951923978422, 63.62142060556388],
            [10.183857597814363, 63.61683083721099],
            [10.183512565925868, 63.61637216877124],
            [10.183188616979379, 63.615996590282165],
            [10.182860514767647, 63.61558597550386],
            [10.176767306848966, 63.61059527035086],
            [10.176580035947593, 63.610418447421644],
            [10.176441999936094, 63.60947385943624],
            [10.174170313415022, 63.607076281813725],
            [10.172669548377906, 63.605492062587615],
            [10.171768883865546, 63.60454081944918],
            [10.171551149313249, 63.604328875293],
            [10.166347308525985, 63.60369939477137],
            [10.16490739972313, 63.603519072267005],
            [10.164987169454578, 63.60329610564313],
            [10.165094824817482, 63.60298881729044],
            [10.165675826492652, 63.6010538570154],
            [10.165818248824815, 63.60058962820538],
            [10.165825441588142, 63.59977682151456],
            [10.161911436973288, 63.598350529566304],
            [10.160797083075774, 63.598061977503804],
            [10.157204472447878, 63.5972722871524],
            [10.15742865548667, 63.5969802728224],
            [10.157482004866388, 63.59691138277978],
            [10.158204042973033, 63.59595570466634],
            [10.157422007763019, 63.59532497651954],
            [10.15699229396743, 63.594972461805554],
            [10.153261654614457, 63.5925920810216],
            [10.152874601127374, 63.59229783659417],
            [10.148580477995479, 63.58996561901359],
            [10.148168750450983, 63.58961647001539],
            [10.146094359129332, 63.58918897033989],
            [10.144960416939284, 63.58916818137986],
            [10.137497817045126, 63.58890442364162],
            [10.135846517845197, 63.5888459471022],
            [10.135124860298715, 63.58875538458554],
            [10.134900835671715, 63.588691759808576],
            [10.134825413490066, 63.588680354012695],
            [10.134746187849863, 63.588668954839],
            [10.134676102172214, 63.58865695127055],
            [10.134705612560811, 63.588588653292675],
            [10.134761578545886, 63.588489369320584],
            [10.134782169108323, 63.58845283264869],
            [10.134845958923904, 63.588189850735574],
            [10.134834508356212, 63.58796415815189],
            [10.134916894835296, 63.58767509504367],
            [10.135013967261598, 63.587277791173804],
            [10.13506441920832, 63.586911013470704],
            [10.135089577596435, 63.58677403219956],
            [10.135128873407966, 63.586568006098226],
            [10.135159699239901, 63.58596959196436],
            [10.135182925461413, 63.58567339342335],
            [10.134932475829268, 63.58526680749548],
            [10.134917077998175, 63.584985127086966],
            [10.13490904396607, 63.58486217388305],
            [10.134886545896386, 63.58471165707386],
            [10.134861516659702, 63.58454171684759],
            [10.13489284725941, 63.584510536706105],
            [10.134924379430048, 63.584479948025034],
            [10.134969538445635, 63.58445733220267],
            [10.135033442508032, 63.58443215277777],
            [10.134990993861182, 63.58438327431533],
            [10.134929117171641, 63.584343712423305],
            [10.134873623257313, 63.58431286673489],
            [10.134827918687595, 63.584292067154934],
            [10.134784823730149, 63.58427135617903],
            [10.134713798881178, 63.58424160195094],
            [10.13465779050631, 63.58421730443755],
            [10.134609417296067, 63.58419794316046],
            [10.134563548363031, 63.584180465745995],
            [10.13450512509946, 63.584162022304795],
            [10.134426475395076, 63.58413612380091],
            [10.13434799916732, 63.58409614087807],
            [10.134297672074098, 63.58405703028782],
            [10.134282029354772, 63.58402082184713],
            [10.134321859433046, 63.58398648303115],
            [10.134350480799718, 63.58395314233647],
            [10.13437022031339, 63.5839274598272],
            [10.134387482643662, 63.58389737598459],
            [10.134411041684203, 63.58386294145106],
            [10.13445426962159, 63.58382742104764],
            [10.134496662307654, 63.58379855043631],
            [10.134480636430341, 63.58376891003921],
            [10.134417156640463, 63.58374993504312],
            [10.134349504849748, 63.58372840518877],
            [10.134254505520548, 63.5836987511505],
            [10.134109767129699, 63.583677390319984],
            [10.134148133952014, 63.58360539093983],
            [10.134156678103016, 63.58354838827369],
            [10.134161266015639, 63.58349916610645],
            [10.134314089772383, 63.58335766168449],
            [10.13434019831608, 63.58331717524075],
            [10.134372876724134, 63.5832819486608],
            [10.134390302750676, 63.58321787243153],
            [10.134390897136267, 63.58318254553808],
            [10.134407871134755, 63.58312582917451],
            [10.1343687541727, 63.58309014292089],
            [10.13440974764737, 63.58304053825229],
            [10.134425931011334, 63.58301203672415],
            [10.134411999536917, 63.58294833456965],
            [10.134364832347043, 63.58289834399528],
            [10.13428640464004, 63.582841085695605],
            [10.134223869617427, 63.582777081855305],
            [10.134161777612748, 63.58271992859671],
            [10.134114801272448, 63.58266292894777],
            [10.134115821957142, 63.58261331579449],
            [10.134085801565053, 63.5825280207563],
            [10.1340866521707, 63.582478221941514],
            [10.134055421172215, 63.58244954904913],
            [10.134024970434869, 63.5823856454992],
            [10.13394631812521, 63.58232145381701],
            [10.133883835556317, 63.58225007633822],
            [10.133821293301768, 63.58220028281187],
            [10.133806807259145, 63.58213629188883],
            [10.133777640531902, 63.5820224242735],
            [10.13374659927855, 63.58196551603222],
            [10.133731892767296, 63.581908712943715],
            [10.133701052437203, 63.5818518115119],
            [10.133702109081849, 63.581794914282675],
            [10.133686971829743, 63.581759502687554],
            [10.133656548474804, 63.581702525461985],
            [10.133610602025398, 63.581610033570115],
            [10.133596116702051, 63.5815460426288],
            [10.133596943274018, 63.5815105437158],
            [10.133629249606333, 63.58147512480966],
            [10.13369341698922, 63.58144699418377],
            [10.133757354123274, 63.58144026184481],
            [10.133853183002907, 63.5814406388864],
            [10.133948821822825, 63.58144802486228],
            [10.134005749904615, 63.581451577513874],
            [10.13406236909917, 63.58143982955917],
            [10.134151066023682, 63.581430565242854],
            [10.1342389854412, 63.58144295041414],
            [10.134311626086014, 63.58143372525847],
            [10.134424880362275, 63.5814006958153],
            [10.13445761663754, 63.5813745553477],
            [10.134453053459001, 63.58133869351534],
            [10.134443280803012, 63.58128844396039],
            [10.13444395960797, 63.5812479033163],
            [10.134423451944844, 63.58121437807052],
            [10.134402554617255, 63.58117841116013],
            [10.134371371533177, 63.581140026231665],
            [10.134334514559347, 63.581106485314095],
            [10.134340638767144, 63.581073055131135],
            [10.13438386121535, 63.58104933951158],
            [10.134467879800143, 63.5810054684688],
            [10.134525061364815, 63.580968600760166],
            [10.134594875452844, 63.58095936943442],
            [10.134697161409207, 63.580943236107885],
            [10.134772436854123, 63.58093158187361],
            [10.134829527385724, 63.58089111329934],
            [10.134806105990798, 63.58085042873683],
            [10.13474244733937, 63.58081660727287],
            [10.134614820055155, 63.58077791493846],
            [10.134406724941286, 63.580726955590485],
            [10.134235947903216, 63.58068796654573],
            [10.134140202170295, 63.580649367292885],
            [10.134081967450044, 63.580618068222606],
            [10.134066087610764, 63.580591715551535],
            [10.134051018811768, 63.58056062351606],
            [10.134002829350594, 63.58054612495584],
            [10.133955061299213, 63.5805244453547],
            [10.133928892537321, 63.58049333602024],
            [10.133897630413118, 63.58044775292861],
            [10.133885425770723, 63.58039638635888],
            [10.133828455440332, 63.58034826603926],
            [10.133823182966182, 63.580297089971076],
            [10.1338369838307, 63.580265989230156],
            [10.133881374854662, 63.580229541752075],
            [10.133909443113334, 63.580205311521134],
            [10.1339526364793, 63.58016819375025],
            [10.134032222445045, 63.58013959744549],
            [10.134108399837713, 63.580113223803764],
            [10.134204289472326, 63.58007546750471],
            [10.13430987386391, 63.580037680677144],
            [10.134370506499751, 63.580012487801476],
            [10.134422322539304, 63.579956235384],
            [10.134461454436863, 63.579913942801014],
            [10.134505214545255, 63.57989474253746],
            [10.134535714655549, 63.57985629407638],
            [10.134524057625967, 63.57980526097844],
            [10.134496336345032, 63.579758449161176],
            [10.134457595459887, 63.57969345459454],
            [10.134447415062871, 63.5796588635124],
            [10.134520019105116, 63.57963891157981],
            [10.13459425797946, 63.57963801531897],
            [10.134696516769738, 63.57963735115813],
            [10.134778450744692, 63.57964103335815],
            [10.134855137715514, 63.5796458864322],
            [10.134934430200571, 63.57964848947101],
            [10.135005866556096, 63.579652174781835],
            [10.135074232122678, 63.57965670015562],
            [10.136296128661375, 63.57916281513704],
            [10.136945219942978, 63.578900187583265],
            [10.137710028073258, 63.57855100422796],
            [10.137916815421871, 63.57844780003727],
            [10.138720595113108, 63.57810429684786],
            [10.142244967457795, 63.576516239241556],
            [10.143109931910217, 63.57592371882925],
            [10.14381655417133, 63.57557864976442],
            [10.144521812803571, 63.57528048056421],
            [10.145235142850867, 63.574876991300634],
            [10.146606613798388, 63.574092057775104],
            [10.147335532009565, 63.57367550671936],
            [10.149166961674988, 63.572579111137394],
            [10.150692855658582, 63.57173520166494],
            [10.150682390341936, 63.571512469666914],
            [10.150578540048413, 63.56930118588538],
            [10.14894825405586, 63.56808879673269],
            [10.147836335321738, 63.567084804413994],
            [10.147471183360834, 63.56678983782741],
            [10.147069283825253, 63.56624071148164],
            [10.146305426717003, 63.564991358415476],
            [10.146221443439659, 63.56485917685709],
            [10.146074361469426, 63.56468411316349],
            [10.146013275803336, 63.56452968276005],
            [10.144391016200442, 63.56198151878839],
            [10.14304940685674, 63.559816105109455],
            [10.141987571375017, 63.558086758103684],
            [10.142273323960637, 63.55765106554995],
            [10.142670310670708, 63.55704574021391],
            [10.142744246750034, 63.55693042588753],
            [10.143960255840337, 63.555076890271465],
            [10.143980146465305, 63.55504896374223],
            [10.144036683642202, 63.55496345887469],
            [10.145720763376067, 63.553111399180075],
            [10.146230337860727, 63.55264569593471],
            [10.14873919310468, 63.55134358805866],
            [10.151314500910061, 63.54716056228891],
            [10.152653752371899, 63.54364113977791],
            [10.15441921570728, 63.541345841250404],
            [10.154713963628332, 63.54097240607708],
            [10.155141200512098, 63.54070769669296],
            [10.160797142183979, 63.54005030784734],
            [10.163712295772795, 63.53975897030901],
            [10.164678483963907, 63.53808196246282],
            [10.164978074481676, 63.53785356635256],
            [10.169324865653126, 63.53550438546455],
            [10.170980858047324, 63.53263915717066],
            [10.171301126466995, 63.53208470041739],
            [10.170697314499625, 63.52808335287588],
            [10.170609874480206, 63.52791086613617],
            [10.170584548255006, 63.527758284124324],
            [10.170378599708384, 63.52659397316584],
            [10.17033910773412, 63.5263706938174],
            [10.170310137740627, 63.526093962780585],
            [10.170249769545983, 63.52582417620514],
            [10.17024199895629, 63.52579036660058],
            [10.23479838542, 63.495577986962644],
            [10.272786874652702, 63.49984081730661],
            [10.312776105760172, 63.50431444122086],
            [10.356563081390252, 63.50919847581782],
            [10.418553627185439, 63.51268702392922],
            [10.488585614057548, 63.516594387180064],
            [10.550349736982886, 63.495293135673336],
            [10.60679582679203, 63.49170752340746],
            [10.65392875109006, 63.4905445160489],
            [10.715080875261359, 63.46863933138131],
            [10.774467828874615, 63.455347180753336],
            [10.838211312095497, 63.4545423946606],
            [10.84411184529681, 63.44647652545383],
            [10.853088200263024, 63.4394843707678],
            [10.853730576370548, 63.43898383513931],
            [10.85473303727142, 63.438256613526704],
            [10.854794273558309, 63.43821218825963],
            [10.854855770926617, 63.43815347826298],
            [10.856554789580969, 63.436534003955245],
            [10.856566590186922, 63.436471873856725],
            [10.856791503376162, 63.435286478453996],
            [10.857030224365214, 63.43403047173564],
            [10.85735901522823, 63.4334073759265],
            [10.857566680039216, 63.43282786726375],
            [10.857605924678442, 63.43257596983962],
            [10.857622354337666, 63.432306960952204],
            [10.857806330209621, 63.4318064959716],
            [10.857898173092117, 63.431546146783305],
            [10.858876270130798, 63.42899705864476],
            [10.85967606381954, 63.42696396883505],
            [10.857248786542842, 63.42231661286276],
            [10.856814937270322, 63.421179335836264],
            [10.856692879453929, 63.42075250779359],
            [10.856667797984244, 63.42054440683958],
            [10.85642921448703, 63.42041981722877],
            [10.856147593665222, 63.41929153999592],
            [10.855789620595822, 63.418072684269355],
            [10.855764215473565, 63.417746190175905],
            [10.855731567659621, 63.41762515100279],
            [10.855545901315944, 63.41730407100105],
            [10.855248307231477, 63.41660014046789],
            [10.855449092228815, 63.41652255432856],
            [10.855672171016993, 63.416436446624736],
            [10.85571959983102, 63.416320698864745],
            [10.856590893415088, 63.41509339769541],
            [10.857392125528282, 63.413861811890484],
            [10.858712082269284, 63.41240725166888],
            [10.859405244323595, 63.41164218889669],
            [10.859548981514092, 63.41114415256092],
            [10.85956281561332, 63.411101137822506],
            [10.859629384017033, 63.41077632474461],
            [10.860439074625837, 63.408063521864804],
            [10.860696267561035, 63.40702522130743],
            [10.86124816577265, 63.40481056071875],
            [10.86156429413326, 63.403539899931594],
            [10.862130153653029, 63.40216403159242],
            [10.862602774982356, 63.40017637515294],
            [10.86263348313776, 63.39987317361053],
            [10.86266396809095, 63.39956178576198],
            [10.862644114472792, 63.3979038495798],
            [10.862693278554215, 63.3956645397333],
            [10.862610944893865, 63.39394222860168],
            [10.862489583329252, 63.39240997743702],
            [10.862341662160267, 63.39027119754806],
            [10.86233845328676, 63.390225351279504],
            [10.862335487664696, 63.39018337726709],
            [10.862326390945576, 63.39011165211808],
            [10.86222363626836, 63.38865760301507],
            [10.862261667785598, 63.38745438174065],
            [10.862233140963081, 63.386892021299005],
            [10.861037822167104, 63.386226499138175],
            [10.860542821349402, 63.38557392392857],
            [10.860232116922328, 63.38504130435423],
            [10.85828466045417, 63.382539247714746],
            [10.85910101904046, 63.381828925107015],
            [10.861202641753197, 63.38013576410557],
            [10.855774946702189, 63.37217171745572],
            [10.845320457443442, 63.356840114876384],
            [10.84417427999413, 63.35514552972547],
            [10.850673020465745, 63.35654823822027],
            [10.851369590260084, 63.35447023219826],
            [10.860241856779767, 63.35481617332173],
            [10.860386129807964, 63.353492258679275],
            [10.854509676065758, 63.35282657819463],
            [10.852438263234948, 63.3529849096636],
            [10.851667884604465, 63.35296401173867],
            [10.854599387075622, 63.34418940238374],
            [10.855446635532633, 63.344077961934644],
            [10.855610405790637, 63.344056478832684],
            [10.856513320431977, 63.343937752631994],
            [10.858879796181196, 63.343626513619064],
            [10.85955363824013, 63.343537963940754],
            [10.865099121773687, 63.34280976676488],
            [10.872337455279986, 63.34185913950975],
            [10.880683605357067, 63.34078720627494],
            [10.898328023888489, 63.3385302780956],
            [10.910721449302915, 63.336906702801606],
            [10.914611219769295, 63.33639038416609],
            [10.921668292601495, 63.335453242769056],
            [10.940341985301304, 63.33276617534553],
            [10.946898441926468, 63.33185435642651],
            [10.963564020031454, 63.32956458704004],
            [10.964594099761106, 63.329421924170155],
            [10.967932727508204, 63.33027751400764],
            [10.970267978975453, 63.330827890047175],
            [10.992075256767626, 63.336021452441074],
            [10.993976317529025, 63.33585544293546],
            [10.994150797064153, 63.33585495703498],
            [10.994381528960547, 63.33589146546436],
            [10.99459033205892, 63.33593463715629],
            [10.99473098599301, 63.33589410164381],
            [10.995019684403784, 63.33576281543415],
            [10.995197936364498, 63.33576252420944],
            [10.99559928169888, 63.33575160719851],
            [10.995762482400915, 63.335724377605395],
            [10.995992490587186, 63.33567700523226],
            [10.996185426775499, 63.33564306112049],
            [10.996489906594045, 63.335622498149704],
            [10.996601018535818, 63.33559874699073],
            [10.99691945391155, 63.33546065316015],
            [10.997149592522248, 63.335446807794106],
            [10.99756419145964, 63.33528166476554],
            [10.997749913552854, 63.335247785559005],
            [10.99796538064133, 63.33525743467003],
            [10.99825762669606, 63.33525719662505],
            [10.998516912598804, 63.335256661221464],
            [10.998726801697282, 63.335261838255406],
            [10.999085017786193, 63.33528628104626],
            [10.999431206043408, 63.3353497523567],
            [10.999622779368872, 63.3353715806331],
            [10.999887993242004, 63.33535718798926],
            [11.000228045606008, 63.3354288437898],
            [11.000468868029785, 63.33545897452539],
            [11.00068490982998, 63.33545299657859],
            [11.001061344948655, 63.33543561262414],
            [11.001468610938147, 63.335420890735115],
            [11.001902968566778, 63.335366662139734],
            [11.002218543298184, 63.3352892352035],
            [11.002497905941262, 63.33520899376119],
            [11.002783310774003, 63.33516729983387],
            [11.003185083933065, 63.33517479893943],
            [11.003556339369197, 63.335193214870266],
            [11.003976406735113, 63.335211561117944],
            [11.004231933421607, 63.33521935850686],
            [11.004374177949742, 63.335256514095555],
            [11.006793396115542, 63.33543715277633],
            [11.007282794687839, 63.33547334133073],
            [11.02170935366768, 63.33731728194605],
            [11.027809073282844, 63.33809264536957],
            [11.037135565049427, 63.33927732046219],
            [11.042871569247602, 63.34064884074155],
            [11.063689706141604, 63.34113738342833],
            [11.073796690514714, 63.34121953166502],
            [11.078006116002658, 63.341463002734194],
            [11.078257309835093, 63.34146928821231],
            [11.079148290230297, 63.34149129410722],
            [11.084141944675208, 63.34160697065938],
            [11.095449409306902, 63.34168641517539],
            [11.096621169175435, 63.34166630591273],
            [11.098185604769368, 63.341572460538984],
            [11.099427570120154, 63.341581841947274],
            [11.10068177582782, 63.34158651462027],
            [11.103608321258921, 63.34154228433296],
            [11.105337332244918, 63.341580031442334],
            [11.106705607962763, 63.341508950911894],
            [11.11116902299205, 63.34139205606945],
            [11.122021516896533, 63.34069908546375],
            [11.133409374203156, 63.34043826745576],
            [11.134649700221033, 63.34028966465684],
            [11.139525439940689, 63.340224413501],
            [11.14068317599187, 63.3407938324157],
            [11.143479398992724, 63.34191078258688],
            [11.1442011835333, 63.342084893668435],
            [11.14434329380879, 63.342118576187794],
            [11.144440285053378, 63.34214115194448],
            [11.148216948865494, 63.342380168640034],
            [11.153598866342247, 63.34293554014526],
            [11.155843235430268, 63.34305883708895],
            [11.158162273457151, 63.343354054353604],
            [11.163444383462934, 63.343835358794536],
            [11.164263674895496, 63.34390953953323],
            [11.174026890704688, 63.345017408535014],
            [11.175074318002933, 63.34532906158351],
            [11.180356071105372, 63.346291857385985],
            [11.18397508651187, 63.34679429770564],
            [11.185377528429635, 63.347068736324466],
            [11.186807925363548, 63.347333214385],
            [11.189142373973356, 63.347894153735034],
            [11.196987298111898, 63.34729347818245],
            [11.205976495967388, 63.34630685520569],
            [11.214717638468173, 63.34571326048996],
            [11.216194271939827, 63.345612465189575],
            [11.222377169666752, 63.34514061308541],
            [11.230316749556987, 63.34451502862973],
            [11.235828445170153, 63.34427817237996],
            [11.244657069796785, 63.343798843499954],
            [11.24478643065926, 63.343791648562764],
            [11.257934293112278, 63.343081892228724],
            [11.26256667812576, 63.342831162109874],
            [11.263982567321356, 63.34275479398758],
            [11.275403927360085, 63.3422445694653],
            [11.282666421480327, 63.341919212232625],
            [11.282807610313958, 63.341913190291564],
            [11.288425745152292, 63.34140382589217],
            [11.298459465220748, 63.34049447154458],
            [11.298656673156225, 63.34047578116175],
            [11.309427639845858, 63.33950421103894],
            [11.32645571372905, 63.33788465197259],
            [11.327340764742154, 63.33780997021927],
            [11.45456167705845, 63.32623369884368],
            [11.550196122703904, 63.26405221049055],
            [11.630786561848199, 63.18068732613448],
            [11.734543284233565, 63.1854403395687],
            [11.73470250113212, 63.18544813423189],
            [11.740192827078372, 63.185687142863294],
            [11.742640562624421, 63.185813128669565],
            [11.745286569311803, 63.18593759845824],
            [11.746250582777279, 63.18598673642841],
            [11.756934293386943, 63.186493240411664],
            [11.758187281420474, 63.1865391052806],
            [11.762282549616826, 63.18671071461905],
            [11.767012152018852, 63.18691030615857],
            [11.771787112629836, 63.18712631181274],
            [11.778950261160661, 63.1874592409547],
            [11.791166341551705, 63.18798703537977],
            [11.930875855490951, 63.19490440635641],
            [12.052459338263922, 63.18344794318978]
          ]
        ]
      },
      "properties": {
        "objektType": "SkredVarslingsområde",
        "omradeID": 3020,
        "omradeNavn": "Sør-Trøndelag",
        "safeName": "Sor_Trøndelag",
        "regionType": "B",
        "dataUttaksdato": "20200127",
        "eksportType": "NVEs nedlastningsløsning"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [7.734595489016545, 62.184633181976004],
            [7.655260503008389, 62.14089256579568],
            [7.579379565549673, 62.1218971921141],
            [7.6318286810512275, 62.08508627523047],
            [7.5920666520985955, 62.07450870749361],
            [7.589321265871828, 62.04769359153988],
            [7.557207757586168, 62.03424296131315],
            [7.442001662567468, 62.01881281543625],
            [7.380880502680348, 62.00296047111602],
            [7.328831444462088, 62.00802314074994],
            [7.311453547881811, 62.01797970933725],
            [7.240762881463988, 62.01892976705184],
            [7.2340652265557495, 62.03409249796596],
            [7.194888434123294, 62.03069378422168],
            [7.199337295608457, 62.01961308774877],
            [7.170770090661512, 62.01199421710257],
            [7.155443536591957, 62.016091025028956],
            [7.0734803638411385, 62.00938552575324],
            [7.082728704707002, 62.00500090674642],
            [7.051395939045871, 61.98442440617608],
            [6.983415591747, 61.98159311055163],
            [6.9516051777384344, 61.98867437640788],
            [6.911665592972717, 61.975292269018105],
            [6.895820187948871, 61.98225480910048],
            [6.851911087492854, 61.97576905874688],
            [6.840865827337052, 61.96354678754039],
            [6.793987849072447, 61.96994634933051],
            [6.688336077355387, 62.05630528731308],
            [6.657573407929146, 62.07185394658499],
            [6.6208260787495234, 62.05189806073398],
            [6.578724946027669, 62.06003480356138],
            [6.561418818546541, 62.05329055818191],
            [6.5362762502224525, 62.055526135767195],
            [6.530873301152169, 62.0412919623015],
            [6.494643644748062, 62.03781081239354],
            [6.495587202257104, 62.01496228802869],
            [6.421017567269673, 62.01437881648338],
            [6.401248092648165, 62.00534341150453],
            [6.404956321209243, 61.98564770999269],
            [6.320624602304048, 61.958762322715266],
            [6.235822299229094, 61.99181295608489],
            [6.257523952683856, 62.00555253410604],
            [6.181774540982831, 62.010666611954775],
            [6.1704270247589745, 61.99411979968836],
            [6.131906230721678, 61.98702627197765],
            [6.141878940994731, 61.973540821978496],
            [6.088683947707437, 61.961714051586256],
            [6.059246310144812, 61.96784691719876],
            [6.039896513977589, 61.956646075922684],
            [5.964776888561535, 61.99410983649981],
            [5.946621765842711, 61.98790179458203],
            [5.926908990938698, 61.99659482172081],
            [5.802578646019904, 61.96599577746085],
            [5.728986013032394, 61.9807920600422],
            [5.703560471047668, 61.96881913641198],
            [5.6801615739442, 61.97404516587276],
            [5.55155885253975, 61.96041235171243],
            [5.475956095089388, 61.985947717972564],
            [5.442874719296145, 61.974209557209164],
            [5.503169311113189, 62.00792661180406],
            [5.485541221031556, 62.01426091274577],
            [5.503090007020899, 62.06673615642628],
            [5.360882662013334, 62.122192146961275],
            [5.357316718511422, 62.16863187171222],
            [5.217879396325414, 62.26120001813496],
            [5.056523897679015, 62.310212733215],
            [5.408871343602525, 62.49242299612174],
            [5.941767575065016, 62.73755293717242],
            [6.141786140930312, 62.8123398872141],
            [6.3292348865543016, 62.74039031317884],
            [6.516113630258742, 62.699816754928676],
            [6.4470029814653325, 62.65097741641468],
            [6.495863327123124, 62.62716214953559],
            [6.676576692282994, 62.64823671618854],
            [6.691612980664667, 62.62818596126737],
            [6.718973090884489, 62.63141065142715],
            [6.732577708297184, 62.61819140772498],
            [6.765056344522908, 62.60993175429412],
            [6.735163681547628, 62.595048084337314],
            [6.77105168845717, 62.58821546073065],
            [6.783214032129566, 62.5735019142749],
            [6.824591711569308, 62.56898123233494],
            [6.863981062893466, 62.540597218109426],
            [6.902951923351396, 62.544410279334436],
            [6.9635209429256175, 62.528125081391494],
            [6.988538059590091, 62.53215377043941],
            [6.99113682962289, 62.51795722462083],
            [6.978849895449827, 62.5160625701405],
            [6.9977358594452586, 62.506505672581504],
            [7.014394297557239, 62.474671279737265],
            [7.047320464101079, 62.45628035027663],
            [7.102653298945103, 62.44688851146385],
            [7.140319355815013, 62.45430882454858],
            [7.1655503608696804, 62.44655874164201],
            [7.233262798546348, 62.48430672492286],
            [7.252162893652413, 62.47129627227144],
            [7.326242644247022, 62.45988502229849],
            [7.335402536764973, 62.41651031823167],
            [7.376613600700867, 62.387788680561144],
            [7.439220008138931, 62.38872089655415],
            [7.447544882738345, 62.398225422755054],
            [7.458199386485341, 62.39438364029595],
            [7.505155433281317, 62.40852500923321],
            [7.507696410339896, 62.41620320020387],
            [7.608318868387198, 62.41950792951294],
            [7.598607315775895, 62.432825761056606],
            [7.623830400626478, 62.43686630959571],
            [7.670784842013426, 62.423368152150786],
            [7.748135603191346, 62.42011214818158],
            [7.825506984935378, 62.373923144686934],
            [7.82857987495981, 62.36290167357965],
            [7.7804483361736105, 62.353637943685456],
            [7.767889835994855, 62.32894266048865],
            [7.718228982501359, 62.310791242934805],
            [7.691655190772798, 62.29191247515137],
            [7.704675313931234, 62.27661135923957],
            [7.633493655944448, 62.26598964150698],
            [7.633394906313481, 62.255594846612645],
            [7.685363213303304, 62.242214637527084],
            [7.707879793243752, 62.22687598782987],
            [7.683997127431966, 62.19939633746778],
            [7.734595489016545, 62.184633181976004]
          ]
        ]
      },
      "properties": {
        "objektType": "SkredVarslingsområde",
        "omradeID": 3024,
        "omradeNavn": "Sunnmøre",
        "safeName": "Sunnmore",
        "regionType": "A",
        "dataUttaksdato": "20200127",
        "eksportType": "NVEs nedlastningsløsning"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [20.099619986429396, 76.64005769064426],
            [17.64185024205509, 77.57070522787768],
            [17.14480591396393, 77.76308110315175],
            [16.65706280480737, 77.85860342239337],
            [16.677990324622, 77.88056570315891],
            [16.75074321346473, 77.89404480911799],
            [16.735780235127574, 77.90443377257986],
            [16.79127635353273, 77.91692085822267],
            [17.265234120735816, 77.94836323693734],
            [17.332708951733792, 77.97402670308169],
            [17.345602205509064, 77.99714073143944],
            [17.2259155095288, 78.0574340802448],
            [17.312604232776888, 78.08541858026732],
            [17.386038881431354, 78.15230870781487],
            [17.298797350787794, 78.22122695236885],
            [16.81532882782304, 78.33793952226205],
            [16.77622460392397, 78.39147639855547],
            [16.597739117036646, 78.41474920804355],
            [16.562731255472155, 78.44641845437339],
            [16.407155220003087, 78.43361354645222],
            [16.28653617987825, 78.45637043132778],
            [16.377991538852573, 78.46228986687143],
            [16.44836210143316, 78.50057053698627],
            [16.45622986266699, 78.53332670293531],
            [16.496870071389534, 78.5353005631778],
            [16.537139864241418, 78.55208691253173],
            [16.53806738143266, 78.57747467623516],
            [16.627335257467152, 78.59092606173955],
            [16.53440923332711, 78.72222968687237],
            [15.429333847894359, 79.00241089716984],
            [13.51957850443841, 80.38550706078894],
            [14.264577225221114, 80.46978838485855],
            [20.124799499130567, 80.86011420909489],
            [24.646031348652617, 80.73364678018532],
            [33.35698921386937, 80.48726238267137],
            [34.8330643570336, 80.04175505945815],
            [33.18913407904105, 79.23895058843526],
            [30.21731138157543, 78.38857596368634],
            [25.272626588448887, 77.14684608986944],
            [20.099619986429396, 76.64005769064426]
          ]
        ]
      },
      "properties": {
        "objektType": "SkredVarslingsområde",
        "omradeID": 3001,
        "omradeNavn": "Svalbard øst",
        "safeName": "Svalbard_ost",
        "regionType": "B",
        "dataUttaksdato": "20200127",
        "eksportType": "NVEs nedlastningsløsning"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [20.099619986429396, 76.64005769064426],
            [16.687528092152185, 76.32695899821647],
            [14.669398684572872, 76.53405680898229],
            [12.298344042263228, 77.33823199181039],
            [12.054377309006913, 77.49477088816444],
            [16.641195499943045, 77.8575143039856],
            [16.65706280480737, 77.85860342239337],
            [17.14480591396393, 77.76308110315175],
            [17.64185024205509, 77.57070522787768],
            [20.099619986429396, 76.64005769064426]
          ]
        ]
      },
      "properties": {
        "objektType": "SkredVarslingsområde",
        "omradeID": 3004,
        "omradeNavn": "Svalbard sør",
        "safeName": "Svalbard_sor",
        "regionType": "B",
        "dataUttaksdato": "20200127",
        "eksportType": "NVEs nedlastningsløsning"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [16.81532882782304, 78.33793952226205],
            [16.619394110833603, 78.3329533638268],
            [16.5314920863841, 78.34229694800237],
            [16.461716056649205, 78.33567563656841],
            [16.336770883478692, 78.35127443175423],
            [16.228721235783954, 78.3500412225407],
            [16.13849131495509, 78.36357508379157],
            [16.017250995268466, 78.35302099423349],
            [15.840881173495061, 78.35157038640274],
            [15.588586489395544, 78.3024069660823],
            [15.56304614197989, 78.28561174803252],
            [15.746608247757468, 78.23311282959781],
            [15.710362819521206, 78.2190240532243],
            [15.674646022230586, 78.22221236273656],
            [15.670639888394643, 78.22256959187996],
            [15.579078983166108, 78.2307130741408],
            [15.540072215648829, 78.24804756036693],
            [15.405763918280325, 78.25105542191213],
            [14.983361970839137, 78.14583269012715],
            [15.005800370933319, 78.10558277283008],
            [14.910221200128634, 78.10057765721898],
            [14.814514216145136, 78.12318340798525],
            [14.465170610382422, 78.09771343325045],
            [14.322467388407519, 78.1065220199969],
            [14.194415832311881, 78.10478523155918],
            [14.167444643069182, 78.09536524747239],
            [14.211213283404566, 78.04293248141073],
            [14.300220064336262, 78.02839002106629],
            [14.277666062429919, 78.01982905834792],
            [14.31492780006843, 78.01035155392127],
            [14.291478421887508, 78.00202244092594],
            [14.336818899354178, 77.96290054675895],
            [14.516978264699675, 77.92303458913551],
            [14.67089884801387, 77.87365123087578],
            [14.878021157241712, 77.78811095798342],
            [15.082842587618464, 77.79909236009624],
            [15.360863536355216, 77.87207068751394],
            [15.625692993703746, 77.85357245367045],
            [15.70837907424238, 77.836572017061],
            [15.896121540131231, 77.82690741342418],
            [15.988544508922425, 77.84195458219635],
            [16.03792059462631, 77.83573436261995],
            [16.094844626603447, 77.847148875346],
            [16.251342638239954, 77.85098835118794],
            [16.304188099701506, 77.85874053144668],
            [16.404859119510146, 77.8475400407298],
            [16.4909381282942, 77.85679949582938],
            [16.641195499943045, 77.8575143039856],
            [12.054377309006913, 77.49477088816444],
            [11.138709125076248, 78.04783925606662],
            [9.111282843225544, 78.98051719944061],
            [8.351435855975717, 79.70856465817414],
            [13.51957850443841, 80.38550706078894],
            [15.429333847894359, 79.00241089716984],
            [16.53440923332711, 78.72222968687237],
            [16.627335257467152, 78.59092606173955],
            [16.53806738143266, 78.57747467623516],
            [16.537139864241418, 78.55208691253173],
            [16.496870071389534, 78.5353005631778],
            [16.45622986266699, 78.53332670293531],
            [16.44836210143316, 78.50057053698627],
            [16.377991538852573, 78.46228986687143],
            [16.28653617987825, 78.45637043132778],
            [16.407155220003087, 78.43361354645222],
            [16.562731255472155, 78.44641845437339],
            [16.597739117036646, 78.41474920804355],
            [16.77622460392397, 78.39147639855547],
            [16.81532882782304, 78.33793952226205]
          ]
        ]
      },
      "properties": {
        "objektType": "SkredVarslingsområde",
        "omradeID": 3002,
        "omradeNavn": "Svalbard vest",
        "safeName": "Svalbard_vest",
        "regionType": "B",
        "dataUttaksdato": "20200127",
        "eksportType": "NVEs nedlastningsløsning"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [15.7894351643963, 66.7210054581923],
            [15.621368715227185, 66.59433537222857],
            [15.377226873879788, 66.48430530696814],
            [15.484732311890602, 66.282459121907],
            [15.035682668202927, 66.15355669781894],
            [14.516289808652726, 66.13257827937542],
            [14.528795263597369, 66.09555948907067],
            [14.349412529679666, 66.10843374089161],
            [14.311217108750377, 66.11908996248538],
            [14.27340112011629, 66.11619862643957],
            [14.254622926721954, 66.13228558520217],
            [14.269417509752138, 66.16285854444514],
            [14.17344041533221, 66.19989621102968],
            [14.0697567485584, 66.20226483619578],
            [13.932813924583256, 66.19263974803002],
            [13.89024326726829, 66.2142894072222],
            [13.860594385620866, 66.25231267202665],
            [13.81875906856772, 66.25693491384821],
            [13.601796024940503, 66.23539176553446],
            [13.543902012434392, 66.25190844119854],
            [13.383595837629555, 66.22833624835607],
            [13.347539335730797, 66.2424041889772],
            [13.324047858720329, 66.24098563900817],
            [13.283636211205458, 66.30192607839045],
            [13.195407651743354, 66.2943757587576],
            [12.95077511779522, 66.30552331828316],
            [12.879145302637363, 66.32951422105153],
            [12.81197230741949, 66.33154606104205],
            [12.627075649145596, 66.26016535023636],
            [12.573027976920613, 66.2639975544063],
            [12.42720755359554, 66.23247261400475],
            [12.33375722792557, 66.28718482585367],
            [12.191343705914967, 66.28638044742779],
            [11.994546721877574, 66.33417988242411],
            [11.839954180304844, 66.31274807035996],
            [11.825666057478893, 66.40284821640185],
            [11.880175058944273, 66.51965022415456],
            [12.0231539370813, 66.65860609528116],
            [12.354311900013679, 66.73867318224086],
            [12.392492197599811, 66.76706778920739],
            [12.943530143211367, 66.9184233690698],
            [13.126137604722665, 67.07550248980277],
            [13.545607970876581, 67.34520266066501],
            [13.863290132804378, 67.20872505212306],
            [13.901690685185484, 67.18640407693475],
            [14.050315800654362, 67.19811977784885],
            [14.17720415489591, 67.22716960795135],
            [14.296476166750658, 67.2258533704311],
            [14.327773847572894, 67.19109183747801],
            [14.30684101453364, 67.15529920337607],
            [14.370454434045872, 67.15577946014231],
            [14.39506634865766, 67.14259027308994],
            [14.382545226555543, 67.13801986172896],
            [14.417325879789527, 67.12459687375579],
            [14.462778467664478, 67.11793024053516],
            [14.48440543150502, 67.1229172736772],
            [14.544685517713049, 67.10205521534517],
            [14.661005995309843, 67.1273632917814],
            [14.71590113958693, 67.08011500388598],
            [14.743790485587246, 67.08660297674795],
            [14.769473689855785, 67.06775001414086],
            [14.912784253313072, 67.03352700069618],
            [15.022235426323375, 66.92938499565871],
            [14.982986214745091, 66.87367005468249],
            [15.7894351643963, 66.7210054581923]
          ]
        ]
      },
      "properties": {
        "objektType": "SkredVarslingsområde",
        "omradeID": 3017,
        "omradeNavn": "Svartisen",
        "safeName": "Svartisen",
        "regionType": "A",
        "dataUttaksdato": "20200127",
        "eksportType": "NVEs nedlastningsløsning"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [9.003978980088142, 59.98169780138345],
            [9.01921116795848, 59.984031528654825],
            [9.0585837007558, 59.96197873519886],
            [9.104273777947476, 59.95892966468817],
            [9.139301871361777, 59.93928795512209],
            [9.179507871448868, 59.92905809120342],
            [9.192594395240505, 59.9168137732459],
            [9.17429160437365, 59.90001642055032],
            [9.188569853561436, 59.89690573477164],
            [9.186088508288819, 59.826987399144095],
            [9.367754845733415, 59.781338828184325],
            [9.344094733947044, 59.75729821975544],
            [9.338960026217286, 59.71950562162159],
            [9.354786605351753, 59.71824920344121],
            [9.333291501078511, 59.69277615616765],
            [9.405283923977665, 59.68453511934652],
            [9.40556601070156, 59.65882800254251],
            [9.464459700300237, 59.566755316261],
            [9.515263540522625, 59.53811475663818],
            [9.46857896805398, 59.49430728028176],
            [9.471744273521056, 59.48221126541468],
            [9.55203196689202, 59.48725439929179],
            [9.584599515663538, 59.46641816532133],
            [9.586835602713029, 59.4506349806536],
            [9.621375057828807, 59.43843535086743],
            [9.624620828936527, 59.42490078569269],
            [9.660119707239597, 59.40787093047277],
            [9.778087414817184, 59.41200210520688],
            [9.769420130867251, 59.375624187503924],
            [9.782812198796005, 59.35033117673916],
            [9.755345567119882, 59.32490802815634],
            [9.810580261190697, 59.28224959444241],
            [9.869493775525333, 59.25186041262234],
            [9.878123440642163, 59.22073060992347],
            [9.85715192130051, 59.21554866836162],
            [9.896416480431304, 59.177002198345455],
            [9.824771269033668, 59.15760929597616],
            [9.820575921769679, 59.1294718308602],
            [9.856146963190497, 59.09880919976054],
            [9.83472082192583, 59.03724699171451],
            [9.824863718392546, 59.04249108266743],
            [9.81293054903542, 59.036010261791255],
            [9.836190479086548, 59.02314624509164],
            [9.834549665299942, 58.9978121801506],
            [9.782541209632047, 59.029965610693594],
            [9.781084757931731, 59.01183273072096],
            [9.764848173225555, 59.010043415575],
            [9.795176963549046, 58.89822410814892],
            [9.636857836351675, 58.76421891698986],
            [9.489869295125105, 58.70155948791656],
            [9.353877934682943, 58.77681903951917],
            [9.328834891411152, 58.78521591367086],
            [9.30497942549406, 58.77203438447765],
            [9.274620234179919, 58.79570119175968],
            [9.196343144881196, 58.80344610186381],
            [9.207898211265752, 58.8131374676706],
            [9.19202921279686, 58.81448230148394],
            [9.190196639843146, 58.84542795361052],
            [9.166675748937203, 58.87930026023287],
            [9.072847704521353, 58.91131689935349],
            [9.034674320620097, 58.932609713689025],
            [8.994883665570041, 58.99322716873492],
            [8.939680775028895, 58.986101488587394],
            [8.834169791164074, 58.98806735527953],
            [8.822212655802172, 58.96986042379708],
            [8.761995326146096, 58.94849083740925],
            [8.761671913208854, 58.937365355115595],
            [8.830738162108114, 58.912573761967195],
            [8.781128963524807, 58.86758306719316],
            [8.792479628922278, 58.86446990469438],
            [8.786440283062037, 58.84356436828035],
            [8.743719082171106, 58.831398211053056],
            [8.721723615728719, 58.85068526380792],
            [8.65341752676809, 58.86940638162364],
            [8.638241856232769, 58.89166286487309],
            [8.575453842022963, 58.93143896073678],
            [8.503052051234702, 58.90799974988102],
            [8.47645974649465, 58.886905305225305],
            [8.39031214196374, 58.91231417031171],
            [8.30993863167172, 58.919456634412796],
            [8.293892382423818, 58.93668250816051],
            [8.222355874904975, 58.97034799609379],
            [8.173291568044283, 58.982337320164085],
            [8.12714776666838, 58.98502382723669],
            [8.079481512013032, 58.97215860998191],
            [8.089156447148246, 58.965083990572424],
            [8.136715088752734, 58.961096990155696],
            [8.091681737713204, 58.94848317230423],
            [8.044400141882209, 58.951932364091356],
            [8.00943623821325, 58.9646989310405],
            [7.985326837997046, 58.96163422780526],
            [7.9419580417578475, 58.98694221669085],
            [7.940495355233494, 59.00544032162313],
            [7.911213764168502, 59.00902110269288],
            [7.805316860747285, 59.117063553238225],
            [7.751208031141693, 59.13765518176954],
            [7.733203332693671, 59.16018123559085],
            [7.758705691611944, 59.20371497196528],
            [7.69616061508549, 59.32673530680455],
            [7.759295544702508, 59.32885841782747],
            [7.7790868513391835, 59.33909489700347],
            [7.791711157620802, 59.35560610347928],
            [7.817867485686327, 59.360907446020796],
            [7.857988986408505, 59.36155464481173],
            [7.890011334308133, 59.35062470006829],
            [9.05482963354076, 59.72172381883944],
            [9.003978980088142, 59.98169780138345]
          ]
        ]
      },
      "properties": {
        "objektType": "SkredVarslingsområde",
        "omradeID": 3039,
        "omradeNavn": "Telemark sør",
        "safeName": "Telemark_sor",
        "regionType": "B",
        "dataUttaksdato": "20200127",
        "eksportType": "NVEs nedlastningsløsning"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [9.361128051433514, 63.211895405532566],
            [9.383728968789686, 63.186025905969075],
            [9.468545408432762, 63.1778741379551],
            [9.547216293597208, 63.18284278082309],
            [9.657430740685886, 63.1504877536824],
            [9.887308405975704, 63.1439469889254],
            [9.908124056084265, 63.08403569241895],
            [9.922836938828636, 63.08041638061473],
            [9.928251749637688, 63.09368951560752],
            [9.943776632390257, 63.09240992522271],
            [9.992769587726121, 63.06157756685752],
            [10.013851233609536, 63.03317814733756],
            [10.009657622215547, 62.99325400093694],
            [9.987917124583086, 62.96481421917301],
            [10.001190178543169, 62.9454334610064],
            [10.12813497883197, 62.86596911315768],
            [10.18789855061616, 62.758735216953774],
            [10.317560424383197, 62.726638095594105],
            [10.325076717304867, 62.695295656522646],
            [10.238727669500868, 62.695074827565946],
            [10.19698685619505, 62.68767702173648],
            [10.176474926881465, 62.69692794159545],
            [10.162987566833616, 62.68604259271652],
            [10.14413824802706, 62.68751220763698],
            [10.147597362192474, 62.67669225954932],
            [10.108972690768075, 62.65362246271322],
            [10.074166528714835, 62.60190068741561],
            [10.026678707560638, 62.585623699124625],
            [10.038760463002276, 62.56777570827657],
            [10.00573180883309, 62.55813255947697],
            [10.097583077440769, 62.42780772375924],
            [9.951809986919612, 62.397198058839614],
            [9.934195114728192, 62.35521995163826],
            [9.90026209780039, 62.344369576569925],
            [9.839302390776712, 62.36208821459702],
            [9.821443589259461, 62.34283680372758],
            [9.854754320482405, 62.33097623865046],
            [9.833558043788948, 62.32868612381926],
            [9.827304208497148, 62.29919431915993],
            [9.792454908954538, 62.28793202989553],
            [9.718068285060943, 62.28278615011217],
            [9.601920978479576, 62.255726729172466],
            [9.483888656260332, 62.29226981176129],
            [9.062061789315832, 62.37260842221783],
            [9.020433267535426, 62.35912356848249],
            [8.931802840542026, 62.353193381606836],
            [8.889618403379208, 62.37549435219113],
            [8.731640233366708, 62.376872972967526],
            [8.666671672463474, 62.4046473401642],
            [8.587360117501474, 62.40833631456265],
            [8.520990908481675, 62.434783107835386],
            [8.513879425386436, 62.45894094818475],
            [8.346391405725091, 62.508196708166146],
            [8.368875835680443, 62.530594765608974],
            [8.31685237587739, 62.574536157007024],
            [8.25697472007471, 62.57709391854003],
            [8.2485682655671, 62.566304944931616],
            [8.217772173182404, 62.577200591148056],
            [8.246527037651187, 62.640411089811835],
            [8.26947462393742, 62.64772904589156],
            [8.291090837711986, 62.67639034108231],
            [8.206132069952552, 62.738137765343964],
            [8.324456323463084, 62.78781916688374],
            [8.294040651420358, 62.800373782740266],
            [8.234475011128444, 62.8000184951085],
            [8.166168411055454, 62.82521611043347],
            [8.138852740538663, 62.851346732255074],
            [8.130057111771869, 62.92956456386004],
            [7.987612416387952, 62.98767712445336],
            [8.202958268544489, 63.02280524264553],
            [8.243706084482348, 63.01208419577288],
            [8.328597599012669, 63.045145692349855],
            [8.338329132767498, 63.03553341721354],
            [8.402801088633316, 63.05687651667619],
            [8.42517248362813, 63.046739298665116],
            [8.43721376385961, 63.06554534020969],
            [8.481498386670923, 63.07965039527113],
            [8.501988069283595, 63.048970961192374],
            [8.622301677837607, 63.07094000132152],
            [8.647691528699507, 63.07253592190303],
            [8.652572275945618, 63.06417586195943],
            [8.688717018392115, 63.07339925037408],
            [8.807152642672738, 63.12661736073491],
            [8.821731067948274, 63.150118481951246],
            [8.769561979815345, 63.173296755722674],
            [8.762415148615178, 63.18982795767448],
            [9.218102736099063, 63.222611841681996],
            [9.228588284331002, 63.204784689608374],
            [9.295555105435147, 63.19537271055317],
            [9.361128051433514, 63.211895405532566]
          ]
        ]
      },
      "properties": {
        "objektType": "SkredVarslingsområde",
        "omradeID": 3022,
        "omradeNavn": "Trollheimen",
        "safeName": "Trollheimen",
        "regionType": "A",
        "dataUttaksdato": "20200127",
        "eksportType": "NVEs nedlastningsløsning"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [20.4218650572547, 70.24184481802578],
            [20.221029382197095, 70.0557625227749],
            [20.206826961958335, 70.03838182795052],
            [19.999783576430733, 69.94972117830828],
            [19.858143645623038, 69.85335132504451],
            [19.73223143820219, 69.69583529311524],
            [19.541301677922704, 69.69129494213225],
            [19.45545885758053, 69.6764676239517],
            [19.221376972673628, 69.6077785547061],
            [19.003344209942842, 69.60013727005654],
            [18.856308944511582, 69.56447305819823],
            [18.95343742436768, 69.52039521219498],
            [18.867906676557997, 69.4899885594217],
            [18.848394162071795, 69.46663355590687],
            [18.749722597028484, 69.45143690551996],
            [18.686096841891295, 69.41474098967174],
            [18.54879828919865, 69.37718614511635],
            [18.519382633335013, 69.39830677590649],
            [18.4180848500325, 69.41424170143135],
            [18.412921364794013, 69.4593072020838],
            [18.36000634001469, 69.5009646371104],
            [18.25900275306697, 69.50380435659594],
            [18.14762288204993, 69.49582476575057],
            [18.073816836082045, 69.52440374769573],
            [18.00492905209568, 69.53661090565633],
            [17.664222002413492, 69.71550066342022],
            [18.135108910839932, 69.98367258952786],
            [18.63157169075969, 70.20539857843127],
            [19.219979236361908, 70.31808034265406],
            [19.725633748404533, 70.36337898978279],
            [20.136194415990854, 70.35381053656504],
            [20.4218650572547, 70.24184481802578]
          ]
        ]
      },
      "properties": {
        "objektType": "SkredVarslingsområde",
        "omradeID": 3011,
        "omradeNavn": "Tromsø",
        "safeName": "Tromso",
        "regionType": "A",
        "dataUttaksdato": "20200127",
        "eksportType": "NVEs nedlastningsløsning"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [24.218235331053357, 69.80654937468323],
            [24.213035234789526, 69.78728566485414],
            [24.193830611351856, 69.69413781358128],
            [24.210662573082715, 69.66879650273229],
            [23.48809943639297, 69.71295745619545],
            [23.32461353550085, 69.70911271003949],
            [23.15945795708163, 69.68621811745987],
            [22.89625793627446, 69.69459768045606],
            [22.83482940279264, 69.66723161198813],
            [22.75509652412686, 69.64545085777694],
            [22.57041517227902, 69.69699086905015],
            [22.537648890041968, 69.72190325778243],
            [22.55513214478825, 69.7478612873366],
            [22.536222523629693, 69.76955483328834],
            [22.45147154276486, 69.79070262335254],
            [22.546645442381447, 69.84602728635203],
            [22.531772042629918, 69.86079158696143],
            [22.47750213730448, 69.86308636444622],
            [22.448572677232658, 69.87335608731064],
            [22.526748938035496, 69.90104363986475],
            [22.497193075040496, 69.91878482913884],
            [22.402729853454254, 69.92444978723728],
            [22.282097378063842, 69.94562518101577],
            [22.24323912763972, 69.96089351433801],
            [22.247613893971053, 69.97609208918395],
            [22.18691802228297, 70.01012726667665],
            [22.186415035587338, 70.02553330299382],
            [22.072801164087, 70.02446370333497],
            [21.83902861595502, 70.00089246366389],
            [21.67306416917924, 70.04386758347485],
            [21.52271769563219, 70.05926547045681],
            [21.438689451956208, 70.05645857999185],
            [21.110583730614884, 70.10448981827307],
            [21.00662959106296, 70.23750770783754],
            [21.200898833183057, 70.43625361617346],
            [21.5258083224392, 70.52703305385738],
            [22.006955963288224, 70.76456234905521],
            [22.96825303510864, 71.06493553481957],
            [23.24746419232016, 71.1862280590386],
            [23.572818693057926, 71.01722699764053],
            [23.8177653107804, 70.92482671743072],
            [23.936641187435686, 70.78251110735],
            [24.168381944599304, 70.72649235609641],
            [24.382979046790773, 70.72465300533035],
            [24.505076108032757, 70.69521502533567],
            [24.606177395950347, 70.65295976473283],
            [24.654850238306754, 70.65786412490141],
            [24.761700754359353, 70.65300705987896],
            [24.977208256311325, 70.61827492569861],
            [24.877036182703815, 70.54896967513831],
            [24.688451587968693, 70.46224727027854],
            [24.674499098992474, 70.44232429161147],
            [24.733498626917076, 70.41587817867527],
            [24.63699623227232, 70.36288564253978],
            [24.493023644314633, 70.33684482930816],
            [24.17711199310049, 70.11257720453648],
            [23.961041837799208, 70.09652263327898],
            [23.911365731678114, 70.00448275362182],
            [24.072400624166352, 69.98248840144097],
            [24.115281113630616, 69.98827476677471],
            [24.218235331053357, 69.80654937468323]
          ]
        ]
      },
      "properties": {
        "objektType": "SkredVarslingsområde",
        "omradeID": 3007,
        "omradeNavn": "Vest-Finnmark",
        "safeName": "Vest_Finnmark",
        "regionType": "A",
        "dataUttaksdato": "20200127",
        "eksportType": "NVEs nedlastningsløsning"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [9.003978980088142, 59.98169780138345],
            [9.05482963354076, 59.72172381883944],
            [7.890011334308133, 59.35062470006829],
            [7.857988986408505, 59.36155464481173],
            [7.817867485686327, 59.360907446020796],
            [7.791711157620802, 59.35560610347928],
            [7.7790868513391835, 59.33909489700347],
            [7.759295544702508, 59.32885841782747],
            [7.69616061508549, 59.32673530680455],
            [7.758705691611944, 59.20371497196528],
            [7.733203332693671, 59.16018123559085],
            [7.751208031141693, 59.13765518176954],
            [7.656916191265985, 59.12981038157017],
            [7.373688038560486, 59.129758005893564],
            [7.373584801564812, 59.12982593071946],
            [7.242064840448176, 59.21606469285613],
            [7.24197520935733, 59.21612326430613],
            [7.240354645145294, 59.45468227305987],
            [7.177689813405382, 59.67303899142585],
            [7.149915900054863, 59.69158688882514],
            [7.110080241067349, 59.70060347289024],
            [7.110451701570402, 59.7633205973096],
            [7.096287399116789, 59.782776822428104],
            [7.158129680422305, 59.82846762910686],
            [7.141345935487646, 59.85363177246644],
            [7.158105381070628, 59.86722227987372],
            [7.146821599543263, 59.880980658988726],
            [7.232910870712489, 59.9627143347557],
            [7.266462725273358, 59.98373892573164],
            [7.320434533086833, 59.985960830963805],
            [7.436428801336987, 60.01922769790947],
            [7.442652739734844, 60.0573201707266],
            [7.488040528304484, 60.098838472494464],
            [7.6460005887947995, 60.126852020758506],
            [7.76466515562384, 60.115934458284464],
            [7.812840509060449, 60.10265102536176],
            [7.920952109229101, 60.13714423666064],
            [8.057670099415326, 60.16358617252871],
            [8.104126000477166, 60.18378638020944],
            [8.1349560801974, 60.18526784712593],
            [8.15380533248517, 60.18460686020647],
            [8.17038267205501, 60.17375038349808],
            [8.186946061234863, 60.17368765316819],
            [8.166885422109868, 60.186353206341884],
            [8.208790453916032, 60.18827181461586],
            [8.284269802308268, 60.17510114419418],
            [8.384281098896755, 60.18117273458293],
            [8.486105719256143, 60.16879444784407],
            [8.565214380740471, 60.17724305738892],
            [8.659873528225322, 60.17200786973075],
            [8.722863576459371, 60.183106927322804],
            [8.832765956846453, 60.14941837147393],
            [8.9578696767773, 60.098060672593974],
            [9.002400474587127, 59.99682193445268],
            [8.987512364427282, 59.98974784422674],
            [8.992794990953824, 59.980771352538014],
            [9.003978980088142, 59.98169780138345]
          ]
        ]
      },
      "properties": {
        "objektType": "SkredVarslingsområde",
        "omradeID": 3035,
        "omradeNavn": "Vest-Telemark",
        "safeName": "Vest_Telemark",
        "regionType": "A",
        "dataUttaksdato": "20200127",
        "eksportType": "NVEs nedlastningsløsning"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [10.54305966600501, 59.45732694695945],
            [10.544031732349035, 59.41230047695761],
            [10.584161857567084, 59.39306382470963],
            [10.595274638675685, 59.374140625080194],
            [10.578244898942453, 59.340935542334414],
            [10.590331585006043, 59.26848324610236],
            [10.655050150731858, 59.191957592148405],
            [10.650976494533284, 59.132815327775],
            [10.622716238008302, 59.111703211590665],
            [10.675019827881227, 59.045287940377804],
            [10.46275515817044, 58.97445949024301],
            [10.004976632587736, 58.912935786277636],
            [9.795176963549046, 58.89822410814892],
            [9.764848173225555, 59.010043415575],
            [9.781084757931731, 59.01183273072096],
            [9.782541209632047, 59.029965610693594],
            [9.834549665299942, 58.9978121801506],
            [9.836190479086548, 59.02314624509164],
            [9.81293054903542, 59.036010261791255],
            [9.824863718392546, 59.04249108266743],
            [9.83472082192583, 59.03724699171451],
            [9.856146963190497, 59.09880919976054],
            [9.820575921769679, 59.1294718308602],
            [9.824771269033668, 59.15760929597616],
            [9.896416480431304, 59.177002198345455],
            [9.85715192130051, 59.21554866836162],
            [9.878123440642163, 59.22073060992347],
            [9.869493775525333, 59.25186041262234],
            [9.810580261190697, 59.28224959444241],
            [9.755345567119882, 59.32490802815634],
            [9.782812198796005, 59.35033117673916],
            [9.769420130867251, 59.375624187503924],
            [9.778087414817184, 59.41200210520688],
            [9.758501966478804, 59.45827853449728],
            [9.819076125430696, 59.469176652921824],
            [9.85294727950259, 59.458329898454025],
            [9.920556332689268, 59.45553134170267],
            [9.944778670599863, 59.468288080765255],
            [9.99831871391597, 59.46699900419357],
            [10.011825163526028, 59.4584802488124],
            [10.059967600742763, 59.4730291038406],
            [10.024989776061151, 59.512347322266685],
            [9.915329270778606, 59.58248410306776],
            [9.941837949944045, 59.58691853002609],
            [9.932930804917332, 59.60387282389357],
            [9.981073908672458, 59.617951841837595],
            [9.974638485584208, 59.63257868964682],
            [9.998171146840987, 59.66381667705343],
            [10.037463449214682, 59.64053280484363],
            [10.08890853500215, 59.64256862417679],
            [10.115514598361626, 59.67066715256403],
            [10.157231978336432, 59.66582064889061],
            [10.192839049694413, 59.67189990200268],
            [10.218963409889, 59.6638317968419],
            [10.224503243501658, 59.67128726237568],
            [10.238611720013791, 59.666408973457386],
            [10.25100771637286, 59.674010966301694],
            [10.302943686629977, 59.66824167931411],
            [10.323407299138625, 59.701938022065065],
            [10.363462922516149, 59.697734676228556],
            [10.410374906221143, 59.66706549988493],
            [10.424496810535366, 59.6252690528437],
            [10.410823774052453, 59.60916981407464],
            [10.423497610813316, 59.59815862982786],
            [10.393691113642435, 59.51468937198992],
            [10.4558138408523, 59.47988333267552],
            [10.54305966600501, 59.45732694695945]
          ]
        ]
      },
      "properties": {
        "objektType": "SkredVarslingsområde",
        "omradeID": 3040,
        "omradeNavn": "Vestfold",
        "safeName": "Vestfold",
        "regionType": "B",
        "dataUttaksdato": "20200127",
        "eksportType": "NVEs nedlastningsløsning"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [6.1320548932301815, 61.135129404857],
            [6.193814804451534, 61.13837967104837],
            [6.368473988897766, 61.09318976997582],
            [6.430076706903276, 61.09355397379061],
            [6.507604492934239, 61.10804055005275],
            [6.576568884166981, 61.136277731687635],
            [6.5973834601733765, 61.187754195301245],
            [6.690267485453665, 61.182774164597255],
            [6.729310920187561, 61.1660704305097],
            [6.882350582234792, 61.15748261798089],
            [6.913618102001655, 61.103245047039934],
            [6.998928567310532, 61.097607931327765],
            [7.0262211973323465, 61.028791815187994],
            [7.0749292605433585, 60.97198875832432],
            [7.18010375759557, 60.93400421758202],
            [7.155772545153291, 60.884627244012606],
            [7.203467528904086, 60.701377942995904],
            [7.469640098781279, 60.67554768935076],
            [7.43884239170354, 60.6600393507578],
            [7.024665955457909, 60.58584968355907],
            [6.908588953539156, 60.485576079801454],
            [6.885513984448099, 60.47884645572992],
            [6.846573899249952, 60.48164105767588],
            [6.805234458829932, 60.469807724314926],
            [6.711021131939559, 60.42606345562055],
            [6.661797669513436, 60.424559997553196],
            [6.5663575667444976, 60.449655977483715],
            [6.450035687113813, 60.40267051252423],
            [6.3289476772498805, 60.37813056302259],
            [6.29113072737172, 60.34537134508769],
            [6.212679311455552, 60.307594744173464],
            [6.210591767256932, 60.26839977713557],
            [6.14597153797096, 60.22627437220699],
            [5.955100530945528, 60.16590428433745],
            [5.913563202967955, 60.15119544166941],
            [5.71347498238484, 60.14350468932902],
            [5.569565756126878, 60.22151661760456],
            [5.584566372335397, 60.25931928930676],
            [5.628397847863731, 60.2988555810099],
            [5.639559055912814, 60.34389101752543],
            [5.6879190597312705, 60.36750681386236],
            [5.61171309013298, 60.45478222294935],
            [5.561915639066571, 60.56268523047001],
            [5.494362706468169, 60.64320081816436],
            [5.395266265928151, 60.70962531632592],
            [5.266718314595623, 60.75024319792633],
            [5.23501157152615, 60.77499058617438],
            [5.33690667575124, 60.822691643166095],
            [5.354346993721623, 60.86351909452606],
            [5.381325324397278, 60.873103998616614],
            [5.446812473340072, 60.87781386484742],
            [5.487739154952199, 60.893231404232246],
            [5.52568300737373, 60.91397386676414],
            [5.516864988987333, 60.927192417275485],
            [5.48526172929529, 60.96756164055361],
            [5.467419867878123, 61.06625670432635],
            [5.682068461742429, 61.12616884246061],
            [5.808630735531791, 61.144873634846114],
            [6.025576371245936, 61.13354343785585],
            [6.1320548932301815, 61.135129404857]
          ]
        ]
      },
      "properties": {
        "objektType": "SkredVarslingsområde",
        "omradeID": 3031,
        "omradeNavn": "Voss",
        "safeName": "Voss",
        "regionType": "A",
        "dataUttaksdato": "20200127",
        "eksportType": "NVEs nedlastningsløsning"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [5.703560471047668, 61.96881913641198],
            [5.70723045528257, 61.89616800890094],
            [5.768813460730791, 61.863037568773244],
            [5.825756228939468, 61.85279635862149],
            [5.877283664400295, 61.81536696243062],
            [5.845998749531457, 61.766777980702386],
            [5.790026106037927, 61.74563179898662],
            [5.636588603846945, 61.741661439608535],
            [5.700317653517425, 61.68889584639155],
            [5.647536307503769, 61.63962269633946],
            [5.6459758972026295, 61.617389230416556],
            [5.6654793079391075, 61.58954205600179],
            [5.7164069797999515, 61.58595929131979],
            [5.718563271687383, 61.57019206797727],
            [5.733439350077098, 61.56503143070083],
            [5.590796675874793, 61.542059719546096],
            [5.538125463199438, 61.44370138366269],
            [5.562361432828173, 61.36165094983987],
            [5.676743750929968, 61.22686354453172],
            [5.6367844374199345, 61.207529986281884],
            [5.633994348661068, 61.18762569143541],
            [5.5888170475762395, 61.18006547814551],
            [5.4912946670778275, 61.20602397325092],
            [5.410982013229979, 61.21087739343542],
            [5.401476149568018, 61.22908055507023],
            [5.38104159727317, 61.230394154033526],
            [5.373151691437533, 61.24467925355987],
            [5.315811011054279, 61.237102192315625],
            [5.256780409473859, 61.2619345148684],
            [5.264996426195674, 61.28219476958158],
            [5.167897674765874, 61.26028526235874],
            [5.1333360813912385, 61.2739511712892],
            [5.084846760458464, 61.27708439835214],
            [5.084757456841734, 61.2537634182692],
            [5.001288814744784, 61.24685659782947],
            [4.995695521650098, 61.23949960247147],
            [4.917200646764432, 61.23625754086492],
            [4.8212797430238385, 61.252406382964146],
            [4.713180020146503, 61.24663775925041],
            [4.515980575739977, 61.219517708473674],
            [4.2979336020509065, 61.225185985457685],
            [4.372002408200049, 61.47717872745954],
            [4.636988901208998, 61.99224132593741],
            [5.056523897679015, 62.310212733215],
            [5.217879396325414, 62.26120001813496],
            [5.357316718511422, 62.16863187171222],
            [5.360882662013334, 62.122192146961275],
            [5.503090007020899, 62.06673615642628],
            [5.485541221031556, 62.01426091274577],
            [5.503169311113189, 62.00792661180406],
            [5.442874719296145, 61.974209557209164],
            [5.475956095089388, 61.985947717972564],
            [5.55155885253975, 61.96041235171243],
            [5.6801615739442, 61.97404516587276],
            [5.703560471047668, 61.96881913641198]
          ]
        ]
      },
      "properties": {
        "objektType": "SkredVarslingsområde",
        "omradeID": 3026,
        "omradeNavn": "Ytre Fjordane",
        "safeName": "Ytre_Fjordane",
        "regionType": "B",
        "dataUttaksdato": "20200127",
        "eksportType": "NVEs nedlastningsløsning"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [9.361128051433514, 63.211895405532566],
            [9.295555105435147, 63.19537271055317],
            [9.228588284331002, 63.204784689608374],
            [9.218102736099063, 63.222611841681996],
            [8.762415148615178, 63.18982795767448],
            [8.769561979815345, 63.173296755722674],
            [8.821731067948274, 63.150118481951246],
            [8.807152642672738, 63.12661736073491],
            [8.688717018392115, 63.07339925037408],
            [8.652572275945618, 63.06417586195943],
            [8.647691528699507, 63.07253592190303],
            [8.622301677837607, 63.07094000132152],
            [8.501988069283595, 63.048970961192374],
            [8.481498386670923, 63.07965039527113],
            [8.43721376385961, 63.06554534020969],
            [8.42517248362813, 63.046739298665116],
            [8.402801088633316, 63.05687651667619],
            [8.338329132767498, 63.03553341721354],
            [8.328597599012669, 63.045145692349855],
            [8.243706084482348, 63.01208419577288],
            [8.202958268544489, 63.02280524264553],
            [7.987612416387952, 62.98767712445336],
            [7.900271192086131, 62.97481700442008],
            [7.845594706118378, 63.01235637096225],
            [7.75630693691404, 63.00533903702276],
            [7.752043223005793, 62.989592137078844],
            [7.660702735446091, 62.9713414876923],
            [7.521395048732485, 62.925246443542854],
            [7.489066728205657, 62.92194173651692],
            [7.445499044971597, 62.956211061709794],
            [7.352629294117444, 62.983935486223224],
            [7.33991212629958, 62.999717049550306],
            [7.360448611619669, 63.010280729892386],
            [7.215076977810782, 63.1543387011524],
            [7.139563956759581, 63.17983650222433],
            [7.392643534545869, 63.35703946302007],
            [7.944616963614216, 63.67063063068193],
            [8.008934963768201, 63.649300871848446],
            [8.108651561020613, 63.59814741995015],
            [8.240533152702376, 63.42209247011288],
            [8.342934303956621, 63.35941352380724],
            [8.43390945562709, 63.38870336243867],
            [8.742727377525458, 63.44748109920632],
            [9.045167794686602, 63.481507792473074],
            [9.100306768144279, 63.463440868332135],
            [9.120253280575968, 63.43623180910111],
            [9.146866943423229, 63.428129310341994],
            [9.240115508467907, 63.31337356141329],
            [9.292888559440565, 63.293023616282504],
            [9.364367739040935, 63.30194294620792],
            [9.381996942324266, 63.286839952823485],
            [9.39877753169378, 63.29085909103089],
            [9.423498603102754, 63.27872630859505],
            [9.36926128363354, 63.274182381933464],
            [9.342995890823154, 63.26421767633488],
            [9.361128051433514, 63.211895405532566]
          ]
        ]
      },
      "properties": {
        "objektType": "SkredVarslingsområde",
        "omradeID": 3021,
        "omradeNavn": "Ytre Nordmøre",
        "safeName": "Ytre_Nordmore",
        "regionType": "B",
        "dataUttaksdato": "20200127",
        "eksportType": "NVEs nedlastningsløsning"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [5.676743750929968, 61.22686354453172],
            [5.808630735531791, 61.144873634846114],
            [5.682068461742429, 61.12616884246061],
            [5.467419867878123, 61.06625670432635],
            [5.48526172929529, 60.96756164055361],
            [5.516864988987333, 60.927192417275485],
            [5.483676966148221, 60.92161156180171],
            [5.477995970107889, 60.934063950290806],
            [5.461483268604318, 60.9346966315162],
            [5.3765613222265145, 60.911264558124],
            [5.330113615624963, 60.91196760854313],
            [5.309110575467039, 60.939818455629435],
            [5.291888033520972, 60.94392103092487],
            [5.2768906497044945, 60.9285069023688],
            [5.226700523785494, 60.92587791268733],
            [5.164142284401497, 60.89993547551698],
            [5.163117684191484, 60.87387315875151],
            [5.132289385912891, 60.859806869686025],
            [5.14060687107164, 60.837446164058576],
            [5.109884264612806, 60.80552016860445],
            [5.048121409148192, 60.82888487850508],
            [4.892077634121957, 60.84667402422644],
            [4.686904157269979, 60.858220119682976],
            [4.6106518139971495, 60.88722032662222],
            [4.349485398239138, 60.855264250986714],
            [4.276092268579106, 61.15022515704728],
            [4.2979336020509065, 61.225185985457685],
            [4.515980575739977, 61.219517708473674],
            [4.713180020146503, 61.24663775925041],
            [4.8212797430238385, 61.252406382964146],
            [4.917200646764432, 61.23625754086492],
            [4.995695521650098, 61.23949960247147],
            [5.001288814744784, 61.24685659782947],
            [5.084757456841734, 61.2537634182692],
            [5.084846760458464, 61.27708439835214],
            [5.1333360813912385, 61.2739511712892],
            [5.167897674765874, 61.26028526235874],
            [5.264996426195674, 61.28219476958158],
            [5.256780409473859, 61.2619345148684],
            [5.315811011054279, 61.237102192315625],
            [5.373151691437533, 61.24467925355987],
            [5.38104159727317, 61.230394154033526],
            [5.401476149568018, 61.22908055507023],
            [5.410982013229979, 61.21087739343542],
            [5.4912946670778275, 61.20602397325092],
            [5.5888170475762395, 61.18006547814551],
            [5.633994348661068, 61.18762569143541],
            [5.6367844374199345, 61.207529986281884],
            [5.676743750929968, 61.22686354453172]
          ]
        ]
      },
      "properties": {
        "objektType": "SkredVarslingsområde",
        "omradeID": 3030,
        "omradeNavn": "Ytre Sogn",
        "safeName": "Ytre_Sogn",
        "regionType": "B",
        "dataUttaksdato": "20200127",
        "eksportType": "NVEs nedlastningsløsning"
      }
    }
  ]
}
